/* eslint-disable */ export * from './types';

import * as Types from './types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export const StatisticFragmentDoc = gql`
    fragment Statistic on Statistic {
  id
  name
  className
  type
  value
  units
  filter
  childrenClassName
  history {
    date
    value
  }
}
    `;
export const AnalyticsSummaryFragmentDoc = gql`
    fragment AnalyticsSummary on AnalyticsSummary {
  timeSaved {
    ...Statistic
  }
  totalWatched {
    ...Statistic
  }
  engagedPercent {
    ...Statistic
  }
  didNotAttendPercent {
    ...Statistic
  }
  leftEarlyPercent {
    ...Statistic
  }
  stayedToEndPercent {
    ...Statistic
  }
  registered {
    ...Statistic
  }
  registrants {
    ...Statistic
  }
  visitors {
    ...Statistic
  }
  attendees {
    ...Statistic
  }
  sessions {
    ...Statistic
  }
  hadSession {
    ...Statistic
  }
  attendedPercent {
    ...Statistic
  }
  watchedPercent {
    ...Statistic
  }
  didNotAttendPercent {
    ...Statistic
  }
  engagedPercent {
    ...Statistic
  }
  joinRate {
    ...Statistic
  }
  registrationRate {
    ...Statistic
  }
  completion {
    ...Statistic
  }
  completionRate {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export const AnalyticsRegistrationConversionFragmentDoc = gql`
    fragment AnalyticsRegistrationConversion on AnalyticsRegistrationConversion {
  hasEverBeenConversion
  conversion {
    ...Statistic
  }
  conversionRate {
    ...Statistic
  }
  amountPerConversion {
    ...Statistic
  }
  amountPerAttendee {
    ...Statistic
  }
  amountPerRegistrant {
    ...Statistic
  }
  totalAmount {
    ...Statistic
  }
  scheduledRegistrants {
    ...Statistic
  }
  onDemandRegistrants {
    ...Statistic
  }
  justInTimeRegistrants {
    ...Statistic
  }
  replayRegistrants {
    ...Statistic
  }
  scheduledJoinRate {
    ...Statistic
  }
  onDemandJoinRate {
    ...Statistic
  }
  justInTimeJoinRate {
    ...Statistic
  }
  replayJoinRate {
    ...Statistic
  }
  scheduledAttendees {
    ...Statistic
  }
  onDemandAttendees {
    ...Statistic
  }
  justInTimeAttendees {
    ...Statistic
  }
  replayAttendees {
    ...Statistic
  }
  scheduledCompletion {
    ...Statistic
  }
  onDemandCompletion {
    ...Statistic
  }
  justInTimeCompletion {
    ...Statistic
  }
  replayCompletion {
    ...Statistic
  }
  scheduledCompletionRate {
    ...Statistic
  }
  onDemandCompletionRate {
    ...Statistic
  }
  justInTimeCompletionRate {
    ...Statistic
  }
  replayCompletionRate {
    ...Statistic
  }
  scheduledConversion {
    ...Statistic
  }
  onDemandConversion {
    ...Statistic
  }
  justInTimeConversion {
    ...Statistic
  }
  replayConversion {
    ...Statistic
  }
  scheduledConversionRate {
    ...Statistic
  }
  onDemandConversionRate {
    ...Statistic
  }
  justInTimeConversionRate {
    ...Statistic
  }
  replayConversionRate {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export const AnalyticsAttendanceItemFragmentDoc = gql`
    fragment AnalyticsAttendanceItem on AnalyticsAttendanceItem {
  attendees {
    ...Statistic
  }
  stayedToEnd {
    ...Statistic
  }
  leftEarly {
    ...Statistic
  }
  watchedReplay {
    ...Statistic
  }
  sessions {
    ...Statistic
  }
  watchedPercent {
    ...Statistic
  }
  attendeesRate {
    ...Statistic
  }
  stayedToEndRate {
    ...Statistic
  }
  leftEarlyRate {
    ...Statistic
  }
  watchedReplayRate {
    ...Statistic
  }
  sessionsRate {
    ...Statistic
  }
  watchedDuration {
    ...Statistic
  }
  completion {
    ...Statistic
  }
  completionRate {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export const StatisticWithAllItemsFragmentDoc = gql`
    fragment StatisticWithAllItems on Statistic {
  ...Statistic
  allItems
}
    ${StatisticFragmentDoc}`;
export const AnalyticsEngagementFragmentDoc = gql`
    fragment AnalyticsEngagement on AnalyticsEngagement {
  attendees {
    ...StatisticWithAllItems
  }
  chats {
    ...StatisticWithAllItems
  }
  likes {
    ...StatisticWithAllItems
  }
  actions {
    ...StatisticWithAllItems
  }
}
    ${StatisticWithAllItemsFragmentDoc}`;
export const AnalyticsEngagementSummaryFragmentDoc = gql`
    fragment AnalyticsEngagementSummary on AnalyticsEngagementSummary {
  engaged {
    ...Statistic
  }
  engagementRate {
    ...Statistic
  }
  totalChat {
    ...Statistic
  }
  totalLikes {
    ...Statistic
  }
  totalActions {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export const MediaRefFragmentDoc = gql`
    fragment MediaRef on MediaRef {
  url
  imageUrl
  videoUrl
  width
  height
  alt
  crop
  fit
  query
}
    `;
export const DisplayRulesFragmentDoc = gql`
    fragment DisplayRules on DisplayRule {
  property
  operator
  value
  arrayValue
}
    `;
export const InteractionDetailsFragmentDoc = gql`
    fragment InteractionDetails on InteractionDetails {
  imageMediaRef {
    ...MediaRef
  }
  imageQuery
  title
  icon
  subtitle
  description
  shortcut
  email
  requireEmail
  hidePhoneNumberField
  buttonText
  resultsAppearAt
  selectionType
  answers {
    text
    value
    isOther
    isAnswer
  }
  link
  endsIn
  endInReplay
  integration
  isSticky
  endsAt
  lastDays
  hideOnMobile
  showTimer
  showCumulativeResults
  skipWhenChatting
  showOverlayButton
  overlayButtonText
  giphyType
  username
  setId
  registerType
  notifyModerator
  overlaySettings {
    width
    height
    transition
    background
    animation
    text
    direction
    imageMediaRef {
      ...MediaRef
    }
    borderRadius
    imageSize
    fontSize
    position
  }
  anchor {
    pause
    pauseSecs
    pauseMessage
    includeInAgenda
  }
  displayRules {
    ...DisplayRules
  }
  testimonial {
    quote
    action
    name
    title
    avatarMediaRef {
      ...MediaRef
    }
    company
    companyLink
  }
  inVideoRegistration {
    displayIn
    isRequired
    showOnlyBuiltInFields
    hideConsentCheckbox
    buttonColor
    buttonText
  }
}
    ${MediaRefFragmentDoc}
${DisplayRulesFragmentDoc}`;
export const InteractionFragmentDoc = gql`
    fragment Interaction on Interaction {
  id
  interactionShortId
  type
  valueType
  room
  appearAt
  propertyName
  createdAt
  updatedAt
  details {
    ...InteractionDetails
  }
  isFavorite
  templateId
  isNewTemplate
  templateCategories
  templateName
  templateDesc
  templateDetails {
    instructions
    imageMediaRef {
      ...MediaRef
    }
  }
}
    ${InteractionDetailsFragmentDoc}
${MediaRefFragmentDoc}`;
export const InteractionWithStatsFragmentDoc = gql`
    fragment InteractionWithStats on Interaction {
  ...Interaction
  stats {
    ...Statistic
  }
}
    ${InteractionFragmentDoc}
${StatisticFragmentDoc}`;
export const AnalyticsInteractionsFragmentDoc = gql`
    fragment AnalyticsInteractions on AnalyticsInteractions {
  total
  nextCursor
  interactions {
    ...InteractionWithStats
  }
}
    ${InteractionWithStatsFragmentDoc}`;
export const PublicSetSettingsFragmentDoc = gql`
    fragment PublicSetSettings on SetSettings {
  pixelID
  enableUngatedOnDemand
  replaySettings {
    useRetargetingLink
    disallowSeek
  }
  accessControl {
    enableAccessControl
    type
    limitPerSession
    requireSSO
  }
  chatNotRespondedEmailTo
  conversionEventInteractionType
  chatBot {
    enabled
    type
    chatBotId
    displayName
    avatarMediaRef {
      ...MediaRef
    }
    autoArchive
    disableReachHuman
  }
}
    ${MediaRefFragmentDoc}`;
export const SocialMediaTagsFragmentDoc = gql`
    fragment socialMediaTags on SocialMediaTags {
  title
  description
  mediaRef {
    ...MediaRef
  }
}
    ${MediaRefFragmentDoc}`;
export const GdprSettingsFragmentDoc = gql`
    fragment GdprSettings on GdprSettings {
  bannerMode
  bannerText
  bannerCode
}
    `;
export const TeamSettingsFragmentDoc = gql`
    fragment TeamSettings on TeamSettings {
  language
  hideBranding
  requireSSOLogin
  gdpr {
    ...GdprSettings
  }
}
    ${GdprSettingsFragmentDoc}`;
export const PublicSetFragmentDoc = gql`
    fragment PublicSet on EWebinarSet {
  id
  isPublishable
  now
  series {
    id
    name
    tag
  }
  seriesOrder
  primaryModerator {
    id
    name
    firstName
    lastName
    isBot
    profileMediaRef {
      ...MediaRef
    }
  }
  assignedModerators {
    id
    firstName
    lastName
    name
    profileMediaRef {
      ...MediaRef
    }
  }
  urls {
    slugId
    setUrl
    shortUrl
    registration
    allWebinars
    replayRegistration
    retargetingReplay
    ungatedOnDemand
  }
  setSettings {
    ...PublicSetSettings
  }
  expireReplayLinkAfterMins
  socialMediaTags {
    ...socialMediaTags
  }
  useScripts {
    registrationPage
    registrationForm
    thankyouPage
    presentationRoom
    script {
      id
      uuid
      name
      content
      disableIfGdprDeclined
    }
  }
  team {
    id
    logoMediaRef {
      ...MediaRef
    }
    name
    shareUrl
    settings {
      ...TeamSettings
    }
  }
}
    ${MediaRefFragmentDoc}
${PublicSetSettingsFragmentDoc}
${SocialMediaTagsFragmentDoc}
${TeamSettingsFragmentDoc}`;
export const ThemeSettingsFragmentDoc = gql`
    fragment ThemeSettings on ThemeSettings {
  primaryColor
  actionColor
  font
  fontSize
  fontCssUrl
  borderRadius
}
    `;
export const PresenterFragmentDoc = gql`
    fragment Presenter on User {
  id
  profileMediaRef {
    ...MediaRef
  }
  name
  firstName
  lastName
  email
  phone
  company
  title
  bio
  displayEmail
  timezone
  socialLinks {
    facebook
    twitter
    linkedin
    instagram
  }
}
    ${MediaRefFragmentDoc}`;
export const PageSectionFragmentDoc = gql`
    fragment PageSection on PageSection {
  active
  type
  imageWithText {
    title
    imageMediaRef {
      ...MediaRef
    }
    text
  }
  certification {
    instructions
    completion
    buttonText
  }
  presenters {
    title
    presenter1
    presenter2
  }
  testimonials {
    testimonials {
      name
      avatarMediaRef {
        ...MediaRef
      }
      description
    }
  }
  logoAndTeaser {
    teaser
    ctaTopBtnText
  }
  imageBackground {
    imageMediaRef {
      ...MediaRef
    }
    title
    text
    overlayColor
    textColor
    blur
    minHeight
  }
  seriesInfo {
    webinars {
      description
      setId
      buttonText
    }
  }
  footer {
    tagline
    disclaimer
  }
}
    ${MediaRefFragmentDoc}`;
export const RegistrationPageSettingsFragmentDoc = gql`
    fragment RegistrationPageSettings on RegistrationPageSettings {
  customRegistrationUrl
  footerSection {
    tagline
    disclaimer
  }
  sections {
    ...PageSection
  }
  widgetConfig {
    ctaBtnText
    ctaBtnBgColor
  }
  specifySocialTags
  socialMediaTags {
    ...socialMediaTags
  }
}
    ${PageSectionFragmentDoc}
${SocialMediaTagsFragmentDoc}`;
export const RegistrationFormFieldFragmentDoc = gql`
    fragment RegistrationFormField on RegistrationFormField {
  fieldName
  propertyName
  type
  subType
  isRequired
  isRemovable
  note
  options {
    text
    value
  }
}
    `;
export const RegistrationFormSettingsFragmentDoc = gql`
    fragment RegistrationFormSettings on RegistrationFormSettings {
  title
  fields {
    ...RegistrationFormField
  }
  fullNameField {
    ...RegistrationFormField
  }
  useFullNameField
  collectedFormFieldsConsent
  showConsentCheckbox
  consentCheckboxText
  registerButton
}
    ${RegistrationFormFieldFragmentDoc}`;
export const ScheduledWebinarFragmentDoc = gql`
    fragment ScheduledWebinar on ScheduledWebinar {
  recurringType
  onWeekDays
  atMinutes
  atDate
  nthDayOfMonth
}
    `;
export const ScheduleSettingsFragmentDoc = gql`
    fragment scheduleSettings on ScheduleSettings {
  schedules {
    ...ScheduledWebinar
  }
  numberOfSessions
  showOndemandSession
  showReplaySession
  justInTimeIntervalMinutes
  justInTimeHoursOfOperations {
    day
    times
  }
  justInTimeWeekDays
  hoursOfOperationTimezone
  blackoutPeriods {
    name
    startDay
    endDay
    rule
    country
  }
  blackoutHolidays {
    startDate
    endDate
    year
  }
}
    ${ScheduledWebinarFragmentDoc}`;
export const PublicChatSettingsFragmentDoc = gql`
    fragment PublicChatSettings on ChatSettings {
  emailOnChatReceive
  smsOnChatReceive
  nameRepliesAsChatHost
  sendInquiriesTo
  Scheduled {
    type
    automatedDetails {
      on
      message
    }
  }
  JustInTime {
    type
    automatedDetails {
      on
      message
    }
  }
  Replay {
    type
    automatedDetails {
      on
      message
    }
  }
  automatedMessages {
    AutoResponder {
      on
      message
      respondInMins
    }
    EmailCapture
  }
}
    `;
export const JobStatusFieldsFragmentDoc = gql`
    fragment JobStatusFields on JobStatus {
  id
  uuid
  job
  stage
  postStage
  closed
  progress
  message
  error
}
    `;
export const VideoUploadPartFragmentDoc = gql`
    fragment VideoUploadPart on VideoUploadPart {
  partNumber
  url
  etag
}
    `;
export const S3UploadFragmentDoc = gql`
    fragment S3Upload on S3Upload {
  key
  uploadId
  partSize
  parts {
    ...VideoUploadPart
  }
}
    ${VideoUploadPartFragmentDoc}`;
export const VideoUrlsFragmentDoc = gql`
    fragment VideoUrls on VideoUrls {
  vimeoId
  name
  sourceUrl
  uploadUrl
  playUrl
  uri
  thumbnailMediaRef {
    ...MediaRef
  }
  s3Upload {
    ...S3Upload
  }
}
    ${MediaRefFragmentDoc}
${S3UploadFragmentDoc}`;
export const UploadStatusFragmentDoc = gql`
    fragment UploadStatus on UploadStatus {
  ...JobStatusFields
  type
  urls {
    ...VideoUrls
  }
}
    ${JobStatusFieldsFragmentDoc}
${VideoUrlsFragmentDoc}`;
export const TranscribeStatusFragmentDoc = gql`
    fragment TranscribeStatus on TranscribeStatus {
  ...JobStatusFields
  vimeoId
}
    ${JobStatusFieldsFragmentDoc}`;
export const JobsFragmentDoc = gql`
    fragment Jobs on Jobs {
  id
  upload {
    ...UploadStatus
  }
  transcribe {
    ...TranscribeStatus
  }
}
    ${UploadStatusFragmentDoc}
${TranscribeStatusFragmentDoc}`;
export const PublicTeamFragmentDoc = gql`
    fragment PublicTeam on Team {
  id
  name
  logoMediaRef {
    ...MediaRef
  }
  timezone
  subdomain
  domain
  isDomainVerified
  shareUrl
  themeSettings {
    ...ThemeSettings
  }
  settings {
    ...TeamSettings
  }
}
    ${MediaRefFragmentDoc}
${ThemeSettingsFragmentDoc}
${TeamSettingsFragmentDoc}`;
export const ThirdPartyIntegrationFragmentDoc = gql`
    fragment ThirdPartyIntegration on ThirdPartyIntegration {
  id
  type
  details {
    Zendesk {
      snippetKey
    }
    Drift {
      appId
    }
    Intercom {
      region
      appId
    }
    Chatbot {
      embedCodes
    }
  }
}
    `;
export const PublicEWebinarFragmentDoc = gql`
    fragment PublicEWebinar on EWebinar {
  id
  title
  duration
  vimeoVideoId
  vimeoTextTrackId
  videoPlayUrl
  waitingRoomDurationSecs
  exitRoomDurationSecs
  isPublished
  logoMediaRef {
    ...MediaRef
  }
  favIconMediaRef {
    ...MediaRef
  }
  themeSettings {
    ...ThemeSettings
  }
  timeZone
  startDate
  endDateEnabled
  endDate
  justInTimeModeEnabled
  presenters {
    ...Presenter
  }
  notificationSettings {
    fromName
    fromEmail
  }
  registrationPageSettings {
    ...RegistrationPageSettings
  }
  registrationFormSettings {
    ...RegistrationFormSettings
  }
  thankyouPageSettings {
    redirectionUrl
    packAttendeeData
    skipForReplayAndJIT
    justInTimeButtonText
    replayButtonText
    addToCalendarButtonText
    sections {
      ...PageSection
    }
    footerSection {
      tagline
      disclaimer
    }
  }
  scheduleType
  scheduleSettings {
    ...scheduleSettings
  }
  enableChat
  emailBeforeSession
  isDisabledChat
  chatSettings {
    ...PublicChatSettings
  }
  viewerRoomSettings {
    attendeeCounter
    attendeeCounterOption
    attendeeReactions
    attendeeReactionsOption
    attendeeReactionsDays
    language
    enableVideoPlaybackSpeed
    enableVideoPause
    videoPauseSecs
    enableVideoTimer
    pauseMessage
  }
  exitRoomSettings {
    exitRoomDisplayType
    exitRoomCTA {
      name
      link
    }
    redirectAfterExit
    redirectLink
    redirectLinkWhenMissed
    postExitRoomCTA {
      name
      link
      description
    }
  }
  uploadStatus {
    ...UploadStatus
  }
  jobs {
    ...Jobs
  }
  team {
    ...PublicTeam
  }
  set {
    id
    urls {
      setUrl
      shortUrl
      registration
      replayRegistration
    }
    setSettings {
      ...PublicSetSettings
    }
  }
  presenterIds
  fullSessions {
    session
    status
  }
  isExternalHost
  stayedToEndPercent
  hasCompletionRequired
  thirdPartyIntegration {
    ...ThirdPartyIntegration
  }
}
    ${MediaRefFragmentDoc}
${ThemeSettingsFragmentDoc}
${PresenterFragmentDoc}
${RegistrationPageSettingsFragmentDoc}
${RegistrationFormSettingsFragmentDoc}
${PageSectionFragmentDoc}
${ScheduleSettingsFragmentDoc}
${PublicChatSettingsFragmentDoc}
${UploadStatusFragmentDoc}
${JobsFragmentDoc}
${PublicTeamFragmentDoc}
${PublicSetSettingsFragmentDoc}
${ThirdPartyIntegrationFragmentDoc}`;
export const AnalyticsPageDataFragmentDoc = gql`
    fragment AnalyticsPageData on AnalyticsPageData {
  set {
    ...PublicSet
    team {
      logoMediaRef {
        ...MediaRef
      }
    }
  }
  publicWebinar {
    ...PublicEWebinar
  }
  sectionAllowed
  filter {
    dateRange
    timezone
    activityScheduleGroupBy
    setId
    includeLegacyInteractions
  }
  isUDEnabled
}
    ${PublicSetFragmentDoc}
${MediaRefFragmentDoc}
${PublicEWebinarFragmentDoc}`;
export const ParticipantAnalyticsPageDataFragmentDoc = gql`
    fragment ParticipantAnalyticsPageData on ParticipantAnalyticsPageData {
  team {
    id
    name
    logoMediaRef {
      ...MediaRef
    }
    settings {
      hideBranding
    }
  }
  filter {
    teamId
    setIds
    dateRange
    timezone
  }
  publicWebinars {
    id
    title
    duration
    setId
    updatedAt
    thumbnailMediaRef {
      ...MediaRef
    }
    set {
      id
      socialMediaTags {
        ...socialMediaTags
      }
    }
  }
}
    ${MediaRefFragmentDoc}
${SocialMediaTagsFragmentDoc}`;
export const AnalyticStatSummaryFragmentDoc = gql`
    fragment AnalyticStatSummary on AnalyticStatSummary {
  visitors
  sessions
  registered
  registrants
  attended
  engaged
  watchedDuration
  avgWatchedPercent
  conversionAttendees
  converted
  completed
  registeredPercent
  attendedPercent
  engagedPercent
  convertedPercent
  completedPercent
}
    `;
export const AnalyticSetStatFragmentDoc = gql`
    fragment AnalyticSetStat on AnalyticSetStat {
  setId
  hasConversion
  visitors
  sessions
  registered
  registrants
  attended
  engaged
  watchedDuration
  avgWatchedPercent
  converted
  completed
  registeredPercent
  attendedPercent
  engagedPercent
  convertedPercent
  completedPercent
}
    `;
export const UniversalAnalyticsSummaryFragmentDoc = gql`
    fragment UniversalAnalyticsSummary on UniversalAnalyticsSummary {
  summary {
    ...AnalyticStatSummary
  }
  stats {
    ...AnalyticSetStat
  }
}
    ${AnalyticStatSummaryFragmentDoc}
${AnalyticSetStatFragmentDoc}`;
export const UtmParamsFragmentDoc = gql`
    fragment UTMParams on UTMParams {
  utm_source
  utm_medium
  utm_campaign
  utm_term
  utm_content
  gclid
}
    `;
export const AttendeeFragmentDoc = gql`
    fragment Attendee on Attendee {
  id
  sessionType
  isOnDemand
  firstName
  lastName
  visitorId
  startTime
  optOut
  subscribed
  joinTime
  joinReplayTime
  email
  attendeeFields
  country
  source
  subscribed
  timezone
  isTest
  paused
  completed
  set {
    id
  }
  ewebinar {
    id
    title
  }
  urls {
    join
    replay
    thankyou
    google
    outlook
    yahoo
    ics
  }
  hasConversation
  lastWatchedSegment {
    startTime
    startAtSecs
    endTime
    endAtSecs
    extendedBySecs
    speed
    lastEvent
  }
  lastReplaySegment {
    startTime
    startAtSecs
    endTime
    endAtSecs
    extendedBySecs
    speed
    lastEvent
  }
  utmParams {
    ...UTMParams
  }
}
    ${UtmParamsFragmentDoc}`;
export const ActionPropertyValueFragmentDoc = gql`
    fragment ActionPropertyValue on ActionPropertyWithValue {
  property
  parentProperty
  alias
  entityPath
  name
  index
  description
  type
  source
  values
  excludeActions
  value
}
    `;
export const AttendeeActionPropertiesFragmentDoc = gql`
    fragment AttendeeActionProperties on AttendeeActionProperties {
  conditionalDisplay {
    ...ActionPropertyValue
  }
  mentionField {
    ...ActionPropertyValue
  }
}
    ${ActionPropertyValueFragmentDoc}`;
export const AttendeeWithPropertiesFragmentDoc = gql`
    fragment AttendeeWithProperties on Attendee {
  ...Attendee
  properties {
    ...AttendeeActionProperties
  }
}
    ${AttendeeFragmentDoc}
${AttendeeActionPropertiesFragmentDoc}`;
export const AttendeeJoinWebinarFragmentDoc = gql`
    fragment AttendeeJoinWebinar on Attendee {
  now
  ...AttendeeWithProperties
  ewebinar {
    ...PublicEWebinar
    interactions {
      ...Interaction
    }
  }
  set {
    ...PublicSet
  }
  properties {
    ...AttendeeActionProperties
  }
}
    ${AttendeeWithPropertiesFragmentDoc}
${PublicEWebinarFragmentDoc}
${InteractionFragmentDoc}
${PublicSetFragmentDoc}
${AttendeeActionPropertiesFragmentDoc}`;
export const ConversationWithAttendeePropertiesFragmentDoc = gql`
    fragment ConversationWithAttendeeProperties on Conversation {
  id
  inEmail
  attendee {
    id
    attendeeFields
    startTime
    firstName
    lastName
    email
    liveSessionType
    lastSegment {
      startTime
      startAtSecs
      endTime
      endAtSecs
      extendedBySecs
      speed
      lastEvent
    }
    properties {
      ...AttendeeActionProperties
    }
  }
  isArchived
  lastReadAt
  isAttendeeLive
  sortDate
  hasUnreadMessages
  lastMessage {
    id
    fromAttendee
    content
    timeSent
    type
    subtype
  }
  set {
    id
  }
  ewebinar {
    id
    title
  }
  isAttendeeLive
  disableAutoResponse
  disableChatBot
  disableReachHuman
}
    ${AttendeeActionPropertiesFragmentDoc}`;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  inEmail
  attendee {
    id
    attendeeFields
    startTime
    firstName
    lastName
    email
    liveSessionType
    sessionType
    lastSegment {
      startTime
      startAtSecs
      endTime
      endAtSecs
      extendedBySecs
      speed
      lastEvent
    }
  }
  isArchived
  lastReadAt
  isAttendeeLive
  sortDate
  hasUnreadMessages
  disableAutoResponse
  disableChatBot
  disableReachHuman
  lastMessage {
    id
    fromAttendee
    content
    timeSent
    type
    subtype
  }
  ewebinar {
    id
    title
  }
  set {
    id
  }
}
    `;
export const ConversationsFragmentDoc = gql`
    fragment Conversations on Conversations {
  conversations {
    ...Conversation
  }
  total
  nextCursor
}
    ${ConversationFragmentDoc}`;
export const ReactionDetailsFragmentDoc = gql`
    fragment ReactionDetails on ReactionDetails {
  requestToContact {
    name
    phone
    email
    message
    requireEmail
    hidePhoneNumberField
  }
  nextWebinar {
    attendeeId
    setId
    sessionType
  }
  inVideoRegistration {
    attendeeId
    setId
    ungatedSessionType
  }
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  uuid
  timeSent
  roomType
  timeInWebinarSecs
  fromAttendee
  sentByEmail
  sendError
  sendRetriable
  user {
    id
    firstName
    lastName
    profileMediaRef {
      ...MediaRef
    }
  }
  content
  type
  subtype
  reaction {
    id
    interactionType
    stringAnswer
    numberAnswer
    arrayAnswer
    detailsFields {
      ...ReactionDetails
    }
  }
  interaction {
    id
    type
    details {
      title
      description
      selectionType
      answers {
        value
        text
        isOther
        isAnswer
      }
    }
  }
  chatBot {
    type
    chatBotId
    avatarMediaRef {
      ...MediaRef
    }
    displayName
  }
}
    ${MediaRefFragmentDoc}
${ReactionDetailsFragmentDoc}`;
export const UpdateLiveFragmentFragmentDoc = gql`
    fragment UpdateLiveFragment on EWebinarSet {
  liveFragment {
    id
    unreadChats
    inSession
  }
}
    `;
export const ArchivedConversationFragmentDoc = gql`
    fragment ArchivedConversation on Conversation {
  id
  isArchived
  set {
    id
    ...UpdateLiveFragment
  }
}
    ${UpdateLiveFragmentFragmentDoc}`;
export const CouponFragmentDoc = gql`
    fragment Coupon on Coupon {
  name
  id
  amount_off
  percent_off
  credit
  desc
  type
  valid
}
    `;
export const SetSettingsFragmentDoc = gql`
    fragment SetSettings on SetSettings {
  pixelID
  replaySettings {
    useRetargetingLink
    disallowSeek
  }
  enableUngatedOnDemand
  registrationNotificationSettings {
    enableNotified
    type
  }
  accessControl {
    enableAccessControl
    type
    limitPerSession
    allowedSettings {
      emails
      domains
    }
    blockedSettings {
      emails
      domains
    }
    requireSSO
    restrictions {
      noDisposableEmails
      noFreeEmails
      requireCaptcha
    }
  }
  chatNotRespondedEmailTo
  conversionEventInteractionType
  chatBot {
    enabled
    type
    chatBotId
    displayName
    avatarMediaRef {
      ...MediaRef
    }
    autoArchive
    disableReachHuman
  }
}
    ${MediaRefFragmentDoc}`;
export const EWebinarSetIDsFragmentDoc = gql`
    fragment EWebinarSetIDs on EWebinarSet {
  id
  assignedModerators {
    id
    email
    displayEmail
  }
  publicWebinar {
    id
    title
  }
  draftWebinar {
    id
    title
  }
  isPublishable
  attendeeChatEmailReplyTo
  setSettings {
    ...SetSettings
  }
  expireReplayLinkAfterMins
  notifiedUser {
    id
    email
    displayEmail
  }
}
    ${SetSettingsFragmentDoc}`;
export const UpdateUploadStatusFragmentDoc = gql`
    fragment UpdateUploadStatus on EWebinar {
  id
  jobs {
    ...Jobs
  }
}
    ${JobsFragmentDoc}`;
export const EWebinarSetAnalyticsSummaryFragmentDoc = gql`
    fragment EWebinarSetAnalyticsSummary on EWebinarSetAnalyticsSummary {
  registered
  attended
  engaged
}
    `;
export const HomePageSetFragmentDoc = gql`
    fragment HomePageSet on HomePageSet {
  id
  group
  title
  editedAt
  presenterIds
  set {
    id
    templateID
    isPublishable
    tags
    fromTemplateID
    draftWebinar {
      id
    }
    publicWebinar {
      id
      duration
    }
    assignedModerators {
      id
    }
    liveFragment {
      id
      unreadChats
      inSession
    }
    analyticSummaryStats {
      ...Statistic
    }
    series {
      id
      name
      tag
    }
    seriesOrder
  }
}
    ${StatisticFragmentDoc}`;
export const TemplateInfoFragmentDoc = gql`
    fragment templateInfo on TemplateInfo {
  name
  author
  hubspotUrl
  language
  recommended
  askForVideoUpload
  order
  templateMediaRef {
    ...MediaRef
  }
}
    ${MediaRefFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment Template on EWebinarSet {
  id
  updatedAt
  templateID
  templateTypes
  templateInfo {
    ...templateInfo
  }
  publicWebinar {
    title
  }
}
    ${TemplateInfoFragmentDoc}`;
export const EWebinarInfoFragmentDoc = gql`
    fragment EWebinarInfo on EWebinar {
  id
  title
  startDate
  duration
  thumbnailMediaRef {
    ...MediaRef
  }
  logoMediaRef {
    ...MediaRef
  }
  favIconMediaRef {
    ...MediaRef
  }
  themeSettings {
    ...ThemeSettings
  }
  vimeoVideoId
  vimeoTextTrackId
  videoPlayUrl
  videoSourceUrl
  timeZone
  viewerRoomSettings {
    language
  }
  justInTimeModeEnabled
  scheduleType
  scheduleSettings {
    justInTimeIntervalMinutes
    showReplaySession
  }
  registrationPageSettings {
    customRegistrationUrl
    sections {
      ...PageSection
    }
    widgetConfig {
      ctaBtnText
      ctaBtnBgColor
    }
    specifySocialTags
    socialMediaTags {
      ...socialMediaTags
    }
  }
  registrationFormSettings {
    ...RegistrationFormSettings
  }
  uploadStatus {
    ...UploadStatus
  }
  jobs {
    ...Jobs
  }
  presenters {
    id
    name
    profileMediaRef {
      ...MediaRef
    }
  }
  set {
    id
  }
  isExternalHost
}
    ${MediaRefFragmentDoc}
${ThemeSettingsFragmentDoc}
${PageSectionFragmentDoc}
${SocialMediaTagsFragmentDoc}
${RegistrationFormSettingsFragmentDoc}
${UploadStatusFragmentDoc}
${JobsFragmentDoc}`;
export const SetInfoFragmentDoc = gql`
    fragment SetInfo on EWebinarSet {
  id
  tags
  updatedAt
  analyticsStartDate
  isPublishable
  attendeeChatEmailReplyTo
  templateID
  templateTypes
  templateInfo {
    ...templateInfo
  }
  urls {
    setUrl
    shortUrl
    registration
    replayRegistration
    retargetingReplay
    ungatedOnDemand
  }
  assignedModerators {
    id
    firstName
    lastName
    name
    email
  }
  publicWebinar {
    ...EWebinarInfo
  }
  draftWebinar {
    ...EWebinarInfo
    createdAt
    updatedAt
  }
  liveFragment {
    id
    unreadChats
    inSession
  }
  setSettings {
    ...SetSettings
  }
  expireReplayLinkAfterMins
}
    ${TemplateInfoFragmentDoc}
${EWebinarInfoFragmentDoc}
${SetSettingsFragmentDoc}`;
export const SetScriptFragmentDoc = gql`
    fragment SetScript on SetScriptRelation {
  setId
  scriptId
  registrationPage
  registrationForm
  thankyouPage
  presentationRoom
}
    `;
export const SeriesScriptFragmentDoc = gql`
    fragment SeriesScript on SeriesScriptRelation {
  seriesId
  scriptId
  useInLandingPage
  useInSubmitEmailForm
  useInRegistrationForm
}
    `;
export const ScriptFragmentDoc = gql`
    fragment Script on Script {
  id
  uuid
  name
  content
  disableIfGdprDeclined
  usedOnPublishedCatalog
  usedInWebinars {
    ...SetScript
  }
  usedInSeries {
    ...SeriesScript
  }
  lastError
  lastErrorAt
  lastErrorPage
}
    ${SetScriptFragmentDoc}
${SeriesScriptFragmentDoc}`;
export const ScriptInSetFragmentDoc = gql`
    fragment ScriptInSet on ScriptInSet {
  setId
  scriptId
  registrationPage
  registrationForm
  thankyouPage
  presentationRoom
  script {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export const UserInSetFragmentDoc = gql`
    fragment UserInSet on UserInSet {
  id
  firstName
  lastName
  name
  email
  profileMediaRef {
    ...MediaRef
  }
  role
  invitationStatus
  setId
  order
}
    ${MediaRefFragmentDoc}`;
export const EWebinarSetFragmentDoc = gql`
    fragment EWebinarSet on EWebinarSet {
  ...SetInfo
  id
  updatedAt
  analyticsStartDate
  fromTemplateID
  isPublishable
  attendeeChatEmailReplyTo
  tags
  seriesTag
  createdAt
  hasRegistrant
  urls {
    slugId
    shortUrl
    setUrl
    registration
    replayRegistration
    allWebinars
    retargetingReplay
    ungatedOnDemand
  }
  notifiedUser {
    id
  }
  publicWebinar {
    id
  }
  setSettings {
    ...SetSettings
  }
  expireReplayLinkAfterMins
  templateID
  templateTypes
  templateInfo {
    ...templateInfo
  }
  hideFromCatalog
  liveFragment {
    id
    unreadChats
    inSession
  }
  useScripts {
    ...ScriptInSet
  }
  assignedModerators {
    ...UserInSet
  }
  primaryModerator {
    id
    name
    firstName
    lastName
    email
    profileMediaRef {
      ...MediaRef
    }
  }
  team {
    id
    name
    shareUrl
    settings {
      ...TeamSettings
    }
  }
  socialMediaTags {
    ...socialMediaTags
  }
}
    ${SetInfoFragmentDoc}
${SetSettingsFragmentDoc}
${TemplateInfoFragmentDoc}
${ScriptInSetFragmentDoc}
${UserInSetFragmentDoc}
${MediaRefFragmentDoc}
${TeamSettingsFragmentDoc}
${SocialMediaTagsFragmentDoc}`;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  ...PublicTeam
  subscriptionStatus
  subscriptionSubstatus
  trialEndingDate
  timezone
  createdAt
  brandingPromoterId
  registrantLimit {
    limit
    registrants
    isFull
    registrantsLeftPercent
    includedLimit
    additionalLimit
    purchasedAdditionalLimit
    resetAt
    isTrialing
  }
}
    ${PublicTeamFragmentDoc}`;
export const TranscriptionFragmentDoc = gql`
    fragment Transcription on Transcription {
  chunks {
    timestamp
    text
  }
}
    `;
export const EWebinarFragmentDoc = gql`
    fragment EWebinar on EWebinar {
  ...PublicEWebinar
  isVideoSharedWithTemplate
  slug
  sessions {
    type
    date
    value
    text
  }
  team {
    ...Team
  }
  notificationSettings {
    fromName
    fromEmail
  }
  uploadStatus {
    ...UploadStatus
  }
  chatSettings {
    ...PublicChatSettings
  }
  jobs {
    ...Jobs
  }
  completionSettings {
    respondedQuiz {
      required
      type
      percentage
    }
    converted
  }
  transcription {
    ...Transcription
  }
  stayedToEndPercent
  updatedAt
  isExternalHost
}
    ${PublicEWebinarFragmentDoc}
${TeamFragmentDoc}
${UploadStatusFragmentDoc}
${PublicChatSettingsFragmentDoc}
${JobsFragmentDoc}
${TranscriptionFragmentDoc}`;
export const EWebinarWithInteractionsFragmentDoc = gql`
    fragment EWebinarWithInteractions on EWebinar {
  ...EWebinar
  interactions {
    ...Interaction
  }
}
    ${EWebinarFragmentDoc}
${InteractionFragmentDoc}`;
export const FullSetFragmentDoc = gql`
    fragment FullSet on EWebinarSet {
  ...EWebinarSet
  draftWebinar {
    ...EWebinarWithInteractions
  }
  publicWebinar {
    ...EWebinarWithInteractions
  }
}
    ${EWebinarSetFragmentDoc}
${EWebinarWithInteractionsFragmentDoc}`;
export const EWebinarWithSetFragmentDoc = gql`
    fragment EWebinarWithSet on EWebinar {
  ...EWebinar
  set {
    ...EWebinarSet
    templateID
  }
}
    ${EWebinarFragmentDoc}
${EWebinarSetFragmentDoc}`;
export const EWebinarWithSetInfoFragmentDoc = gql`
    fragment EWebinarWithSetInfo on EWebinar {
  ...EWebinar
  set {
    ...SetInfo
  }
}
    ${EWebinarFragmentDoc}
${SetInfoFragmentDoc}`;
export const PublicSetWithEWebinarFragmentDoc = gql`
    fragment PublicSetWithEWebinar on EWebinarSet {
  ...PublicSet
  publicWebinar {
    ...PublicEWebinar
  }
}
    ${PublicSetFragmentDoc}
${PublicEWebinarFragmentDoc}`;
export const SetWithPublicEwebinarFragmentDoc = gql`
    fragment SetWithPublicEwebinar on EWebinarSet {
  ...EWebinarSet
  publicWebinar {
    ...EWebinar
  }
  team {
    id
  }
}
    ${EWebinarSetFragmentDoc}
${EWebinarFragmentDoc}`;
export const PublicWebinarDescriptionFragmentDoc = gql`
    fragment PublicWebinarDescription on EWebinar {
  id
  title
  isPublished
  themeSettings {
    ...ThemeSettings
  }
  logoMediaRef {
    ...MediaRef
  }
  thumbnailMediaRef {
    ...MediaRef
  }
  vimeoVideoId
  vimeoTextTrackId
  startDate
  endDateEnabled
  endDate
  justInTimeModeEnabled
  duration
  timeZone
  registrationFormSettings {
    registerButton
  }
  registrationPageSettings {
    customRegistrationUrl
    specifySocialTags
    sections {
      ...PageSection
    }
    socialMediaTags {
      ...socialMediaTags
    }
  }
  scheduleType
  scheduleSettings {
    ...scheduleSettings
  }
  viewerRoomSettings {
    language
  }
  presenters {
    id
    name
    profileMediaRef {
      ...MediaRef
    }
  }
  set {
    id
    urls {
      registration
    }
    tags
  }
  fullSessions {
    session
    status
  }
}
    ${ThemeSettingsFragmentDoc}
${MediaRefFragmentDoc}
${PageSectionFragmentDoc}
${SocialMediaTagsFragmentDoc}
${ScheduleSettingsFragmentDoc}`;
export const PublicSetAndSessionFragmentDoc = gql`
    fragment PublicSetAndSession on EWebinarSet {
  id
  now
  seriesOrder
  assignedModerators {
    id
    firstName
    lastName
    name
  }
  urls {
    slugId
    registration
    replayRegistration
    retargetingReplay
    ungatedOnDemand
  }
  publicWebinar {
    ...PublicWebinarDescription
  }
  setSettings {
    ...SetSettings
  }
  expireReplayLinkAfterMins
  socialMediaTags {
    ...socialMediaTags
  }
}
    ${PublicWebinarDescriptionFragmentDoc}
${SetSettingsFragmentDoc}
${SocialMediaTagsFragmentDoc}`;
export const PageSettingsFragmentDoc = gql`
    fragment PageSettings on EWebinar {
  registrationPageSettings {
    sections {
      ...PageSection
    }
  }
  thankyouPageSettings {
    sections {
      ...PageSection
    }
  }
}
    ${PageSectionFragmentDoc}`;
export const IntegrationTagsFragmentDoc = gql`
    fragment IntegrationTags on IntegrationTags {
  applyWebinarTags
  tags
  applyMissedWatchedTags
  tagsIfWatched
  tagsIfMissed
}
    `;
export const IntegrationDetailsFragmentDoc = gql`
    fragment IntegrationDetails on IntegrationDetails {
  Webhook {
    url
    format
  }
  SSO {
    domain
    clientId
    clientSecret
    openIdIssuerUrl
  }
  Thinkific {
    subdomain
  }
  EmailTransport {
    testEmail
    sendHeader
    sendFooter
  }
  SendGrid {
    group
  }
  SMTP {
    host
    port
    username
    password
  }
  Slack {
    channel {
      id
      name
    }
    oneChannelPerWebinar
    channelPrefix
    onlyShowAttendeesWhoChat
    mentionUsers
  }
  Twilio {
    accountSID
    authToken
    phoneNumber
    responseMessage
    testNumber
    channel
    secondaryNumbers
    testTemplateId
  }
  Salesforce {
    type
    createActivities
    fieldsToExclude
    campaign
    subject
  }
  Marketo {
    identityUrl
    clientId
    clientSecret
  }
  ConvertKit {
    formId
  }
  Vimeo {
    accessToken
  }
  Chatbot {
    embedCodes
  }
  Zendesk {
    snippetKey
  }
  Drift {
    appId
  }
  Intercom {
    region
    appId
    secretKey
  }
  Hubspot {
    enableChat
  }
  Infusionsoft {
    timezone
  }
}
    `;
export const IntegrationFiltersFragmentDoc = gql`
    fragment IntegrationFilters on IntegrationFilters {
  minWatchedPercent
  maxWatchedPercent
}
    `;
export const IntegrationHookDetailsFragmentDoc = gql`
    fragment IntegrationHookDetails on IntegrationHookDetails {
  Mailchimp {
    list {
      id
      name
    }
  }
  ActiveCampaign {
    list {
      id
      name
    }
  }
  ConvertKit {
    tag {
      id
      name
    }
  }
  ConstantContact {
    list {
      list_id
      name
    }
  }
  MailerLite {
    group {
      id
      name
    }
  }
}
    `;
export const IntegrationHookFragmentDoc = gql`
    fragment IntegrationHook on IntegrationHook {
  id
  type
  tag
  action
  connected
  totalErrors
  errorResetAt
  mappings {
    name
    format
    customField {
      id
      name
      label
      type
    }
  }
  filters {
    ...IntegrationFilters
  }
  details {
    ...IntegrationHookDetails
  }
  tagValues {
    ...IntegrationTags
  }
  connected
}
    ${IntegrationFiltersFragmentDoc}
${IntegrationHookDetailsFragmentDoc}
${IntegrationTagsFragmentDoc}`;
export const IntegrationFragmentDoc = gql`
    fragment Integration on Integration {
  id
  name
  type
  desc {
    inBeta
    inAlpha
  }
  transport
  apiUrl
  apiKey
  apiSecret
  connected
  forUser
  forUserEmail
  connectedMessage
  performRedirect
  tagValues {
    ...IntegrationTags
  }
  details {
    ...IntegrationDetails
  }
  totalErrors
  errorResetAt
  integrationHooks {
    ...IntegrationHook
  }
}
    ${IntegrationTagsFragmentDoc}
${IntegrationDetailsFragmentDoc}
${IntegrationHookFragmentDoc}`;
export const IntegrationActionFragmentDoc = gql`
    fragment IntegrationAction on IntegrationAction {
  id
  correlationId
  type
  action
  method
  url
  payload
  status
  statusText
  error
  response
  createdAt
  retriable
}
    `;
export const DraftInteractionFragmentDoc = gql`
    fragment DraftInteraction on DraftInteraction {
  type
  room
  appearAt
  propertyName
  details {
    ...InteractionDetails
  }
}
    ${InteractionDetailsFragmentDoc}`;
export const ConversionNotificationFragmentDoc = gql`
    fragment ConversionNotification on ConversionNotification {
  title
  description
  fromDate
  imageUrl
}
    `;
export const InteractionReactionResultsFragmentDoc = gql`
    fragment InteractionReactionResults on Interaction {
  id
  type
  results {
    average
    answers {
      answer
      count
      percent
    }
  }
}
    `;
export const InteractionWithReactionFragmentDoc = gql`
    fragment InteractionWithReaction on Interaction {
  ...Interaction
  ...InteractionReactionResults
  reaction(attendeeId: $attendeeId) {
    id
    reactedAt
    numberAnswer
    stringAnswer
    arrayAnswer
    detailsFields {
      ...ReactionDetails
    }
    properties {
      ...AttendeeActionProperties
    }
  }
}
    ${InteractionFragmentDoc}
${InteractionReactionResultsFragmentDoc}
${ReactionDetailsFragmentDoc}
${AttendeeActionPropertiesFragmentDoc}`;
export const InteractionForAttendeeFragmentDoc = gql`
    fragment InteractionForAttendee on Interaction {
  ...Interaction
  reaction(attendeeId: $attendeeId) {
    id
    reactedAt
    numberAnswer
    stringAnswer
    arrayAnswer
    detailsFields {
      ...ReactionDetails
    }
  }
}
    ${InteractionFragmentDoc}
${ReactionDetailsFragmentDoc}`;
export const InteractionWithAnalyticsFragmentDoc = gql`
    fragment InteractionWithAnalytics on InteractionWithAnalytics {
  totalCount
  totalCorrect
  results {
    average
    answers {
      answer
      count
      percent
    }
  }
  interaction {
    ...InteractionWithStats
  }
}
    ${InteractionWithStatsFragmentDoc}`;
export const InvoiceFragmentDoc = gql`
    fragment Invoice on Invoice {
  id
  createdAt
  currency
  amount
  startingBalance
  endingBalance
  status
  invoiceURL
  amount_refunded
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  type
  sendBy
  sendTo
  skipWhenConverted
  whenNumber
  whenUnit
  subject
  followUpTo
  message
  previewText
  fontSize
  details {
    templateId
    templateVariables {
      token
      property
    }
  }
}
    `;
export const DraftNotificationFragmentDoc = gql`
    fragment DraftNotification on DraftNotification {
  type
  subject
  message
  whenNumber
  whenUnit
  sendBy
  sendTo
  followUpTo
  skipWhenConverted
}
    `;
export const NotificationTextFragmentDoc = gql`
    fragment NotificationText on NotificationText {
  subject
  message
  previewText
}
    `;
export const AttendeeInTeamFragmentDoc = gql`
    fragment AttendeeInTeam on AttendeeInTeam {
  id
  visitorId
  firstName
  lastName
  email
  country
  subscribed
  team {
    id
    name
  }
  ewebinar {
    id
    title
  }
  set {
    id
    draftWebinar {
      id
      title
    }
  }
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on UserInTeam {
  id
  firstName
  lastName
  profileMediaRef {
    ...MediaRef
  }
  email
  role
  invitationStatus
  lastCountry
}
    ${MediaRefFragmentDoc}`;
export const StatsGraphFragmentDoc = gql`
    fragment StatsGraph on StatsGraph {
  name
  stack
  render
  filter
  stats {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export const TeamWithStatsFragmentDoc = gql`
    fragment TeamWithStats on Team {
  id
  name
  logoMediaRef {
    ...MediaRef
  }
  favIconMediaRef {
    ...MediaRef
  }
  themeSettings {
    primaryColor
    actionColor
  }
  subdomain
  shareUrl
  subscriptionStatus
  users {
    ...TeamMember
  }
  stats {
    ...Statistic
  }
  graphs {
    ...StatsGraph
  }
  isArchived
}
    ${MediaRefFragmentDoc}
${TeamMemberFragmentDoc}
${StatisticFragmentDoc}
${StatsGraphFragmentDoc}`;
export const AttendeeSearchInfoFragmentDoc = gql`
    fragment AttendeeSearchInfo on AttendeeSearchInfo {
  id
  firstName
  lastName
  email
}
    `;
export const AttendeeWithStatsFragmentDoc = gql`
    fragment AttendeeWithStats on AttendeeWithStats {
  id
  visitorId
  firstName
  lastName
  email
  country
  subscribed
  totalAttendees
  totalTeams
  totalEwebinars
}
    `;
export const OutActionFragmentDoc = gql`
    fragment OutAction on OutAction {
  messageId
  from
  subject
  to
  attendeeId
  notificationSentBy
  userId
  createdAt
  unsubscribed
  complained
  opened
  bounced
}
    `;
export const ParticipantFragmentDoc = gql`
    fragment Participant on Participant {
  id
  email
  firstName
  lastName
  firstRegisteredDate
  lastStartTime
  registered
  attended
  converted
  completed
  engaged
  likes
  actions
  chatsSent
  avgWatchedPercent
  conversionRate
}
    `;
export const RegistrantSessionRecordFragmentDoc = gql`
    fragment RegistrantSessionRecord on Attendee {
  id
  sessionType
  isOnDemand
  firstName
  lastName
  visitorId
  startTime
  optOut
  subscribed
  joinTime
  joinReplayTime
  registeredDate
  leaveTime
  leaveReplayTime
  duration
  durationReplay
  totalDuration
  watchedPercent
  watchedReplayPercent
  totalWatchedPercent
  actions
  chatsSent
  likes
  email
  attendeeFields
  country
  source
  subscribed
  timezone
  isTest
  paused
  purchaseCurrency
  lastPurchaseDate
  completed
  set {
    id
    setSettings {
      accessControl {
        blockedSettings {
          emails
        }
      }
    }
  }
  ewebinar {
    id
    title
    duration
  }
  urls {
    join
    replay
    thankyou
    google
    outlook
    yahoo
    ics
  }
  converted
}
    `;
export const ParticipantRecordDetailsFragmentDoc = gql`
    fragment ParticipantRecordDetails on ParticipantSession {
  id
  setId
  likes
  actions
  chatsSent
  converted
  completed
  totalDuration
  totalWatchedPercent
  registeredDate
  startTime
  sessionType
  ewebinar {
    id
    title
    duration
    set {
      hasConversionEvent
    }
  }
  attendees {
    ...RegistrantSessionRecord
  }
}
    ${RegistrantSessionRecordFragmentDoc}`;
export const ActionPropertyDescriptionFragmentDoc = gql`
    fragment ActionPropertyDescription on ActionPropertyDescription {
  group
  property
  parentProperty
  alias
  entityPath
  name
  index
  description
  type
  propertyOf
  source
  values
  excludeActions
  inWebinars {
    setId
    interactionId
    inDraft
    inPublished
  }
  metadata {
    type
    title
    answers {
      value
      text
    }
    isRandomPropertyName
  }
}
    `;
export const ActionPropertyValueWithWebinarFragmentDoc = gql`
    fragment ActionPropertyValueWithWebinar on ActionPropertyValueWithWebinar {
  property
  parentProperty
  alias
  entityPath
  name
  index
  description
  type
  source
  values
  excludeActions
  value
  ewebinar {
    id
    title
  }
  metadata {
    type
    title
    answers {
      value
      text
    }
    isRandomPropertyName
  }
}
    `;
export const ReactionFragmentDoc = gql`
    fragment Reaction on Reaction {
  id
  createdAt
  reactedAt
  reactionAppearRoom
  eventName
  stringAnswer
  numberAnswer
  arrayAnswer
  detailsFields {
    ...ReactionDetails
  }
  interaction {
    ...InteractionReactionResults
  }
}
    ${ReactionDetailsFragmentDoc}
${InteractionReactionResultsFragmentDoc}`;
export const RegistrantSessionFragmentDoc = gql`
    fragment RegistrantSession on Attendee {
  id
  firstName
  lastName
  email
  visitorId
  registeredDate
  watchedPercent
  watchedReplayPercent
  totalWatchedPercent
  startTime
  attendeeFields
  country
  source
  likes
  actions
  chatsSent
  purchaseAmount
  purchaseCurrency
  lastPurchaseDate
  completed
  sessionType
  isOnDemand
  subscribed
  reaction(filter: $filter) {
    ...Reaction
  }
}
    ${ReactionFragmentDoc}`;
export const ReactionForAttendeeFragmentDoc = gql`
    fragment ReactionForAttendee on ReactionForAttendee {
  id
  firstName
  lastName
  email
  visitorId
  registeredDate
  watchedPercent
  watchedReplayPercent
  totalWatchedPercent
  startTime
  attendeeFields
  country
  source
  reaction(filter: $filter) {
    ...Reaction
  }
  likes
  actions
  chatsSent
  purchaseAmount
  purchaseCurrency
  lastPurchaseDate
  completed
  sessionType
  isOnDemand
  subscribed
  sessions {
    ...RegistrantSession
  }
}
    ${ReactionFragmentDoc}
${RegistrantSessionFragmentDoc}`;
export const RegistrantFragmentDoc = gql`
    fragment Registrant on ReactionForAttendee {
  id
  firstName
  lastName
  email
  visitorId
  registeredDate
  watchedPercent
  watchedReplayPercent
  totalWatchedPercent
  startTime
  attendeeFields
  country
  likes
  actions
  chatsSent
  purchaseAmount
  purchaseCurrency
  lastPurchaseDate
  hasConversation
  joinTime
  sessionType
  isOnDemand
  subscribed
  joinReplayTime
  optOut
  source
  completed
  set {
    id
  }
  urls {
    join
    replay
    thankyou
    google
    outlook
    yahoo
  }
  conversation {
    id
  }
}
    `;
export const SavedReplyFragmentDoc = gql`
    fragment SavedReply on SavedReply {
  id
  name
  content
  availableIn
  shortcut
}
    `;
export const SeriesScriptRelationFragmentDoc = gql`
    fragment SeriesScriptRelation on SeriesScriptRelation {
  id
  script {
    id
    name
    content
  }
  useInLandingPage
  useInRegistrationForm
  useInSubmitEmailForm
}
    `;
export const SeriesFragmentDoc = gql`
    fragment Series on Series {
  id
  name
  language
  tag
  url
  updatedAt
  team {
    id
  }
  sets {
    id
    tags
  }
}
    `;
export const EWebinarPreviewInfoFragmentDoc = gql`
    fragment EWebinarPreviewInfo on EWebinar {
  id
  title
  duration
  thumbnailMediaRef {
    ...MediaRef
  }
  presenters {
    id
    name
    profileMediaRef {
      ...MediaRef
    }
  }
  isDisabledChat
}
    ${MediaRefFragmentDoc}`;
export const SetPreviewInfoFragmentDoc = gql`
    fragment SetPreviewInfo on EWebinarSet {
  id
  fromTemplateID
  tags
  updatedAt
  isPublishable
  templateID
  templateTypes
  templateInfo {
    ...templateInfo
  }
  series {
    id
    name
    tag
  }
  seriesOrder
  assignedModerators {
    id
    name
  }
  publicWebinar {
    ...EWebinarPreviewInfo
  }
  draftWebinar {
    ...EWebinarPreviewInfo
    uploadStatus {
      ...UploadStatus
    }
    jobs {
      ...Jobs
    }
    createdAt
    updatedAt
    editedAt
  }
  liveFragment {
    id
    unreadChats
    inSession
  }
  setSettings {
    ...SetSettings
  }
  expireReplayLinkAfterMins
  analyticSummaryStats {
    ...Statistic
  }
  socialMediaTags {
    ...socialMediaTags
  }
}
    ${TemplateInfoFragmentDoc}
${EWebinarPreviewInfoFragmentDoc}
${UploadStatusFragmentDoc}
${JobsFragmentDoc}
${SetSettingsFragmentDoc}
${StatisticFragmentDoc}
${SocialMediaTagsFragmentDoc}`;
export const ScriptInSeriesFragmentDoc = gql`
    fragment ScriptInSeries on ScriptInSeries {
  seriesId
  scriptId
  useInLandingPage
  useInSubmitEmailForm
  useInRegistrationForm
  script {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export const SeriesSettingsFragmentDoc = gql`
    fragment SeriesSettings on SeriesSettings {
  requireSequential
  showSeriesProgressBar
  enableSeriesCertification
  showCountdownTimer
  completionRequirement
  certificationRewardType
  certificationBadge {
    ...MediaRef
  }
  certificationUrl
}
    ${MediaRefFragmentDoc}`;
export const SubmitEmailFormSettingsFragmentDoc = gql`
    fragment SubmitEmailFormSettings on SubmitEmailFormSettings {
  title
  submitButtonText
  fields {
    ...RegistrationFormField
  }
}
    ${RegistrationFormFieldFragmentDoc}`;
export const NotificationSettingsFragmentDoc = gql`
    fragment NotificationSettings on NotificationSettings {
  fromName
  fromEmail
}
    `;
export const FullSeriesFragmentDoc = gql`
    fragment FullSeries on Series {
  id
  name
  language
  tag
  url
  updatedAt
  team {
    id
    logoMediaRef {
      ...MediaRef
    }
    name
    shareUrl
    settings {
      ...TeamSettings
    }
  }
  logoMediaRef {
    ...MediaRef
  }
  favIconMediaRef {
    ...MediaRef
  }
  sets {
    ...SetPreviewInfo
  }
  useScripts {
    ...ScriptInSeries
  }
  registrationPageSettings {
    ...RegistrationPageSettings
  }
  seriesSettings {
    ...SeriesSettings
  }
  registrationFormSettings {
    ...RegistrationFormSettings
  }
  submitEmailFormSettings {
    ...SubmitEmailFormSettings
  }
  themeSettings {
    ...ThemeSettings
  }
  notificationSettings {
    ...NotificationSettings
  }
}
    ${MediaRefFragmentDoc}
${TeamSettingsFragmentDoc}
${SetPreviewInfoFragmentDoc}
${ScriptInSeriesFragmentDoc}
${RegistrationPageSettingsFragmentDoc}
${SeriesSettingsFragmentDoc}
${RegistrationFormSettingsFragmentDoc}
${SubmitEmailFormSettingsFragmentDoc}
${ThemeSettingsFragmentDoc}
${NotificationSettingsFragmentDoc}`;
export const PublicSeriesFragmentDoc = gql`
    fragment PublicSeries on Series {
  id
  name
  language
  tag
  url
  updatedAt
  team {
    id
    name
    shareUrl
    settings {
      ...TeamSettings
    }
  }
  logoMediaRef {
    ...MediaRef
  }
  favIconMediaRef {
    ...MediaRef
  }
  sets {
    ...PublicSet
  }
  registrationPageSettings {
    ...RegistrationPageSettings
  }
  seriesSettings {
    ...SeriesSettings
  }
  registrationFormSettings {
    ...RegistrationFormSettings
  }
  submitEmailFormSettings {
    ...SubmitEmailFormSettings
  }
  themeSettings {
    ...ThemeSettings
  }
}
    ${TeamSettingsFragmentDoc}
${MediaRefFragmentDoc}
${PublicSetFragmentDoc}
${RegistrationPageSettingsFragmentDoc}
${SeriesSettingsFragmentDoc}
${RegistrationFormSettingsFragmentDoc}
${SubmitEmailFormSettingsFragmentDoc}
${ThemeSettingsFragmentDoc}`;
export const MemberFragmentDoc = gql`
    fragment Member on UserInTeam {
  id
  profileMediaRef {
    ...MediaRef
  }
  name
  firstName
  lastName
  email
  phone
  company
  title
  bio
  displayEmail
  socialLinks {
    facebook
    twitter
    linkedin
    instagram
  }
  timezone
  state
  version
  isVerified
  team {
    id
    name
    subdomain
    logoMediaRef {
      ...MediaRef
    }
    themeSettings {
      primaryColor
      actionColor
    }
  }
  assignedSets {
    id
  }
  integrations {
    firstPromoterToken
  }
  role
  invitationStatus
  details {
    occupation
    presenterFirstName
    presenterLastName
    onboardCompletedAt
  }
}
    ${MediaRefFragmentDoc}`;
export const TeamAndUsersFragmentDoc = gql`
    fragment TeamAndUsers on Team {
  ...Team
  users {
    ...Member
  }
}
    ${TeamFragmentDoc}
${MemberFragmentDoc}`;
export const PurchasedProductFragmentDoc = gql`
    fragment PurchasedProduct on PurchasedProduct {
  type
  tierId
}
    `;
export const TeamForAdminFragmentDoc = gql`
    fragment TeamForAdmin on Team {
  ...Team
  subscriptionStatus
  subscriptionSubstatus
  billingCycle
  last4
  ccType
  plan
  nextPaymentDueDate
  credit
  brandingPromoterId
  primaryBillingContact
  billingContacts
  pendingSetupIntent
  purchasedProducts {
    ...PurchasedProduct
  }
}
    ${TeamFragmentDoc}
${PurchasedProductFragmentDoc}`;
export const TeamForAdminNoPendingSetupIntentFragmentDoc = gql`
    fragment TeamForAdminNoPendingSetupIntent on Team {
  ...Team
  subscriptionStatus
  subscriptionSubstatus
  billingCycle
  last4
  ccType
  plan
  nextPaymentDueDate
  credit
  primaryBillingContact
  billingContacts
  purchasedProducts {
    ...PurchasedProduct
  }
}
    ${TeamFragmentDoc}
${PurchasedProductFragmentDoc}`;
export const CardInfoFragmentDoc = gql`
    fragment CardInfo on CardInfo {
  brand
  exp_month
  exp_year
  last4
}
    `;
export const PriceTierFragmentDoc = gql`
    fragment priceTier on PriceTier {
  tierId
  name
  to
  from
  registrantLimit
  packageSize
  monthlyPrice
  pricePerAdditional
  annualPrice
  annualPricePerMonth
  annualPricePerAdditional
  annualPricePerAdditionalPerMonth
}
    `;
export const PricePlanFragmentDoc = gql`
    fragment pricePlan on PricePlan {
  pricePlan {
    ...priceTier
  }
  discountedPricePlan {
    ...priceTier
  }
  coupon {
    id
    name
    percent_off
    amount_off
  }
}
    ${PriceTierFragmentDoc}`;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  name
  type
  scope
  kind
  isSubscribed
  isTrialAvailable
  trialEnd
  trialDays
  hadTrial
  isTrialCancelled
  pricePlan {
    ...pricePlan
  }
}
    ${PricePlanFragmentDoc}`;
export const ProductForAdminFragmentDoc = gql`
    fragment ProductForAdmin on Product {
  ...Product
  price
  quantity
  scheduledQuantity
  activeUntil
}
    ${ProductFragmentDoc}`;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on SubscriptionInfo {
  status
  subStatus
  credit
  currency
  activeWebinars
  endedDate
  nextPaymentDueDate
  trialEndingDate
  amountOwed
  billingCycle
  currentPeriodBillingCycle
  products {
    ...ProductForAdmin
  }
}
    ${ProductForAdminFragmentDoc}`;
export const TeamDomainSettingsFragmentDoc = gql`
    fragment TeamDomainSettings on Team {
  id
  subdomain
  domain
  canonicalDomain
  isDomainVerifiedAndWorks
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  ...Presenter
  state
  version
  isVerified
  role
  invitationStatus
  lastCountry
  team {
    id
    name
    subdomain
    logoMediaRef {
      ...MediaRef
    }
    themeSettings {
      primaryColor
      actionColor
    }
    address {
      country
    }
    settings {
      ...TeamSettings
    }
  }
}
    ${PresenterFragmentDoc}
${MediaRefFragmentDoc}
${TeamSettingsFragmentDoc}`;
export const MeFragmentDoc = gql`
    fragment Me on Me {
  id
  profileMediaRef {
    ...MediaRef
  }
  lastCountry
  name
  firstName
  lastName
  email
  hasPassword
  phone
  company
  title
  bio
  displayEmail
  integrations {
    firstPromoterToken
  }
  socialLinks {
    facebook
    twitter
    linkedin
    instagram
  }
  timezone
  state
  version
  isVerified
  verifiedAt
  team {
    ...Team
    favIconMediaRef {
      ...MediaRef
    }
    extraScopes
    mailAddress
    promoCode
    billingCycle
    settings {
      ...TeamSettings
    }
    details {
      forOnboarding
      useCases
    }
    timeSavedSummary
    isEnabledTest
    pendingSetupIntent
  }
  isInvitedUser
  inTeam {
    role
    invitationStatus
    invitedByUser {
      id
      firstName
      lastName
    }
  }
  impersonatingUser {
    userId
    teamId
  }
  chatTokens {
    accessToken
    refreshToken
  }
  details {
    occupation
    presenterFirstName
    presenterLastName
    onboardCompletedAt
    redirectToUniversalChat
  }
  lastLoginAt
  ipCountry
}
    ${MediaRefFragmentDoc}
${TeamFragmentDoc}
${TeamSettingsFragmentDoc}`;
export const VimeoTextTrackUrlsFragmentDoc = gql`
    fragment VimeoTextTrackUrls on VimeoTextTrackUrls {
  id
  name
  active
  language
  type
  uri
  uploadUrl
}
    `;
export const VisitorIdentificationFragmentDoc = gql`
    fragment VisitorIdentification on VisitorIdentification {
  portalId
  identificationToken
  visitor {
    id
    properties {
      email
      firstname
      lastname
      phone
    }
  }
}
    `;
export const ProductHuntPostFragmentDoc = gql`
    fragment ProductHuntPost on ProductHuntPost {
  id
  url
  name
  description
  tagline
  votesCount
  media {
    url
    videoUrl
    type
  }
  thumbnail {
    url
    videoUrl
    type
  }
}
    `;
export const SalesforceCampaignFragmentDoc = gql`
    fragment SalesforceCampaign on SalesforceCampaign {
  id
  name
}
    `;
export const SalesforceSubjectFragmentDoc = gql`
    fragment SalesforceSubject on SalesforceSubject {
  label
  value
}
    `;
export const ThinkificProductFragmentDoc = gql`
    fragment ThinkificProduct on ThinkificProduct {
  id
  name
  description
  card_image_url
  productUrl
  productable_id
  productable_type
  price {
    description
    price
    currency
  }
  status
  private
  hidden
  subscription
  has_certificate
}
    `;
export const VimeoVideoFragmentDoc = gql`
    fragment VimeoVideo on VimeoVideo {
  id
  title
  description
  duration
  uri
  videoSourceUrl
  videoPlayUrl
  createdTime
}
    `;
export const ZoomMeetingFragmentDoc = gql`
    fragment ZoomMeeting on ZoomMeeting {
  id
  uuid
  name
  startTime
  duration
  videoUrl
  subtitlesUrl
}
    `;
export const AnalyticsSummaryDocument = gql`
    query analyticsSummary($filter: AnalyticsShareFilterInput!) {
  analyticsSummary(analyticsFilter: $filter) {
    ...AnalyticsSummary
  }
}
    ${AnalyticsSummaryFragmentDoc}`;
export type AnalyticsSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>, 'query'> & ({ variables: Types.AnalyticsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsSummaryComponent = (props: AnalyticsSummaryComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables> query={AnalyticsSummaryDocument} {...props} />
    );
    

/**
 * __useAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables> & ({ variables: Types.AnalyticsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>(AnalyticsSummaryDocument, options);
      }
export function useAnalyticsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>(AnalyticsSummaryDocument, options);
        }
export function useAnalyticsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>(AnalyticsSummaryDocument, options);
        }
export type AnalyticsSummaryQueryHookResult = ReturnType<typeof useAnalyticsSummaryQuery>;
export type AnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useAnalyticsSummaryLazyQuery>;
export type AnalyticsSummarySuspenseQueryHookResult = ReturnType<typeof useAnalyticsSummarySuspenseQuery>;
export type AnalyticsSummaryQueryResult = Apollo.QueryResult<Types.AnalyticsSummaryQuery, Types.AnalyticsSummaryQueryVariables>;
export const AnalyticsActivityScheduleDocument = gql`
    query analyticsActivitySchedule($filter: AnalyticsShareFilterInput!) {
  analyticsActivitySchedule(analyticsFilter: $filter) {
    ...Statistic
    items
  }
}
    ${StatisticFragmentDoc}`;
export type AnalyticsActivityScheduleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>, 'query'> & ({ variables: Types.AnalyticsActivityScheduleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsActivityScheduleComponent = (props: AnalyticsActivityScheduleComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables> query={AnalyticsActivityScheduleDocument} {...props} />
    );
    

/**
 * __useAnalyticsActivityScheduleQuery__
 *
 * To run a query within a React component, call `useAnalyticsActivityScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsActivityScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsActivityScheduleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsActivityScheduleQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables> & ({ variables: Types.AnalyticsActivityScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>(AnalyticsActivityScheduleDocument, options);
      }
export function useAnalyticsActivityScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>(AnalyticsActivityScheduleDocument, options);
        }
export function useAnalyticsActivityScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>(AnalyticsActivityScheduleDocument, options);
        }
export type AnalyticsActivityScheduleQueryHookResult = ReturnType<typeof useAnalyticsActivityScheduleQuery>;
export type AnalyticsActivityScheduleLazyQueryHookResult = ReturnType<typeof useAnalyticsActivityScheduleLazyQuery>;
export type AnalyticsActivityScheduleSuspenseQueryHookResult = ReturnType<typeof useAnalyticsActivityScheduleSuspenseQuery>;
export type AnalyticsActivityScheduleQueryResult = Apollo.QueryResult<Types.AnalyticsActivityScheduleQuery, Types.AnalyticsActivityScheduleQueryVariables>;
export const AnalyticsRegistrationConversionDocument = gql`
    query analyticsRegistrationConversion($filter: AnalyticsShareFilterInput!) {
  analyticsRegistrationConversion(analyticsFilter: $filter) {
    ...AnalyticsRegistrationConversion
  }
}
    ${AnalyticsRegistrationConversionFragmentDoc}`;
export type AnalyticsRegistrationConversionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>, 'query'> & ({ variables: Types.AnalyticsRegistrationConversionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsRegistrationConversionComponent = (props: AnalyticsRegistrationConversionComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables> query={AnalyticsRegistrationConversionDocument} {...props} />
    );
    

/**
 * __useAnalyticsRegistrationConversionQuery__
 *
 * To run a query within a React component, call `useAnalyticsRegistrationConversionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsRegistrationConversionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsRegistrationConversionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsRegistrationConversionQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables> & ({ variables: Types.AnalyticsRegistrationConversionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>(AnalyticsRegistrationConversionDocument, options);
      }
export function useAnalyticsRegistrationConversionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>(AnalyticsRegistrationConversionDocument, options);
        }
export function useAnalyticsRegistrationConversionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>(AnalyticsRegistrationConversionDocument, options);
        }
export type AnalyticsRegistrationConversionQueryHookResult = ReturnType<typeof useAnalyticsRegistrationConversionQuery>;
export type AnalyticsRegistrationConversionLazyQueryHookResult = ReturnType<typeof useAnalyticsRegistrationConversionLazyQuery>;
export type AnalyticsRegistrationConversionSuspenseQueryHookResult = ReturnType<typeof useAnalyticsRegistrationConversionSuspenseQuery>;
export type AnalyticsRegistrationConversionQueryResult = Apollo.QueryResult<Types.AnalyticsRegistrationConversionQuery, Types.AnalyticsRegistrationConversionQueryVariables>;
export const AnalyticsAttendanceDocument = gql`
    query analyticsAttendance($filter: AnalyticsShareFilterInput!) {
  analyticsAttendance(analyticsFilter: $filter) {
    scheduled {
      ...AnalyticsAttendanceItem
    }
    onDemand {
      ...AnalyticsAttendanceItem
    }
    justInTime {
      ...AnalyticsAttendanceItem
    }
    replay {
      ...AnalyticsAttendanceItem
    }
  }
}
    ${AnalyticsAttendanceItemFragmentDoc}`;
export type AnalyticsAttendanceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>, 'query'> & ({ variables: Types.AnalyticsAttendanceQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsAttendanceComponent = (props: AnalyticsAttendanceComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables> query={AnalyticsAttendanceDocument} {...props} />
    );
    

/**
 * __useAnalyticsAttendanceQuery__
 *
 * To run a query within a React component, call `useAnalyticsAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsAttendanceQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsAttendanceQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables> & ({ variables: Types.AnalyticsAttendanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>(AnalyticsAttendanceDocument, options);
      }
export function useAnalyticsAttendanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>(AnalyticsAttendanceDocument, options);
        }
export function useAnalyticsAttendanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>(AnalyticsAttendanceDocument, options);
        }
export type AnalyticsAttendanceQueryHookResult = ReturnType<typeof useAnalyticsAttendanceQuery>;
export type AnalyticsAttendanceLazyQueryHookResult = ReturnType<typeof useAnalyticsAttendanceLazyQuery>;
export type AnalyticsAttendanceSuspenseQueryHookResult = ReturnType<typeof useAnalyticsAttendanceSuspenseQuery>;
export type AnalyticsAttendanceQueryResult = Apollo.QueryResult<Types.AnalyticsAttendanceQuery, Types.AnalyticsAttendanceQueryVariables>;
export const AnalyticsEngagementDocument = gql`
    query analyticsEngagement($filter: AnalyticsShareFilterInput!) {
  analyticsEngagement(analyticsFilter: $filter) {
    ...AnalyticsEngagement
  }
}
    ${AnalyticsEngagementFragmentDoc}`;
export type AnalyticsEngagementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>, 'query'> & ({ variables: Types.AnalyticsEngagementQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsEngagementComponent = (props: AnalyticsEngagementComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables> query={AnalyticsEngagementDocument} {...props} />
    );
    

/**
 * __useAnalyticsEngagementQuery__
 *
 * To run a query within a React component, call `useAnalyticsEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsEngagementQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsEngagementQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables> & ({ variables: Types.AnalyticsEngagementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>(AnalyticsEngagementDocument, options);
      }
export function useAnalyticsEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>(AnalyticsEngagementDocument, options);
        }
export function useAnalyticsEngagementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>(AnalyticsEngagementDocument, options);
        }
export type AnalyticsEngagementQueryHookResult = ReturnType<typeof useAnalyticsEngagementQuery>;
export type AnalyticsEngagementLazyQueryHookResult = ReturnType<typeof useAnalyticsEngagementLazyQuery>;
export type AnalyticsEngagementSuspenseQueryHookResult = ReturnType<typeof useAnalyticsEngagementSuspenseQuery>;
export type AnalyticsEngagementQueryResult = Apollo.QueryResult<Types.AnalyticsEngagementQuery, Types.AnalyticsEngagementQueryVariables>;
export const AnalyticsEngagementSummaryDocument = gql`
    query analyticsEngagementSummary($filter: AnalyticsShareFilterInput!) {
  analyticsEngagementSummary(analyticsFilter: $filter) {
    ...AnalyticsEngagementSummary
  }
}
    ${AnalyticsEngagementSummaryFragmentDoc}`;
export type AnalyticsEngagementSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>, 'query'> & ({ variables: Types.AnalyticsEngagementSummaryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsEngagementSummaryComponent = (props: AnalyticsEngagementSummaryComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables> query={AnalyticsEngagementSummaryDocument} {...props} />
    );
    

/**
 * __useAnalyticsEngagementSummaryQuery__
 *
 * To run a query within a React component, call `useAnalyticsEngagementSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsEngagementSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsEngagementSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsEngagementSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables> & ({ variables: Types.AnalyticsEngagementSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>(AnalyticsEngagementSummaryDocument, options);
      }
export function useAnalyticsEngagementSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>(AnalyticsEngagementSummaryDocument, options);
        }
export function useAnalyticsEngagementSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>(AnalyticsEngagementSummaryDocument, options);
        }
export type AnalyticsEngagementSummaryQueryHookResult = ReturnType<typeof useAnalyticsEngagementSummaryQuery>;
export type AnalyticsEngagementSummaryLazyQueryHookResult = ReturnType<typeof useAnalyticsEngagementSummaryLazyQuery>;
export type AnalyticsEngagementSummarySuspenseQueryHookResult = ReturnType<typeof useAnalyticsEngagementSummarySuspenseQuery>;
export type AnalyticsEngagementSummaryQueryResult = Apollo.QueryResult<Types.AnalyticsEngagementSummaryQuery, Types.AnalyticsEngagementSummaryQueryVariables>;
export const AnalyticsInteractionsDocument = gql`
    query analyticsInteractions($filter: AnalyticsShareFilterInput!) {
  analyticsInteractions(analyticsFilter: $filter) {
    ...AnalyticsInteractions
  }
}
    ${AnalyticsInteractionsFragmentDoc}`;
export type AnalyticsInteractionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>, 'query'> & ({ variables: Types.AnalyticsInteractionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsInteractionsComponent = (props: AnalyticsInteractionsComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables> query={AnalyticsInteractionsDocument} {...props} />
    );
    

/**
 * __useAnalyticsInteractionsQuery__
 *
 * To run a query within a React component, call `useAnalyticsInteractionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsInteractionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsInteractionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsInteractionsQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables> & ({ variables: Types.AnalyticsInteractionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>(AnalyticsInteractionsDocument, options);
      }
export function useAnalyticsInteractionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>(AnalyticsInteractionsDocument, options);
        }
export function useAnalyticsInteractionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>(AnalyticsInteractionsDocument, options);
        }
export type AnalyticsInteractionsQueryHookResult = ReturnType<typeof useAnalyticsInteractionsQuery>;
export type AnalyticsInteractionsLazyQueryHookResult = ReturnType<typeof useAnalyticsInteractionsLazyQuery>;
export type AnalyticsInteractionsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsInteractionsSuspenseQuery>;
export type AnalyticsInteractionsQueryResult = Apollo.QueryResult<Types.AnalyticsInteractionsQuery, Types.AnalyticsInteractionsQueryVariables>;
export const AnalyticsInteractionsResultDocument = gql`
    query analyticsInteractionsResult($filter: AnalyticsShareFilterInput!) {
  analyticsInteractionsResult(analyticsFilter: $filter) {
    ...InteractionWithAnalytics
  }
}
    ${InteractionWithAnalyticsFragmentDoc}`;
export type AnalyticsInteractionsResultComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>, 'query'> & ({ variables: Types.AnalyticsInteractionsResultQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnalyticsInteractionsResultComponent = (props: AnalyticsInteractionsResultComponentProps) => (
      <ApolloReactComponents.Query<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables> query={AnalyticsInteractionsResultDocument} {...props} />
    );
    

/**
 * __useAnalyticsInteractionsResultQuery__
 *
 * To run a query within a React component, call `useAnalyticsInteractionsResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsInteractionsResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsInteractionsResultQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAnalyticsInteractionsResultQuery(baseOptions: Apollo.QueryHookOptions<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables> & ({ variables: Types.AnalyticsInteractionsResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>(AnalyticsInteractionsResultDocument, options);
      }
export function useAnalyticsInteractionsResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>(AnalyticsInteractionsResultDocument, options);
        }
export function useAnalyticsInteractionsResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>(AnalyticsInteractionsResultDocument, options);
        }
export type AnalyticsInteractionsResultQueryHookResult = ReturnType<typeof useAnalyticsInteractionsResultQuery>;
export type AnalyticsInteractionsResultLazyQueryHookResult = ReturnType<typeof useAnalyticsInteractionsResultLazyQuery>;
export type AnalyticsInteractionsResultSuspenseQueryHookResult = ReturnType<typeof useAnalyticsInteractionsResultSuspenseQuery>;
export type AnalyticsInteractionsResultQueryResult = Apollo.QueryResult<Types.AnalyticsInteractionsResultQuery, Types.AnalyticsInteractionsResultQueryVariables>;
export const GenerateSharableUrlDocument = gql`
    mutation generateSharableUrl($config: AnalyticsShareConfigInput!) {
  generateSharableUrl(config: $config)
}
    `;
export type GenerateSharableUrlMutationFn = Apollo.MutationFunction<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables>;
export type GenerateSharableUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables>, 'mutation'>;

    export const GenerateSharableUrlComponent = (props: GenerateSharableUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables> mutation={GenerateSharableUrlDocument} {...props} />
    );
    

/**
 * __useGenerateSharableUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSharableUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSharableUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSharableUrlMutation, { data, loading, error }] = useGenerateSharableUrlMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useGenerateSharableUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables>(GenerateSharableUrlDocument, options);
      }
export type GenerateSharableUrlMutationHookResult = ReturnType<typeof useGenerateSharableUrlMutation>;
export type GenerateSharableUrlMutationResult = Apollo.MutationResult<Types.GenerateSharableUrlMutation>;
export type GenerateSharableUrlMutationOptions = Apollo.BaseMutationOptions<Types.GenerateSharableUrlMutation, Types.GenerateSharableUrlMutationVariables>;
export const DisableOldShareUrlDocument = gql`
    mutation disableOldShareUrl($setId: String!) {
  disableOldShareUrl(setId: $setId) {
    id
  }
}
    `;
export type DisableOldShareUrlMutationFn = Apollo.MutationFunction<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables>;
export type DisableOldShareUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables>, 'mutation'>;

    export const DisableOldShareUrlComponent = (props: DisableOldShareUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables> mutation={DisableOldShareUrlDocument} {...props} />
    );
    

/**
 * __useDisableOldShareUrlMutation__
 *
 * To run a mutation, you first call `useDisableOldShareUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableOldShareUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableOldShareUrlMutation, { data, loading, error }] = useDisableOldShareUrlMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useDisableOldShareUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables>(DisableOldShareUrlDocument, options);
      }
export type DisableOldShareUrlMutationHookResult = ReturnType<typeof useDisableOldShareUrlMutation>;
export type DisableOldShareUrlMutationResult = Apollo.MutationResult<Types.DisableOldShareUrlMutation>;
export type DisableOldShareUrlMutationOptions = Apollo.BaseMutationOptions<Types.DisableOldShareUrlMutation, Types.DisableOldShareUrlMutationVariables>;
export const GetAnalyticsPageDataDocument = gql`
    query getAnalyticsPageData($token: String, $setId: String, $filter: AnalyticsShareFilterInput) {
  getAnalyticsPageData(token: $token, setId: $setId, filter: $filter) {
    ...AnalyticsPageData
  }
}
    ${AnalyticsPageDataFragmentDoc}`;
export type GetAnalyticsPageDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>, 'query'>;

    export const GetAnalyticsPageDataComponent = (props: GetAnalyticsPageDataComponentProps) => (
      <ApolloReactComponents.Query<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables> query={GetAnalyticsPageDataDocument} {...props} />
    );
    

/**
 * __useGetAnalyticsPageDataQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsPageDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *      setId: // value for 'setId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAnalyticsPageDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>(GetAnalyticsPageDataDocument, options);
      }
export function useGetAnalyticsPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>(GetAnalyticsPageDataDocument, options);
        }
export function useGetAnalyticsPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>(GetAnalyticsPageDataDocument, options);
        }
export type GetAnalyticsPageDataQueryHookResult = ReturnType<typeof useGetAnalyticsPageDataQuery>;
export type GetAnalyticsPageDataLazyQueryHookResult = ReturnType<typeof useGetAnalyticsPageDataLazyQuery>;
export type GetAnalyticsPageDataSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsPageDataSuspenseQuery>;
export type GetAnalyticsPageDataQueryResult = Apollo.QueryResult<Types.GetAnalyticsPageDataQuery, Types.GetAnalyticsPageDataQueryVariables>;
export const GetParticipantAnalyticsPageDataDocument = gql`
    query getParticipantAnalyticsPageData($token: String, $filter: ParticipantAnalyticsShareFilterInput) {
  getParticipantAnalyticsPageData(token: $token, filter: $filter) {
    ...ParticipantAnalyticsPageData
  }
}
    ${ParticipantAnalyticsPageDataFragmentDoc}`;
export type GetParticipantAnalyticsPageDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>, 'query'>;

    export const GetParticipantAnalyticsPageDataComponent = (props: GetParticipantAnalyticsPageDataComponentProps) => (
      <ApolloReactComponents.Query<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables> query={GetParticipantAnalyticsPageDataDocument} {...props} />
    );
    

/**
 * __useGetParticipantAnalyticsPageDataQuery__
 *
 * To run a query within a React component, call `useGetParticipantAnalyticsPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantAnalyticsPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantAnalyticsPageDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetParticipantAnalyticsPageDataQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>(GetParticipantAnalyticsPageDataDocument, options);
      }
export function useGetParticipantAnalyticsPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>(GetParticipantAnalyticsPageDataDocument, options);
        }
export function useGetParticipantAnalyticsPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>(GetParticipantAnalyticsPageDataDocument, options);
        }
export type GetParticipantAnalyticsPageDataQueryHookResult = ReturnType<typeof useGetParticipantAnalyticsPageDataQuery>;
export type GetParticipantAnalyticsPageDataLazyQueryHookResult = ReturnType<typeof useGetParticipantAnalyticsPageDataLazyQuery>;
export type GetParticipantAnalyticsPageDataSuspenseQueryHookResult = ReturnType<typeof useGetParticipantAnalyticsPageDataSuspenseQuery>;
export type GetParticipantAnalyticsPageDataQueryResult = Apollo.QueryResult<Types.GetParticipantAnalyticsPageDataQuery, Types.GetParticipantAnalyticsPageDataQueryVariables>;
export const GenerateSharableUrlOfParticipantDocument = gql`
    mutation generateSharableUrlOfParticipant($config: ParticipantAnalyticsShareConfigInput!) {
  generateSharableUrlOfParticipant(config: $config)
}
    `;
export type GenerateSharableUrlOfParticipantMutationFn = Apollo.MutationFunction<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables>;
export type GenerateSharableUrlOfParticipantComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables>, 'mutation'>;

    export const GenerateSharableUrlOfParticipantComponent = (props: GenerateSharableUrlOfParticipantComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables> mutation={GenerateSharableUrlOfParticipantDocument} {...props} />
    );
    

/**
 * __useGenerateSharableUrlOfParticipantMutation__
 *
 * To run a mutation, you first call `useGenerateSharableUrlOfParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSharableUrlOfParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSharableUrlOfParticipantMutation, { data, loading, error }] = useGenerateSharableUrlOfParticipantMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useGenerateSharableUrlOfParticipantMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables>(GenerateSharableUrlOfParticipantDocument, options);
      }
export type GenerateSharableUrlOfParticipantMutationHookResult = ReturnType<typeof useGenerateSharableUrlOfParticipantMutation>;
export type GenerateSharableUrlOfParticipantMutationResult = Apollo.MutationResult<Types.GenerateSharableUrlOfParticipantMutation>;
export type GenerateSharableUrlOfParticipantMutationOptions = Apollo.BaseMutationOptions<Types.GenerateSharableUrlOfParticipantMutation, Types.GenerateSharableUrlOfParticipantMutationVariables>;
export const UniversalAnalyticsSummaryDocument = gql`
    query universalAnalyticsSummary($filter: ParticipantAnalyticsShareFilterInput!) {
  universalAnalyticsSummary(filter: $filter) {
    ...UniversalAnalyticsSummary
  }
}
    ${UniversalAnalyticsSummaryFragmentDoc}`;
export type UniversalAnalyticsSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>, 'query'> & ({ variables: Types.UniversalAnalyticsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const UniversalAnalyticsSummaryComponent = (props: UniversalAnalyticsSummaryComponentProps) => (
      <ApolloReactComponents.Query<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables> query={UniversalAnalyticsSummaryDocument} {...props} />
    );
    

/**
 * __useUniversalAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useUniversalAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalAnalyticsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUniversalAnalyticsSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables> & ({ variables: Types.UniversalAnalyticsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>(UniversalAnalyticsSummaryDocument, options);
      }
export function useUniversalAnalyticsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>(UniversalAnalyticsSummaryDocument, options);
        }
export function useUniversalAnalyticsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>(UniversalAnalyticsSummaryDocument, options);
        }
export type UniversalAnalyticsSummaryQueryHookResult = ReturnType<typeof useUniversalAnalyticsSummaryQuery>;
export type UniversalAnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useUniversalAnalyticsSummaryLazyQuery>;
export type UniversalAnalyticsSummarySuspenseQueryHookResult = ReturnType<typeof useUniversalAnalyticsSummarySuspenseQuery>;
export type UniversalAnalyticsSummaryQueryResult = Apollo.QueryResult<Types.UniversalAnalyticsSummaryQuery, Types.UniversalAnalyticsSummaryQueryVariables>;
export const ExtractAssetColorsDocument = gql`
    query extractAssetColors($src: String!) {
  extractAssetColors(src: $src) {
    id
    colors
  }
}
    `;
export type ExtractAssetColorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>, 'query'> & ({ variables: Types.ExtractAssetColorsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExtractAssetColorsComponent = (props: ExtractAssetColorsComponentProps) => (
      <ApolloReactComponents.Query<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables> query={ExtractAssetColorsDocument} {...props} />
    );
    

/**
 * __useExtractAssetColorsQuery__
 *
 * To run a query within a React component, call `useExtractAssetColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtractAssetColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtractAssetColorsQuery({
 *   variables: {
 *      src: // value for 'src'
 *   },
 * });
 */
export function useExtractAssetColorsQuery(baseOptions: Apollo.QueryHookOptions<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables> & ({ variables: Types.ExtractAssetColorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>(ExtractAssetColorsDocument, options);
      }
export function useExtractAssetColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>(ExtractAssetColorsDocument, options);
        }
export function useExtractAssetColorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>(ExtractAssetColorsDocument, options);
        }
export type ExtractAssetColorsQueryHookResult = ReturnType<typeof useExtractAssetColorsQuery>;
export type ExtractAssetColorsLazyQueryHookResult = ReturnType<typeof useExtractAssetColorsLazyQuery>;
export type ExtractAssetColorsSuspenseQueryHookResult = ReturnType<typeof useExtractAssetColorsSuspenseQuery>;
export type ExtractAssetColorsQueryResult = Apollo.QueryResult<Types.ExtractAssetColorsQuery, Types.ExtractAssetColorsQueryVariables>;
export const CreateUploadUrlDocument = gql`
    mutation createUploadUrl($data: UploadAssetInput!) {
  createAssetUploadUrl(data: $data) {
    url
    uploadUrl
  }
}
    `;
export type CreateUploadUrlMutationFn = Apollo.MutationFunction<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables>;
export type CreateUploadUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables>, 'mutation'>;

    export const CreateUploadUrlComponent = (props: CreateUploadUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables> mutation={CreateUploadUrlDocument} {...props} />
    );
    

/**
 * __useCreateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadUrlMutation, { data, loading, error }] = useCreateUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables>(CreateUploadUrlDocument, options);
      }
export type CreateUploadUrlMutationHookResult = ReturnType<typeof useCreateUploadUrlMutation>;
export type CreateUploadUrlMutationResult = Apollo.MutationResult<Types.CreateUploadUrlMutation>;
export type CreateUploadUrlMutationOptions = Apollo.BaseMutationOptions<Types.CreateUploadUrlMutation, Types.CreateUploadUrlMutationVariables>;
export const GetMediaRefFromUrlDocument = gql`
    mutation getMediaRefFromURL($url: String!) {
  getMediaRefFromURL(url: $url) {
    ...MediaRef
  }
}
    ${MediaRefFragmentDoc}`;
export type GetMediaRefFromUrlMutationFn = Apollo.MutationFunction<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables>;
export type GetMediaRefFromUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables>, 'mutation'>;

    export const GetMediaRefFromUrlComponent = (props: GetMediaRefFromUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables> mutation={GetMediaRefFromUrlDocument} {...props} />
    );
    

/**
 * __useGetMediaRefFromUrlMutation__
 *
 * To run a mutation, you first call `useGetMediaRefFromUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMediaRefFromUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMediaRefFromUrlMutation, { data, loading, error }] = useGetMediaRefFromUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetMediaRefFromUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables>(GetMediaRefFromUrlDocument, options);
      }
export type GetMediaRefFromUrlMutationHookResult = ReturnType<typeof useGetMediaRefFromUrlMutation>;
export type GetMediaRefFromUrlMutationResult = Apollo.MutationResult<Types.GetMediaRefFromUrlMutation>;
export type GetMediaRefFromUrlMutationOptions = Apollo.BaseMutationOptions<Types.GetMediaRefFromUrlMutation, Types.GetMediaRefFromUrlMutationVariables>;
export const UploadDraftMediaDocument = gql`
    mutation uploadDraftMedia($data: MetaMediaInput!) {
  uploadDraftMedia(data: $data) {
    ...MediaRef
  }
}
    ${MediaRefFragmentDoc}`;
export type UploadDraftMediaMutationFn = Apollo.MutationFunction<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables>;
export type UploadDraftMediaComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables>, 'mutation'>;

    export const UploadDraftMediaComponent = (props: UploadDraftMediaComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables> mutation={UploadDraftMediaDocument} {...props} />
    );
    

/**
 * __useUploadDraftMediaMutation__
 *
 * To run a mutation, you first call `useUploadDraftMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDraftMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDraftMediaMutation, { data, loading, error }] = useUploadDraftMediaMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadDraftMediaMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables>(UploadDraftMediaDocument, options);
      }
export type UploadDraftMediaMutationHookResult = ReturnType<typeof useUploadDraftMediaMutation>;
export type UploadDraftMediaMutationResult = Apollo.MutationResult<Types.UploadDraftMediaMutation>;
export type UploadDraftMediaMutationOptions = Apollo.BaseMutationOptions<Types.UploadDraftMediaMutation, Types.UploadDraftMediaMutationVariables>;
export const UploadMediaRefDocument = gql`
    mutation uploadMediaRef($data: MetaMediaInput!) {
  uploadMediaRef(data: $data) {
    ...MediaRef
  }
}
    ${MediaRefFragmentDoc}`;
export type UploadMediaRefMutationFn = Apollo.MutationFunction<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables>;
export type UploadMediaRefComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables>, 'mutation'>;

    export const UploadMediaRefComponent = (props: UploadMediaRefComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables> mutation={UploadMediaRefDocument} {...props} />
    );
    

/**
 * __useUploadMediaRefMutation__
 *
 * To run a mutation, you first call `useUploadMediaRefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaRefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaRefMutation, { data, loading, error }] = useUploadMediaRefMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadMediaRefMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables>(UploadMediaRefDocument, options);
      }
export type UploadMediaRefMutationHookResult = ReturnType<typeof useUploadMediaRefMutation>;
export type UploadMediaRefMutationResult = Apollo.MutationResult<Types.UploadMediaRefMutation>;
export type UploadMediaRefMutationOptions = Apollo.BaseMutationOptions<Types.UploadMediaRefMutation, Types.UploadMediaRefMutationVariables>;
export const AttendeeRecordDocument = gql`
    query attendeeRecord($id: String!) {
  attendeeRecord(id: $id)
}
    `;
export type AttendeeRecordComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>, 'query'> & ({ variables: Types.AttendeeRecordQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AttendeeRecordComponent = (props: AttendeeRecordComponentProps) => (
      <ApolloReactComponents.Query<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables> query={AttendeeRecordDocument} {...props} />
    );
    

/**
 * __useAttendeeRecordQuery__
 *
 * To run a query within a React component, call `useAttendeeRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendeeRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendeeRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttendeeRecordQuery(baseOptions: Apollo.QueryHookOptions<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables> & ({ variables: Types.AttendeeRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>(AttendeeRecordDocument, options);
      }
export function useAttendeeRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>(AttendeeRecordDocument, options);
        }
export function useAttendeeRecordSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>(AttendeeRecordDocument, options);
        }
export type AttendeeRecordQueryHookResult = ReturnType<typeof useAttendeeRecordQuery>;
export type AttendeeRecordLazyQueryHookResult = ReturnType<typeof useAttendeeRecordLazyQuery>;
export type AttendeeRecordSuspenseQueryHookResult = ReturnType<typeof useAttendeeRecordSuspenseQuery>;
export type AttendeeRecordQueryResult = Apollo.QueryResult<Types.AttendeeRecordQuery, Types.AttendeeRecordQueryVariables>;
export const GetAttendeeDocument = gql`
    query getAttendee($id: String!, $setId: String!) {
  attendee(id: $id, setId: $setId) {
    ...AttendeeWithProperties
  }
}
    ${AttendeeWithPropertiesFragmentDoc}`;
export type GetAttendeeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>, 'query'> & ({ variables: Types.GetAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAttendeeComponent = (props: GetAttendeeComponentProps) => (
      <ApolloReactComponents.Query<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables> query={GetAttendeeDocument} {...props} />
    );
    

/**
 * __useGetAttendeeQuery__
 *
 * To run a query within a React component, call `useGetAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useGetAttendeeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables> & ({ variables: Types.GetAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>(GetAttendeeDocument, options);
      }
export function useGetAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>(GetAttendeeDocument, options);
        }
export function useGetAttendeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>(GetAttendeeDocument, options);
        }
export type GetAttendeeQueryHookResult = ReturnType<typeof useGetAttendeeQuery>;
export type GetAttendeeLazyQueryHookResult = ReturnType<typeof useGetAttendeeLazyQuery>;
export type GetAttendeeSuspenseQueryHookResult = ReturnType<typeof useGetAttendeeSuspenseQuery>;
export type GetAttendeeQueryResult = Apollo.QueryResult<Types.GetAttendeeQuery, Types.GetAttendeeQueryVariables>;
export const GuessCountryDocument = gql`
    query guessCountry {
  guessCountry
}
    `;
export type GuessCountryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>, 'query'>;

    export const GuessCountryComponent = (props: GuessCountryComponentProps) => (
      <ApolloReactComponents.Query<Types.GuessCountryQuery, Types.GuessCountryQueryVariables> query={GuessCountryDocument} {...props} />
    );
    

/**
 * __useGuessCountryQuery__
 *
 * To run a query within a React component, call `useGuessCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuessCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuessCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuessCountryQuery(baseOptions?: Apollo.QueryHookOptions<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>(GuessCountryDocument, options);
      }
export function useGuessCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>(GuessCountryDocument, options);
        }
export function useGuessCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>(GuessCountryDocument, options);
        }
export type GuessCountryQueryHookResult = ReturnType<typeof useGuessCountryQuery>;
export type GuessCountryLazyQueryHookResult = ReturnType<typeof useGuessCountryLazyQuery>;
export type GuessCountrySuspenseQueryHookResult = ReturnType<typeof useGuessCountrySuspenseQuery>;
export type GuessCountryQueryResult = Apollo.QueryResult<Types.GuessCountryQuery, Types.GuessCountryQueryVariables>;
export const FakeConversionNotificationsDocument = gql`
    query fakeConversionNotifications($setId: String!, $interactionId: String) {
  fakeConversionNotifications(setId: $setId, interactionId: $interactionId) {
    ...ConversionNotification
  }
}
    ${ConversionNotificationFragmentDoc}`;
export type FakeConversionNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>, 'query'> & ({ variables: Types.FakeConversionNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FakeConversionNotificationsComponent = (props: FakeConversionNotificationsComponentProps) => (
      <ApolloReactComponents.Query<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables> query={FakeConversionNotificationsDocument} {...props} />
    );
    

/**
 * __useFakeConversionNotificationsQuery__
 *
 * To run a query within a React component, call `useFakeConversionNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFakeConversionNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFakeConversionNotificationsQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *      interactionId: // value for 'interactionId'
 *   },
 * });
 */
export function useFakeConversionNotificationsQuery(baseOptions: Apollo.QueryHookOptions<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables> & ({ variables: Types.FakeConversionNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>(FakeConversionNotificationsDocument, options);
      }
export function useFakeConversionNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>(FakeConversionNotificationsDocument, options);
        }
export function useFakeConversionNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>(FakeConversionNotificationsDocument, options);
        }
export type FakeConversionNotificationsQueryHookResult = ReturnType<typeof useFakeConversionNotificationsQuery>;
export type FakeConversionNotificationsLazyQueryHookResult = ReturnType<typeof useFakeConversionNotificationsLazyQuery>;
export type FakeConversionNotificationsSuspenseQueryHookResult = ReturnType<typeof useFakeConversionNotificationsSuspenseQuery>;
export type FakeConversionNotificationsQueryResult = Apollo.QueryResult<Types.FakeConversionNotificationsQuery, Types.FakeConversionNotificationsQueryVariables>;
export const ConversionNotificationsDocument = gql`
    query conversionNotifications($interactionId: String!) {
  conversionNotifications(interactionId: $interactionId) {
    ...ConversionNotification
  }
}
    ${ConversionNotificationFragmentDoc}`;
export type ConversionNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>, 'query'> & ({ variables: Types.ConversionNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversionNotificationsComponent = (props: ConversionNotificationsComponentProps) => (
      <ApolloReactComponents.Query<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables> query={ConversionNotificationsDocument} {...props} />
    );
    

/**
 * __useConversionNotificationsQuery__
 *
 * To run a query within a React component, call `useConversionNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversionNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversionNotificationsQuery({
 *   variables: {
 *      interactionId: // value for 'interactionId'
 *   },
 * });
 */
export function useConversionNotificationsQuery(baseOptions: Apollo.QueryHookOptions<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables> & ({ variables: Types.ConversionNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>(ConversionNotificationsDocument, options);
      }
export function useConversionNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>(ConversionNotificationsDocument, options);
        }
export function useConversionNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>(ConversionNotificationsDocument, options);
        }
export type ConversionNotificationsQueryHookResult = ReturnType<typeof useConversionNotificationsQuery>;
export type ConversionNotificationsLazyQueryHookResult = ReturnType<typeof useConversionNotificationsLazyQuery>;
export type ConversionNotificationsSuspenseQueryHookResult = ReturnType<typeof useConversionNotificationsSuspenseQuery>;
export type ConversionNotificationsQueryResult = Apollo.QueryResult<Types.ConversionNotificationsQuery, Types.ConversionNotificationsQueryVariables>;
export const RegisterAttendeeDocument = gql`
    mutation registerAttendee($data: RegisterAttendeeInput!, $forTesting: Boolean) {
  registerAttendee(data: $data, forTesting: $forTesting) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type RegisterAttendeeMutationFn = Apollo.MutationFunction<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables>;
export type RegisterAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables>, 'mutation'>;

    export const RegisterAttendeeComponent = (props: RegisterAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables> mutation={RegisterAttendeeDocument} {...props} />
    );
    

/**
 * __useRegisterAttendeeMutation__
 *
 * To run a mutation, you first call `useRegisterAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAttendeeMutation, { data, loading, error }] = useRegisterAttendeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      forTesting: // value for 'forTesting'
 *   },
 * });
 */
export function useRegisterAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables>(RegisterAttendeeDocument, options);
      }
export type RegisterAttendeeMutationHookResult = ReturnType<typeof useRegisterAttendeeMutation>;
export type RegisterAttendeeMutationResult = Apollo.MutationResult<Types.RegisterAttendeeMutation>;
export type RegisterAttendeeMutationOptions = Apollo.BaseMutationOptions<Types.RegisterAttendeeMutation, Types.RegisterAttendeeMutationVariables>;
export const UpdateUngatedAttendeeDocument = gql`
    mutation updateUngatedAttendee($data: UpdateUngatedAttendeeInput!) {
  updateUngatedAttendee(data: $data) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type UpdateUngatedAttendeeMutationFn = Apollo.MutationFunction<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables>;
export type UpdateUngatedAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables>, 'mutation'>;

    export const UpdateUngatedAttendeeComponent = (props: UpdateUngatedAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables> mutation={UpdateUngatedAttendeeDocument} {...props} />
    );
    

/**
 * __useUpdateUngatedAttendeeMutation__
 *
 * To run a mutation, you first call `useUpdateUngatedAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUngatedAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUngatedAttendeeMutation, { data, loading, error }] = useUpdateUngatedAttendeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUngatedAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables>(UpdateUngatedAttendeeDocument, options);
      }
export type UpdateUngatedAttendeeMutationHookResult = ReturnType<typeof useUpdateUngatedAttendeeMutation>;
export type UpdateUngatedAttendeeMutationResult = Apollo.MutationResult<Types.UpdateUngatedAttendeeMutation>;
export type UpdateUngatedAttendeeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUngatedAttendeeMutation, Types.UpdateUngatedAttendeeMutationVariables>;
export const GetTestAttendeeDocument = gql`
    query getTestAttendee($setId: String!) {
  getTestAttendee(setId: $setId) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type GetTestAttendeeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>, 'query'> & ({ variables: Types.GetTestAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTestAttendeeComponent = (props: GetTestAttendeeComponentProps) => (
      <ApolloReactComponents.Query<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables> query={GetTestAttendeeDocument} {...props} />
    );
    

/**
 * __useGetTestAttendeeQuery__
 *
 * To run a query within a React component, call `useGetTestAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestAttendeeQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useGetTestAttendeeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables> & ({ variables: Types.GetTestAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>(GetTestAttendeeDocument, options);
      }
export function useGetTestAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>(GetTestAttendeeDocument, options);
        }
export function useGetTestAttendeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>(GetTestAttendeeDocument, options);
        }
export type GetTestAttendeeQueryHookResult = ReturnType<typeof useGetTestAttendeeQuery>;
export type GetTestAttendeeLazyQueryHookResult = ReturnType<typeof useGetTestAttendeeLazyQuery>;
export type GetTestAttendeeSuspenseQueryHookResult = ReturnType<typeof useGetTestAttendeeSuspenseQuery>;
export type GetTestAttendeeQueryResult = Apollo.QueryResult<Types.GetTestAttendeeQuery, Types.GetTestAttendeeQueryVariables>;
export const PlaybackEventDocument = gql`
    mutation playbackEvent($id: String!, $connectionId: String!, $forReplay: Boolean!, $events: [PlaybackEventInput!]!) {
  playbackEvent(
    id: $id
    connectionId: $connectionId
    forReplay: $forReplay
    events: $events
  ) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type PlaybackEventMutationFn = Apollo.MutationFunction<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables>;
export type PlaybackEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables>, 'mutation'>;

    export const PlaybackEventComponent = (props: PlaybackEventComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables> mutation={PlaybackEventDocument} {...props} />
    );
    

/**
 * __usePlaybackEventMutation__
 *
 * To run a mutation, you first call `usePlaybackEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaybackEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playbackEventMutation, { data, loading, error }] = usePlaybackEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      connectionId: // value for 'connectionId'
 *      forReplay: // value for 'forReplay'
 *      events: // value for 'events'
 *   },
 * });
 */
export function usePlaybackEventMutation(baseOptions?: Apollo.MutationHookOptions<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables>(PlaybackEventDocument, options);
      }
export type PlaybackEventMutationHookResult = ReturnType<typeof usePlaybackEventMutation>;
export type PlaybackEventMutationResult = Apollo.MutationResult<Types.PlaybackEventMutation>;
export type PlaybackEventMutationOptions = Apollo.BaseMutationOptions<Types.PlaybackEventMutation, Types.PlaybackEventMutationVariables>;
export const RegisterAttendeeToWebinarDocument = gql`
    mutation registerAttendeeToWebinar($data: RegisterAttendeeToWebinarInput!) {
  registerAttendeeToWebinar(data: $data) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type RegisterAttendeeToWebinarMutationFn = Apollo.MutationFunction<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables>;
export type RegisterAttendeeToWebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables>, 'mutation'>;

    export const RegisterAttendeeToWebinarComponent = (props: RegisterAttendeeToWebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables> mutation={RegisterAttendeeToWebinarDocument} {...props} />
    );
    

/**
 * __useRegisterAttendeeToWebinarMutation__
 *
 * To run a mutation, you first call `useRegisterAttendeeToWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAttendeeToWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAttendeeToWebinarMutation, { data, loading, error }] = useRegisterAttendeeToWebinarMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRegisterAttendeeToWebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables>(RegisterAttendeeToWebinarDocument, options);
      }
export type RegisterAttendeeToWebinarMutationHookResult = ReturnType<typeof useRegisterAttendeeToWebinarMutation>;
export type RegisterAttendeeToWebinarMutationResult = Apollo.MutationResult<Types.RegisterAttendeeToWebinarMutation>;
export type RegisterAttendeeToWebinarMutationOptions = Apollo.BaseMutationOptions<Types.RegisterAttendeeToWebinarMutation, Types.RegisterAttendeeToWebinarMutationVariables>;
export const CreateAttendeesTestDocument = gql`
    mutation createAttendeesTest($data: RegisterAttendeeTestInput!, $numberAttendee: Float!) {
  createAttendeesTest(data: $data, numberAttendee: $numberAttendee) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type CreateAttendeesTestMutationFn = Apollo.MutationFunction<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables>;
export type CreateAttendeesTestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables>, 'mutation'>;

    export const CreateAttendeesTestComponent = (props: CreateAttendeesTestComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables> mutation={CreateAttendeesTestDocument} {...props} />
    );
    

/**
 * __useCreateAttendeesTestMutation__
 *
 * To run a mutation, you first call `useCreateAttendeesTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendeesTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendeesTestMutation, { data, loading, error }] = useCreateAttendeesTestMutation({
 *   variables: {
 *      data: // value for 'data'
 *      numberAttendee: // value for 'numberAttendee'
 *   },
 * });
 */
export function useCreateAttendeesTestMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables>(CreateAttendeesTestDocument, options);
      }
export type CreateAttendeesTestMutationHookResult = ReturnType<typeof useCreateAttendeesTestMutation>;
export type CreateAttendeesTestMutationResult = Apollo.MutationResult<Types.CreateAttendeesTestMutation>;
export type CreateAttendeesTestMutationOptions = Apollo.BaseMutationOptions<Types.CreateAttendeesTestMutation, Types.CreateAttendeesTestMutationVariables>;
export const UpdateStartTimeDocument = gql`
    mutation updateStartTime($id: String!, $startFresh: Boolean, $startTime: DateTime!, $sessionType: SessionType) {
  updateStartTime(
    id: $id
    startFresh: $startFresh
    startTime: $startTime
    sessionType: $sessionType
  ) {
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type UpdateStartTimeMutationFn = Apollo.MutationFunction<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables>;
export type UpdateStartTimeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables>, 'mutation'>;

    export const UpdateStartTimeComponent = (props: UpdateStartTimeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables> mutation={UpdateStartTimeDocument} {...props} />
    );
    

/**
 * __useUpdateStartTimeMutation__
 *
 * To run a mutation, you first call `useUpdateStartTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStartTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStartTimeMutation, { data, loading, error }] = useUpdateStartTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startFresh: // value for 'startFresh'
 *      startTime: // value for 'startTime'
 *      sessionType: // value for 'sessionType'
 *   },
 * });
 */
export function useUpdateStartTimeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables>(UpdateStartTimeDocument, options);
      }
export type UpdateStartTimeMutationHookResult = ReturnType<typeof useUpdateStartTimeMutation>;
export type UpdateStartTimeMutationResult = Apollo.MutationResult<Types.UpdateStartTimeMutation>;
export type UpdateStartTimeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateStartTimeMutation, Types.UpdateStartTimeMutationVariables>;
export const MarkAsConvertedDocument = gql`
    mutation markAsConverted($attendees: AttendeeListInput!, $purchase: PurchaseOrderInput!) {
  markAsConverted(attendees: $attendees, purchase: $purchase) {
    id
    purchaseAmount
    lastPurchaseDate
    purchaseCurrency
  }
}
    `;
export type MarkAsConvertedMutationFn = Apollo.MutationFunction<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables>;
export type MarkAsConvertedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables>, 'mutation'>;

    export const MarkAsConvertedComponent = (props: MarkAsConvertedComponentProps) => (
      <ApolloReactComponents.Mutation<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables> mutation={MarkAsConvertedDocument} {...props} />
    );
    

/**
 * __useMarkAsConvertedMutation__
 *
 * To run a mutation, you first call `useMarkAsConvertedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsConvertedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsConvertedMutation, { data, loading, error }] = useMarkAsConvertedMutation({
 *   variables: {
 *      attendees: // value for 'attendees'
 *      purchase: // value for 'purchase'
 *   },
 * });
 */
export function useMarkAsConvertedMutation(baseOptions?: Apollo.MutationHookOptions<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables>(MarkAsConvertedDocument, options);
      }
export type MarkAsConvertedMutationHookResult = ReturnType<typeof useMarkAsConvertedMutation>;
export type MarkAsConvertedMutationResult = Apollo.MutationResult<Types.MarkAsConvertedMutation>;
export type MarkAsConvertedMutationOptions = Apollo.BaseMutationOptions<Types.MarkAsConvertedMutation, Types.MarkAsConvertedMutationVariables>;
export const MarkAsUnconvertedDocument = gql`
    mutation markAsUnconverted($attendees: AttendeeListInput!) {
  markAsUnconverted(attendees: $attendees) {
    id
    purchaseAmount
    lastPurchaseDate
    purchaseCurrency
  }
}
    `;
export type MarkAsUnconvertedMutationFn = Apollo.MutationFunction<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables>;
export type MarkAsUnconvertedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables>, 'mutation'>;

    export const MarkAsUnconvertedComponent = (props: MarkAsUnconvertedComponentProps) => (
      <ApolloReactComponents.Mutation<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables> mutation={MarkAsUnconvertedDocument} {...props} />
    );
    

/**
 * __useMarkAsUnconvertedMutation__
 *
 * To run a mutation, you first call `useMarkAsUnconvertedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsUnconvertedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsUnconvertedMutation, { data, loading, error }] = useMarkAsUnconvertedMutation({
 *   variables: {
 *      attendees: // value for 'attendees'
 *   },
 * });
 */
export function useMarkAsUnconvertedMutation(baseOptions?: Apollo.MutationHookOptions<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables>(MarkAsUnconvertedDocument, options);
      }
export type MarkAsUnconvertedMutationHookResult = ReturnType<typeof useMarkAsUnconvertedMutation>;
export type MarkAsUnconvertedMutationResult = Apollo.MutationResult<Types.MarkAsUnconvertedMutation>;
export type MarkAsUnconvertedMutationOptions = Apollo.BaseMutationOptions<Types.MarkAsUnconvertedMutation, Types.MarkAsUnconvertedMutationVariables>;
export const AttendeeJoinWebinarDocument = gql`
    mutation attendeeJoinWebinar($id: String!, $setId: String!, $joinTime: DateTime, $joiningReplay: Boolean, $visitorId: String, $connectionId: String) {
  attendeeJoinWebinar(
    id: $id
    setId: $setId
    joinTime: $joinTime
    joiningReplay: $joiningReplay
    visitorId: $visitorId
    connectionId: $connectionId
  ) {
    ...AttendeeJoinWebinar
  }
}
    ${AttendeeJoinWebinarFragmentDoc}`;
export type AttendeeJoinWebinarMutationFn = Apollo.MutationFunction<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables>;
export type AttendeeJoinWebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables>, 'mutation'>;

    export const AttendeeJoinWebinarComponent = (props: AttendeeJoinWebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables> mutation={AttendeeJoinWebinarDocument} {...props} />
    );
    

/**
 * __useAttendeeJoinWebinarMutation__
 *
 * To run a mutation, you first call `useAttendeeJoinWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeeJoinWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeeJoinWebinarMutation, { data, loading, error }] = useAttendeeJoinWebinarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setId: // value for 'setId'
 *      joinTime: // value for 'joinTime'
 *      joiningReplay: // value for 'joiningReplay'
 *      visitorId: // value for 'visitorId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useAttendeeJoinWebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables>(AttendeeJoinWebinarDocument, options);
      }
export type AttendeeJoinWebinarMutationHookResult = ReturnType<typeof useAttendeeJoinWebinarMutation>;
export type AttendeeJoinWebinarMutationResult = Apollo.MutationResult<Types.AttendeeJoinWebinarMutation>;
export type AttendeeJoinWebinarMutationOptions = Apollo.BaseMutationOptions<Types.AttendeeJoinWebinarMutation, Types.AttendeeJoinWebinarMutationVariables>;
export const AttendeeJoinUngatedSessionDocument = gql`
    mutation attendeeJoinUngatedSession($data: RegisterUngatedAttendeeInput!, $joinTime: DateTime, $connectionId: String) {
  attendeeJoinUngatedSession(
    data: $data
    joinTime: $joinTime
    connectionId: $connectionId
  ) {
    ...AttendeeJoinWebinar
  }
}
    ${AttendeeJoinWebinarFragmentDoc}`;
export type AttendeeJoinUngatedSessionMutationFn = Apollo.MutationFunction<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables>;
export type AttendeeJoinUngatedSessionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables>, 'mutation'>;

    export const AttendeeJoinUngatedSessionComponent = (props: AttendeeJoinUngatedSessionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables> mutation={AttendeeJoinUngatedSessionDocument} {...props} />
    );
    

/**
 * __useAttendeeJoinUngatedSessionMutation__
 *
 * To run a mutation, you first call `useAttendeeJoinUngatedSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeeJoinUngatedSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeeJoinUngatedSessionMutation, { data, loading, error }] = useAttendeeJoinUngatedSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      joinTime: // value for 'joinTime'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useAttendeeJoinUngatedSessionMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables>(AttendeeJoinUngatedSessionDocument, options);
      }
export type AttendeeJoinUngatedSessionMutationHookResult = ReturnType<typeof useAttendeeJoinUngatedSessionMutation>;
export type AttendeeJoinUngatedSessionMutationResult = Apollo.MutationResult<Types.AttendeeJoinUngatedSessionMutation>;
export type AttendeeJoinUngatedSessionMutationOptions = Apollo.BaseMutationOptions<Types.AttendeeJoinUngatedSessionMutation, Types.AttendeeJoinUngatedSessionMutationVariables>;
export const AttendeeJoinWebinarLiteDocument = gql`
    mutation attendeeJoinWebinarLite($id: String!, $setId: String!, $joinTime: DateTime, $joiningReplay: Boolean, $visitorId: String, $connectionId: String) {
  attendeeJoinWebinar(
    id: $id
    setId: $setId
    joinTime: $joinTime
    joiningReplay: $joiningReplay
    visitorId: $visitorId
    connectionId: $connectionId
  ) {
    now
    ...Attendee
  }
}
    ${AttendeeFragmentDoc}`;
export type AttendeeJoinWebinarLiteMutationFn = Apollo.MutationFunction<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables>;
export type AttendeeJoinWebinarLiteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables>, 'mutation'>;

    export const AttendeeJoinWebinarLiteComponent = (props: AttendeeJoinWebinarLiteComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables> mutation={AttendeeJoinWebinarLiteDocument} {...props} />
    );
    

/**
 * __useAttendeeJoinWebinarLiteMutation__
 *
 * To run a mutation, you first call `useAttendeeJoinWebinarLiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeeJoinWebinarLiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeeJoinWebinarLiteMutation, { data, loading, error }] = useAttendeeJoinWebinarLiteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setId: // value for 'setId'
 *      joinTime: // value for 'joinTime'
 *      joiningReplay: // value for 'joiningReplay'
 *      visitorId: // value for 'visitorId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useAttendeeJoinWebinarLiteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables>(AttendeeJoinWebinarLiteDocument, options);
      }
export type AttendeeJoinWebinarLiteMutationHookResult = ReturnType<typeof useAttendeeJoinWebinarLiteMutation>;
export type AttendeeJoinWebinarLiteMutationResult = Apollo.MutationResult<Types.AttendeeJoinWebinarLiteMutation>;
export type AttendeeJoinWebinarLiteMutationOptions = Apollo.BaseMutationOptions<Types.AttendeeJoinWebinarLiteMutation, Types.AttendeeJoinWebinarLiteMutationVariables>;
export const AttendeeOptOutDocument = gql`
    mutation attendeeOptOut($id: String!, $optOut: Boolean!, $toCompany: Boolean!, $toWebinarSet: Boolean) {
  attendeeOptOut(
    id: $id
    optOut: $optOut
    toCompany: $toCompany
    toWebinarSet: $toWebinarSet
  ) {
    id
    subscribed
    optOut
    ewebinar {
      id
      logoMediaRef {
        ...MediaRef
      }
      title
      viewerRoomSettings {
        language
      }
      team {
        id
        name
        logoMediaRef {
          ...MediaRef
        }
      }
    }
  }
}
    ${MediaRefFragmentDoc}`;
export type AttendeeOptOutMutationFn = Apollo.MutationFunction<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables>;
export type AttendeeOptOutComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables>, 'mutation'>;

    export const AttendeeOptOutComponent = (props: AttendeeOptOutComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables> mutation={AttendeeOptOutDocument} {...props} />
    );
    

/**
 * __useAttendeeOptOutMutation__
 *
 * To run a mutation, you first call `useAttendeeOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeeOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeeOptOutMutation, { data, loading, error }] = useAttendeeOptOutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      optOut: // value for 'optOut'
 *      toCompany: // value for 'toCompany'
 *      toWebinarSet: // value for 'toWebinarSet'
 *   },
 * });
 */
export function useAttendeeOptOutMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables>(AttendeeOptOutDocument, options);
      }
export type AttendeeOptOutMutationHookResult = ReturnType<typeof useAttendeeOptOutMutation>;
export type AttendeeOptOutMutationResult = Apollo.MutationResult<Types.AttendeeOptOutMutation>;
export type AttendeeOptOutMutationOptions = Apollo.BaseMutationOptions<Types.AttendeeOptOutMutation, Types.AttendeeOptOutMutationVariables>;
export const DeleteAttendeesDocument = gql`
    mutation deleteAttendees($attendees: AttendeeListInput!) {
  deleteAttendees(attendees: $attendees)
}
    `;
export type DeleteAttendeesMutationFn = Apollo.MutationFunction<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables>;
export type DeleteAttendeesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables>, 'mutation'>;

    export const DeleteAttendeesComponent = (props: DeleteAttendeesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables> mutation={DeleteAttendeesDocument} {...props} />
    );
    

/**
 * __useDeleteAttendeesMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeesMutation, { data, loading, error }] = useDeleteAttendeesMutation({
 *   variables: {
 *      attendees: // value for 'attendees'
 *   },
 * });
 */
export function useDeleteAttendeesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables>(DeleteAttendeesDocument, options);
      }
export type DeleteAttendeesMutationHookResult = ReturnType<typeof useDeleteAttendeesMutation>;
export type DeleteAttendeesMutationResult = Apollo.MutationResult<Types.DeleteAttendeesMutation>;
export type DeleteAttendeesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAttendeesMutation, Types.DeleteAttendeesMutationVariables>;
export const AttendeeNotificationHistoryDocument = gql`
    query attendeeNotificationHistory($filter: OutActionAttendeeInput!) {
  attendeeNotificationHistory(filter: $filter) {
    data {
      ...OutAction
    }
    total
    nextCursor
  }
}
    ${OutActionFragmentDoc}`;
export type AttendeeNotificationHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>, 'query'> & ({ variables: Types.AttendeeNotificationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AttendeeNotificationHistoryComponent = (props: AttendeeNotificationHistoryComponentProps) => (
      <ApolloReactComponents.Query<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables> query={AttendeeNotificationHistoryDocument} {...props} />
    );
    

/**
 * __useAttendeeNotificationHistoryQuery__
 *
 * To run a query within a React component, call `useAttendeeNotificationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendeeNotificationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendeeNotificationHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttendeeNotificationHistoryQuery(baseOptions: Apollo.QueryHookOptions<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables> & ({ variables: Types.AttendeeNotificationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>(AttendeeNotificationHistoryDocument, options);
      }
export function useAttendeeNotificationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>(AttendeeNotificationHistoryDocument, options);
        }
export function useAttendeeNotificationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>(AttendeeNotificationHistoryDocument, options);
        }
export type AttendeeNotificationHistoryQueryHookResult = ReturnType<typeof useAttendeeNotificationHistoryQuery>;
export type AttendeeNotificationHistoryLazyQueryHookResult = ReturnType<typeof useAttendeeNotificationHistoryLazyQuery>;
export type AttendeeNotificationHistorySuspenseQueryHookResult = ReturnType<typeof useAttendeeNotificationHistorySuspenseQuery>;
export type AttendeeNotificationHistoryQueryResult = Apollo.QueryResult<Types.AttendeeNotificationHistoryQuery, Types.AttendeeNotificationHistoryQueryVariables>;
export const ConversationDocument = gql`
    query conversation($id: String!) {
  conversation(id: $id) {
    ...ConversationWithAttendeeProperties
    messages {
      ...Message
    }
  }
}
    ${ConversationWithAttendeePropertiesFragmentDoc}
${MessageFragmentDoc}`;
export type ConversationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConversationQuery, Types.ConversationQueryVariables>, 'query'> & ({ variables: Types.ConversationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversationComponent = (props: ConversationComponentProps) => (
      <ApolloReactComponents.Query<Types.ConversationQuery, Types.ConversationQueryVariables> query={ConversationDocument} {...props} />
    );
    

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationQuery(baseOptions: Apollo.QueryHookOptions<Types.ConversationQuery, Types.ConversationQueryVariables> & ({ variables: Types.ConversationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConversationQuery, Types.ConversationQueryVariables>(ConversationDocument, options);
      }
export function useConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConversationQuery, Types.ConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConversationQuery, Types.ConversationQueryVariables>(ConversationDocument, options);
        }
export function useConversationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConversationQuery, Types.ConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConversationQuery, Types.ConversationQueryVariables>(ConversationDocument, options);
        }
export type ConversationQueryHookResult = ReturnType<typeof useConversationQuery>;
export type ConversationLazyQueryHookResult = ReturnType<typeof useConversationLazyQuery>;
export type ConversationSuspenseQueryHookResult = ReturnType<typeof useConversationSuspenseQuery>;
export type ConversationQueryResult = Apollo.QueryResult<Types.ConversationQuery, Types.ConversationQueryVariables>;
export const ConversationForAttendeeDocument = gql`
    query conversationForAttendee($attendeeId: String!) {
  conversationForAttendee(attendeeId: $attendeeId) {
    ...Conversation
    messages {
      ...Message
    }
  }
}
    ${ConversationFragmentDoc}
${MessageFragmentDoc}`;
export type ConversationForAttendeeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>, 'query'> & ({ variables: Types.ConversationForAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversationForAttendeeComponent = (props: ConversationForAttendeeComponentProps) => (
      <ApolloReactComponents.Query<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables> query={ConversationForAttendeeDocument} {...props} />
    );
    

/**
 * __useConversationForAttendeeQuery__
 *
 * To run a query within a React component, call `useConversationForAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationForAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationForAttendeeQuery({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useConversationForAttendeeQuery(baseOptions: Apollo.QueryHookOptions<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables> & ({ variables: Types.ConversationForAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>(ConversationForAttendeeDocument, options);
      }
export function useConversationForAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>(ConversationForAttendeeDocument, options);
        }
export function useConversationForAttendeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>(ConversationForAttendeeDocument, options);
        }
export type ConversationForAttendeeQueryHookResult = ReturnType<typeof useConversationForAttendeeQuery>;
export type ConversationForAttendeeLazyQueryHookResult = ReturnType<typeof useConversationForAttendeeLazyQuery>;
export type ConversationForAttendeeSuspenseQueryHookResult = ReturnType<typeof useConversationForAttendeeSuspenseQuery>;
export type ConversationForAttendeeQueryResult = Apollo.QueryResult<Types.ConversationForAttendeeQuery, Types.ConversationForAttendeeQueryVariables>;
export const ConversationsDocument = gql`
    query conversations($filters: ConversationFilters!) {
  conversations(filters: $filters) {
    conversations {
      ...Conversation
    }
    total
    nextCursor
  }
}
    ${ConversationFragmentDoc}`;
export type ConversationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConversationsQuery, Types.ConversationsQueryVariables>, 'query'> & ({ variables: Types.ConversationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConversationsComponent = (props: ConversationsComponentProps) => (
      <ApolloReactComponents.Query<Types.ConversationsQuery, Types.ConversationsQueryVariables> query={ConversationsDocument} {...props} />
    );
    

/**
 * __useConversationsQuery__
 *
 * To run a query within a React component, call `useConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useConversationsQuery(baseOptions: Apollo.QueryHookOptions<Types.ConversationsQuery, Types.ConversationsQueryVariables> & ({ variables: Types.ConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConversationsQuery, Types.ConversationsQueryVariables>(ConversationsDocument, options);
      }
export function useConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConversationsQuery, Types.ConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConversationsQuery, Types.ConversationsQueryVariables>(ConversationsDocument, options);
        }
export function useConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConversationsQuery, Types.ConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConversationsQuery, Types.ConversationsQueryVariables>(ConversationsDocument, options);
        }
export type ConversationsQueryHookResult = ReturnType<typeof useConversationsQuery>;
export type ConversationsLazyQueryHookResult = ReturnType<typeof useConversationsLazyQuery>;
export type ConversationsSuspenseQueryHookResult = ReturnType<typeof useConversationsSuspenseQuery>;
export type ConversationsQueryResult = Apollo.QueryResult<Types.ConversationsQuery, Types.ConversationsQueryVariables>;
export const ArchiveConversationDocument = gql`
    mutation ArchiveConversation($id: String!) {
  archiveConversation(id: $id) {
    ...ArchivedConversation
  }
}
    ${ArchivedConversationFragmentDoc}`;
export type ArchiveConversationMutationFn = Apollo.MutationFunction<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables>;
export type ArchiveConversationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables>, 'mutation'>;

    export const ArchiveConversationComponent = (props: ArchiveConversationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables> mutation={ArchiveConversationDocument} {...props} />
    );
    

/**
 * __useArchiveConversationMutation__
 *
 * To run a mutation, you first call `useArchiveConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConversationMutation, { data, loading, error }] = useArchiveConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveConversationMutation(baseOptions?: Apollo.MutationHookOptions<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables>(ArchiveConversationDocument, options);
      }
export type ArchiveConversationMutationHookResult = ReturnType<typeof useArchiveConversationMutation>;
export type ArchiveConversationMutationResult = Apollo.MutationResult<Types.ArchiveConversationMutation>;
export type ArchiveConversationMutationOptions = Apollo.BaseMutationOptions<Types.ArchiveConversationMutation, Types.ArchiveConversationMutationVariables>;
export const SeenConversationDocument = gql`
    mutation seenConversation($id: String!) {
  seenConversation(id: $id) {
    id
    hasUnreadMessages
    set {
      id
      ...UpdateLiveFragment
    }
  }
}
    ${UpdateLiveFragmentFragmentDoc}`;
export type SeenConversationMutationFn = Apollo.MutationFunction<Types.SeenConversationMutation, Types.SeenConversationMutationVariables>;
export type SeenConversationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SeenConversationMutation, Types.SeenConversationMutationVariables>, 'mutation'>;

    export const SeenConversationComponent = (props: SeenConversationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SeenConversationMutation, Types.SeenConversationMutationVariables> mutation={SeenConversationDocument} {...props} />
    );
    

/**
 * __useSeenConversationMutation__
 *
 * To run a mutation, you first call `useSeenConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeenConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seenConversationMutation, { data, loading, error }] = useSeenConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeenConversationMutation(baseOptions?: Apollo.MutationHookOptions<Types.SeenConversationMutation, Types.SeenConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SeenConversationMutation, Types.SeenConversationMutationVariables>(SeenConversationDocument, options);
      }
export type SeenConversationMutationHookResult = ReturnType<typeof useSeenConversationMutation>;
export type SeenConversationMutationResult = Apollo.MutationResult<Types.SeenConversationMutation>;
export type SeenConversationMutationOptions = Apollo.BaseMutationOptions<Types.SeenConversationMutation, Types.SeenConversationMutationVariables>;
export const DisableAutoResponseDocument = gql`
    mutation disableAutoResponse($id: String!) {
  disableAutoResponse(id: $id) {
    id
    disableAutoResponse
  }
}
    `;
export type DisableAutoResponseMutationFn = Apollo.MutationFunction<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables>;
export type DisableAutoResponseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables>, 'mutation'>;

    export const DisableAutoResponseComponent = (props: DisableAutoResponseComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables> mutation={DisableAutoResponseDocument} {...props} />
    );
    

/**
 * __useDisableAutoResponseMutation__
 *
 * To run a mutation, you first call `useDisableAutoResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAutoResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAutoResponseMutation, { data, loading, error }] = useDisableAutoResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableAutoResponseMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables>(DisableAutoResponseDocument, options);
      }
export type DisableAutoResponseMutationHookResult = ReturnType<typeof useDisableAutoResponseMutation>;
export type DisableAutoResponseMutationResult = Apollo.MutationResult<Types.DisableAutoResponseMutation>;
export type DisableAutoResponseMutationOptions = Apollo.BaseMutationOptions<Types.DisableAutoResponseMutation, Types.DisableAutoResponseMutationVariables>;
export const ModeratorDisableChatBotDocument = gql`
    mutation moderatorDisableChatBot($id: String!) {
  moderatorDisableChatBot(id: $id) {
    id
    disableChatBot
  }
}
    `;
export type ModeratorDisableChatBotMutationFn = Apollo.MutationFunction<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables>;
export type ModeratorDisableChatBotComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables>, 'mutation'>;

    export const ModeratorDisableChatBotComponent = (props: ModeratorDisableChatBotComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables> mutation={ModeratorDisableChatBotDocument} {...props} />
    );
    

/**
 * __useModeratorDisableChatBotMutation__
 *
 * To run a mutation, you first call `useModeratorDisableChatBotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModeratorDisableChatBotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderatorDisableChatBotMutation, { data, loading, error }] = useModeratorDisableChatBotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModeratorDisableChatBotMutation(baseOptions?: Apollo.MutationHookOptions<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables>(ModeratorDisableChatBotDocument, options);
      }
export type ModeratorDisableChatBotMutationHookResult = ReturnType<typeof useModeratorDisableChatBotMutation>;
export type ModeratorDisableChatBotMutationResult = Apollo.MutationResult<Types.ModeratorDisableChatBotMutation>;
export type ModeratorDisableChatBotMutationOptions = Apollo.BaseMutationOptions<Types.ModeratorDisableChatBotMutation, Types.ModeratorDisableChatBotMutationVariables>;
export const ModeratorEnableChatBotDocument = gql`
    mutation moderatorEnableChatBot($id: String!) {
  moderatorEnableChatBot(id: $id) {
    id
    disableChatBot
    disableAutoResponse
  }
}
    `;
export type ModeratorEnableChatBotMutationFn = Apollo.MutationFunction<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables>;
export type ModeratorEnableChatBotComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables>, 'mutation'>;

    export const ModeratorEnableChatBotComponent = (props: ModeratorEnableChatBotComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables> mutation={ModeratorEnableChatBotDocument} {...props} />
    );
    

/**
 * __useModeratorEnableChatBotMutation__
 *
 * To run a mutation, you first call `useModeratorEnableChatBotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModeratorEnableChatBotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderatorEnableChatBotMutation, { data, loading, error }] = useModeratorEnableChatBotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModeratorEnableChatBotMutation(baseOptions?: Apollo.MutationHookOptions<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables>(ModeratorEnableChatBotDocument, options);
      }
export type ModeratorEnableChatBotMutationHookResult = ReturnType<typeof useModeratorEnableChatBotMutation>;
export type ModeratorEnableChatBotMutationResult = Apollo.MutationResult<Types.ModeratorEnableChatBotMutation>;
export type ModeratorEnableChatBotMutationOptions = Apollo.BaseMutationOptions<Types.ModeratorEnableChatBotMutation, Types.ModeratorEnableChatBotMutationVariables>;
export const CouponDocument = gql`
    query coupon($code: String!) {
  coupon(code: $code) {
    ...Coupon
  }
}
    ${CouponFragmentDoc}`;
export type CouponComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.CouponQuery, Types.CouponQueryVariables>, 'query'> & ({ variables: Types.CouponQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CouponComponent = (props: CouponComponentProps) => (
      <ApolloReactComponents.Query<Types.CouponQuery, Types.CouponQueryVariables> query={CouponDocument} {...props} />
    );
    

/**
 * __useCouponQuery__
 *
 * To run a query within a React component, call `useCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCouponQuery(baseOptions: Apollo.QueryHookOptions<Types.CouponQuery, Types.CouponQueryVariables> & ({ variables: Types.CouponQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CouponQuery, Types.CouponQueryVariables>(CouponDocument, options);
      }
export function useCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CouponQuery, Types.CouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CouponQuery, Types.CouponQueryVariables>(CouponDocument, options);
        }
export function useCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CouponQuery, Types.CouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CouponQuery, Types.CouponQueryVariables>(CouponDocument, options);
        }
export type CouponQueryHookResult = ReturnType<typeof useCouponQuery>;
export type CouponLazyQueryHookResult = ReturnType<typeof useCouponLazyQuery>;
export type CouponSuspenseQueryHookResult = ReturnType<typeof useCouponSuspenseQuery>;
export type CouponQueryResult = Apollo.QueryResult<Types.CouponQuery, Types.CouponQueryVariables>;
export const TemplateTypesDocument = gql`
    query templateTypes {
  templateTypes
}
    `;
export type TemplateTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>, 'query'>;

    export const TemplateTypesComponent = (props: TemplateTypesComponentProps) => (
      <ApolloReactComponents.Query<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables> query={TemplateTypesDocument} {...props} />
    );
    

/**
 * __useTemplateTypesQuery__
 *
 * To run a query within a React component, call `useTemplateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplateTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>(TemplateTypesDocument, options);
      }
export function useTemplateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>(TemplateTypesDocument, options);
        }
export function useTemplateTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>(TemplateTypesDocument, options);
        }
export type TemplateTypesQueryHookResult = ReturnType<typeof useTemplateTypesQuery>;
export type TemplateTypesLazyQueryHookResult = ReturnType<typeof useTemplateTypesLazyQuery>;
export type TemplateTypesSuspenseQueryHookResult = ReturnType<typeof useTemplateTypesSuspenseQuery>;
export type TemplateTypesQueryResult = Apollo.QueryResult<Types.TemplateTypesQuery, Types.TemplateTypesQueryVariables>;
export const TeamTemplateTypesDocument = gql`
    query teamTemplateTypes {
  teamTemplateTypes
}
    `;
export type TeamTemplateTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>, 'query'>;

    export const TeamTemplateTypesComponent = (props: TeamTemplateTypesComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables> query={TeamTemplateTypesDocument} {...props} />
    );
    

/**
 * __useTeamTemplateTypesQuery__
 *
 * To run a query within a React component, call `useTeamTemplateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamTemplateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamTemplateTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamTemplateTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>(TeamTemplateTypesDocument, options);
      }
export function useTeamTemplateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>(TeamTemplateTypesDocument, options);
        }
export function useTeamTemplateTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>(TeamTemplateTypesDocument, options);
        }
export type TeamTemplateTypesQueryHookResult = ReturnType<typeof useTeamTemplateTypesQuery>;
export type TeamTemplateTypesLazyQueryHookResult = ReturnType<typeof useTeamTemplateTypesLazyQuery>;
export type TeamTemplateTypesSuspenseQueryHookResult = ReturnType<typeof useTeamTemplateTypesSuspenseQuery>;
export type TeamTemplateTypesQueryResult = Apollo.QueryResult<Types.TeamTemplateTypesQuery, Types.TeamTemplateTypesQueryVariables>;
export const TemplatesDocument = gql`
    query templates($filter: TemplatesFilterInput) {
  templates(filter: $filter) {
    templates {
      ...Template
    }
    nextCursor
  }
}
    ${TemplateFragmentDoc}`;
export type TemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TemplatesQuery, Types.TemplatesQueryVariables>, 'query'>;

    export const TemplatesComponent = (props: TemplatesComponentProps) => (
      <ApolloReactComponents.Query<Types.TemplatesQuery, Types.TemplatesQueryVariables> query={TemplatesDocument} {...props} />
    );
    

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.TemplatesQuery, Types.TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TemplatesQuery, Types.TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TemplatesQuery, Types.TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TemplatesQuery, Types.TemplatesQueryVariables>(TemplatesDocument, options);
        }
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TemplatesQuery, Types.TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TemplatesQuery, Types.TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesSuspenseQueryHookResult = ReturnType<typeof useTemplatesSuspenseQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<Types.TemplatesQuery, Types.TemplatesQueryVariables>;
export const UseEWebinarTemplateDocument = gql`
    mutation useEWebinarTemplate($templateId: String!, $data: CreateEwebinarInput) {
  useEWebinarTemplate(templateId: $templateId, data: $data) {
    id
    draftWebinar {
      ...EWebinar
    }
  }
}
    ${EWebinarFragmentDoc}`;
export type UseEWebinarTemplateMutationFn = Apollo.MutationFunction<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables>;
export type UseEWebinarTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables>, 'mutation'>;

    export const UseEWebinarTemplateComponent = (props: UseEWebinarTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables> mutation={UseEWebinarTemplateDocument} {...props} />
    );
    

/**
 * __useUseEWebinarTemplateMutation__
 *
 * To run a mutation, you first call `useUseEWebinarTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseEWebinarTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useEWebinarTemplateMutation, { data, loading, error }] = useUseEWebinarTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUseEWebinarTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables>(UseEWebinarTemplateDocument, options);
      }
export type UseEWebinarTemplateMutationHookResult = ReturnType<typeof useUseEWebinarTemplateMutation>;
export type UseEWebinarTemplateMutationResult = Apollo.MutationResult<Types.UseEWebinarTemplateMutation>;
export type UseEWebinarTemplateMutationOptions = Apollo.BaseMutationOptions<Types.UseEWebinarTemplateMutation, Types.UseEWebinarTemplateMutationVariables>;
export const PublishAsTemplateDocument = gql`
    mutation publishAsTemplate($setId: String!, $templateInput: TemplateInput) {
  publishAsTemplate(setId: $setId, templateInput: $templateInput) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;
export type PublishAsTemplateMutationFn = Apollo.MutationFunction<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables>;
export type PublishAsTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables>, 'mutation'>;

    export const PublishAsTemplateComponent = (props: PublishAsTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables> mutation={PublishAsTemplateDocument} {...props} />
    );
    

/**
 * __usePublishAsTemplateMutation__
 *
 * To run a mutation, you first call `usePublishAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAsTemplateMutation, { data, loading, error }] = usePublishAsTemplateMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      templateInput: // value for 'templateInput'
 *   },
 * });
 */
export function usePublishAsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables>(PublishAsTemplateDocument, options);
      }
export type PublishAsTemplateMutationHookResult = ReturnType<typeof usePublishAsTemplateMutation>;
export type PublishAsTemplateMutationResult = Apollo.MutationResult<Types.PublishAsTemplateMutation>;
export type PublishAsTemplateMutationOptions = Apollo.BaseMutationOptions<Types.PublishAsTemplateMutation, Types.PublishAsTemplateMutationVariables>;
export const UpdateTemplateInfoDocument = gql`
    mutation updateTemplateInfo($setId: String!, $templateInput: TemplateInput!) {
  updateTemplateInfo(setId: $setId, templateInput: $templateInput) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;
export type UpdateTemplateInfoMutationFn = Apollo.MutationFunction<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables>;
export type UpdateTemplateInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables>, 'mutation'>;

    export const UpdateTemplateInfoComponent = (props: UpdateTemplateInfoComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables> mutation={UpdateTemplateInfoDocument} {...props} />
    );
    

/**
 * __useUpdateTemplateInfoMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateInfoMutation, { data, loading, error }] = useUpdateTemplateInfoMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      templateInput: // value for 'templateInput'
 *   },
 * });
 */
export function useUpdateTemplateInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables>(UpdateTemplateInfoDocument, options);
      }
export type UpdateTemplateInfoMutationHookResult = ReturnType<typeof useUpdateTemplateInfoMutation>;
export type UpdateTemplateInfoMutationResult = Apollo.MutationResult<Types.UpdateTemplateInfoMutation>;
export type UpdateTemplateInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTemplateInfoMutation, Types.UpdateTemplateInfoMutationVariables>;
export const CreateEwebinarDocument = gql`
    mutation createEwebinar($data: CreateEwebinarInput!) {
  createEwebinar(data: $data) {
    id
    title
    vimeoVideoId
    thumbnailMediaRef {
      ...MediaRef
    }
    jobs {
      ...Jobs
    }
  }
}
    ${MediaRefFragmentDoc}
${JobsFragmentDoc}`;
export type CreateEwebinarMutationFn = Apollo.MutationFunction<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables>;
export type CreateEwebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables>, 'mutation'>;

    export const CreateEwebinarComponent = (props: CreateEwebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables> mutation={CreateEwebinarDocument} {...props} />
    );
    

/**
 * __useCreateEwebinarMutation__
 *
 * To run a mutation, you first call `useCreateEwebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEwebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEwebinarMutation, { data, loading, error }] = useCreateEwebinarMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEwebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables>(CreateEwebinarDocument, options);
      }
export type CreateEwebinarMutationHookResult = ReturnType<typeof useCreateEwebinarMutation>;
export type CreateEwebinarMutationResult = Apollo.MutationResult<Types.CreateEwebinarMutation>;
export type CreateEwebinarMutationOptions = Apollo.BaseMutationOptions<Types.CreateEwebinarMutation, Types.CreateEwebinarMutationVariables>;
export const CreateEwebinarSetDocument = gql`
    mutation createEwebinarSet($data: CreateEwebinarSetInput!) {
  createEwebinarSet(data: $data) {
    id
    draftWebinar {
      ...EWebinar
    }
  }
}
    ${EWebinarFragmentDoc}`;
export type CreateEwebinarSetMutationFn = Apollo.MutationFunction<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables>;
export type CreateEwebinarSetComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables>, 'mutation'>;

    export const CreateEwebinarSetComponent = (props: CreateEwebinarSetComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables> mutation={CreateEwebinarSetDocument} {...props} />
    );
    

/**
 * __useCreateEwebinarSetMutation__
 *
 * To run a mutation, you first call `useCreateEwebinarSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEwebinarSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEwebinarSetMutation, { data, loading, error }] = useCreateEwebinarSetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEwebinarSetMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables>(CreateEwebinarSetDocument, options);
      }
export type CreateEwebinarSetMutationHookResult = ReturnType<typeof useCreateEwebinarSetMutation>;
export type CreateEwebinarSetMutationResult = Apollo.MutationResult<Types.CreateEwebinarSetMutation>;
export type CreateEwebinarSetMutationOptions = Apollo.BaseMutationOptions<Types.CreateEwebinarSetMutation, Types.CreateEwebinarSetMutationVariables>;
export const EwebinarWithSetDocument = gql`
    query ewebinarWithSet($id: String!) {
  ewebinar(id: $id) {
    ...EWebinarWithSet
  }
}
    ${EWebinarWithSetFragmentDoc}`;
export type EwebinarWithSetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>, 'query'> & ({ variables: Types.EwebinarWithSetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EwebinarWithSetComponent = (props: EwebinarWithSetComponentProps) => (
      <ApolloReactComponents.Query<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables> query={EwebinarWithSetDocument} {...props} />
    );
    

/**
 * __useEwebinarWithSetQuery__
 *
 * To run a query within a React component, call `useEwebinarWithSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useEwebinarWithSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEwebinarWithSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEwebinarWithSetQuery(baseOptions: Apollo.QueryHookOptions<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables> & ({ variables: Types.EwebinarWithSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>(EwebinarWithSetDocument, options);
      }
export function useEwebinarWithSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>(EwebinarWithSetDocument, options);
        }
export function useEwebinarWithSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>(EwebinarWithSetDocument, options);
        }
export type EwebinarWithSetQueryHookResult = ReturnType<typeof useEwebinarWithSetQuery>;
export type EwebinarWithSetLazyQueryHookResult = ReturnType<typeof useEwebinarWithSetLazyQuery>;
export type EwebinarWithSetSuspenseQueryHookResult = ReturnType<typeof useEwebinarWithSetSuspenseQuery>;
export type EwebinarWithSetQueryResult = Apollo.QueryResult<Types.EwebinarWithSetQuery, Types.EwebinarWithSetQueryVariables>;
export const PublicEwebinarDocument = gql`
    query publicEwebinar($id: String!) {
  ewebinar(id: $id) {
    ...PublicEWebinar
  }
}
    ${PublicEWebinarFragmentDoc}`;
export type PublicEwebinarComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>, 'query'> & ({ variables: Types.PublicEwebinarQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PublicEwebinarComponent = (props: PublicEwebinarComponentProps) => (
      <ApolloReactComponents.Query<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables> query={PublicEwebinarDocument} {...props} />
    );
    

/**
 * __usePublicEwebinarQuery__
 *
 * To run a query within a React component, call `usePublicEwebinarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicEwebinarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicEwebinarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicEwebinarQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables> & ({ variables: Types.PublicEwebinarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>(PublicEwebinarDocument, options);
      }
export function usePublicEwebinarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>(PublicEwebinarDocument, options);
        }
export function usePublicEwebinarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>(PublicEwebinarDocument, options);
        }
export type PublicEwebinarQueryHookResult = ReturnType<typeof usePublicEwebinarQuery>;
export type PublicEwebinarLazyQueryHookResult = ReturnType<typeof usePublicEwebinarLazyQuery>;
export type PublicEwebinarSuspenseQueryHookResult = ReturnType<typeof usePublicEwebinarSuspenseQuery>;
export type PublicEwebinarQueryResult = Apollo.QueryResult<Types.PublicEwebinarQuery, Types.PublicEwebinarQueryVariables>;
export const UpdateEwebinarDocument = gql`
    mutation updateEwebinar($data: UpdateEwebinarInput!) {
  updateEwebinar(data: $data) {
    ...EWebinarWithSet
  }
}
    ${EWebinarWithSetFragmentDoc}`;
export type UpdateEwebinarMutationFn = Apollo.MutationFunction<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables>;
export type UpdateEwebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables>, 'mutation'>;

    export const UpdateEwebinarComponent = (props: UpdateEwebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables> mutation={UpdateEwebinarDocument} {...props} />
    );
    

/**
 * __useUpdateEwebinarMutation__
 *
 * To run a mutation, you first call `useUpdateEwebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEwebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEwebinarMutation, { data, loading, error }] = useUpdateEwebinarMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEwebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables>(UpdateEwebinarDocument, options);
      }
export type UpdateEwebinarMutationHookResult = ReturnType<typeof useUpdateEwebinarMutation>;
export type UpdateEwebinarMutationResult = Apollo.MutationResult<Types.UpdateEwebinarMutation>;
export type UpdateEwebinarMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEwebinarMutation, Types.UpdateEwebinarMutationVariables>;
export const UpdateJobStatusDocument = gql`
    mutation updateJobStatus($ewebinarId: String!, $job: JobType!, $status: JobStatusInput!) {
  updateJobStatus(ewebinarId: $ewebinarId, job: $job, status: $status) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type UpdateJobStatusMutationFn = Apollo.MutationFunction<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables>;
export type UpdateJobStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables>, 'mutation'>;

    export const UpdateJobStatusComponent = (props: UpdateJobStatusComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables> mutation={UpdateJobStatusDocument} {...props} />
    );
    

/**
 * __useUpdateJobStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobStatusMutation, { data, loading, error }] = useUpdateJobStatusMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      job: // value for 'job'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables>(UpdateJobStatusDocument, options);
      }
export type UpdateJobStatusMutationHookResult = ReturnType<typeof useUpdateJobStatusMutation>;
export type UpdateJobStatusMutationResult = Apollo.MutationResult<Types.UpdateJobStatusMutation>;
export type UpdateJobStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateJobStatusMutation, Types.UpdateJobStatusMutationVariables>;
export const UpdateUploadStatusDocument = gql`
    mutation updateUploadStatus($ewebinarId: String!, $data: UploadStatusInput!) {
  updateUploadStatus(ewebinarId: $ewebinarId, data: $data) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type UpdateUploadStatusMutationFn = Apollo.MutationFunction<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables>;
export type UpdateUploadStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables>, 'mutation'>;

    export const UpdateUploadStatusComponent = (props: UpdateUploadStatusComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables> mutation={UpdateUploadStatusDocument} {...props} />
    );
    

/**
 * __useUpdateUploadStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUploadStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUploadStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUploadStatusMutation, { data, loading, error }] = useUpdateUploadStatusMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUploadStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables>(UpdateUploadStatusDocument, options);
      }
export type UpdateUploadStatusMutationHookResult = ReturnType<typeof useUpdateUploadStatusMutation>;
export type UpdateUploadStatusMutationResult = Apollo.MutationResult<Types.UpdateUploadStatusMutation>;
export type UpdateUploadStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUploadStatusMutation, Types.UpdateUploadStatusMutationVariables>;
export const UpdateTranscriptionStatusDocument = gql`
    mutation updateTranscriptionStatus($ewebinarId: String!, $status: TranscribeStatusInput!) {
  updateTranscriptionStatus(ewebinarId: $ewebinarId, status: $status) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type UpdateTranscriptionStatusMutationFn = Apollo.MutationFunction<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables>;
export type UpdateTranscriptionStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables>, 'mutation'>;

    export const UpdateTranscriptionStatusComponent = (props: UpdateTranscriptionStatusComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables> mutation={UpdateTranscriptionStatusDocument} {...props} />
    );
    

/**
 * __useUpdateTranscriptionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptionStatusMutation, { data, loading, error }] = useUpdateTranscriptionStatusMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTranscriptionStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables>(UpdateTranscriptionStatusDocument, options);
      }
export type UpdateTranscriptionStatusMutationHookResult = ReturnType<typeof useUpdateTranscriptionStatusMutation>;
export type UpdateTranscriptionStatusMutationResult = Apollo.MutationResult<Types.UpdateTranscriptionStatusMutation>;
export type UpdateTranscriptionStatusMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTranscriptionStatusMutation, Types.UpdateTranscriptionStatusMutationVariables>;
export const DeleteEwebinarDocument = gql`
    mutation deleteEwebinar($id: String!) {
  deleteEwebinar(id: $id)
}
    `;
export type DeleteEwebinarMutationFn = Apollo.MutationFunction<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables>;
export type DeleteEwebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables>, 'mutation'>;

    export const DeleteEwebinarComponent = (props: DeleteEwebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables> mutation={DeleteEwebinarDocument} {...props} />
    );
    

/**
 * __useDeleteEwebinarMutation__
 *
 * To run a mutation, you first call `useDeleteEwebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEwebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEwebinarMutation, { data, loading, error }] = useDeleteEwebinarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEwebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables>(DeleteEwebinarDocument, options);
      }
export type DeleteEwebinarMutationHookResult = ReturnType<typeof useDeleteEwebinarMutation>;
export type DeleteEwebinarMutationResult = Apollo.MutationResult<Types.DeleteEwebinarMutation>;
export type DeleteEwebinarMutationOptions = Apollo.BaseMutationOptions<Types.DeleteEwebinarMutation, Types.DeleteEwebinarMutationVariables>;
export const PrepairPublishEwebinarDocument = gql`
    query prepairPublishEwebinar($setId: String!) {
  prepairPublishEwebinar(setId: $setId) {
    date
    additional
    no
    billingCycle
    upgradeRequired
    nextPlan {
      id
      name
      from
      to
      monthlyPrice
      pricePerAdditional
    }
    isEmptySession
  }
}
    `;
export type PrepairPublishEwebinarComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>, 'query'> & ({ variables: Types.PrepairPublishEwebinarQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PrepairPublishEwebinarComponent = (props: PrepairPublishEwebinarComponentProps) => (
      <ApolloReactComponents.Query<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables> query={PrepairPublishEwebinarDocument} {...props} />
    );
    

/**
 * __usePrepairPublishEwebinarQuery__
 *
 * To run a query within a React component, call `usePrepairPublishEwebinarQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepairPublishEwebinarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepairPublishEwebinarQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function usePrepairPublishEwebinarQuery(baseOptions: Apollo.QueryHookOptions<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables> & ({ variables: Types.PrepairPublishEwebinarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>(PrepairPublishEwebinarDocument, options);
      }
export function usePrepairPublishEwebinarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>(PrepairPublishEwebinarDocument, options);
        }
export function usePrepairPublishEwebinarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>(PrepairPublishEwebinarDocument, options);
        }
export type PrepairPublishEwebinarQueryHookResult = ReturnType<typeof usePrepairPublishEwebinarQuery>;
export type PrepairPublishEwebinarLazyQueryHookResult = ReturnType<typeof usePrepairPublishEwebinarLazyQuery>;
export type PrepairPublishEwebinarSuspenseQueryHookResult = ReturnType<typeof usePrepairPublishEwebinarSuspenseQuery>;
export type PrepairPublishEwebinarQueryResult = Apollo.QueryResult<Types.PrepairPublishEwebinarQuery, Types.PrepairPublishEwebinarQueryVariables>;
export const PublishEwebinarDocument = gql`
    mutation publishEwebinar($setId: String!, $paymentIntentId: String) {
  publishEwebinarWith3DS(setId: $setId, paymentIntentId: $paymentIntentId) {
    paymentIntentSecret
    set {
      ...EWebinarSet
      team {
        id
        pendingSetupIntent
      }
    }
  }
}
    ${EWebinarSetFragmentDoc}`;
export type PublishEwebinarMutationFn = Apollo.MutationFunction<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables>;
export type PublishEwebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables>, 'mutation'>;

    export const PublishEwebinarComponent = (props: PublishEwebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables> mutation={PublishEwebinarDocument} {...props} />
    );
    

/**
 * __usePublishEwebinarMutation__
 *
 * To run a mutation, you first call `usePublishEwebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEwebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEwebinarMutation, { data, loading, error }] = usePublishEwebinarMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function usePublishEwebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables>(PublishEwebinarDocument, options);
      }
export type PublishEwebinarMutationHookResult = ReturnType<typeof usePublishEwebinarMutation>;
export type PublishEwebinarMutationResult = Apollo.MutationResult<Types.PublishEwebinarMutation>;
export type PublishEwebinarMutationOptions = Apollo.BaseMutationOptions<Types.PublishEwebinarMutation, Types.PublishEwebinarMutationVariables>;
export const UnpublishEwebinarDocument = gql`
    mutation unpublishEwebinar($id: String!) {
  unpublishEwebinar(id: $id) {
    id
    draftWebinar {
      id
      isPublished
    }
    publicWebinar {
      id
    }
    team {
      id
      pendingSetupIntent
    }
  }
}
    `;
export type UnpublishEwebinarMutationFn = Apollo.MutationFunction<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables>;
export type UnpublishEwebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables>, 'mutation'>;

    export const UnpublishEwebinarComponent = (props: UnpublishEwebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables> mutation={UnpublishEwebinarDocument} {...props} />
    );
    

/**
 * __useUnpublishEwebinarMutation__
 *
 * To run a mutation, you first call `useUnpublishEwebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishEwebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishEwebinarMutation, { data, loading, error }] = useUnpublishEwebinarMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishEwebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables>(UnpublishEwebinarDocument, options);
      }
export type UnpublishEwebinarMutationHookResult = ReturnType<typeof useUnpublishEwebinarMutation>;
export type UnpublishEwebinarMutationResult = Apollo.MutationResult<Types.UnpublishEwebinarMutation>;
export type UnpublishEwebinarMutationOptions = Apollo.BaseMutationOptions<Types.UnpublishEwebinarMutation, Types.UnpublishEwebinarMutationVariables>;
export const DuplicateDocument = gql`
    mutation duplicate($setId: String!) {
  duplicateEwebinar(setId: $setId) {
    id
    isPublished
    set {
      id
    }
  }
}
    `;
export type DuplicateMutationFn = Apollo.MutationFunction<Types.DuplicateMutation, Types.DuplicateMutationVariables>;
export type DuplicateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DuplicateMutation, Types.DuplicateMutationVariables>, 'mutation'>;

    export const DuplicateComponent = (props: DuplicateComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DuplicateMutation, Types.DuplicateMutationVariables> mutation={DuplicateDocument} {...props} />
    );
    

/**
 * __useDuplicateMutation__
 *
 * To run a mutation, you first call `useDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateMutation, { data, loading, error }] = useDuplicateMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateMutation, Types.DuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateMutation, Types.DuplicateMutationVariables>(DuplicateDocument, options);
      }
export type DuplicateMutationHookResult = ReturnType<typeof useDuplicateMutation>;
export type DuplicateMutationResult = Apollo.MutationResult<Types.DuplicateMutation>;
export type DuplicateMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateMutation, Types.DuplicateMutationVariables>;
export const CloneAcrossTeamsDocument = gql`
    mutation cloneAcrossTeams($setId: String!, $teamId: String) {
  cloneAcrossTeams(setId: $setId, teamId: $teamId) {
    id
  }
}
    `;
export type CloneAcrossTeamsMutationFn = Apollo.MutationFunction<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables>;
export type CloneAcrossTeamsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables>, 'mutation'>;

    export const CloneAcrossTeamsComponent = (props: CloneAcrossTeamsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables> mutation={CloneAcrossTeamsDocument} {...props} />
    );
    

/**
 * __useCloneAcrossTeamsMutation__
 *
 * To run a mutation, you first call `useCloneAcrossTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneAcrossTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneAcrossTeamsMutation, { data, loading, error }] = useCloneAcrossTeamsMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCloneAcrossTeamsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables>(CloneAcrossTeamsDocument, options);
      }
export type CloneAcrossTeamsMutationHookResult = ReturnType<typeof useCloneAcrossTeamsMutation>;
export type CloneAcrossTeamsMutationResult = Apollo.MutationResult<Types.CloneAcrossTeamsMutation>;
export type CloneAcrossTeamsMutationOptions = Apollo.BaseMutationOptions<Types.CloneAcrossTeamsMutation, Types.CloneAcrossTeamsMutationVariables>;
export const DiscardEwebinarChangesDocument = gql`
    mutation discardEwebinarChanges($setId: String!) {
  discardEwebinarChanges(setId: $setId) {
    id
  }
}
    `;
export type DiscardEwebinarChangesMutationFn = Apollo.MutationFunction<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables>;
export type DiscardEwebinarChangesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables>, 'mutation'>;

    export const DiscardEwebinarChangesComponent = (props: DiscardEwebinarChangesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables> mutation={DiscardEwebinarChangesDocument} {...props} />
    );
    

/**
 * __useDiscardEwebinarChangesMutation__
 *
 * To run a mutation, you first call `useDiscardEwebinarChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardEwebinarChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardEwebinarChangesMutation, { data, loading, error }] = useDiscardEwebinarChangesMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useDiscardEwebinarChangesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables>(DiscardEwebinarChangesDocument, options);
      }
export type DiscardEwebinarChangesMutationHookResult = ReturnType<typeof useDiscardEwebinarChangesMutation>;
export type DiscardEwebinarChangesMutationResult = Apollo.MutationResult<Types.DiscardEwebinarChangesMutation>;
export type DiscardEwebinarChangesMutationOptions = Apollo.BaseMutationOptions<Types.DiscardEwebinarChangesMutation, Types.DiscardEwebinarChangesMutationVariables>;
export const PublicSetDocument = gql`
    query publicSet($id: String!, $forPublish: Boolean) {
  publicSet(id: $id, forPublish: $forPublish) {
    ...PublicSetWithEWebinar
  }
}
    ${PublicSetWithEWebinarFragmentDoc}`;
export type PublicSetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PublicSetQuery, Types.PublicSetQueryVariables>, 'query'> & ({ variables: Types.PublicSetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PublicSetComponent = (props: PublicSetComponentProps) => (
      <ApolloReactComponents.Query<Types.PublicSetQuery, Types.PublicSetQueryVariables> query={PublicSetDocument} {...props} />
    );
    

/**
 * __usePublicSetQuery__
 *
 * To run a query within a React component, call `usePublicSetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      forPublish: // value for 'forPublish'
 *   },
 * });
 */
export function usePublicSetQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicSetQuery, Types.PublicSetQueryVariables> & ({ variables: Types.PublicSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicSetQuery, Types.PublicSetQueryVariables>(PublicSetDocument, options);
      }
export function usePublicSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicSetQuery, Types.PublicSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicSetQuery, Types.PublicSetQueryVariables>(PublicSetDocument, options);
        }
export function usePublicSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublicSetQuery, Types.PublicSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublicSetQuery, Types.PublicSetQueryVariables>(PublicSetDocument, options);
        }
export type PublicSetQueryHookResult = ReturnType<typeof usePublicSetQuery>;
export type PublicSetLazyQueryHookResult = ReturnType<typeof usePublicSetLazyQuery>;
export type PublicSetSuspenseQueryHookResult = ReturnType<typeof usePublicSetSuspenseQuery>;
export type PublicSetQueryResult = Apollo.QueryResult<Types.PublicSetQuery, Types.PublicSetQueryVariables>;
export const DraftSetDocument = gql`
    query draftSet($id: String, $templateID: String) {
  set(id: $id, templateID: $templateID) {
    ...EWebinarSet
    draftWebinar {
      ...EWebinar
      interactions {
        ...Interaction
      }
      notifications {
        ...Notification
      }
    }
  }
}
    ${EWebinarSetFragmentDoc}
${EWebinarFragmentDoc}
${InteractionFragmentDoc}
${NotificationFragmentDoc}`;
export type DraftSetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.DraftSetQuery, Types.DraftSetQueryVariables>, 'query'>;

    export const DraftSetComponent = (props: DraftSetComponentProps) => (
      <ApolloReactComponents.Query<Types.DraftSetQuery, Types.DraftSetQueryVariables> query={DraftSetDocument} {...props} />
    );
    

/**
 * __useDraftSetQuery__
 *
 * To run a query within a React component, call `useDraftSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function useDraftSetQuery(baseOptions?: Apollo.QueryHookOptions<Types.DraftSetQuery, Types.DraftSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DraftSetQuery, Types.DraftSetQueryVariables>(DraftSetDocument, options);
      }
export function useDraftSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DraftSetQuery, Types.DraftSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DraftSetQuery, Types.DraftSetQueryVariables>(DraftSetDocument, options);
        }
export function useDraftSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.DraftSetQuery, Types.DraftSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.DraftSetQuery, Types.DraftSetQueryVariables>(DraftSetDocument, options);
        }
export type DraftSetQueryHookResult = ReturnType<typeof useDraftSetQuery>;
export type DraftSetLazyQueryHookResult = ReturnType<typeof useDraftSetLazyQuery>;
export type DraftSetSuspenseQueryHookResult = ReturnType<typeof useDraftSetSuspenseQuery>;
export type DraftSetQueryResult = Apollo.QueryResult<Types.DraftSetQuery, Types.DraftSetQueryVariables>;
export const SetDocument = gql`
    query set($id: String, $templateID: String) {
  set(id: $id, templateID: $templateID) {
    ...SetWithPublicEwebinar
  }
}
    ${SetWithPublicEwebinarFragmentDoc}`;
export type SetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SetQuery, Types.SetQueryVariables>, 'query'>;

    export const SetComponent = (props: SetComponentProps) => (
      <ApolloReactComponents.Query<Types.SetQuery, Types.SetQueryVariables> query={SetDocument} {...props} />
    );
    

/**
 * __useSetQuery__
 *
 * To run a query within a React component, call `useSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function useSetQuery(baseOptions?: Apollo.QueryHookOptions<Types.SetQuery, Types.SetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SetQuery, Types.SetQueryVariables>(SetDocument, options);
      }
export function useSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SetQuery, Types.SetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SetQuery, Types.SetQueryVariables>(SetDocument, options);
        }
export function useSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SetQuery, Types.SetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SetQuery, Types.SetQueryVariables>(SetDocument, options);
        }
export type SetQueryHookResult = ReturnType<typeof useSetQuery>;
export type SetLazyQueryHookResult = ReturnType<typeof useSetLazyQuery>;
export type SetSuspenseQueryHookResult = ReturnType<typeof useSetSuspenseQuery>;
export type SetQueryResult = Apollo.QueryResult<Types.SetQuery, Types.SetQueryVariables>;
export const FullSetDocument = gql`
    query fullSet($id: String, $templateID: String) {
  set(id: $id, templateID: $templateID) {
    ...FullSet
  }
}
    ${FullSetFragmentDoc}`;
export type FullSetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.FullSetQuery, Types.FullSetQueryVariables>, 'query'>;

    export const FullSetComponent = (props: FullSetComponentProps) => (
      <ApolloReactComponents.Query<Types.FullSetQuery, Types.FullSetQueryVariables> query={FullSetDocument} {...props} />
    );
    

/**
 * __useFullSetQuery__
 *
 * To run a query within a React component, call `useFullSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *   },
 * });
 */
export function useFullSetQuery(baseOptions?: Apollo.QueryHookOptions<Types.FullSetQuery, Types.FullSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FullSetQuery, Types.FullSetQueryVariables>(FullSetDocument, options);
      }
export function useFullSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FullSetQuery, Types.FullSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FullSetQuery, Types.FullSetQueryVariables>(FullSetDocument, options);
        }
export function useFullSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FullSetQuery, Types.FullSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FullSetQuery, Types.FullSetQueryVariables>(FullSetDocument, options);
        }
export type FullSetQueryHookResult = ReturnType<typeof useFullSetQuery>;
export type FullSetLazyQueryHookResult = ReturnType<typeof useFullSetLazyQuery>;
export type FullSetSuspenseQueryHookResult = ReturnType<typeof useFullSetSuspenseQuery>;
export type FullSetQueryResult = Apollo.QueryResult<Types.FullSetQuery, Types.FullSetQueryVariables>;
export const UpdateUnreadConversationsCountSetsDocument = gql`
    query updateUnreadConversationsCountSets {
  sets {
    id
    liveFragment {
      id
      unreadChats
      inSession
    }
  }
}
    `;
export type UpdateUnreadConversationsCountSetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>, 'query'>;

    export const UpdateUnreadConversationsCountSetsComponent = (props: UpdateUnreadConversationsCountSetsComponentProps) => (
      <ApolloReactComponents.Query<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables> query={UpdateUnreadConversationsCountSetsDocument} {...props} />
    );
    

/**
 * __useUpdateUnreadConversationsCountSetsQuery__
 *
 * To run a query within a React component, call `useUpdateUnreadConversationsCountSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnreadConversationsCountSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateUnreadConversationsCountSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUnreadConversationsCountSetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>(UpdateUnreadConversationsCountSetsDocument, options);
      }
export function useUpdateUnreadConversationsCountSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>(UpdateUnreadConversationsCountSetsDocument, options);
        }
export function useUpdateUnreadConversationsCountSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>(UpdateUnreadConversationsCountSetsDocument, options);
        }
export type UpdateUnreadConversationsCountSetsQueryHookResult = ReturnType<typeof useUpdateUnreadConversationsCountSetsQuery>;
export type UpdateUnreadConversationsCountSetsLazyQueryHookResult = ReturnType<typeof useUpdateUnreadConversationsCountSetsLazyQuery>;
export type UpdateUnreadConversationsCountSetsSuspenseQueryHookResult = ReturnType<typeof useUpdateUnreadConversationsCountSetsSuspenseQuery>;
export type UpdateUnreadConversationsCountSetsQueryResult = Apollo.QueryResult<Types.UpdateUnreadConversationsCountSetsQuery, Types.UpdateUnreadConversationsCountSetsQueryVariables>;
export const HomePageSetsDocument = gql`
    query homePageSets {
  homePageSets {
    ...HomePageSet
  }
}
    ${HomePageSetFragmentDoc}`;
export type HomePageSetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>, 'query'>;

    export const HomePageSetsComponent = (props: HomePageSetsComponentProps) => (
      <ApolloReactComponents.Query<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables> query={HomePageSetsDocument} {...props} />
    );
    

/**
 * __useHomePageSetsQuery__
 *
 * To run a query within a React component, call `useHomePageSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageSetsQuery(baseOptions?: Apollo.QueryHookOptions<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>(HomePageSetsDocument, options);
      }
export function useHomePageSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>(HomePageSetsDocument, options);
        }
export function useHomePageSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>(HomePageSetsDocument, options);
        }
export type HomePageSetsQueryHookResult = ReturnType<typeof useHomePageSetsQuery>;
export type HomePageSetsLazyQueryHookResult = ReturnType<typeof useHomePageSetsLazyQuery>;
export type HomePageSetsSuspenseQueryHookResult = ReturnType<typeof useHomePageSetsSuspenseQuery>;
export type HomePageSetsQueryResult = Apollo.QueryResult<Types.HomePageSetsQuery, Types.HomePageSetsQueryVariables>;
export const SetPreviewInfoDocument = gql`
    query setPreviewInfo($id: String!) {
  set(id: $id) {
    ...SetPreviewInfo
  }
}
    ${SetPreviewInfoFragmentDoc}`;
export type SetPreviewInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>, 'query'> & ({ variables: Types.SetPreviewInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SetPreviewInfoComponent = (props: SetPreviewInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables> query={SetPreviewInfoDocument} {...props} />
    );
    

/**
 * __useSetPreviewInfoQuery__
 *
 * To run a query within a React component, call `useSetPreviewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetPreviewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetPreviewInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetPreviewInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables> & ({ variables: Types.SetPreviewInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>(SetPreviewInfoDocument, options);
      }
export function useSetPreviewInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>(SetPreviewInfoDocument, options);
        }
export function useSetPreviewInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>(SetPreviewInfoDocument, options);
        }
export type SetPreviewInfoQueryHookResult = ReturnType<typeof useSetPreviewInfoQuery>;
export type SetPreviewInfoLazyQueryHookResult = ReturnType<typeof useSetPreviewInfoLazyQuery>;
export type SetPreviewInfoSuspenseQueryHookResult = ReturnType<typeof useSetPreviewInfoSuspenseQuery>;
export type SetPreviewInfoQueryResult = Apollo.QueryResult<Types.SetPreviewInfoQuery, Types.SetPreviewInfoQueryVariables>;
export const VisibleSetsDocument = gql`
    query visibleSets($teamId: String!, $nextCursor: String!) {
  visibleSets(teamId: $teamId, nextCursor: $nextCursor) {
    sets {
      ...PublicSetAndSession
    }
    nextCursor
  }
}
    ${PublicSetAndSessionFragmentDoc}`;
export type VisibleSetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>, 'query'> & ({ variables: Types.VisibleSetsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const VisibleSetsComponent = (props: VisibleSetsComponentProps) => (
      <ApolloReactComponents.Query<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables> query={VisibleSetsDocument} {...props} />
    );
    

/**
 * __useVisibleSetsQuery__
 *
 * To run a query within a React component, call `useVisibleSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibleSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibleSetsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      nextCursor: // value for 'nextCursor'
 *   },
 * });
 */
export function useVisibleSetsQuery(baseOptions: Apollo.QueryHookOptions<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables> & ({ variables: Types.VisibleSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>(VisibleSetsDocument, options);
      }
export function useVisibleSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>(VisibleSetsDocument, options);
        }
export function useVisibleSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>(VisibleSetsDocument, options);
        }
export type VisibleSetsQueryHookResult = ReturnType<typeof useVisibleSetsQuery>;
export type VisibleSetsLazyQueryHookResult = ReturnType<typeof useVisibleSetsLazyQuery>;
export type VisibleSetsSuspenseQueryHookResult = ReturnType<typeof useVisibleSetsSuspenseQuery>;
export type VisibleSetsQueryResult = Apollo.QueryResult<Types.VisibleSetsQuery, Types.VisibleSetsQueryVariables>;
export const PublicSetsDocument = gql`
    query publicSets($teamId: String!, $nextCursor: String!) {
  publicSets(teamId: $teamId, nextCursor: $nextCursor) {
    sets {
      ...PublicSetAndSession
    }
    nextCursor
  }
}
    ${PublicSetAndSessionFragmentDoc}`;
export type PublicSetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>, 'query'> & ({ variables: Types.PublicSetsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PublicSetsComponent = (props: PublicSetsComponentProps) => (
      <ApolloReactComponents.Query<Types.PublicSetsQuery, Types.PublicSetsQueryVariables> query={PublicSetsDocument} {...props} />
    );
    

/**
 * __usePublicSetsQuery__
 *
 * To run a query within a React component, call `usePublicSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicSetsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      nextCursor: // value for 'nextCursor'
 *   },
 * });
 */
export function usePublicSetsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicSetsQuery, Types.PublicSetsQueryVariables> & ({ variables: Types.PublicSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>(PublicSetsDocument, options);
      }
export function usePublicSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>(PublicSetsDocument, options);
        }
export function usePublicSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>(PublicSetsDocument, options);
        }
export type PublicSetsQueryHookResult = ReturnType<typeof usePublicSetsQuery>;
export type PublicSetsLazyQueryHookResult = ReturnType<typeof usePublicSetsLazyQuery>;
export type PublicSetsSuspenseQueryHookResult = ReturnType<typeof usePublicSetsSuspenseQuery>;
export type PublicSetsQueryResult = Apollo.QueryResult<Types.PublicSetsQuery, Types.PublicSetsQueryVariables>;
export const UpdatePublicEWebinarDocument = gql`
    mutation updatePublicEWebinar($data: UpdatePublicEWebinarInput!) {
  updatePublicEWebinar(data: $data) {
    ...PublicEWebinar
  }
}
    ${PublicEWebinarFragmentDoc}`;
export type UpdatePublicEWebinarMutationFn = Apollo.MutationFunction<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables>;
export type UpdatePublicEWebinarComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables>, 'mutation'>;

    export const UpdatePublicEWebinarComponent = (props: UpdatePublicEWebinarComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables> mutation={UpdatePublicEWebinarDocument} {...props} />
    );
    

/**
 * __useUpdatePublicEWebinarMutation__
 *
 * To run a mutation, you first call `useUpdatePublicEWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePublicEWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePublicEWebinarMutation, { data, loading, error }] = useUpdatePublicEWebinarMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePublicEWebinarMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables>(UpdatePublicEWebinarDocument, options);
      }
export type UpdatePublicEWebinarMutationHookResult = ReturnType<typeof useUpdatePublicEWebinarMutation>;
export type UpdatePublicEWebinarMutationResult = Apollo.MutationResult<Types.UpdatePublicEWebinarMutation>;
export type UpdatePublicEWebinarMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePublicEWebinarMutation, Types.UpdatePublicEWebinarMutationVariables>;
export const GetEwebinarSectionsFromTemplateDocument = gql`
    query getEwebinarSectionsFromTemplate($setId: String!) {
  ewebinarTemplateFrom(setId: $setId) {
    ...PageSettings
  }
}
    ${PageSettingsFragmentDoc}`;
export type GetEwebinarSectionsFromTemplateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>, 'query'> & ({ variables: Types.GetEwebinarSectionsFromTemplateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEwebinarSectionsFromTemplateComponent = (props: GetEwebinarSectionsFromTemplateComponentProps) => (
      <ApolloReactComponents.Query<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables> query={GetEwebinarSectionsFromTemplateDocument} {...props} />
    );
    

/**
 * __useGetEwebinarSectionsFromTemplateQuery__
 *
 * To run a query within a React component, call `useGetEwebinarSectionsFromTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEwebinarSectionsFromTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEwebinarSectionsFromTemplateQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useGetEwebinarSectionsFromTemplateQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables> & ({ variables: Types.GetEwebinarSectionsFromTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>(GetEwebinarSectionsFromTemplateDocument, options);
      }
export function useGetEwebinarSectionsFromTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>(GetEwebinarSectionsFromTemplateDocument, options);
        }
export function useGetEwebinarSectionsFromTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>(GetEwebinarSectionsFromTemplateDocument, options);
        }
export type GetEwebinarSectionsFromTemplateQueryHookResult = ReturnType<typeof useGetEwebinarSectionsFromTemplateQuery>;
export type GetEwebinarSectionsFromTemplateLazyQueryHookResult = ReturnType<typeof useGetEwebinarSectionsFromTemplateLazyQuery>;
export type GetEwebinarSectionsFromTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEwebinarSectionsFromTemplateSuspenseQuery>;
export type GetEwebinarSectionsFromTemplateQueryResult = Apollo.QueryResult<Types.GetEwebinarSectionsFromTemplateQuery, Types.GetEwebinarSectionsFromTemplateQueryVariables>;
export const BlockRegistrantsDocument = gql`
    mutation blockRegistrants($setId: String!, $emails: [String!]!) {
  blockRegistrants(setId: $setId, emails: $emails) {
    id
    setSettings {
      ...SetSettings
    }
  }
}
    ${SetSettingsFragmentDoc}`;
export type BlockRegistrantsMutationFn = Apollo.MutationFunction<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables>;
export type BlockRegistrantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables>, 'mutation'>;

    export const BlockRegistrantsComponent = (props: BlockRegistrantsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables> mutation={BlockRegistrantsDocument} {...props} />
    );
    

/**
 * __useBlockRegistrantsMutation__
 *
 * To run a mutation, you first call `useBlockRegistrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockRegistrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockRegistrantsMutation, { data, loading, error }] = useBlockRegistrantsMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useBlockRegistrantsMutation(baseOptions?: Apollo.MutationHookOptions<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables>(BlockRegistrantsDocument, options);
      }
export type BlockRegistrantsMutationHookResult = ReturnType<typeof useBlockRegistrantsMutation>;
export type BlockRegistrantsMutationResult = Apollo.MutationResult<Types.BlockRegistrantsMutation>;
export type BlockRegistrantsMutationOptions = Apollo.BaseMutationOptions<Types.BlockRegistrantsMutation, Types.BlockRegistrantsMutationVariables>;
export const UnblockRegistrantsDocument = gql`
    mutation unblockRegistrants($setId: String!, $emails: [String!]!) {
  unblockRegistrants(setId: $setId, emails: $emails) {
    id
    setSettings {
      ...SetSettings
    }
  }
}
    ${SetSettingsFragmentDoc}`;
export type UnblockRegistrantsMutationFn = Apollo.MutationFunction<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables>;
export type UnblockRegistrantsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables>, 'mutation'>;

    export const UnblockRegistrantsComponent = (props: UnblockRegistrantsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables> mutation={UnblockRegistrantsDocument} {...props} />
    );
    

/**
 * __useUnblockRegistrantsMutation__
 *
 * To run a mutation, you first call `useUnblockRegistrantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockRegistrantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockRegistrantsMutation, { data, loading, error }] = useUnblockRegistrantsMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useUnblockRegistrantsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables>(UnblockRegistrantsDocument, options);
      }
export type UnblockRegistrantsMutationHookResult = ReturnType<typeof useUnblockRegistrantsMutation>;
export type UnblockRegistrantsMutationResult = Apollo.MutationResult<Types.UnblockRegistrantsMutation>;
export type UnblockRegistrantsMutationOptions = Apollo.BaseMutationOptions<Types.UnblockRegistrantsMutation, Types.UnblockRegistrantsMutationVariables>;
export const BlockRegistrantInSetsDocument = gql`
    mutation blockRegistrantInSets($email: String!, $setIds: [String!]!) {
  blockRegistrantInSets(email: $email, setIds: $setIds) {
    id
  }
}
    `;
export type BlockRegistrantInSetsMutationFn = Apollo.MutationFunction<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables>;
export type BlockRegistrantInSetsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables>, 'mutation'>;

    export const BlockRegistrantInSetsComponent = (props: BlockRegistrantInSetsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables> mutation={BlockRegistrantInSetsDocument} {...props} />
    );
    

/**
 * __useBlockRegistrantInSetsMutation__
 *
 * To run a mutation, you first call `useBlockRegistrantInSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockRegistrantInSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockRegistrantInSetsMutation, { data, loading, error }] = useBlockRegistrantInSetsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      setIds: // value for 'setIds'
 *   },
 * });
 */
export function useBlockRegistrantInSetsMutation(baseOptions?: Apollo.MutationHookOptions<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables>(BlockRegistrantInSetsDocument, options);
      }
export type BlockRegistrantInSetsMutationHookResult = ReturnType<typeof useBlockRegistrantInSetsMutation>;
export type BlockRegistrantInSetsMutationResult = Apollo.MutationResult<Types.BlockRegistrantInSetsMutation>;
export type BlockRegistrantInSetsMutationOptions = Apollo.BaseMutationOptions<Types.BlockRegistrantInSetsMutation, Types.BlockRegistrantInSetsMutationVariables>;
export const UnblockRegistrantInSetsDocument = gql`
    mutation unblockRegistrantInSets($email: String!, $setIds: [String!]!) {
  unblockRegistrantInSets(email: $email, setIds: $setIds) {
    id
  }
}
    `;
export type UnblockRegistrantInSetsMutationFn = Apollo.MutationFunction<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables>;
export type UnblockRegistrantInSetsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables>, 'mutation'>;

    export const UnblockRegistrantInSetsComponent = (props: UnblockRegistrantInSetsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables> mutation={UnblockRegistrantInSetsDocument} {...props} />
    );
    

/**
 * __useUnblockRegistrantInSetsMutation__
 *
 * To run a mutation, you first call `useUnblockRegistrantInSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockRegistrantInSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockRegistrantInSetsMutation, { data, loading, error }] = useUnblockRegistrantInSetsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      setIds: // value for 'setIds'
 *   },
 * });
 */
export function useUnblockRegistrantInSetsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables>(UnblockRegistrantInSetsDocument, options);
      }
export type UnblockRegistrantInSetsMutationHookResult = ReturnType<typeof useUnblockRegistrantInSetsMutation>;
export type UnblockRegistrantInSetsMutationResult = Apollo.MutationResult<Types.UnblockRegistrantInSetsMutation>;
export type UnblockRegistrantInSetsMutationOptions = Apollo.BaseMutationOptions<Types.UnblockRegistrantInSetsMutation, Types.UnblockRegistrantInSetsMutationVariables>;
export const UpdateEwebinarTagsDocument = gql`
    mutation updateEwebinarTags($setId: String!, $tags: [String!]!) {
  updateEwebinarTags(setId: $setId, tags: $tags) {
    id
  }
}
    `;
export type UpdateEwebinarTagsMutationFn = Apollo.MutationFunction<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables>;
export type UpdateEwebinarTagsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables>, 'mutation'>;

    export const UpdateEwebinarTagsComponent = (props: UpdateEwebinarTagsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables> mutation={UpdateEwebinarTagsDocument} {...props} />
    );
    

/**
 * __useUpdateEwebinarTagsMutation__
 *
 * To run a mutation, you first call `useUpdateEwebinarTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEwebinarTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEwebinarTagsMutation, { data, loading, error }] = useUpdateEwebinarTagsMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateEwebinarTagsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables>(UpdateEwebinarTagsDocument, options);
      }
export type UpdateEwebinarTagsMutationHookResult = ReturnType<typeof useUpdateEwebinarTagsMutation>;
export type UpdateEwebinarTagsMutationResult = Apollo.MutationResult<Types.UpdateEwebinarTagsMutation>;
export type UpdateEwebinarTagsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateEwebinarTagsMutation, Types.UpdateEwebinarTagsMutationVariables>;
export const WidgetSettingsDocument = gql`
    query widgetSettings($setId: String!) {
  publicSet(id: $setId) {
    id
    widgetSettings
  }
}
    `;
export type WidgetSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>, 'query'> & ({ variables: Types.WidgetSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WidgetSettingsComponent = (props: WidgetSettingsComponentProps) => (
      <ApolloReactComponents.Query<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables> query={WidgetSettingsDocument} {...props} />
    );
    

/**
 * __useWidgetSettingsQuery__
 *
 * To run a query within a React component, call `useWidgetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetSettingsQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useWidgetSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables> & ({ variables: Types.WidgetSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>(WidgetSettingsDocument, options);
      }
export function useWidgetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>(WidgetSettingsDocument, options);
        }
export function useWidgetSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>(WidgetSettingsDocument, options);
        }
export type WidgetSettingsQueryHookResult = ReturnType<typeof useWidgetSettingsQuery>;
export type WidgetSettingsLazyQueryHookResult = ReturnType<typeof useWidgetSettingsLazyQuery>;
export type WidgetSettingsSuspenseQueryHookResult = ReturnType<typeof useWidgetSettingsSuspenseQuery>;
export type WidgetSettingsQueryResult = Apollo.QueryResult<Types.WidgetSettingsQuery, Types.WidgetSettingsQueryVariables>;
export const UpdateWidgetSettingsDocument = gql`
    mutation updateWidgetSettings($setId: String!, $widgetSettings: JSON!) {
  updateWidgetSettings(setId: $setId, widgetSettings: $widgetSettings) {
    id
    widgetSettings
  }
}
    `;
export type UpdateWidgetSettingsMutationFn = Apollo.MutationFunction<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables>;
export type UpdateWidgetSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables>, 'mutation'>;

    export const UpdateWidgetSettingsComponent = (props: UpdateWidgetSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables> mutation={UpdateWidgetSettingsDocument} {...props} />
    );
    

/**
 * __useUpdateWidgetSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetSettingsMutation, { data, loading, error }] = useUpdateWidgetSettingsMutation({
 *   variables: {
 *      setId: // value for 'setId'
 *      widgetSettings: // value for 'widgetSettings'
 *   },
 * });
 */
export function useUpdateWidgetSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables>(UpdateWidgetSettingsDocument, options);
      }
export type UpdateWidgetSettingsMutationHookResult = ReturnType<typeof useUpdateWidgetSettingsMutation>;
export type UpdateWidgetSettingsMutationResult = Apollo.MutationResult<Types.UpdateWidgetSettingsMutation>;
export type UpdateWidgetSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateWidgetSettingsMutation, Types.UpdateWidgetSettingsMutationVariables>;
export const UpdateDashboardSettingsDocument = gql`
    mutation updateDashboardSettings($settings: AnalyticsSettingsInput!, $setId: String) {
  updateDashboardSettings(settings: $settings, setId: $setId) {
    set {
      id
      analyticsStartDate
    }
    team {
      id
      timezone
    }
    me {
      id
      timezone
    }
  }
}
    `;
export type UpdateDashboardSettingsMutationFn = Apollo.MutationFunction<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables>;
export type UpdateDashboardSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables>, 'mutation'>;

    export const UpdateDashboardSettingsComponent = (props: UpdateDashboardSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables> mutation={UpdateDashboardSettingsDocument} {...props} />
    );
    

/**
 * __useUpdateDashboardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardSettingsMutation, { data, loading, error }] = useUpdateDashboardSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useUpdateDashboardSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables>(UpdateDashboardSettingsDocument, options);
      }
export type UpdateDashboardSettingsMutationHookResult = ReturnType<typeof useUpdateDashboardSettingsMutation>;
export type UpdateDashboardSettingsMutationResult = Apollo.MutationResult<Types.UpdateDashboardSettingsMutation>;
export type UpdateDashboardSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDashboardSettingsMutation, Types.UpdateDashboardSettingsMutationVariables>;
export const StartTranscribingDocument = gql`
    mutation startTranscribing($ewebinarId: String!) {
  startTranscribing(ewebinarId: $ewebinarId) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type StartTranscribingMutationFn = Apollo.MutationFunction<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables>;
export type StartTranscribingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables>, 'mutation'>;

    export const StartTranscribingComponent = (props: StartTranscribingComponentProps) => (
      <ApolloReactComponents.Mutation<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables> mutation={StartTranscribingDocument} {...props} />
    );
    

/**
 * __useStartTranscribingMutation__
 *
 * To run a mutation, you first call `useStartTranscribingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTranscribingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTranscribingMutation, { data, loading, error }] = useStartTranscribingMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *   },
 * });
 */
export function useStartTranscribingMutation(baseOptions?: Apollo.MutationHookOptions<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables>(StartTranscribingDocument, options);
      }
export type StartTranscribingMutationHookResult = ReturnType<typeof useStartTranscribingMutation>;
export type StartTranscribingMutationResult = Apollo.MutationResult<Types.StartTranscribingMutation>;
export type StartTranscribingMutationOptions = Apollo.BaseMutationOptions<Types.StartTranscribingMutation, Types.StartTranscribingMutationVariables>;
export const GenerateAiInteractionsDocument = gql`
    mutation generateAIInteractions($ewebinarId: String!, $userPrompt: String) {
  generateAIInteractions(ewebinarId: $ewebinarId, userPrompt: $userPrompt) {
    ...DraftInteraction
  }
}
    ${DraftInteractionFragmentDoc}`;
export type GenerateAiInteractionsMutationFn = Apollo.MutationFunction<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables>;
export type GenerateAiInteractionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables>, 'mutation'>;

    export const GenerateAiInteractionsComponent = (props: GenerateAiInteractionsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables> mutation={GenerateAiInteractionsDocument} {...props} />
    );
    

/**
 * __useGenerateAiInteractionsMutation__
 *
 * To run a mutation, you first call `useGenerateAiInteractionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiInteractionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiInteractionsMutation, { data, loading, error }] = useGenerateAiInteractionsMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      userPrompt: // value for 'userPrompt'
 *   },
 * });
 */
export function useGenerateAiInteractionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables>(GenerateAiInteractionsDocument, options);
      }
export type GenerateAiInteractionsMutationHookResult = ReturnType<typeof useGenerateAiInteractionsMutation>;
export type GenerateAiInteractionsMutationResult = Apollo.MutationResult<Types.GenerateAiInteractionsMutation>;
export type GenerateAiInteractionsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateAiInteractionsMutation, Types.GenerateAiInteractionsMutationVariables>;
export const GenerateAiInteractionAtDocument = gql`
    mutation generateAIInteractionAt($ewebinarId: String!, $atSecs: Float!, $type: String) {
  generateAIInteractionAt(ewebinarId: $ewebinarId, atSecs: $atSecs, type: $type) {
    ...DraftInteraction
  }
}
    ${DraftInteractionFragmentDoc}`;
export type GenerateAiInteractionAtMutationFn = Apollo.MutationFunction<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables>;
export type GenerateAiInteractionAtComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables>, 'mutation'>;

    export const GenerateAiInteractionAtComponent = (props: GenerateAiInteractionAtComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables> mutation={GenerateAiInteractionAtDocument} {...props} />
    );
    

/**
 * __useGenerateAiInteractionAtMutation__
 *
 * To run a mutation, you first call `useGenerateAiInteractionAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiInteractionAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiInteractionAtMutation, { data, loading, error }] = useGenerateAiInteractionAtMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      atSecs: // value for 'atSecs'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenerateAiInteractionAtMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables>(GenerateAiInteractionAtDocument, options);
      }
export type GenerateAiInteractionAtMutationHookResult = ReturnType<typeof useGenerateAiInteractionAtMutation>;
export type GenerateAiInteractionAtMutationResult = Apollo.MutationResult<Types.GenerateAiInteractionAtMutation>;
export type GenerateAiInteractionAtMutationOptions = Apollo.BaseMutationOptions<Types.GenerateAiInteractionAtMutation, Types.GenerateAiInteractionAtMutationVariables>;
export const WebinarVideoResponseDocument = gql`
    query webinarVideoResponse($ewebinarId: String!) {
  webinarVideoResponse(ewebinarId: $ewebinarId) {
    statusCode
    statusText
  }
}
    `;
export type WebinarVideoResponseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>, 'query'> & ({ variables: Types.WebinarVideoResponseQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WebinarVideoResponseComponent = (props: WebinarVideoResponseComponentProps) => (
      <ApolloReactComponents.Query<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables> query={WebinarVideoResponseDocument} {...props} />
    );
    

/**
 * __useWebinarVideoResponseQuery__
 *
 * To run a query within a React component, call `useWebinarVideoResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebinarVideoResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebinarVideoResponseQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *   },
 * });
 */
export function useWebinarVideoResponseQuery(baseOptions: Apollo.QueryHookOptions<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables> & ({ variables: Types.WebinarVideoResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>(WebinarVideoResponseDocument, options);
      }
export function useWebinarVideoResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>(WebinarVideoResponseDocument, options);
        }
export function useWebinarVideoResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>(WebinarVideoResponseDocument, options);
        }
export type WebinarVideoResponseQueryHookResult = ReturnType<typeof useWebinarVideoResponseQuery>;
export type WebinarVideoResponseLazyQueryHookResult = ReturnType<typeof useWebinarVideoResponseLazyQuery>;
export type WebinarVideoResponseSuspenseQueryHookResult = ReturnType<typeof useWebinarVideoResponseSuspenseQuery>;
export type WebinarVideoResponseQueryResult = Apollo.QueryResult<Types.WebinarVideoResponseQuery, Types.WebinarVideoResponseQueryVariables>;
export const GeneratePageDocument = gql`
    mutation generatePage($ewebinarId: String!, $page: PageType!, $userPrompt: String) {
  generatePage(ewebinarId: $ewebinarId, page: $page, userPrompt: $userPrompt) {
    sections {
      ...PageSection
    }
  }
}
    ${PageSectionFragmentDoc}`;
export type GeneratePageMutationFn = Apollo.MutationFunction<Types.GeneratePageMutation, Types.GeneratePageMutationVariables>;
export type GeneratePageComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GeneratePageMutation, Types.GeneratePageMutationVariables>, 'mutation'>;

    export const GeneratePageComponent = (props: GeneratePageComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GeneratePageMutation, Types.GeneratePageMutationVariables> mutation={GeneratePageDocument} {...props} />
    );
    

/**
 * __useGeneratePageMutation__
 *
 * To run a mutation, you first call `useGeneratePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePageMutation, { data, loading, error }] = useGeneratePageMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      page: // value for 'page'
 *      userPrompt: // value for 'userPrompt'
 *   },
 * });
 */
export function useGeneratePageMutation(baseOptions?: Apollo.MutationHookOptions<Types.GeneratePageMutation, Types.GeneratePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GeneratePageMutation, Types.GeneratePageMutationVariables>(GeneratePageDocument, options);
      }
export type GeneratePageMutationHookResult = ReturnType<typeof useGeneratePageMutation>;
export type GeneratePageMutationResult = Apollo.MutationResult<Types.GeneratePageMutation>;
export type GeneratePageMutationOptions = Apollo.BaseMutationOptions<Types.GeneratePageMutation, Types.GeneratePageMutationVariables>;
export const RewritePageSectionDocument = gql`
    mutation rewritePageSection($ewebinarId: String!, $page: PageType!, $section: PageSectionInput!, $userPrompt: String!) {
  rewritePageSection(
    ewebinarId: $ewebinarId
    page: $page
    section: $section
    userPrompt: $userPrompt
  ) {
    ...PageSection
  }
}
    ${PageSectionFragmentDoc}`;
export type RewritePageSectionMutationFn = Apollo.MutationFunction<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables>;
export type RewritePageSectionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables>, 'mutation'>;

    export const RewritePageSectionComponent = (props: RewritePageSectionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables> mutation={RewritePageSectionDocument} {...props} />
    );
    

/**
 * __useRewritePageSectionMutation__
 *
 * To run a mutation, you first call `useRewritePageSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRewritePageSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rewritePageSectionMutation, { data, loading, error }] = useRewritePageSectionMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      page: // value for 'page'
 *      section: // value for 'section'
 *      userPrompt: // value for 'userPrompt'
 *   },
 * });
 */
export function useRewritePageSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables>(RewritePageSectionDocument, options);
      }
export type RewritePageSectionMutationHookResult = ReturnType<typeof useRewritePageSectionMutation>;
export type RewritePageSectionMutationResult = Apollo.MutationResult<Types.RewritePageSectionMutation>;
export type RewritePageSectionMutationOptions = Apollo.BaseMutationOptions<Types.RewritePageSectionMutation, Types.RewritePageSectionMutationVariables>;
export const DisableSetChatbotDocument = gql`
    mutation disableSetChatbot($id: String!) {
  disableSetChatbot(id: $id)
}
    `;
export type DisableSetChatbotMutationFn = Apollo.MutationFunction<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables>;
export type DisableSetChatbotComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables>, 'mutation'>;

    export const DisableSetChatbotComponent = (props: DisableSetChatbotComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables> mutation={DisableSetChatbotDocument} {...props} />
    );
    

/**
 * __useDisableSetChatbotMutation__
 *
 * To run a mutation, you first call `useDisableSetChatbotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSetChatbotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSetChatbotMutation, { data, loading, error }] = useDisableSetChatbotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableSetChatbotMutation(baseOptions?: Apollo.MutationHookOptions<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables>(DisableSetChatbotDocument, options);
      }
export type DisableSetChatbotMutationHookResult = ReturnType<typeof useDisableSetChatbotMutation>;
export type DisableSetChatbotMutationResult = Apollo.MutationResult<Types.DisableSetChatbotMutation>;
export type DisableSetChatbotMutationOptions = Apollo.BaseMutationOptions<Types.DisableSetChatbotMutation, Types.DisableSetChatbotMutationVariables>;
export const TeamIntegrationsDocument = gql`
    query teamIntegrations {
  teamIntegrations {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;
export type TeamIntegrationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>, 'query'>;

    export const TeamIntegrationsComponent = (props: TeamIntegrationsComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables> query={TeamIntegrationsDocument} {...props} />
    );
    

/**
 * __useTeamIntegrationsQuery__
 *
 * To run a query within a React component, call `useTeamIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>(TeamIntegrationsDocument, options);
      }
export function useTeamIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>(TeamIntegrationsDocument, options);
        }
export function useTeamIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>(TeamIntegrationsDocument, options);
        }
export type TeamIntegrationsQueryHookResult = ReturnType<typeof useTeamIntegrationsQuery>;
export type TeamIntegrationsLazyQueryHookResult = ReturnType<typeof useTeamIntegrationsLazyQuery>;
export type TeamIntegrationsSuspenseQueryHookResult = ReturnType<typeof useTeamIntegrationsSuspenseQuery>;
export type TeamIntegrationsQueryResult = Apollo.QueryResult<Types.TeamIntegrationsQuery, Types.TeamIntegrationsQueryVariables>;
export const IntegrationTypesDocument = gql`
    query integrationTypes {
  integrationTypes {
    type
    inBeta
    inAlpha
  }
}
    `;
export type IntegrationTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>, 'query'>;

    export const IntegrationTypesComponent = (props: IntegrationTypesComponentProps) => (
      <ApolloReactComponents.Query<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables> query={IntegrationTypesDocument} {...props} />
    );
    

/**
 * __useIntegrationTypesQuery__
 *
 * To run a query within a React component, call `useIntegrationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationTypesQuery(baseOptions?: Apollo.QueryHookOptions<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>(IntegrationTypesDocument, options);
      }
export function useIntegrationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>(IntegrationTypesDocument, options);
        }
export function useIntegrationTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>(IntegrationTypesDocument, options);
        }
export type IntegrationTypesQueryHookResult = ReturnType<typeof useIntegrationTypesQuery>;
export type IntegrationTypesLazyQueryHookResult = ReturnType<typeof useIntegrationTypesLazyQuery>;
export type IntegrationTypesSuspenseQueryHookResult = ReturnType<typeof useIntegrationTypesSuspenseQuery>;
export type IntegrationTypesQueryResult = Apollo.QueryResult<Types.IntegrationTypesQuery, Types.IntegrationTypesQueryVariables>;
export const AddIntegrationDocument = gql`
    mutation addIntegration($data: IntegrationUpdateInput!) {
  addIntegration(data: $data) {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;
export type AddIntegrationMutationFn = Apollo.MutationFunction<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables>;
export type AddIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables>, 'mutation'>;

    export const AddIntegrationComponent = (props: AddIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables> mutation={AddIntegrationDocument} {...props} />
    );
    

/**
 * __useAddIntegrationMutation__
 *
 * To run a mutation, you first call `useAddIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIntegrationMutation, { data, loading, error }] = useAddIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables>(AddIntegrationDocument, options);
      }
export type AddIntegrationMutationHookResult = ReturnType<typeof useAddIntegrationMutation>;
export type AddIntegrationMutationResult = Apollo.MutationResult<Types.AddIntegrationMutation>;
export type AddIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.AddIntegrationMutation, Types.AddIntegrationMutationVariables>;
export const UpdateIntegrationDocument = gql`
    mutation updateIntegration($data: IntegrationUpdateInput!) {
  updateIntegration(data: $data) {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>;
export type UpdateIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>, 'mutation'>;

    export const UpdateIntegrationComponent = (props: UpdateIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables> mutation={UpdateIntegrationDocument} {...props} />
    );
    

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<Types.UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateIntegrationMutation, Types.UpdateIntegrationMutationVariables>;
export const RemoveIntegrationDocument = gql`
    mutation removeIntegration($id: String!, $integrationHookId: String) {
  removeIntegration(id: $id, integrationHookId: $integrationHookId)
}
    `;
export type RemoveIntegrationMutationFn = Apollo.MutationFunction<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>;
export type RemoveIntegrationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>, 'mutation'>;

    export const RemoveIntegrationComponent = (props: RemoveIntegrationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables> mutation={RemoveIntegrationDocument} {...props} />
    );
    

/**
 * __useRemoveIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIntegrationMutation, { data, loading, error }] = useRemoveIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      integrationHookId: // value for 'integrationHookId'
 *   },
 * });
 */
export function useRemoveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>(RemoveIntegrationDocument, options);
      }
export type RemoveIntegrationMutationHookResult = ReturnType<typeof useRemoveIntegrationMutation>;
export type RemoveIntegrationMutationResult = Apollo.MutationResult<Types.RemoveIntegrationMutation>;
export type RemoveIntegrationMutationOptions = Apollo.BaseMutationOptions<Types.RemoveIntegrationMutation, Types.RemoveIntegrationMutationVariables>;
export const RegenerateIntegrationKeyDocument = gql`
    mutation regenerateIntegrationKey($id: String!) {
  regenerateIntegrationKey(id: $id) {
    ...Integration
  }
}
    ${IntegrationFragmentDoc}`;
export type RegenerateIntegrationKeyMutationFn = Apollo.MutationFunction<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables>;
export type RegenerateIntegrationKeyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables>, 'mutation'>;

    export const RegenerateIntegrationKeyComponent = (props: RegenerateIntegrationKeyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables> mutation={RegenerateIntegrationKeyDocument} {...props} />
    );
    

/**
 * __useRegenerateIntegrationKeyMutation__
 *
 * To run a mutation, you first call `useRegenerateIntegrationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateIntegrationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateIntegrationKeyMutation, { data, loading, error }] = useRegenerateIntegrationKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateIntegrationKeyMutation(baseOptions?: Apollo.MutationHookOptions<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables>(RegenerateIntegrationKeyDocument, options);
      }
export type RegenerateIntegrationKeyMutationHookResult = ReturnType<typeof useRegenerateIntegrationKeyMutation>;
export type RegenerateIntegrationKeyMutationResult = Apollo.MutationResult<Types.RegenerateIntegrationKeyMutation>;
export type RegenerateIntegrationKeyMutationOptions = Apollo.BaseMutationOptions<Types.RegenerateIntegrationKeyMutation, Types.RegenerateIntegrationKeyMutationVariables>;
export const ToggleIntegrationHookDocument = gql`
    mutation toggleIntegrationHook($id: String!, $on: Boolean!) {
  toggleIntegrationHook(id: $id, on: $on) {
    ...IntegrationHook
  }
}
    ${IntegrationHookFragmentDoc}`;
export type ToggleIntegrationHookMutationFn = Apollo.MutationFunction<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables>;
export type ToggleIntegrationHookComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables>, 'mutation'>;

    export const ToggleIntegrationHookComponent = (props: ToggleIntegrationHookComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables> mutation={ToggleIntegrationHookDocument} {...props} />
    );
    

/**
 * __useToggleIntegrationHookMutation__
 *
 * To run a mutation, you first call `useToggleIntegrationHookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIntegrationHookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIntegrationHookMutation, { data, loading, error }] = useToggleIntegrationHookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      on: // value for 'on'
 *   },
 * });
 */
export function useToggleIntegrationHookMutation(baseOptions?: Apollo.MutationHookOptions<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables>(ToggleIntegrationHookDocument, options);
      }
export type ToggleIntegrationHookMutationHookResult = ReturnType<typeof useToggleIntegrationHookMutation>;
export type ToggleIntegrationHookMutationResult = Apollo.MutationResult<Types.ToggleIntegrationHookMutation>;
export type ToggleIntegrationHookMutationOptions = Apollo.BaseMutationOptions<Types.ToggleIntegrationHookMutation, Types.ToggleIntegrationHookMutationVariables>;
export const SsoUserInfoDocument = gql`
    query ssoUserInfo($setId: String!, $attendeeId: String) {
  ssoUserInfo(setId: $setId, attendeeId: $attendeeId) {
    sub
    email
    name
    given_name
    family_name
    middle_name
    phone_number
    address
    locale
  }
}
    `;
export type SsoUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>, 'query'> & ({ variables: Types.SsoUserInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SsoUserInfoComponent = (props: SsoUserInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables> query={SsoUserInfoDocument} {...props} />
    );
    

/**
 * __useSsoUserInfoQuery__
 *
 * To run a query within a React component, call `useSsoUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoUserInfoQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useSsoUserInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables> & ({ variables: Types.SsoUserInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>(SsoUserInfoDocument, options);
      }
export function useSsoUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>(SsoUserInfoDocument, options);
        }
export function useSsoUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>(SsoUserInfoDocument, options);
        }
export type SsoUserInfoQueryHookResult = ReturnType<typeof useSsoUserInfoQuery>;
export type SsoUserInfoLazyQueryHookResult = ReturnType<typeof useSsoUserInfoLazyQuery>;
export type SsoUserInfoSuspenseQueryHookResult = ReturnType<typeof useSsoUserInfoSuspenseQuery>;
export type SsoUserInfoQueryResult = Apollo.QueryResult<Types.SsoUserInfoQuery, Types.SsoUserInfoQueryVariables>;
export const IntegrationActionsFilteredDocument = gql`
    query integrationActionsFiltered($filters: IntegrationActionsFilter!) {
  integrationActionsFiltered(filters: $filters) {
    total
    nextCursor
    integrationActions {
      ...IntegrationAction
    }
  }
}
    ${IntegrationActionFragmentDoc}`;
export type IntegrationActionsFilteredComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>, 'query'> & ({ variables: Types.IntegrationActionsFilteredQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IntegrationActionsFilteredComponent = (props: IntegrationActionsFilteredComponentProps) => (
      <ApolloReactComponents.Query<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables> query={IntegrationActionsFilteredDocument} {...props} />
    );
    

/**
 * __useIntegrationActionsFilteredQuery__
 *
 * To run a query within a React component, call `useIntegrationActionsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationActionsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationActionsFilteredQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIntegrationActionsFilteredQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables> & ({ variables: Types.IntegrationActionsFilteredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>(IntegrationActionsFilteredDocument, options);
      }
export function useIntegrationActionsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>(IntegrationActionsFilteredDocument, options);
        }
export function useIntegrationActionsFilteredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>(IntegrationActionsFilteredDocument, options);
        }
export type IntegrationActionsFilteredQueryHookResult = ReturnType<typeof useIntegrationActionsFilteredQuery>;
export type IntegrationActionsFilteredLazyQueryHookResult = ReturnType<typeof useIntegrationActionsFilteredLazyQuery>;
export type IntegrationActionsFilteredSuspenseQueryHookResult = ReturnType<typeof useIntegrationActionsFilteredSuspenseQuery>;
export type IntegrationActionsFilteredQueryResult = Apollo.QueryResult<Types.IntegrationActionsFilteredQuery, Types.IntegrationActionsFilteredQueryVariables>;
export const RetryIntegrationHookDocument = gql`
    mutation retryIntegrationHook($id: String!) {
  retryIntegrationHook(id: $id) {
    ...IntegrationAction
  }
}
    ${IntegrationActionFragmentDoc}`;
export type RetryIntegrationHookMutationFn = Apollo.MutationFunction<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables>;
export type RetryIntegrationHookComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables>, 'mutation'>;

    export const RetryIntegrationHookComponent = (props: RetryIntegrationHookComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables> mutation={RetryIntegrationHookDocument} {...props} />
    );
    

/**
 * __useRetryIntegrationHookMutation__
 *
 * To run a mutation, you first call `useRetryIntegrationHookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryIntegrationHookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryIntegrationHookMutation, { data, loading, error }] = useRetryIntegrationHookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryIntegrationHookMutation(baseOptions?: Apollo.MutationHookOptions<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables>(RetryIntegrationHookDocument, options);
      }
export type RetryIntegrationHookMutationHookResult = ReturnType<typeof useRetryIntegrationHookMutation>;
export type RetryIntegrationHookMutationResult = Apollo.MutationResult<Types.RetryIntegrationHookMutation>;
export type RetryIntegrationHookMutationOptions = Apollo.BaseMutationOptions<Types.RetryIntegrationHookMutation, Types.RetryIntegrationHookMutationVariables>;
export const BuiltInPropertyDescriptionsDocument = gql`
    query builtInPropertyDescriptions($consumer: String) {
  builtInPropertyDescriptions(consumer: $consumer) {
    ...ActionPropertyDescription
  }
}
    ${ActionPropertyDescriptionFragmentDoc}`;
export type BuiltInPropertyDescriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>, 'query'>;

    export const BuiltInPropertyDescriptionsComponent = (props: BuiltInPropertyDescriptionsComponentProps) => (
      <ApolloReactComponents.Query<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables> query={BuiltInPropertyDescriptionsDocument} {...props} />
    );
    

/**
 * __useBuiltInPropertyDescriptionsQuery__
 *
 * To run a query within a React component, call `useBuiltInPropertyDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuiltInPropertyDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuiltInPropertyDescriptionsQuery({
 *   variables: {
 *      consumer: // value for 'consumer'
 *   },
 * });
 */
export function useBuiltInPropertyDescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>(BuiltInPropertyDescriptionsDocument, options);
      }
export function useBuiltInPropertyDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>(BuiltInPropertyDescriptionsDocument, options);
        }
export function useBuiltInPropertyDescriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>(BuiltInPropertyDescriptionsDocument, options);
        }
export type BuiltInPropertyDescriptionsQueryHookResult = ReturnType<typeof useBuiltInPropertyDescriptionsQuery>;
export type BuiltInPropertyDescriptionsLazyQueryHookResult = ReturnType<typeof useBuiltInPropertyDescriptionsLazyQuery>;
export type BuiltInPropertyDescriptionsSuspenseQueryHookResult = ReturnType<typeof useBuiltInPropertyDescriptionsSuspenseQuery>;
export type BuiltInPropertyDescriptionsQueryResult = Apollo.QueryResult<Types.BuiltInPropertyDescriptionsQuery, Types.BuiltInPropertyDescriptionsQueryVariables>;
export const PropertyDescriptionsDocument = gql`
    query propertyDescriptions($filter: PropertyFilterInput!) {
  propertyDescriptions(filter: $filter) {
    ...ActionPropertyDescription
  }
}
    ${ActionPropertyDescriptionFragmentDoc}`;
export type PropertyDescriptionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>, 'query'> & ({ variables: Types.PropertyDescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PropertyDescriptionsComponent = (props: PropertyDescriptionsComponentProps) => (
      <ApolloReactComponents.Query<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables> query={PropertyDescriptionsDocument} {...props} />
    );
    

/**
 * __usePropertyDescriptionsQuery__
 *
 * To run a query within a React component, call `usePropertyDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDescriptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyDescriptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables> & ({ variables: Types.PropertyDescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>(PropertyDescriptionsDocument, options);
      }
export function usePropertyDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>(PropertyDescriptionsDocument, options);
        }
export function usePropertyDescriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>(PropertyDescriptionsDocument, options);
        }
export type PropertyDescriptionsQueryHookResult = ReturnType<typeof usePropertyDescriptionsQuery>;
export type PropertyDescriptionsLazyQueryHookResult = ReturnType<typeof usePropertyDescriptionsLazyQuery>;
export type PropertyDescriptionsSuspenseQueryHookResult = ReturnType<typeof usePropertyDescriptionsSuspenseQuery>;
export type PropertyDescriptionsQueryResult = Apollo.QueryResult<Types.PropertyDescriptionsQuery, Types.PropertyDescriptionsQueryVariables>;
export const ViewIntegrationsDocument = gql`
    mutation viewIntegrations($integrationId: String, $integrationHookId: String) {
  viewIntegrations(
    integrationId: $integrationId
    integrationHookId: $integrationHookId
  ) {
    integration {
      id
      totalErrors
      errorResetAt
    }
    integrationHook {
      id
      totalErrors
      errorResetAt
    }
  }
}
    `;
export type ViewIntegrationsMutationFn = Apollo.MutationFunction<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables>;
export type ViewIntegrationsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables>, 'mutation'>;

    export const ViewIntegrationsComponent = (props: ViewIntegrationsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables> mutation={ViewIntegrationsDocument} {...props} />
    );
    

/**
 * __useViewIntegrationsMutation__
 *
 * To run a mutation, you first call `useViewIntegrationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewIntegrationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewIntegrationsMutation, { data, loading, error }] = useViewIntegrationsMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      integrationHookId: // value for 'integrationHookId'
 *   },
 * });
 */
export function useViewIntegrationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables>(ViewIntegrationsDocument, options);
      }
export type ViewIntegrationsMutationHookResult = ReturnType<typeof useViewIntegrationsMutation>;
export type ViewIntegrationsMutationResult = Apollo.MutationResult<Types.ViewIntegrationsMutation>;
export type ViewIntegrationsMutationOptions = Apollo.BaseMutationOptions<Types.ViewIntegrationsMutation, Types.ViewIntegrationsMutationVariables>;
export const ChatbaseAgentsDocument = gql`
    query chatbaseAgents {
  chatbaseAgents {
    id
    name
    displayName
    status
    avatarMediaRef {
      url
      imageUrl
    }
  }
}
    `;
export type ChatbaseAgentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>, 'query'>;

    export const ChatbaseAgentsComponent = (props: ChatbaseAgentsComponentProps) => (
      <ApolloReactComponents.Query<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables> query={ChatbaseAgentsDocument} {...props} />
    );
    

/**
 * __useChatbaseAgentsQuery__
 *
 * To run a query within a React component, call `useChatbaseAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatbaseAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatbaseAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatbaseAgentsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>(ChatbaseAgentsDocument, options);
      }
export function useChatbaseAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>(ChatbaseAgentsDocument, options);
        }
export function useChatbaseAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>(ChatbaseAgentsDocument, options);
        }
export type ChatbaseAgentsQueryHookResult = ReturnType<typeof useChatbaseAgentsQuery>;
export type ChatbaseAgentsLazyQueryHookResult = ReturnType<typeof useChatbaseAgentsLazyQuery>;
export type ChatbaseAgentsSuspenseQueryHookResult = ReturnType<typeof useChatbaseAgentsSuspenseQuery>;
export type ChatbaseAgentsQueryResult = Apollo.QueryResult<Types.ChatbaseAgentsQuery, Types.ChatbaseAgentsQueryVariables>;
export const ReactionLikesDocument = gql`
    query reactionLikes($ewebinarSetId: String!) {
  reactionLikes(ewebinarSetId: $ewebinarSetId) {
    timeFrame
    likeCount
  }
}
    `;
export type ReactionLikesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>, 'query'> & ({ variables: Types.ReactionLikesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ReactionLikesComponent = (props: ReactionLikesComponentProps) => (
      <ApolloReactComponents.Query<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables> query={ReactionLikesDocument} {...props} />
    );
    

/**
 * __useReactionLikesQuery__
 *
 * To run a query within a React component, call `useReactionLikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReactionLikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReactionLikesQuery({
 *   variables: {
 *      ewebinarSetId: // value for 'ewebinarSetId'
 *   },
 * });
 */
export function useReactionLikesQuery(baseOptions: Apollo.QueryHookOptions<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables> & ({ variables: Types.ReactionLikesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>(ReactionLikesDocument, options);
      }
export function useReactionLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>(ReactionLikesDocument, options);
        }
export function useReactionLikesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>(ReactionLikesDocument, options);
        }
export type ReactionLikesQueryHookResult = ReturnType<typeof useReactionLikesQuery>;
export type ReactionLikesLazyQueryHookResult = ReturnType<typeof useReactionLikesLazyQuery>;
export type ReactionLikesSuspenseQueryHookResult = ReturnType<typeof useReactionLikesSuspenseQuery>;
export type ReactionLikesQueryResult = Apollo.QueryResult<Types.ReactionLikesQuery, Types.ReactionLikesQueryVariables>;
export const GetInteractionsForAttendeeDocument = gql`
    query getInteractionsForAttendee($ewebinarId: String!, $attendeeId: String!) {
  interactions(ewebinarId: $ewebinarId) {
    ...InteractionForAttendee
  }
}
    ${InteractionForAttendeeFragmentDoc}`;
export type GetInteractionsForAttendeeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>, 'query'> & ({ variables: Types.GetInteractionsForAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInteractionsForAttendeeComponent = (props: GetInteractionsForAttendeeComponentProps) => (
      <ApolloReactComponents.Query<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables> query={GetInteractionsForAttendeeDocument} {...props} />
    );
    

/**
 * __useGetInteractionsForAttendeeQuery__
 *
 * To run a query within a React component, call `useGetInteractionsForAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionsForAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionsForAttendeeQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useGetInteractionsForAttendeeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables> & ({ variables: Types.GetInteractionsForAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>(GetInteractionsForAttendeeDocument, options);
      }
export function useGetInteractionsForAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>(GetInteractionsForAttendeeDocument, options);
        }
export function useGetInteractionsForAttendeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>(GetInteractionsForAttendeeDocument, options);
        }
export type GetInteractionsForAttendeeQueryHookResult = ReturnType<typeof useGetInteractionsForAttendeeQuery>;
export type GetInteractionsForAttendeeLazyQueryHookResult = ReturnType<typeof useGetInteractionsForAttendeeLazyQuery>;
export type GetInteractionsForAttendeeSuspenseQueryHookResult = ReturnType<typeof useGetInteractionsForAttendeeSuspenseQuery>;
export type GetInteractionsForAttendeeQueryResult = Apollo.QueryResult<Types.GetInteractionsForAttendeeQuery, Types.GetInteractionsForAttendeeQueryVariables>;
export const GetInteractionsInWebinarDocument = gql`
    query getInteractionsInWebinar($ewebinarId: String!) {
  interactions(ewebinarId: $ewebinarId) {
    ...Interaction
  }
}
    ${InteractionFragmentDoc}`;
export type GetInteractionsInWebinarComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>, 'query'> & ({ variables: Types.GetInteractionsInWebinarQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInteractionsInWebinarComponent = (props: GetInteractionsInWebinarComponentProps) => (
      <ApolloReactComponents.Query<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables> query={GetInteractionsInWebinarDocument} {...props} />
    );
    

/**
 * __useGetInteractionsInWebinarQuery__
 *
 * To run a query within a React component, call `useGetInteractionsInWebinarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionsInWebinarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionsInWebinarQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *   },
 * });
 */
export function useGetInteractionsInWebinarQuery(baseOptions: Apollo.QueryHookOptions<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables> & ({ variables: Types.GetInteractionsInWebinarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>(GetInteractionsInWebinarDocument, options);
      }
export function useGetInteractionsInWebinarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>(GetInteractionsInWebinarDocument, options);
        }
export function useGetInteractionsInWebinarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>(GetInteractionsInWebinarDocument, options);
        }
export type GetInteractionsInWebinarQueryHookResult = ReturnType<typeof useGetInteractionsInWebinarQuery>;
export type GetInteractionsInWebinarLazyQueryHookResult = ReturnType<typeof useGetInteractionsInWebinarLazyQuery>;
export type GetInteractionsInWebinarSuspenseQueryHookResult = ReturnType<typeof useGetInteractionsInWebinarSuspenseQuery>;
export type GetInteractionsInWebinarQueryResult = Apollo.QueryResult<Types.GetInteractionsInWebinarQuery, Types.GetInteractionsInWebinarQueryVariables>;
export const GetInteractionDocument = gql`
    query getInteraction($id: String!) {
  interaction(id: $id) {
    ...Interaction
    ewebinar {
      ...PublicEWebinar
    }
  }
}
    ${InteractionFragmentDoc}
${PublicEWebinarFragmentDoc}`;
export type GetInteractionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>, 'query'> & ({ variables: Types.GetInteractionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInteractionComponent = (props: GetInteractionComponentProps) => (
      <ApolloReactComponents.Query<Types.GetInteractionQuery, Types.GetInteractionQueryVariables> query={GetInteractionDocument} {...props} />
    );
    

/**
 * __useGetInteractionQuery__
 *
 * To run a query within a React component, call `useGetInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInteractionQuery(baseOptions: Apollo.QueryHookOptions<Types.GetInteractionQuery, Types.GetInteractionQueryVariables> & ({ variables: Types.GetInteractionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>(GetInteractionDocument, options);
      }
export function useGetInteractionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>(GetInteractionDocument, options);
        }
export function useGetInteractionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>(GetInteractionDocument, options);
        }
export type GetInteractionQueryHookResult = ReturnType<typeof useGetInteractionQuery>;
export type GetInteractionLazyQueryHookResult = ReturnType<typeof useGetInteractionLazyQuery>;
export type GetInteractionSuspenseQueryHookResult = ReturnType<typeof useGetInteractionSuspenseQuery>;
export type GetInteractionQueryResult = Apollo.QueryResult<Types.GetInteractionQuery, Types.GetInteractionQueryVariables>;
export const GetInteractionsInSetDocument = gql`
    query getInteractionsInSet($ewebinarSetId: String!, $includeDraft: Boolean, $includePublished: Boolean, $includeLegacyInteractions: Boolean) {
  interactionsInEwebinarSet(
    ewebinarSetId: $ewebinarSetId
    includeDraft: $includeDraft
    includePublished: $includePublished
    includeLegacyInteractions: $includeLegacyInteractions
  ) {
    ...Interaction
  }
}
    ${InteractionFragmentDoc}`;
export type GetInteractionsInSetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>, 'query'> & ({ variables: Types.GetInteractionsInSetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInteractionsInSetComponent = (props: GetInteractionsInSetComponentProps) => (
      <ApolloReactComponents.Query<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables> query={GetInteractionsInSetDocument} {...props} />
    );
    

/**
 * __useGetInteractionsInSetQuery__
 *
 * To run a query within a React component, call `useGetInteractionsInSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInteractionsInSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInteractionsInSetQuery({
 *   variables: {
 *      ewebinarSetId: // value for 'ewebinarSetId'
 *      includeDraft: // value for 'includeDraft'
 *      includePublished: // value for 'includePublished'
 *      includeLegacyInteractions: // value for 'includeLegacyInteractions'
 *   },
 * });
 */
export function useGetInteractionsInSetQuery(baseOptions: Apollo.QueryHookOptions<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables> & ({ variables: Types.GetInteractionsInSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>(GetInteractionsInSetDocument, options);
      }
export function useGetInteractionsInSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>(GetInteractionsInSetDocument, options);
        }
export function useGetInteractionsInSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>(GetInteractionsInSetDocument, options);
        }
export type GetInteractionsInSetQueryHookResult = ReturnType<typeof useGetInteractionsInSetQuery>;
export type GetInteractionsInSetLazyQueryHookResult = ReturnType<typeof useGetInteractionsInSetLazyQuery>;
export type GetInteractionsInSetSuspenseQueryHookResult = ReturnType<typeof useGetInteractionsInSetSuspenseQuery>;
export type GetInteractionsInSetQueryResult = Apollo.QueryResult<Types.GetInteractionsInSetQuery, Types.GetInteractionsInSetQueryVariables>;
export const CreateInteractionDocument = gql`
    mutation createInteraction($data: InteractionInput!) {
  createInteraction(data: $data) {
    ...Interaction
    ewebinar {
      id
      interactions {
        ...Interaction
      }
    }
    set {
      id
      isPublishable
    }
  }
}
    ${InteractionFragmentDoc}`;
export type CreateInteractionMutationFn = Apollo.MutationFunction<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables>;
export type CreateInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables>, 'mutation'>;

    export const CreateInteractionComponent = (props: CreateInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables> mutation={CreateInteractionDocument} {...props} />
    );
    

/**
 * __useCreateInteractionMutation__
 *
 * To run a mutation, you first call `useCreateInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionMutation, { data, loading, error }] = useCreateInteractionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInteractionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables>(CreateInteractionDocument, options);
      }
export type CreateInteractionMutationHookResult = ReturnType<typeof useCreateInteractionMutation>;
export type CreateInteractionMutationResult = Apollo.MutationResult<Types.CreateInteractionMutation>;
export type CreateInteractionMutationOptions = Apollo.BaseMutationOptions<Types.CreateInteractionMutation, Types.CreateInteractionMutationVariables>;
export const UpdateInteractionDocument = gql`
    mutation updateInteraction($data: InteractionInput!) {
  updateInteraction(data: $data) {
    ...Interaction
    ewebinar {
      id
      set {
        id
        isPublishable
      }
    }
  }
}
    ${InteractionFragmentDoc}`;
export type UpdateInteractionMutationFn = Apollo.MutationFunction<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables>;
export type UpdateInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables>, 'mutation'>;

    export const UpdateInteractionComponent = (props: UpdateInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables> mutation={UpdateInteractionDocument} {...props} />
    );
    

/**
 * __useUpdateInteractionMutation__
 *
 * To run a mutation, you first call `useUpdateInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInteractionMutation, { data, loading, error }] = useUpdateInteractionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInteractionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables>(UpdateInteractionDocument, options);
      }
export type UpdateInteractionMutationHookResult = ReturnType<typeof useUpdateInteractionMutation>;
export type UpdateInteractionMutationResult = Apollo.MutationResult<Types.UpdateInteractionMutation>;
export type UpdateInteractionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInteractionMutation, Types.UpdateInteractionMutationVariables>;
export const DeleteInteractionDocument = gql`
    mutation deleteInteraction($id: String!) {
  deleteInteraction(id: $id) {
    id
    interactions {
      ...Interaction
    }
    set {
      id
      isPublishable
    }
  }
}
    ${InteractionFragmentDoc}`;
export type DeleteInteractionMutationFn = Apollo.MutationFunction<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables>;
export type DeleteInteractionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables>, 'mutation'>;

    export const DeleteInteractionComponent = (props: DeleteInteractionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables> mutation={DeleteInteractionDocument} {...props} />
    );
    

/**
 * __useDeleteInteractionMutation__
 *
 * To run a mutation, you first call `useDeleteInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInteractionMutation, { data, loading, error }] = useDeleteInteractionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInteractionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables>(DeleteInteractionDocument, options);
      }
export type DeleteInteractionMutationHookResult = ReturnType<typeof useDeleteInteractionMutation>;
export type DeleteInteractionMutationResult = Apollo.MutationResult<Types.DeleteInteractionMutation>;
export type DeleteInteractionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteInteractionMutation, Types.DeleteInteractionMutationVariables>;
export const InteractionAnalyticsDocument = gql`
    query interactionAnalytics($ewebinarSetId: String!, $from: String!, $to: String!, $timezone: String!, $includeLegacyInteractions: Boolean!) {
  interactionAnalytics(
    ewebinarSetId: $ewebinarSetId
    from: $from
    to: $to
    timezone: $timezone
    includeLegacyInteractions: $includeLegacyInteractions
  ) {
    ...InteractionWithAnalytics
  }
}
    ${InteractionWithAnalyticsFragmentDoc}`;
export type InteractionAnalyticsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>, 'query'> & ({ variables: Types.InteractionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InteractionAnalyticsComponent = (props: InteractionAnalyticsComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables> query={InteractionAnalyticsDocument} {...props} />
    );
    

/**
 * __useInteractionAnalyticsQuery__
 *
 * To run a query within a React component, call `useInteractionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionAnalyticsQuery({
 *   variables: {
 *      ewebinarSetId: // value for 'ewebinarSetId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timezone: // value for 'timezone'
 *      includeLegacyInteractions: // value for 'includeLegacyInteractions'
 *   },
 * });
 */
export function useInteractionAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables> & ({ variables: Types.InteractionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>(InteractionAnalyticsDocument, options);
      }
export function useInteractionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>(InteractionAnalyticsDocument, options);
        }
export function useInteractionAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>(InteractionAnalyticsDocument, options);
        }
export type InteractionAnalyticsQueryHookResult = ReturnType<typeof useInteractionAnalyticsQuery>;
export type InteractionAnalyticsLazyQueryHookResult = ReturnType<typeof useInteractionAnalyticsLazyQuery>;
export type InteractionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useInteractionAnalyticsSuspenseQuery>;
export type InteractionAnalyticsQueryResult = Apollo.QueryResult<Types.InteractionAnalyticsQuery, Types.InteractionAnalyticsQueryVariables>;
export const InteractionReactionResultsDocument = gql`
    query interactionReactionResults($id: String!) {
  interaction(id: $id) {
    ...InteractionReactionResults
  }
}
    ${InteractionReactionResultsFragmentDoc}`;
export type InteractionReactionResultsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>, 'query'> & ({ variables: Types.InteractionReactionResultsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InteractionReactionResultsComponent = (props: InteractionReactionResultsComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables> query={InteractionReactionResultsDocument} {...props} />
    );
    

/**
 * __useInteractionReactionResultsQuery__
 *
 * To run a query within a React component, call `useInteractionReactionResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionReactionResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionReactionResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInteractionReactionResultsQuery(baseOptions: Apollo.QueryHookOptions<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables> & ({ variables: Types.InteractionReactionResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>(InteractionReactionResultsDocument, options);
      }
export function useInteractionReactionResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>(InteractionReactionResultsDocument, options);
        }
export function useInteractionReactionResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>(InteractionReactionResultsDocument, options);
        }
export type InteractionReactionResultsQueryHookResult = ReturnType<typeof useInteractionReactionResultsQuery>;
export type InteractionReactionResultsLazyQueryHookResult = ReturnType<typeof useInteractionReactionResultsLazyQuery>;
export type InteractionReactionResultsSuspenseQueryHookResult = ReturnType<typeof useInteractionReactionResultsSuspenseQuery>;
export type InteractionReactionResultsQueryResult = Apollo.QueryResult<Types.InteractionReactionResultsQuery, Types.InteractionReactionResultsQueryVariables>;
export const InteractionTemplateCategoriesDocument = gql`
    query interactionTemplateCategories {
  interactionTemplateCategories
}
    `;
export type InteractionTemplateCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>, 'query'>;

    export const InteractionTemplateCategoriesComponent = (props: InteractionTemplateCategoriesComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables> query={InteractionTemplateCategoriesDocument} {...props} />
    );
    

/**
 * __useInteractionTemplateCategoriesQuery__
 *
 * To run a query within a React component, call `useInteractionTemplateCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionTemplateCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionTemplateCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInteractionTemplateCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>(InteractionTemplateCategoriesDocument, options);
      }
export function useInteractionTemplateCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>(InteractionTemplateCategoriesDocument, options);
        }
export function useInteractionTemplateCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>(InteractionTemplateCategoriesDocument, options);
        }
export type InteractionTemplateCategoriesQueryHookResult = ReturnType<typeof useInteractionTemplateCategoriesQuery>;
export type InteractionTemplateCategoriesLazyQueryHookResult = ReturnType<typeof useInteractionTemplateCategoriesLazyQuery>;
export type InteractionTemplateCategoriesSuspenseQueryHookResult = ReturnType<typeof useInteractionTemplateCategoriesSuspenseQuery>;
export type InteractionTemplateCategoriesQueryResult = Apollo.QueryResult<Types.InteractionTemplateCategoriesQuery, Types.InteractionTemplateCategoriesQueryVariables>;
export const InteractionsMenuDocument = gql`
    query interactionsMenu($filter: FilterInteractionMenuInput) {
  interactionsMenu(filter: $filter) {
    title
    items {
      ...Interaction
    }
  }
}
    ${InteractionFragmentDoc}`;
export type InteractionsMenuComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>, 'query'>;

    export const InteractionsMenuComponent = (props: InteractionsMenuComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables> query={InteractionsMenuDocument} {...props} />
    );
    

/**
 * __useInteractionsMenuQuery__
 *
 * To run a query within a React component, call `useInteractionsMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionsMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionsMenuQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInteractionsMenuQuery(baseOptions?: Apollo.QueryHookOptions<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>(InteractionsMenuDocument, options);
      }
export function useInteractionsMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>(InteractionsMenuDocument, options);
        }
export function useInteractionsMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>(InteractionsMenuDocument, options);
        }
export type InteractionsMenuQueryHookResult = ReturnType<typeof useInteractionsMenuQuery>;
export type InteractionsMenuLazyQueryHookResult = ReturnType<typeof useInteractionsMenuLazyQuery>;
export type InteractionsMenuSuspenseQueryHookResult = ReturnType<typeof useInteractionsMenuSuspenseQuery>;
export type InteractionsMenuQueryResult = Apollo.QueryResult<Types.InteractionsMenuQuery, Types.InteractionsMenuQueryVariables>;
export const InteractionTemplatesDocument = gql`
    query interactionTemplates($filter: FilterInteractionTemplateInput) {
  interactionTemplates(filter: $filter) {
    templates {
      ...Interaction
      set {
        id
      }
    }
    nextCursor
  }
}
    ${InteractionFragmentDoc}`;
export type InteractionTemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>, 'query'>;

    export const InteractionTemplatesComponent = (props: InteractionTemplatesComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables> query={InteractionTemplatesDocument} {...props} />
    );
    

/**
 * __useInteractionTemplatesQuery__
 *
 * To run a query within a React component, call `useInteractionTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInteractionTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>(InteractionTemplatesDocument, options);
      }
export function useInteractionTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>(InteractionTemplatesDocument, options);
        }
export function useInteractionTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>(InteractionTemplatesDocument, options);
        }
export type InteractionTemplatesQueryHookResult = ReturnType<typeof useInteractionTemplatesQuery>;
export type InteractionTemplatesLazyQueryHookResult = ReturnType<typeof useInteractionTemplatesLazyQuery>;
export type InteractionTemplatesSuspenseQueryHookResult = ReturnType<typeof useInteractionTemplatesSuspenseQuery>;
export type InteractionTemplatesQueryResult = Apollo.QueryResult<Types.InteractionTemplatesQuery, Types.InteractionTemplatesQueryVariables>;
export const CreateInteractionFromTemplateDocument = gql`
    mutation createInteractionFromTemplate($data: CreateInteractionFromTemplateInput!) {
  createInteractionFromTemplate(data: $data) {
    ...Interaction
    ewebinar {
      id
      interactions {
        ...Interaction
      }
    }
    set {
      id
      isPublishable
    }
  }
}
    ${InteractionFragmentDoc}`;
export type CreateInteractionFromTemplateMutationFn = Apollo.MutationFunction<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables>;
export type CreateInteractionFromTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables>, 'mutation'>;

    export const CreateInteractionFromTemplateComponent = (props: CreateInteractionFromTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables> mutation={CreateInteractionFromTemplateDocument} {...props} />
    );
    

/**
 * __useCreateInteractionFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateInteractionFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionFromTemplateMutation, { data, loading, error }] = useCreateInteractionFromTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInteractionFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables>(CreateInteractionFromTemplateDocument, options);
      }
export type CreateInteractionFromTemplateMutationHookResult = ReturnType<typeof useCreateInteractionFromTemplateMutation>;
export type CreateInteractionFromTemplateMutationResult = Apollo.MutationResult<Types.CreateInteractionFromTemplateMutation>;
export type CreateInteractionFromTemplateMutationOptions = Apollo.BaseMutationOptions<Types.CreateInteractionFromTemplateMutation, Types.CreateInteractionFromTemplateMutationVariables>;
export const UpdateInteractionFavoriteDocument = gql`
    mutation updateInteractionFavorite($interactionId: String!, $favorite: Boolean!) {
  updateInteractionFavorite(interactionId: $interactionId, favorite: $favorite) {
    ...Interaction
  }
}
    ${InteractionFragmentDoc}`;
export type UpdateInteractionFavoriteMutationFn = Apollo.MutationFunction<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables>;
export type UpdateInteractionFavoriteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables>, 'mutation'>;

    export const UpdateInteractionFavoriteComponent = (props: UpdateInteractionFavoriteComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables> mutation={UpdateInteractionFavoriteDocument} {...props} />
    );
    

/**
 * __useUpdateInteractionFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdateInteractionFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInteractionFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInteractionFavoriteMutation, { data, loading, error }] = useUpdateInteractionFavoriteMutation({
 *   variables: {
 *      interactionId: // value for 'interactionId'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useUpdateInteractionFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables>(UpdateInteractionFavoriteDocument, options);
      }
export type UpdateInteractionFavoriteMutationHookResult = ReturnType<typeof useUpdateInteractionFavoriteMutation>;
export type UpdateInteractionFavoriteMutationResult = Apollo.MutationResult<Types.UpdateInteractionFavoriteMutation>;
export type UpdateInteractionFavoriteMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInteractionFavoriteMutation, Types.UpdateInteractionFavoriteMutationVariables>;
export const CreateReactionsTestDocument = gql`
    mutation createReactionsTest($data: ReactionTestInput!, $numberAttendee: Float!) {
  createReactionsTest(data: $data, numberAttendee: $numberAttendee) {
    ...Reaction
  }
}
    ${ReactionFragmentDoc}`;
export type CreateReactionsTestMutationFn = Apollo.MutationFunction<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables>;
export type CreateReactionsTestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables>, 'mutation'>;

    export const CreateReactionsTestComponent = (props: CreateReactionsTestComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables> mutation={CreateReactionsTestDocument} {...props} />
    );
    

/**
 * __useCreateReactionsTestMutation__
 *
 * To run a mutation, you first call `useCreateReactionsTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionsTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionsTestMutation, { data, loading, error }] = useCreateReactionsTestMutation({
 *   variables: {
 *      data: // value for 'data'
 *      numberAttendee: // value for 'numberAttendee'
 *   },
 * });
 */
export function useCreateReactionsTestMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables>(CreateReactionsTestDocument, options);
      }
export type CreateReactionsTestMutationHookResult = ReturnType<typeof useCreateReactionsTestMutation>;
export type CreateReactionsTestMutationResult = Apollo.MutationResult<Types.CreateReactionsTestMutation>;
export type CreateReactionsTestMutationOptions = Apollo.BaseMutationOptions<Types.CreateReactionsTestMutation, Types.CreateReactionsTestMutationVariables>;
export const AttendeeReactionResultsDocument = gql`
    query attendeeReactionResults($ewebinarId: String!, $interactionId: String!) {
  attendeeReactionResults(ewebinarId: $ewebinarId, interactionId: $interactionId) {
    total
  }
}
    `;
export type AttendeeReactionResultsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>, 'query'> & ({ variables: Types.AttendeeReactionResultsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AttendeeReactionResultsComponent = (props: AttendeeReactionResultsComponentProps) => (
      <ApolloReactComponents.Query<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables> query={AttendeeReactionResultsDocument} {...props} />
    );
    

/**
 * __useAttendeeReactionResultsQuery__
 *
 * To run a query within a React component, call `useAttendeeReactionResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendeeReactionResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendeeReactionResultsQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      interactionId: // value for 'interactionId'
 *   },
 * });
 */
export function useAttendeeReactionResultsQuery(baseOptions: Apollo.QueryHookOptions<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables> & ({ variables: Types.AttendeeReactionResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>(AttendeeReactionResultsDocument, options);
      }
export function useAttendeeReactionResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>(AttendeeReactionResultsDocument, options);
        }
export function useAttendeeReactionResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>(AttendeeReactionResultsDocument, options);
        }
export type AttendeeReactionResultsQueryHookResult = ReturnType<typeof useAttendeeReactionResultsQuery>;
export type AttendeeReactionResultsLazyQueryHookResult = ReturnType<typeof useAttendeeReactionResultsLazyQuery>;
export type AttendeeReactionResultsSuspenseQueryHookResult = ReturnType<typeof useAttendeeReactionResultsSuspenseQuery>;
export type AttendeeReactionResultsQueryResult = Apollo.QueryResult<Types.AttendeeReactionResultsQuery, Types.AttendeeReactionResultsQueryVariables>;
export const CreateLikeReactionDocument = gql`
    mutation createLikeReaction($data: ReactionInput!, $connectionId: String, $isReplay: Boolean) {
  createLikeReaction(
    data: $data
    connectionId: $connectionId
    isReplay: $isReplay
  ) {
    id
  }
}
    `;
export type CreateLikeReactionMutationFn = Apollo.MutationFunction<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables>;
export type CreateLikeReactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables>, 'mutation'>;

    export const CreateLikeReactionComponent = (props: CreateLikeReactionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables> mutation={CreateLikeReactionDocument} {...props} />
    );
    

/**
 * __useCreateLikeReactionMutation__
 *
 * To run a mutation, you first call `useCreateLikeReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLikeReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLikeReactionMutation, { data, loading, error }] = useCreateLikeReactionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      connectionId: // value for 'connectionId'
 *      isReplay: // value for 'isReplay'
 *   },
 * });
 */
export function useCreateLikeReactionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables>(CreateLikeReactionDocument, options);
      }
export type CreateLikeReactionMutationHookResult = ReturnType<typeof useCreateLikeReactionMutation>;
export type CreateLikeReactionMutationResult = Apollo.MutationResult<Types.CreateLikeReactionMutation>;
export type CreateLikeReactionMutationOptions = Apollo.BaseMutationOptions<Types.CreateLikeReactionMutation, Types.CreateLikeReactionMutationVariables>;
export const CreateInteractionReactionDocument = gql`
    mutation createInteractionReaction($attendeeId: String!, $data: ReactionForInteractionInput!, $connectionId: String, $isReplay: Boolean) {
  createInteractionReaction(
    data: $data
    attendeeId: $attendeeId
    connectionId: $connectionId
    isReplay: $isReplay
  ) {
    ...InteractionWithReaction
  }
}
    ${InteractionWithReactionFragmentDoc}`;
export type CreateInteractionReactionMutationFn = Apollo.MutationFunction<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables>;
export type CreateInteractionReactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables>, 'mutation'>;

    export const CreateInteractionReactionComponent = (props: CreateInteractionReactionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables> mutation={CreateInteractionReactionDocument} {...props} />
    );
    

/**
 * __useCreateInteractionReactionMutation__
 *
 * To run a mutation, you first call `useCreateInteractionReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInteractionReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInteractionReactionMutation, { data, loading, error }] = useCreateInteractionReactionMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *      data: // value for 'data'
 *      connectionId: // value for 'connectionId'
 *      isReplay: // value for 'isReplay'
 *   },
 * });
 */
export function useCreateInteractionReactionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables>(CreateInteractionReactionDocument, options);
      }
export type CreateInteractionReactionMutationHookResult = ReturnType<typeof useCreateInteractionReactionMutation>;
export type CreateInteractionReactionMutationResult = Apollo.MutationResult<Types.CreateInteractionReactionMutation>;
export type CreateInteractionReactionMutationOptions = Apollo.BaseMutationOptions<Types.CreateInteractionReactionMutation, Types.CreateInteractionReactionMutationVariables>;
export const InvoicesDocument = gql`
    query invoices($filter: GetInvoicesInput!) {
  invoices(filter: $filter) {
    invoices {
      ...Invoice
    }
    total
    nextCursor
  }
}
    ${InvoiceFragmentDoc}`;
export type InvoicesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables>, 'query'> & ({ variables: Types.InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InvoicesComponent = (props: InvoicesComponentProps) => (
      <ApolloReactComponents.Query<Types.InvoicesQuery, Types.InvoicesQueryVariables> query={InvoicesDocument} {...props} />
    );
    

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables> & ({ variables: Types.InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InvoicesQuery, Types.InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InvoicesQuery, Types.InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InvoicesQuery, Types.InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InvoicesQuery, Types.InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<Types.InvoicesQuery, Types.InvoicesQueryVariables>;
export const SendTestEmailDocument = gql`
    mutation sendTestEmail($ewebinarId: String!, $emailTemplate: String!) {
  sendTestEmail(ewebinarId: $ewebinarId, emailTemplate: $emailTemplate)
}
    `;
export type SendTestEmailMutationFn = Apollo.MutationFunction<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables>;
export type SendTestEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables>, 'mutation'>;

    export const SendTestEmailComponent = (props: SendTestEmailComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables> mutation={SendTestEmailDocument} {...props} />
    );
    

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      emailTemplate: // value for 'emailTemplate'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = Apollo.MutationResult<Types.SendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<Types.SendTestEmailMutation, Types.SendTestEmailMutationVariables>;
export const GetEwebinarNotificationsDocument = gql`
    query getEwebinarNotifications($ewebinarId: String!) {
  notifications(ewebinarId: $ewebinarId) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type GetEwebinarNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>, 'query'> & ({ variables: Types.GetEwebinarNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEwebinarNotificationsComponent = (props: GetEwebinarNotificationsComponentProps) => (
      <ApolloReactComponents.Query<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables> query={GetEwebinarNotificationsDocument} {...props} />
    );
    

/**
 * __useGetEwebinarNotificationsQuery__
 *
 * To run a query within a React component, call `useGetEwebinarNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEwebinarNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEwebinarNotificationsQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *   },
 * });
 */
export function useGetEwebinarNotificationsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables> & ({ variables: Types.GetEwebinarNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>(GetEwebinarNotificationsDocument, options);
      }
export function useGetEwebinarNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>(GetEwebinarNotificationsDocument, options);
        }
export function useGetEwebinarNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>(GetEwebinarNotificationsDocument, options);
        }
export type GetEwebinarNotificationsQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsQuery>;
export type GetEwebinarNotificationsLazyQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsLazyQuery>;
export type GetEwebinarNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsSuspenseQuery>;
export type GetEwebinarNotificationsQueryResult = Apollo.QueryResult<Types.GetEwebinarNotificationsQuery, Types.GetEwebinarNotificationsQueryVariables>;
export const GetEwebinarNotificationsFromTemplateDocument = gql`
    query getEwebinarNotificationsFromTemplate($setId: String!) {
  ewebinarTemplateFrom(setId: $setId) {
    notifications {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type GetEwebinarNotificationsFromTemplateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>, 'query'> & ({ variables: Types.GetEwebinarNotificationsFromTemplateQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetEwebinarNotificationsFromTemplateComponent = (props: GetEwebinarNotificationsFromTemplateComponentProps) => (
      <ApolloReactComponents.Query<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables> query={GetEwebinarNotificationsFromTemplateDocument} {...props} />
    );
    

/**
 * __useGetEwebinarNotificationsFromTemplateQuery__
 *
 * To run a query within a React component, call `useGetEwebinarNotificationsFromTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEwebinarNotificationsFromTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEwebinarNotificationsFromTemplateQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useGetEwebinarNotificationsFromTemplateQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables> & ({ variables: Types.GetEwebinarNotificationsFromTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>(GetEwebinarNotificationsFromTemplateDocument, options);
      }
export function useGetEwebinarNotificationsFromTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>(GetEwebinarNotificationsFromTemplateDocument, options);
        }
export function useGetEwebinarNotificationsFromTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>(GetEwebinarNotificationsFromTemplateDocument, options);
        }
export type GetEwebinarNotificationsFromTemplateQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsFromTemplateQuery>;
export type GetEwebinarNotificationsFromTemplateLazyQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsFromTemplateLazyQuery>;
export type GetEwebinarNotificationsFromTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEwebinarNotificationsFromTemplateSuspenseQuery>;
export type GetEwebinarNotificationsFromTemplateQueryResult = Apollo.QueryResult<Types.GetEwebinarNotificationsFromTemplateQuery, Types.GetEwebinarNotificationsFromTemplateQueryVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($data: NotificationInput!) {
  createNotification(data: $data) {
    id
    notifications {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables>;
export type CreateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables>, 'mutation'>;

    export const CreateNotificationComponent = (props: CreateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables> mutation={CreateNotificationDocument} {...props} />
    );
    

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<Types.CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<Types.CreateNotificationMutation, Types.CreateNotificationMutationVariables>;
export const DeleteNotificationDocument = gql`
    mutation deleteNotification($id: String!) {
  deleteNotification(id: $id) {
    id
    notifications {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type DeleteNotificationMutationFn = Apollo.MutationFunction<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables>;
export type DeleteNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables>, 'mutation'>;

    export const DeleteNotificationComponent = (props: DeleteNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables> mutation={DeleteNotificationDocument} {...props} />
    );
    

/**
 * __useDeleteNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationMutation, { data, loading, error }] = useDeleteNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables>(DeleteNotificationDocument, options);
      }
export type DeleteNotificationMutationHookResult = ReturnType<typeof useDeleteNotificationMutation>;
export type DeleteNotificationMutationResult = Apollo.MutationResult<Types.DeleteNotificationMutation>;
export type DeleteNotificationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteNotificationMutation, Types.DeleteNotificationMutationVariables>;
export const DuplicateNotificationDocument = gql`
    mutation duplicateNotification($id: String!) {
  duplicateNotification(id: $id) {
    id
    notifications {
      ...Notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type DuplicateNotificationMutationFn = Apollo.MutationFunction<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables>;
export type DuplicateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables>, 'mutation'>;

    export const DuplicateNotificationComponent = (props: DuplicateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables> mutation={DuplicateNotificationDocument} {...props} />
    );
    

/**
 * __useDuplicateNotificationMutation__
 *
 * To run a mutation, you first call `useDuplicateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateNotificationMutation, { data, loading, error }] = useDuplicateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables>(DuplicateNotificationDocument, options);
      }
export type DuplicateNotificationMutationHookResult = ReturnType<typeof useDuplicateNotificationMutation>;
export type DuplicateNotificationMutationResult = Apollo.MutationResult<Types.DuplicateNotificationMutation>;
export type DuplicateNotificationMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateNotificationMutation, Types.DuplicateNotificationMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($data: NotificationInput!) {
  updateNotification(data: $data) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables>;
export type UpdateNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables>, 'mutation'>;

    export const UpdateNotificationComponent = (props: UpdateNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables> mutation={UpdateNotificationDocument} {...props} />
    );
    

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<Types.UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNotificationMutation, Types.UpdateNotificationMutationVariables>;
export const SendNotificationTestDocument = gql`
    mutation sendNotificationTest($id: String!) {
  sendNotificationTest(id: $id)
}
    `;
export type SendNotificationTestMutationFn = Apollo.MutationFunction<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables>;
export type SendNotificationTestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables>, 'mutation'>;

    export const SendNotificationTestComponent = (props: SendNotificationTestComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables> mutation={SendNotificationTestDocument} {...props} />
    );
    

/**
 * __useSendNotificationTestMutation__
 *
 * To run a mutation, you first call `useSendNotificationTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationTestMutation, { data, loading, error }] = useSendNotificationTestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendNotificationTestMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables>(SendNotificationTestDocument, options);
      }
export type SendNotificationTestMutationHookResult = ReturnType<typeof useSendNotificationTestMutation>;
export type SendNotificationTestMutationResult = Apollo.MutationResult<Types.SendNotificationTestMutation>;
export type SendNotificationTestMutationOptions = Apollo.BaseMutationOptions<Types.SendNotificationTestMutation, Types.SendNotificationTestMutationVariables>;
export const GetNotificationHeaderAndFooterDocument = gql`
    query getNotificationHeaderAndFooter($type: NotificationType!, $ewebinarId: String!) {
  generateHeaderAndFooter(type: $type, ewebinarId: $ewebinarId) {
    header
    footer
  }
}
    `;
export type GetNotificationHeaderAndFooterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>, 'query'> & ({ variables: Types.GetNotificationHeaderAndFooterQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNotificationHeaderAndFooterComponent = (props: GetNotificationHeaderAndFooterComponentProps) => (
      <ApolloReactComponents.Query<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables> query={GetNotificationHeaderAndFooterDocument} {...props} />
    );
    

/**
 * __useGetNotificationHeaderAndFooterQuery__
 *
 * To run a query within a React component, call `useGetNotificationHeaderAndFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationHeaderAndFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationHeaderAndFooterQuery({
 *   variables: {
 *      type: // value for 'type'
 *      ewebinarId: // value for 'ewebinarId'
 *   },
 * });
 */
export function useGetNotificationHeaderAndFooterQuery(baseOptions: Apollo.QueryHookOptions<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables> & ({ variables: Types.GetNotificationHeaderAndFooterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>(GetNotificationHeaderAndFooterDocument, options);
      }
export function useGetNotificationHeaderAndFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>(GetNotificationHeaderAndFooterDocument, options);
        }
export function useGetNotificationHeaderAndFooterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>(GetNotificationHeaderAndFooterDocument, options);
        }
export type GetNotificationHeaderAndFooterQueryHookResult = ReturnType<typeof useGetNotificationHeaderAndFooterQuery>;
export type GetNotificationHeaderAndFooterLazyQueryHookResult = ReturnType<typeof useGetNotificationHeaderAndFooterLazyQuery>;
export type GetNotificationHeaderAndFooterSuspenseQueryHookResult = ReturnType<typeof useGetNotificationHeaderAndFooterSuspenseQuery>;
export type GetNotificationHeaderAndFooterQueryResult = Apollo.QueryResult<Types.GetNotificationHeaderAndFooterQuery, Types.GetNotificationHeaderAndFooterQueryVariables>;
export const GenerateAiNotificationsDocument = gql`
    mutation generateAINotifications($ewebinarId: String!, $userPrompt: String) {
  generateAINotifications(ewebinarId: $ewebinarId, userPrompt: $userPrompt) {
    ...DraftNotification
  }
}
    ${DraftNotificationFragmentDoc}`;
export type GenerateAiNotificationsMutationFn = Apollo.MutationFunction<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables>;
export type GenerateAiNotificationsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables>, 'mutation'>;

    export const GenerateAiNotificationsComponent = (props: GenerateAiNotificationsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables> mutation={GenerateAiNotificationsDocument} {...props} />
    );
    

/**
 * __useGenerateAiNotificationsMutation__
 *
 * To run a mutation, you first call `useGenerateAiNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiNotificationsMutation, { data, loading, error }] = useGenerateAiNotificationsMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      userPrompt: // value for 'userPrompt'
 *   },
 * });
 */
export function useGenerateAiNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables>(GenerateAiNotificationsDocument, options);
      }
export type GenerateAiNotificationsMutationHookResult = ReturnType<typeof useGenerateAiNotificationsMutation>;
export type GenerateAiNotificationsMutationResult = Apollo.MutationResult<Types.GenerateAiNotificationsMutation>;
export type GenerateAiNotificationsMutationOptions = Apollo.BaseMutationOptions<Types.GenerateAiNotificationsMutation, Types.GenerateAiNotificationsMutationVariables>;
export const RewriteAiNotificationDocument = gql`
    mutation rewriteAINotification($notification: NotificationInput!, $edited: NotificationTextInput!, $userPrompt: String!) {
  rewriteAINotification(
    notification: $notification
    edited: $edited
    userPrompt: $userPrompt
  ) {
    ...NotificationText
  }
}
    ${NotificationTextFragmentDoc}`;
export type RewriteAiNotificationMutationFn = Apollo.MutationFunction<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables>;
export type RewriteAiNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables>, 'mutation'>;

    export const RewriteAiNotificationComponent = (props: RewriteAiNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables> mutation={RewriteAiNotificationDocument} {...props} />
    );
    

/**
 * __useRewriteAiNotificationMutation__
 *
 * To run a mutation, you first call `useRewriteAiNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRewriteAiNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rewriteAiNotificationMutation, { data, loading, error }] = useRewriteAiNotificationMutation({
 *   variables: {
 *      notification: // value for 'notification'
 *      edited: // value for 'edited'
 *      userPrompt: // value for 'userPrompt'
 *   },
 * });
 */
export function useRewriteAiNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables>(RewriteAiNotificationDocument, options);
      }
export type RewriteAiNotificationMutationHookResult = ReturnType<typeof useRewriteAiNotificationMutation>;
export type RewriteAiNotificationMutationResult = Apollo.MutationResult<Types.RewriteAiNotificationMutation>;
export type RewriteAiNotificationMutationOptions = Apollo.BaseMutationOptions<Types.RewriteAiNotificationMutation, Types.RewriteAiNotificationMutationVariables>;
export const OpsSearchTeamsDocument = gql`
    query opsSearchTeams($filter: CrossTeamFilterInput!) {
  opsSearchTeams(filter: $filter) {
    teams {
      ...TeamWithStats
    }
    total
    stats {
      ...Statistic
    }
    nextCursor
  }
}
    ${TeamWithStatsFragmentDoc}
${StatisticFragmentDoc}`;
export type OpsSearchTeamsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>, 'query'> & ({ variables: Types.OpsSearchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsSearchTeamsComponent = (props: OpsSearchTeamsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables> query={OpsSearchTeamsDocument} {...props} />
    );
    

/**
 * __useOpsSearchTeamsQuery__
 *
 * To run a query within a React component, call `useOpsSearchTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsSearchTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsSearchTeamsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOpsSearchTeamsQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables> & ({ variables: Types.OpsSearchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>(OpsSearchTeamsDocument, options);
      }
export function useOpsSearchTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>(OpsSearchTeamsDocument, options);
        }
export function useOpsSearchTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>(OpsSearchTeamsDocument, options);
        }
export type OpsSearchTeamsQueryHookResult = ReturnType<typeof useOpsSearchTeamsQuery>;
export type OpsSearchTeamsLazyQueryHookResult = ReturnType<typeof useOpsSearchTeamsLazyQuery>;
export type OpsSearchTeamsSuspenseQueryHookResult = ReturnType<typeof useOpsSearchTeamsSuspenseQuery>;
export type OpsSearchTeamsQueryResult = Apollo.QueryResult<Types.OpsSearchTeamsQuery, Types.OpsSearchTeamsQueryVariables>;
export const OpsTeamsStatsDocument = gql`
    query opsTeamsStats {
  opsTeamsStats {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export type OpsTeamsStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>, 'query'>;

    export const OpsTeamsStatsComponent = (props: OpsTeamsStatsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables> query={OpsTeamsStatsDocument} {...props} />
    );
    

/**
 * __useOpsTeamsStatsQuery__
 *
 * To run a query within a React component, call `useOpsTeamsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsTeamsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsTeamsStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpsTeamsStatsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>(OpsTeamsStatsDocument, options);
      }
export function useOpsTeamsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>(OpsTeamsStatsDocument, options);
        }
export function useOpsTeamsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>(OpsTeamsStatsDocument, options);
        }
export type OpsTeamsStatsQueryHookResult = ReturnType<typeof useOpsTeamsStatsQuery>;
export type OpsTeamsStatsLazyQueryHookResult = ReturnType<typeof useOpsTeamsStatsLazyQuery>;
export type OpsTeamsStatsSuspenseQueryHookResult = ReturnType<typeof useOpsTeamsStatsSuspenseQuery>;
export type OpsTeamsStatsQueryResult = Apollo.QueryResult<Types.OpsTeamsStatsQuery, Types.OpsTeamsStatsQueryVariables>;
export const TeamWithStatsDocument = gql`
    query teamWithStats($filter: CrossTeamFilterInput!) {
  teamWithStats(filter: $filter) {
    ...TeamWithStats
  }
}
    ${TeamWithStatsFragmentDoc}`;
export type TeamWithStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>, 'query'> & ({ variables: Types.TeamWithStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamWithStatsComponent = (props: TeamWithStatsComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables> query={TeamWithStatsDocument} {...props} />
    );
    

/**
 * __useTeamWithStatsQuery__
 *
 * To run a query within a React component, call `useTeamWithStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamWithStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamWithStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTeamWithStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables> & ({ variables: Types.TeamWithStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>(TeamWithStatsDocument, options);
      }
export function useTeamWithStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>(TeamWithStatsDocument, options);
        }
export function useTeamWithStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>(TeamWithStatsDocument, options);
        }
export type TeamWithStatsQueryHookResult = ReturnType<typeof useTeamWithStatsQuery>;
export type TeamWithStatsLazyQueryHookResult = ReturnType<typeof useTeamWithStatsLazyQuery>;
export type TeamWithStatsSuspenseQueryHookResult = ReturnType<typeof useTeamWithStatsSuspenseQuery>;
export type TeamWithStatsQueryResult = Apollo.QueryResult<Types.TeamWithStatsQuery, Types.TeamWithStatsQueryVariables>;
export const SearchTeamsDocument = gql`
    query searchTeams($filter: TeamsInput!) {
  searchTeams(filter: $filter) {
    data {
      id
      name
      logoMediaRef {
        ...MediaRef
      }
      favIconMediaRef {
        ...MediaRef
      }
      subdomain
      users {
        name
      }
    }
    total
    nextCursor
  }
}
    ${MediaRefFragmentDoc}`;
export type SearchTeamsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>, 'query'> & ({ variables: Types.SearchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchTeamsComponent = (props: SearchTeamsComponentProps) => (
      <ApolloReactComponents.Query<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables> query={SearchTeamsDocument} {...props} />
    );
    

/**
 * __useSearchTeamsQuery__
 *
 * To run a query within a React component, call `useSearchTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTeamsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchTeamsQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables> & ({ variables: Types.SearchTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>(SearchTeamsDocument, options);
      }
export function useSearchTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>(SearchTeamsDocument, options);
        }
export function useSearchTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>(SearchTeamsDocument, options);
        }
export type SearchTeamsQueryHookResult = ReturnType<typeof useSearchTeamsQuery>;
export type SearchTeamsLazyQueryHookResult = ReturnType<typeof useSearchTeamsLazyQuery>;
export type SearchTeamsSuspenseQueryHookResult = ReturnType<typeof useSearchTeamsSuspenseQuery>;
export type SearchTeamsQueryResult = Apollo.QueryResult<Types.SearchTeamsQuery, Types.SearchTeamsQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($filter: OutActionSearchInput!) {
  searchUsers(filter: $filter) {
    data {
      id
      firstName
      lastName
      profileMediaRef {
        ...MediaRef
      }
      email
      role
      invitationStatus
      lastCountry
      teamId
    }
    total
    nextCursor
  }
}
    ${MediaRefFragmentDoc}`;
export type SearchUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>, 'query'> & ({ variables: Types.SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchUsersComponent = (props: SearchUsersComponentProps) => (
      <ApolloReactComponents.Query<Types.SearchUsersQuery, Types.SearchUsersQueryVariables> query={SearchUsersDocument} {...props} />
    );
    

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchUsersQuery, Types.SearchUsersQueryVariables> & ({ variables: Types.SearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<Types.SearchUsersQuery, Types.SearchUsersQueryVariables>;
export const SearchEmailsOutDocument = gql`
    query searchEmailsOut($filter: OutActionSearchInput!) {
  searchEmailsOut(filter: $filter) {
    data {
      messageId
      from
      subject
      to
      attendeeId
      userId
      createdAt
      unsubscribed
      complained
      opened
      bounced
    }
    total
    nextCursor
  }
}
    `;
export type SearchEmailsOutComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>, 'query'> & ({ variables: Types.SearchEmailsOutQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchEmailsOutComponent = (props: SearchEmailsOutComponentProps) => (
      <ApolloReactComponents.Query<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables> query={SearchEmailsOutDocument} {...props} />
    );
    

/**
 * __useSearchEmailsOutQuery__
 *
 * To run a query within a React component, call `useSearchEmailsOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailsOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailsOutQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchEmailsOutQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables> & ({ variables: Types.SearchEmailsOutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>(SearchEmailsOutDocument, options);
      }
export function useSearchEmailsOutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>(SearchEmailsOutDocument, options);
        }
export function useSearchEmailsOutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>(SearchEmailsOutDocument, options);
        }
export type SearchEmailsOutQueryHookResult = ReturnType<typeof useSearchEmailsOutQuery>;
export type SearchEmailsOutLazyQueryHookResult = ReturnType<typeof useSearchEmailsOutLazyQuery>;
export type SearchEmailsOutSuspenseQueryHookResult = ReturnType<typeof useSearchEmailsOutSuspenseQuery>;
export type SearchEmailsOutQueryResult = Apollo.QueryResult<Types.SearchEmailsOutQuery, Types.SearchEmailsOutQueryVariables>;
export const SearchAttendeesDocument = gql`
    query searchAttendees($filter: AttendeesInput!) {
  searchAttendees(filter: $filter) {
    data {
      ...AttendeeSearchInfo
    }
    total
    nextCursor
  }
}
    ${AttendeeSearchInfoFragmentDoc}`;
export type SearchAttendeesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>, 'query'> & ({ variables: Types.SearchAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchAttendeesComponent = (props: SearchAttendeesComponentProps) => (
      <ApolloReactComponents.Query<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables> query={SearchAttendeesDocument} {...props} />
    );
    

/**
 * __useSearchAttendeesQuery__
 *
 * To run a query within a React component, call `useSearchAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAttendeesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchAttendeesQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables> & ({ variables: Types.SearchAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>(SearchAttendeesDocument, options);
      }
export function useSearchAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>(SearchAttendeesDocument, options);
        }
export function useSearchAttendeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>(SearchAttendeesDocument, options);
        }
export type SearchAttendeesQueryHookResult = ReturnType<typeof useSearchAttendeesQuery>;
export type SearchAttendeesLazyQueryHookResult = ReturnType<typeof useSearchAttendeesLazyQuery>;
export type SearchAttendeesSuspenseQueryHookResult = ReturnType<typeof useSearchAttendeesSuspenseQuery>;
export type SearchAttendeesQueryResult = Apollo.QueryResult<Types.SearchAttendeesQuery, Types.SearchAttendeesQueryVariables>;
export const OpsGetAttendeeInfoDocument = gql`
    query opsGetAttendeeInfo($email: String!) {
  opsGetAttendeeInfo(email: $email) {
    ...AttendeeWithStats
  }
}
    ${AttendeeWithStatsFragmentDoc}`;
export type OpsGetAttendeeInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>, 'query'> & ({ variables: Types.OpsGetAttendeeInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsGetAttendeeInfoComponent = (props: OpsGetAttendeeInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables> query={OpsGetAttendeeInfoDocument} {...props} />
    );
    

/**
 * __useOpsGetAttendeeInfoQuery__
 *
 * To run a query within a React component, call `useOpsGetAttendeeInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsGetAttendeeInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsGetAttendeeInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useOpsGetAttendeeInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables> & ({ variables: Types.OpsGetAttendeeInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>(OpsGetAttendeeInfoDocument, options);
      }
export function useOpsGetAttendeeInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>(OpsGetAttendeeInfoDocument, options);
        }
export function useOpsGetAttendeeInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>(OpsGetAttendeeInfoDocument, options);
        }
export type OpsGetAttendeeInfoQueryHookResult = ReturnType<typeof useOpsGetAttendeeInfoQuery>;
export type OpsGetAttendeeInfoLazyQueryHookResult = ReturnType<typeof useOpsGetAttendeeInfoLazyQuery>;
export type OpsGetAttendeeInfoSuspenseQueryHookResult = ReturnType<typeof useOpsGetAttendeeInfoSuspenseQuery>;
export type OpsGetAttendeeInfoQueryResult = Apollo.QueryResult<Types.OpsGetAttendeeInfoQuery, Types.OpsGetAttendeeInfoQueryVariables>;
export const SearchAttendeesByEmailDocument = gql`
    query searchAttendeesByEmail($filter: AttendeesEmailsGroupInput!) {
  searchAttendeesByEmail(filter: $filter) {
    data {
      ...AttendeeInTeam
    }
    total
    nextCursor
  }
}
    ${AttendeeInTeamFragmentDoc}`;
export type SearchAttendeesByEmailComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>, 'query'> & ({ variables: Types.SearchAttendeesByEmailQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchAttendeesByEmailComponent = (props: SearchAttendeesByEmailComponentProps) => (
      <ApolloReactComponents.Query<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables> query={SearchAttendeesByEmailDocument} {...props} />
    );
    

/**
 * __useSearchAttendeesByEmailQuery__
 *
 * To run a query within a React component, call `useSearchAttendeesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAttendeesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAttendeesByEmailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchAttendeesByEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables> & ({ variables: Types.SearchAttendeesByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>(SearchAttendeesByEmailDocument, options);
      }
export function useSearchAttendeesByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>(SearchAttendeesByEmailDocument, options);
        }
export function useSearchAttendeesByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>(SearchAttendeesByEmailDocument, options);
        }
export type SearchAttendeesByEmailQueryHookResult = ReturnType<typeof useSearchAttendeesByEmailQuery>;
export type SearchAttendeesByEmailLazyQueryHookResult = ReturnType<typeof useSearchAttendeesByEmailLazyQuery>;
export type SearchAttendeesByEmailSuspenseQueryHookResult = ReturnType<typeof useSearchAttendeesByEmailSuspenseQuery>;
export type SearchAttendeesByEmailQueryResult = Apollo.QueryResult<Types.SearchAttendeesByEmailQuery, Types.SearchAttendeesByEmailQueryVariables>;
export const AttendeesOptOutAcrossTeamsDocument = gql`
    mutation attendeesOptOutAcrossTeams($email: String!, $optOut: Boolean!) {
  attendeesOptOutAcrossTeams(email: $email, optOut: $optOut)
}
    `;
export type AttendeesOptOutAcrossTeamsMutationFn = Apollo.MutationFunction<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables>;
export type AttendeesOptOutAcrossTeamsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables>, 'mutation'>;

    export const AttendeesOptOutAcrossTeamsComponent = (props: AttendeesOptOutAcrossTeamsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables> mutation={AttendeesOptOutAcrossTeamsDocument} {...props} />
    );
    

/**
 * __useAttendeesOptOutAcrossTeamsMutation__
 *
 * To run a mutation, you first call `useAttendeesOptOutAcrossTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeesOptOutAcrossTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeesOptOutAcrossTeamsMutation, { data, loading, error }] = useAttendeesOptOutAcrossTeamsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      optOut: // value for 'optOut'
 *   },
 * });
 */
export function useAttendeesOptOutAcrossTeamsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables>(AttendeesOptOutAcrossTeamsDocument, options);
      }
export type AttendeesOptOutAcrossTeamsMutationHookResult = ReturnType<typeof useAttendeesOptOutAcrossTeamsMutation>;
export type AttendeesOptOutAcrossTeamsMutationResult = Apollo.MutationResult<Types.AttendeesOptOutAcrossTeamsMutation>;
export type AttendeesOptOutAcrossTeamsMutationOptions = Apollo.BaseMutationOptions<Types.AttendeesOptOutAcrossTeamsMutation, Types.AttendeesOptOutAcrossTeamsMutationVariables>;
export const DeleteAttendeesAcrossTeamsDocument = gql`
    mutation deleteAttendeesAcrossTeams($email: String!) {
  deleteAttendeesAcrossTeams(email: $email)
}
    `;
export type DeleteAttendeesAcrossTeamsMutationFn = Apollo.MutationFunction<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables>;
export type DeleteAttendeesAcrossTeamsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables>, 'mutation'>;

    export const DeleteAttendeesAcrossTeamsComponent = (props: DeleteAttendeesAcrossTeamsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables> mutation={DeleteAttendeesAcrossTeamsDocument} {...props} />
    );
    

/**
 * __useDeleteAttendeesAcrossTeamsMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeesAcrossTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeesAcrossTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeesAcrossTeamsMutation, { data, loading, error }] = useDeleteAttendeesAcrossTeamsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteAttendeesAcrossTeamsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables>(DeleteAttendeesAcrossTeamsDocument, options);
      }
export type DeleteAttendeesAcrossTeamsMutationHookResult = ReturnType<typeof useDeleteAttendeesAcrossTeamsMutation>;
export type DeleteAttendeesAcrossTeamsMutationResult = Apollo.MutationResult<Types.DeleteAttendeesAcrossTeamsMutation>;
export type DeleteAttendeesAcrossTeamsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAttendeesAcrossTeamsMutation, Types.DeleteAttendeesAcrossTeamsMutationVariables>;
export const DeleteAttendeeDocument = gql`
    mutation deleteAttendee($attendeeId: String!) {
  deleteAttendee(attendeeId: $attendeeId)
}
    `;
export type DeleteAttendeeMutationFn = Apollo.MutationFunction<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables>;
export type DeleteAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables>, 'mutation'>;

    export const DeleteAttendeeComponent = (props: DeleteAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables> mutation={DeleteAttendeeDocument} {...props} />
    );
    

/**
 * __useDeleteAttendeeMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeeMutation, { data, loading, error }] = useDeleteAttendeeMutation({
 *   variables: {
 *      attendeeId: // value for 'attendeeId'
 *   },
 * });
 */
export function useDeleteAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables>(DeleteAttendeeDocument, options);
      }
export type DeleteAttendeeMutationHookResult = ReturnType<typeof useDeleteAttendeeMutation>;
export type DeleteAttendeeMutationResult = Apollo.MutationResult<Types.DeleteAttendeeMutation>;
export type DeleteAttendeeMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAttendeeMutation, Types.DeleteAttendeeMutationVariables>;
export const OpsStatsDocument = gql`
    query opsStats($filter: CrossTeamFilterInput!, $page: String!) {
  opsStats(filter: $filter, page: $page) {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export type OpsStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>, 'query'> & ({ variables: Types.OpsStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsStatsComponent = (props: OpsStatsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsStatsQuery, Types.OpsStatsQueryVariables> query={OpsStatsDocument} {...props} />
    );
    

/**
 * __useOpsStatsQuery__
 *
 * To run a query within a React component, call `useOpsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOpsStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsStatsQuery, Types.OpsStatsQueryVariables> & ({ variables: Types.OpsStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>(OpsStatsDocument, options);
      }
export function useOpsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>(OpsStatsDocument, options);
        }
export function useOpsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>(OpsStatsDocument, options);
        }
export type OpsStatsQueryHookResult = ReturnType<typeof useOpsStatsQuery>;
export type OpsStatsLazyQueryHookResult = ReturnType<typeof useOpsStatsLazyQuery>;
export type OpsStatsSuspenseQueryHookResult = ReturnType<typeof useOpsStatsSuspenseQuery>;
export type OpsStatsQueryResult = Apollo.QueryResult<Types.OpsStatsQuery, Types.OpsStatsQueryVariables>;
export const OpsStatsHistoryDocument = gql`
    query opsStatsHistory($filter: StatsHistoryFilter!) {
  opsStatsHistory(filter: $filter) {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export type OpsStatsHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>, 'query'> & ({ variables: Types.OpsStatsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsStatsHistoryComponent = (props: OpsStatsHistoryComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables> query={OpsStatsHistoryDocument} {...props} />
    );
    

/**
 * __useOpsStatsHistoryQuery__
 *
 * To run a query within a React component, call `useOpsStatsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsStatsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsStatsHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOpsStatsHistoryQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables> & ({ variables: Types.OpsStatsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>(OpsStatsHistoryDocument, options);
      }
export function useOpsStatsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>(OpsStatsHistoryDocument, options);
        }
export function useOpsStatsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>(OpsStatsHistoryDocument, options);
        }
export type OpsStatsHistoryQueryHookResult = ReturnType<typeof useOpsStatsHistoryQuery>;
export type OpsStatsHistoryLazyQueryHookResult = ReturnType<typeof useOpsStatsHistoryLazyQuery>;
export type OpsStatsHistorySuspenseQueryHookResult = ReturnType<typeof useOpsStatsHistorySuspenseQuery>;
export type OpsStatsHistoryQueryResult = Apollo.QueryResult<Types.OpsStatsHistoryQuery, Types.OpsStatsHistoryQueryVariables>;
export const OpsGraphsDocument = gql`
    query opsGraphs($filter: CrossTeamFilterInput!, $page: String!) {
  opsGraphs(filter: $filter, page: $page) {
    ...StatsGraph
  }
}
    ${StatsGraphFragmentDoc}`;
export type OpsGraphsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>, 'query'> & ({ variables: Types.OpsGraphsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsGraphsComponent = (props: OpsGraphsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables> query={OpsGraphsDocument} {...props} />
    );
    

/**
 * __useOpsGraphsQuery__
 *
 * To run a query within a React component, call `useOpsGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsGraphsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOpsGraphsQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables> & ({ variables: Types.OpsGraphsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>(OpsGraphsDocument, options);
      }
export function useOpsGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>(OpsGraphsDocument, options);
        }
export function useOpsGraphsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>(OpsGraphsDocument, options);
        }
export type OpsGraphsQueryHookResult = ReturnType<typeof useOpsGraphsQuery>;
export type OpsGraphsLazyQueryHookResult = ReturnType<typeof useOpsGraphsLazyQuery>;
export type OpsGraphsSuspenseQueryHookResult = ReturnType<typeof useOpsGraphsSuspenseQuery>;
export type OpsGraphsQueryResult = Apollo.QueryResult<Types.OpsGraphsQuery, Types.OpsGraphsQueryVariables>;
export const OpsStatItemsDocument = gql`
    query opsStatItems($stat: StatisticInput!, $cursor: String!) {
  opsStatItems(stat: $stat, cursor: $cursor) {
    items {
      __typename
      ... on EWebinarSet {
        id
        draftWebinar {
          id
          title
        }
      }
      ... on Attendee {
        id
        firstName
        lastName
        email
        sessionType
        startTime
        joinTime
        joinReplayTime
        optOut
        country
        deletedAt
      }
      ... on Team {
        id
        name
        subdomain
      }
      ... on HistoricStat {
        value
        date
      }
    }
    total
    nextCursor
  }
}
    `;
export type OpsStatItemsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>, 'query'> & ({ variables: Types.OpsStatItemsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OpsStatItemsComponent = (props: OpsStatItemsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables> query={OpsStatItemsDocument} {...props} />
    );
    

/**
 * __useOpsStatItemsQuery__
 *
 * To run a query within a React component, call `useOpsStatItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsStatItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsStatItemsQuery({
 *   variables: {
 *      stat: // value for 'stat'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useOpsStatItemsQuery(baseOptions: Apollo.QueryHookOptions<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables> & ({ variables: Types.OpsStatItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>(OpsStatItemsDocument, options);
      }
export function useOpsStatItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>(OpsStatItemsDocument, options);
        }
export function useOpsStatItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>(OpsStatItemsDocument, options);
        }
export type OpsStatItemsQueryHookResult = ReturnType<typeof useOpsStatItemsQuery>;
export type OpsStatItemsLazyQueryHookResult = ReturnType<typeof useOpsStatItemsLazyQuery>;
export type OpsStatItemsSuspenseQueryHookResult = ReturnType<typeof useOpsStatItemsSuspenseQuery>;
export type OpsStatItemsQueryResult = Apollo.QueryResult<Types.OpsStatItemsQuery, Types.OpsStatItemsQueryVariables>;
export const OpsOperationsDocument = gql`
    query opsOperations {
  opsOperations {
    operator
    group
    name
    desc
    args
    details
  }
}
    `;
export type OpsOperationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>, 'query'>;

    export const OpsOperationsComponent = (props: OpsOperationsComponentProps) => (
      <ApolloReactComponents.Query<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables> query={OpsOperationsDocument} {...props} />
    );
    

/**
 * __useOpsOperationsQuery__
 *
 * To run a query within a React component, call `useOpsOperationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsOperationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsOperationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpsOperationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>(OpsOperationsDocument, options);
      }
export function useOpsOperationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>(OpsOperationsDocument, options);
        }
export function useOpsOperationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>(OpsOperationsDocument, options);
        }
export type OpsOperationsQueryHookResult = ReturnType<typeof useOpsOperationsQuery>;
export type OpsOperationsLazyQueryHookResult = ReturnType<typeof useOpsOperationsLazyQuery>;
export type OpsOperationsSuspenseQueryHookResult = ReturnType<typeof useOpsOperationsSuspenseQuery>;
export type OpsOperationsQueryResult = Apollo.QueryResult<Types.OpsOperationsQuery, Types.OpsOperationsQueryVariables>;
export const PerformOperationDocument = gql`
    mutation performOperation($op: String!, $args: JSON) {
  performOperation(op: $op, args: $args)
}
    `;
export type PerformOperationMutationFn = Apollo.MutationFunction<Types.PerformOperationMutation, Types.PerformOperationMutationVariables>;
export type PerformOperationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PerformOperationMutation, Types.PerformOperationMutationVariables>, 'mutation'>;

    export const PerformOperationComponent = (props: PerformOperationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PerformOperationMutation, Types.PerformOperationMutationVariables> mutation={PerformOperationDocument} {...props} />
    );
    

/**
 * __usePerformOperationMutation__
 *
 * To run a mutation, you first call `usePerformOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performOperationMutation, { data, loading, error }] = usePerformOperationMutation({
 *   variables: {
 *      op: // value for 'op'
 *      args: // value for 'args'
 *   },
 * });
 */
export function usePerformOperationMutation(baseOptions?: Apollo.MutationHookOptions<Types.PerformOperationMutation, Types.PerformOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PerformOperationMutation, Types.PerformOperationMutationVariables>(PerformOperationDocument, options);
      }
export type PerformOperationMutationHookResult = ReturnType<typeof usePerformOperationMutation>;
export type PerformOperationMutationResult = Apollo.MutationResult<Types.PerformOperationMutation>;
export type PerformOperationMutationOptions = Apollo.BaseMutationOptions<Types.PerformOperationMutation, Types.PerformOperationMutationVariables>;
export const ImpersonateDocument = gql`
    mutation impersonate($teamId: String!, $userId: String!) {
  impersonate(teamId: $teamId, userId: $userId) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type ImpersonateMutationFn = Apollo.MutationFunction<Types.ImpersonateMutation, Types.ImpersonateMutationVariables>;
export type ImpersonateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ImpersonateMutation, Types.ImpersonateMutationVariables>, 'mutation'>;

    export const ImpersonateComponent = (props: ImpersonateComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ImpersonateMutation, Types.ImpersonateMutationVariables> mutation={ImpersonateDocument} {...props} />
    );
    

/**
 * __useImpersonateMutation__
 *
 * To run a mutation, you first call `useImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateMutation, { data, loading, error }] = useImpersonateMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useImpersonateMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImpersonateMutation, Types.ImpersonateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImpersonateMutation, Types.ImpersonateMutationVariables>(ImpersonateDocument, options);
      }
export type ImpersonateMutationHookResult = ReturnType<typeof useImpersonateMutation>;
export type ImpersonateMutationResult = Apollo.MutationResult<Types.ImpersonateMutation>;
export type ImpersonateMutationOptions = Apollo.BaseMutationOptions<Types.ImpersonateMutation, Types.ImpersonateMutationVariables>;
export const ImpersonateByEmailDocument = gql`
    mutation impersonateByEmail($email: String!, $userId: String) {
  impersonateByEmail(email: $email, userId: $userId) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type ImpersonateByEmailMutationFn = Apollo.MutationFunction<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables>;
export type ImpersonateByEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables>, 'mutation'>;

    export const ImpersonateByEmailComponent = (props: ImpersonateByEmailComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables> mutation={ImpersonateByEmailDocument} {...props} />
    );
    

/**
 * __useImpersonateByEmailMutation__
 *
 * To run a mutation, you first call `useImpersonateByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateByEmailMutation, { data, loading, error }] = useImpersonateByEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useImpersonateByEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables>(ImpersonateByEmailDocument, options);
      }
export type ImpersonateByEmailMutationHookResult = ReturnType<typeof useImpersonateByEmailMutation>;
export type ImpersonateByEmailMutationResult = Apollo.MutationResult<Types.ImpersonateByEmailMutation>;
export type ImpersonateByEmailMutationOptions = Apollo.BaseMutationOptions<Types.ImpersonateByEmailMutation, Types.ImpersonateByEmailMutationVariables>;
export const StopImpersonatingDocument = gql`
    mutation stopImpersonating {
  stopImpersonating {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type StopImpersonatingMutationFn = Apollo.MutationFunction<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables>;
export type StopImpersonatingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables>, 'mutation'>;

    export const StopImpersonatingComponent = (props: StopImpersonatingComponentProps) => (
      <ApolloReactComponents.Mutation<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables> mutation={StopImpersonatingDocument} {...props} />
    );
    

/**
 * __useStopImpersonatingMutation__
 *
 * To run a mutation, you first call `useStopImpersonatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImpersonatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImpersonatingMutation, { data, loading, error }] = useStopImpersonatingMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopImpersonatingMutation(baseOptions?: Apollo.MutationHookOptions<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables>(StopImpersonatingDocument, options);
      }
export type StopImpersonatingMutationHookResult = ReturnType<typeof useStopImpersonatingMutation>;
export type StopImpersonatingMutationResult = Apollo.MutationResult<Types.StopImpersonatingMutation>;
export type StopImpersonatingMutationOptions = Apollo.BaseMutationOptions<Types.StopImpersonatingMutation, Types.StopImpersonatingMutationVariables>;
export const StatDataDocument = gql`
    query statData($statInput: StatisticInput!) {
  statData(statInput: $statInput) {
    ...Statistic
  }
}
    ${StatisticFragmentDoc}`;
export type StatDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.StatDataQuery, Types.StatDataQueryVariables>, 'query'> & ({ variables: Types.StatDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StatDataComponent = (props: StatDataComponentProps) => (
      <ApolloReactComponents.Query<Types.StatDataQuery, Types.StatDataQueryVariables> query={StatDataDocument} {...props} />
    );
    

/**
 * __useStatDataQuery__
 *
 * To run a query within a React component, call `useStatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatDataQuery({
 *   variables: {
 *      statInput: // value for 'statInput'
 *   },
 * });
 */
export function useStatDataQuery(baseOptions: Apollo.QueryHookOptions<Types.StatDataQuery, Types.StatDataQueryVariables> & ({ variables: Types.StatDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StatDataQuery, Types.StatDataQueryVariables>(StatDataDocument, options);
      }
export function useStatDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StatDataQuery, Types.StatDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StatDataQuery, Types.StatDataQueryVariables>(StatDataDocument, options);
        }
export function useStatDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.StatDataQuery, Types.StatDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.StatDataQuery, Types.StatDataQueryVariables>(StatDataDocument, options);
        }
export type StatDataQueryHookResult = ReturnType<typeof useStatDataQuery>;
export type StatDataLazyQueryHookResult = ReturnType<typeof useStatDataLazyQuery>;
export type StatDataSuspenseQueryHookResult = ReturnType<typeof useStatDataSuspenseQuery>;
export type StatDataQueryResult = Apollo.QueryResult<Types.StatDataQuery, Types.StatDataQueryVariables>;
export const StatsGraphDataDocument = gql`
    query statsGraphData($statsGraphInput: StatsGraphInput!) {
  statsGraphData(statsGraphInput: $statsGraphInput) {
    ...StatsGraph
  }
}
    ${StatsGraphFragmentDoc}`;
export type StatsGraphDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>, 'query'> & ({ variables: Types.StatsGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const StatsGraphDataComponent = (props: StatsGraphDataComponentProps) => (
      <ApolloReactComponents.Query<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables> query={StatsGraphDataDocument} {...props} />
    );
    

/**
 * __useStatsGraphDataQuery__
 *
 * To run a query within a React component, call `useStatsGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsGraphDataQuery({
 *   variables: {
 *      statsGraphInput: // value for 'statsGraphInput'
 *   },
 * });
 */
export function useStatsGraphDataQuery(baseOptions: Apollo.QueryHookOptions<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables> & ({ variables: Types.StatsGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>(StatsGraphDataDocument, options);
      }
export function useStatsGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>(StatsGraphDataDocument, options);
        }
export function useStatsGraphDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>(StatsGraphDataDocument, options);
        }
export type StatsGraphDataQueryHookResult = ReturnType<typeof useStatsGraphDataQuery>;
export type StatsGraphDataLazyQueryHookResult = ReturnType<typeof useStatsGraphDataLazyQuery>;
export type StatsGraphDataSuspenseQueryHookResult = ReturnType<typeof useStatsGraphDataSuspenseQuery>;
export type StatsGraphDataQueryResult = Apollo.QueryResult<Types.StatsGraphDataQuery, Types.StatsGraphDataQueryVariables>;
export const ParticipantsDocument = gql`
    query participants($filter: ParticipantFilter!) {
  participants(filter: $filter) {
    participants {
      ...Participant
    }
    total
    nextCursor
  }
}
    ${ParticipantFragmentDoc}`;
export type ParticipantsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>, 'query'> & ({ variables: Types.ParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ParticipantsComponent = (props: ParticipantsComponentProps) => (
      <ApolloReactComponents.Query<Types.ParticipantsQuery, Types.ParticipantsQueryVariables> query={ParticipantsDocument} {...props} />
    );
    

/**
 * __useParticipantsQuery__
 *
 * To run a query within a React component, call `useParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useParticipantsQuery(baseOptions: Apollo.QueryHookOptions<Types.ParticipantsQuery, Types.ParticipantsQueryVariables> & ({ variables: Types.ParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>(ParticipantsDocument, options);
      }
export function useParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>(ParticipantsDocument, options);
        }
export function useParticipantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>(ParticipantsDocument, options);
        }
export type ParticipantsQueryHookResult = ReturnType<typeof useParticipantsQuery>;
export type ParticipantsLazyQueryHookResult = ReturnType<typeof useParticipantsLazyQuery>;
export type ParticipantsSuspenseQueryHookResult = ReturnType<typeof useParticipantsSuspenseQuery>;
export type ParticipantsQueryResult = Apollo.QueryResult<Types.ParticipantsQuery, Types.ParticipantsQueryVariables>;
export const CountParticipantsDocument = gql`
    query countParticipants($filter: ParticipantFilter!) {
  countParticipants(filter: $filter)
}
    `;
export type CountParticipantsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>, 'query'> & ({ variables: Types.CountParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CountParticipantsComponent = (props: CountParticipantsComponentProps) => (
      <ApolloReactComponents.Query<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables> query={CountParticipantsDocument} {...props} />
    );
    

/**
 * __useCountParticipantsQuery__
 *
 * To run a query within a React component, call `useCountParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountParticipantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountParticipantsQuery(baseOptions: Apollo.QueryHookOptions<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables> & ({ variables: Types.CountParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>(CountParticipantsDocument, options);
      }
export function useCountParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>(CountParticipantsDocument, options);
        }
export function useCountParticipantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>(CountParticipantsDocument, options);
        }
export type CountParticipantsQueryHookResult = ReturnType<typeof useCountParticipantsQuery>;
export type CountParticipantsLazyQueryHookResult = ReturnType<typeof useCountParticipantsLazyQuery>;
export type CountParticipantsSuspenseQueryHookResult = ReturnType<typeof useCountParticipantsSuspenseQuery>;
export type CountParticipantsQueryResult = Apollo.QueryResult<Types.CountParticipantsQuery, Types.CountParticipantsQueryVariables>;
export const DeleteParticipantDocument = gql`
    mutation deleteParticipant($data: DeleteParticipantInput!) {
  deleteParticipant(data: $data)
}
    `;
export type DeleteParticipantMutationFn = Apollo.MutationFunction<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables>;
export type DeleteParticipantComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables>, 'mutation'>;

    export const DeleteParticipantComponent = (props: DeleteParticipantComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables> mutation={DeleteParticipantDocument} {...props} />
    );
    

/**
 * __useDeleteParticipantMutation__
 *
 * To run a mutation, you first call `useDeleteParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParticipantMutation, { data, loading, error }] = useDeleteParticipantMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeleteParticipantMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables>(DeleteParticipantDocument, options);
      }
export type DeleteParticipantMutationHookResult = ReturnType<typeof useDeleteParticipantMutation>;
export type DeleteParticipantMutationResult = Apollo.MutationResult<Types.DeleteParticipantMutation>;
export type DeleteParticipantMutationOptions = Apollo.BaseMutationOptions<Types.DeleteParticipantMutation, Types.DeleteParticipantMutationVariables>;
export const ParticipantRecordInfoDocument = gql`
    query participantRecordInfo($filter: ParticipantPropertyFilter!) {
  participantRecordInfo(filter: $filter)
}
    `;
export type ParticipantRecordInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>, 'query'> & ({ variables: Types.ParticipantRecordInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ParticipantRecordInfoComponent = (props: ParticipantRecordInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables> query={ParticipantRecordInfoDocument} {...props} />
    );
    

/**
 * __useParticipantRecordInfoQuery__
 *
 * To run a query within a React component, call `useParticipantRecordInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantRecordInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantRecordInfoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useParticipantRecordInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables> & ({ variables: Types.ParticipantRecordInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>(ParticipantRecordInfoDocument, options);
      }
export function useParticipantRecordInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>(ParticipantRecordInfoDocument, options);
        }
export function useParticipantRecordInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>(ParticipantRecordInfoDocument, options);
        }
export type ParticipantRecordInfoQueryHookResult = ReturnType<typeof useParticipantRecordInfoQuery>;
export type ParticipantRecordInfoLazyQueryHookResult = ReturnType<typeof useParticipantRecordInfoLazyQuery>;
export type ParticipantRecordInfoSuspenseQueryHookResult = ReturnType<typeof useParticipantRecordInfoSuspenseQuery>;
export type ParticipantRecordInfoQueryResult = Apollo.QueryResult<Types.ParticipantRecordInfoQuery, Types.ParticipantRecordInfoQueryVariables>;
export const ParticipantCustomPropertiesDocument = gql`
    query participantCustomProperties($filter: ParticipantPropertyFilter!) {
  participantCustomProperties(filter: $filter) {
    ...ActionPropertyValueWithWebinar
  }
}
    ${ActionPropertyValueWithWebinarFragmentDoc}`;
export type ParticipantCustomPropertiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>, 'query'> & ({ variables: Types.ParticipantCustomPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ParticipantCustomPropertiesComponent = (props: ParticipantCustomPropertiesComponentProps) => (
      <ApolloReactComponents.Query<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables> query={ParticipantCustomPropertiesDocument} {...props} />
    );
    

/**
 * __useParticipantCustomPropertiesQuery__
 *
 * To run a query within a React component, call `useParticipantCustomPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantCustomPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantCustomPropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useParticipantCustomPropertiesQuery(baseOptions: Apollo.QueryHookOptions<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables> & ({ variables: Types.ParticipantCustomPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>(ParticipantCustomPropertiesDocument, options);
      }
export function useParticipantCustomPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>(ParticipantCustomPropertiesDocument, options);
        }
export function useParticipantCustomPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>(ParticipantCustomPropertiesDocument, options);
        }
export type ParticipantCustomPropertiesQueryHookResult = ReturnType<typeof useParticipantCustomPropertiesQuery>;
export type ParticipantCustomPropertiesLazyQueryHookResult = ReturnType<typeof useParticipantCustomPropertiesLazyQuery>;
export type ParticipantCustomPropertiesSuspenseQueryHookResult = ReturnType<typeof useParticipantCustomPropertiesSuspenseQuery>;
export type ParticipantCustomPropertiesQueryResult = Apollo.QueryResult<Types.ParticipantCustomPropertiesQuery, Types.ParticipantCustomPropertiesQueryVariables>;
export const ParticipantRecordDetailsDocument = gql`
    query participantRecordDetails($email: String!) {
  participantRecordDetails(email: $email) {
    ...ParticipantRecordDetails
  }
}
    ${ParticipantRecordDetailsFragmentDoc}`;
export type ParticipantRecordDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>, 'query'> & ({ variables: Types.ParticipantRecordDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ParticipantRecordDetailsComponent = (props: ParticipantRecordDetailsComponentProps) => (
      <ApolloReactComponents.Query<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables> query={ParticipantRecordDetailsDocument} {...props} />
    );
    

/**
 * __useParticipantRecordDetailsQuery__
 *
 * To run a query within a React component, call `useParticipantRecordDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantRecordDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantRecordDetailsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useParticipantRecordDetailsQuery(baseOptions: Apollo.QueryHookOptions<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables> & ({ variables: Types.ParticipantRecordDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>(ParticipantRecordDetailsDocument, options);
      }
export function useParticipantRecordDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>(ParticipantRecordDetailsDocument, options);
        }
export function useParticipantRecordDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>(ParticipantRecordDetailsDocument, options);
        }
export type ParticipantRecordDetailsQueryHookResult = ReturnType<typeof useParticipantRecordDetailsQuery>;
export type ParticipantRecordDetailsLazyQueryHookResult = ReturnType<typeof useParticipantRecordDetailsLazyQuery>;
export type ParticipantRecordDetailsSuspenseQueryHookResult = ReturnType<typeof useParticipantRecordDetailsSuspenseQuery>;
export type ParticipantRecordDetailsQueryResult = Apollo.QueryResult<Types.ParticipantRecordDetailsQuery, Types.ParticipantRecordDetailsQueryVariables>;
export const GetRegularPriceDocument = gql`
    query getRegularPrice {
  price {
    pricePlan {
      ...priceTier
    }
  }
}
    ${PriceTierFragmentDoc}`;
export type GetRegularPriceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>, 'query'>;

    export const GetRegularPriceComponent = (props: GetRegularPriceComponentProps) => (
      <ApolloReactComponents.Query<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables> query={GetRegularPriceDocument} {...props} />
    );
    

/**
 * __useGetRegularPriceQuery__
 *
 * To run a query within a React component, call `useGetRegularPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegularPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegularPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegularPriceQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>(GetRegularPriceDocument, options);
      }
export function useGetRegularPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>(GetRegularPriceDocument, options);
        }
export function useGetRegularPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>(GetRegularPriceDocument, options);
        }
export type GetRegularPriceQueryHookResult = ReturnType<typeof useGetRegularPriceQuery>;
export type GetRegularPriceLazyQueryHookResult = ReturnType<typeof useGetRegularPriceLazyQuery>;
export type GetRegularPriceSuspenseQueryHookResult = ReturnType<typeof useGetRegularPriceSuspenseQuery>;
export type GetRegularPriceQueryResult = Apollo.QueryResult<Types.GetRegularPriceQuery, Types.GetRegularPriceQueryVariables>;
export const GetDiscountedPriceByCodeDocument = gql`
    query getDiscountedPriceByCode($code: String!) {
  getDiscountedPriceByCode(code: $code) {
    ...pricePlan
  }
}
    ${PricePlanFragmentDoc}`;
export type GetDiscountedPriceByCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>, 'query'> & ({ variables: Types.GetDiscountedPriceByCodeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDiscountedPriceByCodeComponent = (props: GetDiscountedPriceByCodeComponentProps) => (
      <ApolloReactComponents.Query<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables> query={GetDiscountedPriceByCodeDocument} {...props} />
    );
    

/**
 * __useGetDiscountedPriceByCodeQuery__
 *
 * To run a query within a React component, call `useGetDiscountedPriceByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountedPriceByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountedPriceByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDiscountedPriceByCodeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables> & ({ variables: Types.GetDiscountedPriceByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>(GetDiscountedPriceByCodeDocument, options);
      }
export function useGetDiscountedPriceByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>(GetDiscountedPriceByCodeDocument, options);
        }
export function useGetDiscountedPriceByCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>(GetDiscountedPriceByCodeDocument, options);
        }
export type GetDiscountedPriceByCodeQueryHookResult = ReturnType<typeof useGetDiscountedPriceByCodeQuery>;
export type GetDiscountedPriceByCodeLazyQueryHookResult = ReturnType<typeof useGetDiscountedPriceByCodeLazyQuery>;
export type GetDiscountedPriceByCodeSuspenseQueryHookResult = ReturnType<typeof useGetDiscountedPriceByCodeSuspenseQuery>;
export type GetDiscountedPriceByCodeQueryResult = Apollo.QueryResult<Types.GetDiscountedPriceByCodeQuery, Types.GetDiscountedPriceByCodeQueryVariables>;
export const GetDiscountedPriceByTeamDocument = gql`
    query getDiscountedPriceByTeam {
  getDiscountedPriceByTeam {
    ...pricePlan
  }
}
    ${PricePlanFragmentDoc}`;
export type GetDiscountedPriceByTeamComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>, 'query'>;

    export const GetDiscountedPriceByTeamComponent = (props: GetDiscountedPriceByTeamComponentProps) => (
      <ApolloReactComponents.Query<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables> query={GetDiscountedPriceByTeamDocument} {...props} />
    );
    

/**
 * __useGetDiscountedPriceByTeamQuery__
 *
 * To run a query within a React component, call `useGetDiscountedPriceByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountedPriceByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountedPriceByTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiscountedPriceByTeamQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>(GetDiscountedPriceByTeamDocument, options);
      }
export function useGetDiscountedPriceByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>(GetDiscountedPriceByTeamDocument, options);
        }
export function useGetDiscountedPriceByTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>(GetDiscountedPriceByTeamDocument, options);
        }
export type GetDiscountedPriceByTeamQueryHookResult = ReturnType<typeof useGetDiscountedPriceByTeamQuery>;
export type GetDiscountedPriceByTeamLazyQueryHookResult = ReturnType<typeof useGetDiscountedPriceByTeamLazyQuery>;
export type GetDiscountedPriceByTeamSuspenseQueryHookResult = ReturnType<typeof useGetDiscountedPriceByTeamSuspenseQuery>;
export type GetDiscountedPriceByTeamQueryResult = Apollo.QueryResult<Types.GetDiscountedPriceByTeamQuery, Types.GetDiscountedPriceByTeamQueryVariables>;
export const AddOnsDocument = gql`
    query addOns {
  addOns {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export type AddOnsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AddOnsQuery, Types.AddOnsQueryVariables>, 'query'>;

    export const AddOnsComponent = (props: AddOnsComponentProps) => (
      <ApolloReactComponents.Query<Types.AddOnsQuery, Types.AddOnsQueryVariables> query={AddOnsDocument} {...props} />
    );
    

/**
 * __useAddOnsQuery__
 *
 * To run a query within a React component, call `useAddOnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddOnsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AddOnsQuery, Types.AddOnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AddOnsQuery, Types.AddOnsQueryVariables>(AddOnsDocument, options);
      }
export function useAddOnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AddOnsQuery, Types.AddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AddOnsQuery, Types.AddOnsQueryVariables>(AddOnsDocument, options);
        }
export function useAddOnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AddOnsQuery, Types.AddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AddOnsQuery, Types.AddOnsQueryVariables>(AddOnsDocument, options);
        }
export type AddOnsQueryHookResult = ReturnType<typeof useAddOnsQuery>;
export type AddOnsLazyQueryHookResult = ReturnType<typeof useAddOnsLazyQuery>;
export type AddOnsSuspenseQueryHookResult = ReturnType<typeof useAddOnsSuspenseQuery>;
export type AddOnsQueryResult = Apollo.QueryResult<Types.AddOnsQuery, Types.AddOnsQueryVariables>;
export const UpdateAddOnDocument = gql`
    mutation updateAddOn($input: UpdateAddOnInput!) {
  updateAddOn(input: $input) {
    paymentIntentSecret
    team {
      id
      purchasedProducts {
        ...PurchasedProduct
      }
    }
  }
}
    ${PurchasedProductFragmentDoc}`;
export type UpdateAddOnMutationFn = Apollo.MutationFunction<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables>;
export type UpdateAddOnComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables>, 'mutation'>;

    export const UpdateAddOnComponent = (props: UpdateAddOnComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables> mutation={UpdateAddOnDocument} {...props} />
    );
    

/**
 * __useUpdateAddOnMutation__
 *
 * To run a mutation, you first call `useUpdateAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddOnMutation, { data, loading, error }] = useUpdateAddOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddOnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables>(UpdateAddOnDocument, options);
      }
export type UpdateAddOnMutationHookResult = ReturnType<typeof useUpdateAddOnMutation>;
export type UpdateAddOnMutationResult = Apollo.MutationResult<Types.UpdateAddOnMutation>;
export type UpdateAddOnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAddOnMutation, Types.UpdateAddOnMutationVariables>;
export const PrepareSwitchingPlansDocument = gql`
    query prepareSwitchingPlans {
  prepareSwitchingPlans {
    additional
    currentPeriodEnd
    nextPrice
  }
}
    `;
export type PrepareSwitchingPlansComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>, 'query'>;

    export const PrepareSwitchingPlansComponent = (props: PrepareSwitchingPlansComponentProps) => (
      <ApolloReactComponents.Query<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables> query={PrepareSwitchingPlansDocument} {...props} />
    );
    

/**
 * __usePrepareSwitchingPlansQuery__
 *
 * To run a query within a React component, call `usePrepareSwitchingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepareSwitchingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepareSwitchingPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrepareSwitchingPlansQuery(baseOptions?: Apollo.QueryHookOptions<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>(PrepareSwitchingPlansDocument, options);
      }
export function usePrepareSwitchingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>(PrepareSwitchingPlansDocument, options);
        }
export function usePrepareSwitchingPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>(PrepareSwitchingPlansDocument, options);
        }
export type PrepareSwitchingPlansQueryHookResult = ReturnType<typeof usePrepareSwitchingPlansQuery>;
export type PrepareSwitchingPlansLazyQueryHookResult = ReturnType<typeof usePrepareSwitchingPlansLazyQuery>;
export type PrepareSwitchingPlansSuspenseQueryHookResult = ReturnType<typeof usePrepareSwitchingPlansSuspenseQuery>;
export type PrepareSwitchingPlansQueryResult = Apollo.QueryResult<Types.PrepareSwitchingPlansQuery, Types.PrepareSwitchingPlansQueryVariables>;
export const SwitchPlansDocument = gql`
    mutation switchPlans($paymentIntentId: String) {
  switchPlans(paymentIntentId: $paymentIntentId) {
    paymentIntentSecret
    team {
      id
    }
  }
}
    `;
export type SwitchPlansMutationFn = Apollo.MutationFunction<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables>;
export type SwitchPlansComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables>, 'mutation'>;

    export const SwitchPlansComponent = (props: SwitchPlansComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables> mutation={SwitchPlansDocument} {...props} />
    );
    

/**
 * __useSwitchPlansMutation__
 *
 * To run a mutation, you first call `useSwitchPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPlansMutation, { data, loading, error }] = useSwitchPlansMutation({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useSwitchPlansMutation(baseOptions?: Apollo.MutationHookOptions<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables>(SwitchPlansDocument, options);
      }
export type SwitchPlansMutationHookResult = ReturnType<typeof useSwitchPlansMutation>;
export type SwitchPlansMutationResult = Apollo.MutationResult<Types.SwitchPlansMutation>;
export type SwitchPlansMutationOptions = Apollo.BaseMutationOptions<Types.SwitchPlansMutation, Types.SwitchPlansMutationVariables>;
export const AvailableAddOnsDocument = gql`
    query availableAddOns {
  availableAddOns {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export type AvailableAddOnsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>, 'query'>;

    export const AvailableAddOnsComponent = (props: AvailableAddOnsComponentProps) => (
      <ApolloReactComponents.Query<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables> query={AvailableAddOnsDocument} {...props} />
    );
    

/**
 * __useAvailableAddOnsQuery__
 *
 * To run a query within a React component, call `useAvailableAddOnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAddOnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAddOnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableAddOnsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>(AvailableAddOnsDocument, options);
      }
export function useAvailableAddOnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>(AvailableAddOnsDocument, options);
        }
export function useAvailableAddOnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>(AvailableAddOnsDocument, options);
        }
export type AvailableAddOnsQueryHookResult = ReturnType<typeof useAvailableAddOnsQuery>;
export type AvailableAddOnsLazyQueryHookResult = ReturnType<typeof useAvailableAddOnsLazyQuery>;
export type AvailableAddOnsSuspenseQueryHookResult = ReturnType<typeof useAvailableAddOnsSuspenseQuery>;
export type AvailableAddOnsQueryResult = Apollo.QueryResult<Types.AvailableAddOnsQuery, Types.AvailableAddOnsQueryVariables>;
export const RegistrantsDocument = gql`
    query registrants($filter: GetRegistrantsInput!) {
  registrants(filter: $filter) {
    attendees {
      ...ReactionForAttendee
    }
    total
    nextCursor
  }
}
    ${ReactionForAttendeeFragmentDoc}`;
export type RegistrantsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>, 'query'> & ({ variables: Types.RegistrantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistrantsComponent = (props: RegistrantsComponentProps) => (
      <ApolloReactComponents.Query<Types.RegistrantsQuery, Types.RegistrantsQueryVariables> query={RegistrantsDocument} {...props} />
    );
    

/**
 * __useRegistrantsQuery__
 *
 * To run a query within a React component, call `useRegistrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRegistrantsQuery(baseOptions: Apollo.QueryHookOptions<Types.RegistrantsQuery, Types.RegistrantsQueryVariables> & ({ variables: Types.RegistrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>(RegistrantsDocument, options);
      }
export function useRegistrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>(RegistrantsDocument, options);
        }
export function useRegistrantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>(RegistrantsDocument, options);
        }
export type RegistrantsQueryHookResult = ReturnType<typeof useRegistrantsQuery>;
export type RegistrantsLazyQueryHookResult = ReturnType<typeof useRegistrantsLazyQuery>;
export type RegistrantsSuspenseQueryHookResult = ReturnType<typeof useRegistrantsSuspenseQuery>;
export type RegistrantsQueryResult = Apollo.QueryResult<Types.RegistrantsQuery, Types.RegistrantsQueryVariables>;
export const CountRegistrantsDocument = gql`
    query countRegistrants($filter: GetRegistrantsInput!) {
  countRegistrants(filter: $filter)
}
    `;
export type CountRegistrantsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>, 'query'> & ({ variables: Types.CountRegistrantsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CountRegistrantsComponent = (props: CountRegistrantsComponentProps) => (
      <ApolloReactComponents.Query<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables> query={CountRegistrantsDocument} {...props} />
    );
    

/**
 * __useCountRegistrantsQuery__
 *
 * To run a query within a React component, call `useCountRegistrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRegistrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRegistrantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountRegistrantsQuery(baseOptions: Apollo.QueryHookOptions<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables> & ({ variables: Types.CountRegistrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>(CountRegistrantsDocument, options);
      }
export function useCountRegistrantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>(CountRegistrantsDocument, options);
        }
export function useCountRegistrantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>(CountRegistrantsDocument, options);
        }
export type CountRegistrantsQueryHookResult = ReturnType<typeof useCountRegistrantsQuery>;
export type CountRegistrantsLazyQueryHookResult = ReturnType<typeof useCountRegistrantsLazyQuery>;
export type CountRegistrantsSuspenseQueryHookResult = ReturnType<typeof useCountRegistrantsSuspenseQuery>;
export type CountRegistrantsQueryResult = Apollo.QueryResult<Types.CountRegistrantsQuery, Types.CountRegistrantsQueryVariables>;
export const RegistrantDocument = gql`
    query registrant($id: String!) {
  registrant(id: $id) {
    ...Registrant
  }
}
    ${RegistrantFragmentDoc}`;
export type RegistrantComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.RegistrantQuery, Types.RegistrantQueryVariables>, 'query'> & ({ variables: Types.RegistrantQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const RegistrantComponent = (props: RegistrantComponentProps) => (
      <ApolloReactComponents.Query<Types.RegistrantQuery, Types.RegistrantQueryVariables> query={RegistrantDocument} {...props} />
    );
    

/**
 * __useRegistrantQuery__
 *
 * To run a query within a React component, call `useRegistrantQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistrantQuery(baseOptions: Apollo.QueryHookOptions<Types.RegistrantQuery, Types.RegistrantQueryVariables> & ({ variables: Types.RegistrantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RegistrantQuery, Types.RegistrantQueryVariables>(RegistrantDocument, options);
      }
export function useRegistrantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RegistrantQuery, Types.RegistrantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RegistrantQuery, Types.RegistrantQueryVariables>(RegistrantDocument, options);
        }
export function useRegistrantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.RegistrantQuery, Types.RegistrantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.RegistrantQuery, Types.RegistrantQueryVariables>(RegistrantDocument, options);
        }
export type RegistrantQueryHookResult = ReturnType<typeof useRegistrantQuery>;
export type RegistrantLazyQueryHookResult = ReturnType<typeof useRegistrantLazyQuery>;
export type RegistrantSuspenseQueryHookResult = ReturnType<typeof useRegistrantSuspenseQuery>;
export type RegistrantQueryResult = Apollo.QueryResult<Types.RegistrantQuery, Types.RegistrantQueryVariables>;
export const SavedRepliesDocument = gql`
    query savedReplies {
  savedReplies {
    ...SavedReply
  }
}
    ${SavedReplyFragmentDoc}`;
export type SavedRepliesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>, 'query'>;

    export const SavedRepliesComponent = (props: SavedRepliesComponentProps) => (
      <ApolloReactComponents.Query<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables> query={SavedRepliesDocument} {...props} />
    );
    

/**
 * __useSavedRepliesQuery__
 *
 * To run a query within a React component, call `useSavedRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedRepliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedRepliesQuery(baseOptions?: Apollo.QueryHookOptions<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>(SavedRepliesDocument, options);
      }
export function useSavedRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>(SavedRepliesDocument, options);
        }
export function useSavedRepliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>(SavedRepliesDocument, options);
        }
export type SavedRepliesQueryHookResult = ReturnType<typeof useSavedRepliesQuery>;
export type SavedRepliesLazyQueryHookResult = ReturnType<typeof useSavedRepliesLazyQuery>;
export type SavedRepliesSuspenseQueryHookResult = ReturnType<typeof useSavedRepliesSuspenseQuery>;
export type SavedRepliesQueryResult = Apollo.QueryResult<Types.SavedRepliesQuery, Types.SavedRepliesQueryVariables>;
export const CreateSavedReplyDocument = gql`
    mutation createSavedReply($data: SavedReplyInput!) {
  createSavedReply(data: $data) {
    ...SavedReply
  }
}
    ${SavedReplyFragmentDoc}`;
export type CreateSavedReplyMutationFn = Apollo.MutationFunction<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables>;
export type CreateSavedReplyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables>, 'mutation'>;

    export const CreateSavedReplyComponent = (props: CreateSavedReplyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables> mutation={CreateSavedReplyDocument} {...props} />
    );
    

/**
 * __useCreateSavedReplyMutation__
 *
 * To run a mutation, you first call `useCreateSavedReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedReplyMutation, { data, loading, error }] = useCreateSavedReplyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSavedReplyMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables>(CreateSavedReplyDocument, options);
      }
export type CreateSavedReplyMutationHookResult = ReturnType<typeof useCreateSavedReplyMutation>;
export type CreateSavedReplyMutationResult = Apollo.MutationResult<Types.CreateSavedReplyMutation>;
export type CreateSavedReplyMutationOptions = Apollo.BaseMutationOptions<Types.CreateSavedReplyMutation, Types.CreateSavedReplyMutationVariables>;
export const UpdateSavedReplyDocument = gql`
    mutation updateSavedReply($data: UpdateSavedReplyInput!) {
  updateSavedReply(data: $data) {
    ...SavedReply
  }
}
    ${SavedReplyFragmentDoc}`;
export type UpdateSavedReplyMutationFn = Apollo.MutationFunction<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables>;
export type UpdateSavedReplyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables>, 'mutation'>;

    export const UpdateSavedReplyComponent = (props: UpdateSavedReplyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables> mutation={UpdateSavedReplyDocument} {...props} />
    );
    

/**
 * __useUpdateSavedReplyMutation__
 *
 * To run a mutation, you first call `useUpdateSavedReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedReplyMutation, { data, loading, error }] = useUpdateSavedReplyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSavedReplyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables>(UpdateSavedReplyDocument, options);
      }
export type UpdateSavedReplyMutationHookResult = ReturnType<typeof useUpdateSavedReplyMutation>;
export type UpdateSavedReplyMutationResult = Apollo.MutationResult<Types.UpdateSavedReplyMutation>;
export type UpdateSavedReplyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSavedReplyMutation, Types.UpdateSavedReplyMutationVariables>;
export const DeleteSavedReplyDocument = gql`
    mutation deleteSavedReply($id: String!) {
  deleteSavedReply(id: $id)
}
    `;
export type DeleteSavedReplyMutationFn = Apollo.MutationFunction<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables>;
export type DeleteSavedReplyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables>, 'mutation'>;

    export const DeleteSavedReplyComponent = (props: DeleteSavedReplyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables> mutation={DeleteSavedReplyDocument} {...props} />
    );
    

/**
 * __useDeleteSavedReplyMutation__
 *
 * To run a mutation, you first call `useDeleteSavedReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedReplyMutation, { data, loading, error }] = useDeleteSavedReplyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavedReplyMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables>(DeleteSavedReplyDocument, options);
      }
export type DeleteSavedReplyMutationHookResult = ReturnType<typeof useDeleteSavedReplyMutation>;
export type DeleteSavedReplyMutationResult = Apollo.MutationResult<Types.DeleteSavedReplyMutation>;
export type DeleteSavedReplyMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSavedReplyMutation, Types.DeleteSavedReplyMutationVariables>;
export const ScriptDocument = gql`
    query script($id: String!) {
  script(id: $id) {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export type ScriptComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ScriptQuery, Types.ScriptQueryVariables>, 'query'> & ({ variables: Types.ScriptQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ScriptComponent = (props: ScriptComponentProps) => (
      <ApolloReactComponents.Query<Types.ScriptQuery, Types.ScriptQueryVariables> query={ScriptDocument} {...props} />
    );
    

/**
 * __useScriptQuery__
 *
 * To run a query within a React component, call `useScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScriptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScriptQuery(baseOptions: Apollo.QueryHookOptions<Types.ScriptQuery, Types.ScriptQueryVariables> & ({ variables: Types.ScriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScriptQuery, Types.ScriptQueryVariables>(ScriptDocument, options);
      }
export function useScriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScriptQuery, Types.ScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScriptQuery, Types.ScriptQueryVariables>(ScriptDocument, options);
        }
export function useScriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScriptQuery, Types.ScriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScriptQuery, Types.ScriptQueryVariables>(ScriptDocument, options);
        }
export type ScriptQueryHookResult = ReturnType<typeof useScriptQuery>;
export type ScriptLazyQueryHookResult = ReturnType<typeof useScriptLazyQuery>;
export type ScriptSuspenseQueryHookResult = ReturnType<typeof useScriptSuspenseQuery>;
export type ScriptQueryResult = Apollo.QueryResult<Types.ScriptQuery, Types.ScriptQueryVariables>;
export const ScriptsDocument = gql`
    query scripts {
  scripts {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export type ScriptsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ScriptsQuery, Types.ScriptsQueryVariables>, 'query'>;

    export const ScriptsComponent = (props: ScriptsComponentProps) => (
      <ApolloReactComponents.Query<Types.ScriptsQuery, Types.ScriptsQueryVariables> query={ScriptsDocument} {...props} />
    );
    

/**
 * __useScriptsQuery__
 *
 * To run a query within a React component, call `useScriptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScriptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScriptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScriptsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ScriptsQuery, Types.ScriptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ScriptsQuery, Types.ScriptsQueryVariables>(ScriptsDocument, options);
      }
export function useScriptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ScriptsQuery, Types.ScriptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ScriptsQuery, Types.ScriptsQueryVariables>(ScriptsDocument, options);
        }
export function useScriptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ScriptsQuery, Types.ScriptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ScriptsQuery, Types.ScriptsQueryVariables>(ScriptsDocument, options);
        }
export type ScriptsQueryHookResult = ReturnType<typeof useScriptsQuery>;
export type ScriptsLazyQueryHookResult = ReturnType<typeof useScriptsLazyQuery>;
export type ScriptsSuspenseQueryHookResult = ReturnType<typeof useScriptsSuspenseQuery>;
export type ScriptsQueryResult = Apollo.QueryResult<Types.ScriptsQuery, Types.ScriptsQueryVariables>;
export const CreateScriptDocument = gql`
    mutation createScript($data: ScriptInput!) {
  createScript(data: $data) {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export type CreateScriptMutationFn = Apollo.MutationFunction<Types.CreateScriptMutation, Types.CreateScriptMutationVariables>;
export type CreateScriptComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateScriptMutation, Types.CreateScriptMutationVariables>, 'mutation'>;

    export const CreateScriptComponent = (props: CreateScriptComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateScriptMutation, Types.CreateScriptMutationVariables> mutation={CreateScriptDocument} {...props} />
    );
    

/**
 * __useCreateScriptMutation__
 *
 * To run a mutation, you first call `useCreateScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScriptMutation, { data, loading, error }] = useCreateScriptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateScriptMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateScriptMutation, Types.CreateScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateScriptMutation, Types.CreateScriptMutationVariables>(CreateScriptDocument, options);
      }
export type CreateScriptMutationHookResult = ReturnType<typeof useCreateScriptMutation>;
export type CreateScriptMutationResult = Apollo.MutationResult<Types.CreateScriptMutation>;
export type CreateScriptMutationOptions = Apollo.BaseMutationOptions<Types.CreateScriptMutation, Types.CreateScriptMutationVariables>;
export const UpdateScriptDocument = gql`
    mutation updateScript($data: UpdateScriptInput!) {
  updateScript(data: $data) {
    ...Script
  }
}
    ${ScriptFragmentDoc}`;
export type UpdateScriptMutationFn = Apollo.MutationFunction<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables>;
export type UpdateScriptComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables>, 'mutation'>;

    export const UpdateScriptComponent = (props: UpdateScriptComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables> mutation={UpdateScriptDocument} {...props} />
    );
    

/**
 * __useUpdateScriptMutation__
 *
 * To run a mutation, you first call `useUpdateScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScriptMutation, { data, loading, error }] = useUpdateScriptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateScriptMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables>(UpdateScriptDocument, options);
      }
export type UpdateScriptMutationHookResult = ReturnType<typeof useUpdateScriptMutation>;
export type UpdateScriptMutationResult = Apollo.MutationResult<Types.UpdateScriptMutation>;
export type UpdateScriptMutationOptions = Apollo.BaseMutationOptions<Types.UpdateScriptMutation, Types.UpdateScriptMutationVariables>;
export const DeleteScriptDocument = gql`
    mutation deleteScript($id: String!) {
  deleteScript(id: $id)
}
    `;
export type DeleteScriptMutationFn = Apollo.MutationFunction<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables>;
export type DeleteScriptComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables>, 'mutation'>;

    export const DeleteScriptComponent = (props: DeleteScriptComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables> mutation={DeleteScriptDocument} {...props} />
    );
    

/**
 * __useDeleteScriptMutation__
 *
 * To run a mutation, you first call `useDeleteScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScriptMutation, { data, loading, error }] = useDeleteScriptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScriptMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables>(DeleteScriptDocument, options);
      }
export type DeleteScriptMutationHookResult = ReturnType<typeof useDeleteScriptMutation>;
export type DeleteScriptMutationResult = Apollo.MutationResult<Types.DeleteScriptMutation>;
export type DeleteScriptMutationOptions = Apollo.BaseMutationOptions<Types.DeleteScriptMutation, Types.DeleteScriptMutationVariables>;
export const JoinEWebinarWithScriptsDocument = gql`
    mutation joinEWebinarWithScripts($data: UpdateEWebinarSetInput!) {
  joinEWebinarWithScripts(data: $data) {
    ...SetScript
  }
}
    ${SetScriptFragmentDoc}`;
export type JoinEWebinarWithScriptsMutationFn = Apollo.MutationFunction<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables>;
export type JoinEWebinarWithScriptsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables>, 'mutation'>;

    export const JoinEWebinarWithScriptsComponent = (props: JoinEWebinarWithScriptsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables> mutation={JoinEWebinarWithScriptsDocument} {...props} />
    );
    

/**
 * __useJoinEWebinarWithScriptsMutation__
 *
 * To run a mutation, you first call `useJoinEWebinarWithScriptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinEWebinarWithScriptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinEWebinarWithScriptsMutation, { data, loading, error }] = useJoinEWebinarWithScriptsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useJoinEWebinarWithScriptsMutation(baseOptions?: Apollo.MutationHookOptions<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables>(JoinEWebinarWithScriptsDocument, options);
      }
export type JoinEWebinarWithScriptsMutationHookResult = ReturnType<typeof useJoinEWebinarWithScriptsMutation>;
export type JoinEWebinarWithScriptsMutationResult = Apollo.MutationResult<Types.JoinEWebinarWithScriptsMutation>;
export type JoinEWebinarWithScriptsMutationOptions = Apollo.BaseMutationOptions<Types.JoinEWebinarWithScriptsMutation, Types.JoinEWebinarWithScriptsMutationVariables>;
export const UpdateSeriesScriptRelationsDocument = gql`
    mutation updateSeriesScriptRelations($seriesId: String!, $relations: [SeriesScriptInput!]!) {
  updateSeriesScriptRelations(seriesId: $seriesId, relations: $relations) {
    ...SeriesScript
  }
}
    ${SeriesScriptFragmentDoc}`;
export type UpdateSeriesScriptRelationsMutationFn = Apollo.MutationFunction<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables>;
export type UpdateSeriesScriptRelationsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables>, 'mutation'>;

    export const UpdateSeriesScriptRelationsComponent = (props: UpdateSeriesScriptRelationsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables> mutation={UpdateSeriesScriptRelationsDocument} {...props} />
    );
    

/**
 * __useUpdateSeriesScriptRelationsMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesScriptRelationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesScriptRelationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesScriptRelationsMutation, { data, loading, error }] = useUpdateSeriesScriptRelationsMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      relations: // value for 'relations'
 *   },
 * });
 */
export function useUpdateSeriesScriptRelationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables>(UpdateSeriesScriptRelationsDocument, options);
      }
export type UpdateSeriesScriptRelationsMutationHookResult = ReturnType<typeof useUpdateSeriesScriptRelationsMutation>;
export type UpdateSeriesScriptRelationsMutationResult = Apollo.MutationResult<Types.UpdateSeriesScriptRelationsMutation>;
export type UpdateSeriesScriptRelationsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSeriesScriptRelationsMutation, Types.UpdateSeriesScriptRelationsMutationVariables>;
export const AllSeriesDocument = gql`
    query allSeries {
  allSeries {
    ...Series
  }
}
    ${SeriesFragmentDoc}`;
export type AllSeriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>, 'query'>;

    export const AllSeriesComponent = (props: AllSeriesComponentProps) => (
      <ApolloReactComponents.Query<Types.AllSeriesQuery, Types.AllSeriesQueryVariables> query={AllSeriesDocument} {...props} />
    );
    

/**
 * __useAllSeriesQuery__
 *
 * To run a query within a React component, call `useAllSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSeriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSeriesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>(AllSeriesDocument, options);
      }
export function useAllSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>(AllSeriesDocument, options);
        }
export function useAllSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>(AllSeriesDocument, options);
        }
export type AllSeriesQueryHookResult = ReturnType<typeof useAllSeriesQuery>;
export type AllSeriesLazyQueryHookResult = ReturnType<typeof useAllSeriesLazyQuery>;
export type AllSeriesSuspenseQueryHookResult = ReturnType<typeof useAllSeriesSuspenseQuery>;
export type AllSeriesQueryResult = Apollo.QueryResult<Types.AllSeriesQuery, Types.AllSeriesQueryVariables>;
export const SeriesDocument = gql`
    query series($id: String!) {
  series(id: $id) {
    ...FullSeries
  }
}
    ${FullSeriesFragmentDoc}`;
export type SeriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SeriesQuery, Types.SeriesQueryVariables>, 'query'> & ({ variables: Types.SeriesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SeriesComponent = (props: SeriesComponentProps) => (
      <ApolloReactComponents.Query<Types.SeriesQuery, Types.SeriesQueryVariables> query={SeriesDocument} {...props} />
    );
    

/**
 * __useSeriesQuery__
 *
 * To run a query within a React component, call `useSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSeriesQuery(baseOptions: Apollo.QueryHookOptions<Types.SeriesQuery, Types.SeriesQueryVariables> & ({ variables: Types.SeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SeriesQuery, Types.SeriesQueryVariables>(SeriesDocument, options);
      }
export function useSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SeriesQuery, Types.SeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SeriesQuery, Types.SeriesQueryVariables>(SeriesDocument, options);
        }
export function useSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SeriesQuery, Types.SeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SeriesQuery, Types.SeriesQueryVariables>(SeriesDocument, options);
        }
export type SeriesQueryHookResult = ReturnType<typeof useSeriesQuery>;
export type SeriesLazyQueryHookResult = ReturnType<typeof useSeriesLazyQuery>;
export type SeriesSuspenseQueryHookResult = ReturnType<typeof useSeriesSuspenseQuery>;
export type SeriesQueryResult = Apollo.QueryResult<Types.SeriesQuery, Types.SeriesQueryVariables>;
export const PublicSeriesDocument = gql`
    query publicSeries($id: String!) {
  series(id: $id) {
    ...PublicSeries
  }
}
    ${PublicSeriesFragmentDoc}`;
export type PublicSeriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>, 'query'> & ({ variables: Types.PublicSeriesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PublicSeriesComponent = (props: PublicSeriesComponentProps) => (
      <ApolloReactComponents.Query<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables> query={PublicSeriesDocument} {...props} />
    );
    

/**
 * __usePublicSeriesQuery__
 *
 * To run a query within a React component, call `usePublicSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicSeriesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables> & ({ variables: Types.PublicSeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>(PublicSeriesDocument, options);
      }
export function usePublicSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>(PublicSeriesDocument, options);
        }
export function usePublicSeriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>(PublicSeriesDocument, options);
        }
export type PublicSeriesQueryHookResult = ReturnType<typeof usePublicSeriesQuery>;
export type PublicSeriesLazyQueryHookResult = ReturnType<typeof usePublicSeriesLazyQuery>;
export type PublicSeriesSuspenseQueryHookResult = ReturnType<typeof usePublicSeriesSuspenseQuery>;
export type PublicSeriesQueryResult = Apollo.QueryResult<Types.PublicSeriesQuery, Types.PublicSeriesQueryVariables>;
export const CreateSeriesDocument = gql`
    mutation createSeries($data: SeriesInput!) {
  createSeries(data: $data) {
    id
  }
}
    `;
export type CreateSeriesMutationFn = Apollo.MutationFunction<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables>;
export type CreateSeriesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables>, 'mutation'>;

    export const CreateSeriesComponent = (props: CreateSeriesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables> mutation={CreateSeriesDocument} {...props} />
    );
    

/**
 * __useCreateSeriesMutation__
 *
 * To run a mutation, you first call `useCreateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesMutation, { data, loading, error }] = useCreateSeriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSeriesMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables>(CreateSeriesDocument, options);
      }
export type CreateSeriesMutationHookResult = ReturnType<typeof useCreateSeriesMutation>;
export type CreateSeriesMutationResult = Apollo.MutationResult<Types.CreateSeriesMutation>;
export type CreateSeriesMutationOptions = Apollo.BaseMutationOptions<Types.CreateSeriesMutation, Types.CreateSeriesMutationVariables>;
export const UpdateSeriesDocument = gql`
    mutation updateSeries($id: String!, $data: SeriesInput!) {
  updateSeries(id: $id, data: $data) {
    ...FullSeries
  }
}
    ${FullSeriesFragmentDoc}`;
export type UpdateSeriesMutationFn = Apollo.MutationFunction<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables>;
export type UpdateSeriesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables>, 'mutation'>;

    export const UpdateSeriesComponent = (props: UpdateSeriesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables> mutation={UpdateSeriesDocument} {...props} />
    );
    

/**
 * __useUpdateSeriesMutation__
 *
 * To run a mutation, you first call `useUpdateSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeriesMutation, { data, loading, error }] = useUpdateSeriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSeriesMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables>(UpdateSeriesDocument, options);
      }
export type UpdateSeriesMutationHookResult = ReturnType<typeof useUpdateSeriesMutation>;
export type UpdateSeriesMutationResult = Apollo.MutationResult<Types.UpdateSeriesMutation>;
export type UpdateSeriesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSeriesMutation, Types.UpdateSeriesMutationVariables>;
export const DeleteSeriesDocument = gql`
    mutation deleteSeries($id: String!) {
  deleteSeries(id: $id)
}
    `;
export type DeleteSeriesMutationFn = Apollo.MutationFunction<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables>;
export type DeleteSeriesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables>, 'mutation'>;

    export const DeleteSeriesComponent = (props: DeleteSeriesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables> mutation={DeleteSeriesDocument} {...props} />
    );
    

/**
 * __useDeleteSeriesMutation__
 *
 * To run a mutation, you first call `useDeleteSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeriesMutation, { data, loading, error }] = useDeleteSeriesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSeriesMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables>(DeleteSeriesDocument, options);
      }
export type DeleteSeriesMutationHookResult = ReturnType<typeof useDeleteSeriesMutation>;
export type DeleteSeriesMutationResult = Apollo.MutationResult<Types.DeleteSeriesMutation>;
export type DeleteSeriesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteSeriesMutation, Types.DeleteSeriesMutationVariables>;
export const RenameSeriesTagDocument = gql`
    mutation renameSeriesTag($id: String!, $newTag: String!) {
  renameSeriesTag(id: $id, newTag: $newTag) {
    ...Series
  }
}
    ${SeriesFragmentDoc}`;
export type RenameSeriesTagMutationFn = Apollo.MutationFunction<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables>;
export type RenameSeriesTagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables>, 'mutation'>;

    export const RenameSeriesTagComponent = (props: RenameSeriesTagComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables> mutation={RenameSeriesTagDocument} {...props} />
    );
    

/**
 * __useRenameSeriesTagMutation__
 *
 * To run a mutation, you first call `useRenameSeriesTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameSeriesTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameSeriesTagMutation, { data, loading, error }] = useRenameSeriesTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newTag: // value for 'newTag'
 *   },
 * });
 */
export function useRenameSeriesTagMutation(baseOptions?: Apollo.MutationHookOptions<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables>(RenameSeriesTagDocument, options);
      }
export type RenameSeriesTagMutationHookResult = ReturnType<typeof useRenameSeriesTagMutation>;
export type RenameSeriesTagMutationResult = Apollo.MutationResult<Types.RenameSeriesTagMutation>;
export type RenameSeriesTagMutationOptions = Apollo.BaseMutationOptions<Types.RenameSeriesTagMutation, Types.RenameSeriesTagMutationVariables>;
export const EwebinarSessionsDocument = gql`
    query EwebinarSessions($data: EwebinarSessionsInput!) {
  ewebinarSessions(data: $data) {
    sessions {
      value
      text
      type
      date
    }
    timeZone
  }
}
    `;
export type EwebinarSessionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>, 'query'> & ({ variables: Types.EwebinarSessionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EwebinarSessionsComponent = (props: EwebinarSessionsComponentProps) => (
      <ApolloReactComponents.Query<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables> query={EwebinarSessionsDocument} {...props} />
    );
    

/**
 * __useEwebinarSessionsQuery__
 *
 * To run a query within a React component, call `useEwebinarSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEwebinarSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEwebinarSessionsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEwebinarSessionsQuery(baseOptions: Apollo.QueryHookOptions<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables> & ({ variables: Types.EwebinarSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>(EwebinarSessionsDocument, options);
      }
export function useEwebinarSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>(EwebinarSessionsDocument, options);
        }
export function useEwebinarSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>(EwebinarSessionsDocument, options);
        }
export type EwebinarSessionsQueryHookResult = ReturnType<typeof useEwebinarSessionsQuery>;
export type EwebinarSessionsLazyQueryHookResult = ReturnType<typeof useEwebinarSessionsLazyQuery>;
export type EwebinarSessionsSuspenseQueryHookResult = ReturnType<typeof useEwebinarSessionsSuspenseQuery>;
export type EwebinarSessionsQueryResult = Apollo.QueryResult<Types.EwebinarSessionsQuery, Types.EwebinarSessionsQueryVariables>;
export const MyTeamDocument = gql`
    query myTeam {
  myTeam {
    ...TeamAndUsers
  }
}
    ${TeamAndUsersFragmentDoc}`;
export type MyTeamComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MyTeamQuery, Types.MyTeamQueryVariables>, 'query'>;

    export const MyTeamComponent = (props: MyTeamComponentProps) => (
      <ApolloReactComponents.Query<Types.MyTeamQuery, Types.MyTeamQueryVariables> query={MyTeamDocument} {...props} />
    );
    

/**
 * __useMyTeamQuery__
 *
 * To run a query within a React component, call `useMyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTeamQuery(baseOptions?: Apollo.QueryHookOptions<Types.MyTeamQuery, Types.MyTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MyTeamQuery, Types.MyTeamQueryVariables>(MyTeamDocument, options);
      }
export function useMyTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MyTeamQuery, Types.MyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MyTeamQuery, Types.MyTeamQueryVariables>(MyTeamDocument, options);
        }
export function useMyTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MyTeamQuery, Types.MyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MyTeamQuery, Types.MyTeamQueryVariables>(MyTeamDocument, options);
        }
export type MyTeamQueryHookResult = ReturnType<typeof useMyTeamQuery>;
export type MyTeamLazyQueryHookResult = ReturnType<typeof useMyTeamLazyQuery>;
export type MyTeamSuspenseQueryHookResult = ReturnType<typeof useMyTeamSuspenseQuery>;
export type MyTeamQueryResult = Apollo.QueryResult<Types.MyTeamQuery, Types.MyTeamQueryVariables>;
export const TeamNextPaymentDueDateDocument = gql`
    query teamNextPaymentDueDate {
  myTeam {
    id
    nextPaymentDueDate
  }
}
    `;
export type TeamNextPaymentDueDateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>, 'query'>;

    export const TeamNextPaymentDueDateComponent = (props: TeamNextPaymentDueDateComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables> query={TeamNextPaymentDueDateDocument} {...props} />
    );
    

/**
 * __useTeamNextPaymentDueDateQuery__
 *
 * To run a query within a React component, call `useTeamNextPaymentDueDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamNextPaymentDueDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamNextPaymentDueDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamNextPaymentDueDateQuery(baseOptions?: Apollo.QueryHookOptions<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>(TeamNextPaymentDueDateDocument, options);
      }
export function useTeamNextPaymentDueDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>(TeamNextPaymentDueDateDocument, options);
        }
export function useTeamNextPaymentDueDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>(TeamNextPaymentDueDateDocument, options);
        }
export type TeamNextPaymentDueDateQueryHookResult = ReturnType<typeof useTeamNextPaymentDueDateQuery>;
export type TeamNextPaymentDueDateLazyQueryHookResult = ReturnType<typeof useTeamNextPaymentDueDateLazyQuery>;
export type TeamNextPaymentDueDateSuspenseQueryHookResult = ReturnType<typeof useTeamNextPaymentDueDateSuspenseQuery>;
export type TeamNextPaymentDueDateQueryResult = Apollo.QueryResult<Types.TeamNextPaymentDueDateQuery, Types.TeamNextPaymentDueDateQueryVariables>;
export const TeamTagsDocument = gql`
    query teamTags {
  teamTags
}
    `;
export type TeamTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>, 'query'>;

    export const TeamTagsComponent = (props: TeamTagsComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamTagsQuery, Types.TeamTagsQueryVariables> query={TeamTagsDocument} {...props} />
    );
    

/**
 * __useTeamTagsQuery__
 *
 * To run a query within a React component, call `useTeamTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamTagsQuery(baseOptions?: Apollo.QueryHookOptions<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>(TeamTagsDocument, options);
      }
export function useTeamTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>(TeamTagsDocument, options);
        }
export function useTeamTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>(TeamTagsDocument, options);
        }
export type TeamTagsQueryHookResult = ReturnType<typeof useTeamTagsQuery>;
export type TeamTagsLazyQueryHookResult = ReturnType<typeof useTeamTagsLazyQuery>;
export type TeamTagsSuspenseQueryHookResult = ReturnType<typeof useTeamTagsSuspenseQuery>;
export type TeamTagsQueryResult = Apollo.QueryResult<Types.TeamTagsQuery, Types.TeamTagsQueryVariables>;
export const MyTeamForAdminDocument = gql`
    query myTeamForAdmin {
  myTeam {
    ...TeamForAdmin
  }
}
    ${TeamForAdminFragmentDoc}`;
export type MyTeamForAdminComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>, 'query'>;

    export const MyTeamForAdminComponent = (props: MyTeamForAdminComponentProps) => (
      <ApolloReactComponents.Query<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables> query={MyTeamForAdminDocument} {...props} />
    );
    

/**
 * __useMyTeamForAdminQuery__
 *
 * To run a query within a React component, call `useMyTeamForAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamForAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamForAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTeamForAdminQuery(baseOptions?: Apollo.QueryHookOptions<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>(MyTeamForAdminDocument, options);
      }
export function useMyTeamForAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>(MyTeamForAdminDocument, options);
        }
export function useMyTeamForAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>(MyTeamForAdminDocument, options);
        }
export type MyTeamForAdminQueryHookResult = ReturnType<typeof useMyTeamForAdminQuery>;
export type MyTeamForAdminLazyQueryHookResult = ReturnType<typeof useMyTeamForAdminLazyQuery>;
export type MyTeamForAdminSuspenseQueryHookResult = ReturnType<typeof useMyTeamForAdminSuspenseQuery>;
export type MyTeamForAdminQueryResult = Apollo.QueryResult<Types.MyTeamForAdminQuery, Types.MyTeamForAdminQueryVariables>;
export const PermanentlyDeleteTeamDocument = gql`
    mutation permanentlyDeleteTeam($id: String!) {
  permanentlyDeleteTeam(id: $id)
}
    `;
export type PermanentlyDeleteTeamMutationFn = Apollo.MutationFunction<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables>;
export type PermanentlyDeleteTeamComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables>, 'mutation'>;

    export const PermanentlyDeleteTeamComponent = (props: PermanentlyDeleteTeamComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables> mutation={PermanentlyDeleteTeamDocument} {...props} />
    );
    

/**
 * __usePermanentlyDeleteTeamMutation__
 *
 * To run a mutation, you first call `usePermanentlyDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermanentlyDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permanentlyDeleteTeamMutation, { data, loading, error }] = usePermanentlyDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermanentlyDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables>(PermanentlyDeleteTeamDocument, options);
      }
export type PermanentlyDeleteTeamMutationHookResult = ReturnType<typeof usePermanentlyDeleteTeamMutation>;
export type PermanentlyDeleteTeamMutationResult = Apollo.MutationResult<Types.PermanentlyDeleteTeamMutation>;
export type PermanentlyDeleteTeamMutationOptions = Apollo.BaseMutationOptions<Types.PermanentlyDeleteTeamMutation, Types.PermanentlyDeleteTeamMutationVariables>;
export const PermanentlyDeleteUserDocument = gql`
    mutation permanentlyDeleteUser($id: String!, $replacementId: String!, $teamId: String!) {
  permanentlyDeleteUser(id: $id, replacementId: $replacementId, teamId: $teamId) {
    ...TeamAndUsers
  }
}
    ${TeamAndUsersFragmentDoc}`;
export type PermanentlyDeleteUserMutationFn = Apollo.MutationFunction<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables>;
export type PermanentlyDeleteUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables>, 'mutation'>;

    export const PermanentlyDeleteUserComponent = (props: PermanentlyDeleteUserComponentProps) => (
      <ApolloReactComponents.Mutation<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables> mutation={PermanentlyDeleteUserDocument} {...props} />
    );
    

/**
 * __usePermanentlyDeleteUserMutation__
 *
 * To run a mutation, you first call `usePermanentlyDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermanentlyDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permanentlyDeleteUserMutation, { data, loading, error }] = usePermanentlyDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      replacementId: // value for 'replacementId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function usePermanentlyDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables>(PermanentlyDeleteUserDocument, options);
      }
export type PermanentlyDeleteUserMutationHookResult = ReturnType<typeof usePermanentlyDeleteUserMutation>;
export type PermanentlyDeleteUserMutationResult = Apollo.MutationResult<Types.PermanentlyDeleteUserMutation>;
export type PermanentlyDeleteUserMutationOptions = Apollo.BaseMutationOptions<Types.PermanentlyDeleteUserMutation, Types.PermanentlyDeleteUserMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($id: String!, $replacementId: String!) {
  removeUser(id: $id, replacementId: $replacementId) {
    ...TeamAndUsers
  }
}
    ${TeamAndUsersFragmentDoc}`;
export type RemoveUserMutationFn = Apollo.MutationFunction<Types.RemoveUserMutation, Types.RemoveUserMutationVariables>;
export type RemoveUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RemoveUserMutation, Types.RemoveUserMutationVariables>, 'mutation'>;

    export const RemoveUserComponent = (props: RemoveUserComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RemoveUserMutation, Types.RemoveUserMutationVariables> mutation={RemoveUserDocument} {...props} />
    );
    

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      replacementId: // value for 'replacementId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveUserMutation, Types.RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveUserMutation, Types.RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<Types.RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<Types.RemoveUserMutation, Types.RemoveUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: EditUserInput!) {
  updateUser(data: $data) {
    ...Member
  }
}
    ${MemberFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export type UpdateUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>, 'mutation'>;

    export const UpdateUserComponent = (props: UpdateUserComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables> mutation={UpdateUserDocument} {...props} />
    );
    

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const AddUserDocument = gql`
    mutation addUser($data: NewUserInput!) {
  addUser(data: $data) {
    ...Member
  }
}
    ${MemberFragmentDoc}`;
export type AddUserMutationFn = Apollo.MutationFunction<Types.AddUserMutation, Types.AddUserMutationVariables>;
export type AddUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AddUserMutation, Types.AddUserMutationVariables>, 'mutation'>;

    export const AddUserComponent = (props: AddUserComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AddUserMutation, Types.AddUserMutationVariables> mutation={AddUserDocument} {...props} />
    );
    

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddUserMutation, Types.AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddUserMutation, Types.AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<Types.AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<Types.AddUserMutation, Types.AddUserMutationVariables>;
export const UpdateBillingContactsDocument = gql`
    mutation updateBillingContacts($data: BillingContactInput!) {
  updateBillingContacts(data: $data) {
    ...TeamForAdmin
  }
}
    ${TeamForAdminFragmentDoc}`;
export type UpdateBillingContactsMutationFn = Apollo.MutationFunction<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables>;
export type UpdateBillingContactsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables>, 'mutation'>;

    export const UpdateBillingContactsComponent = (props: UpdateBillingContactsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables> mutation={UpdateBillingContactsDocument} {...props} />
    );
    

/**
 * __useUpdateBillingContactsMutation__
 *
 * To run a mutation, you first call `useUpdateBillingContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingContactsMutation, { data, loading, error }] = useUpdateBillingContactsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBillingContactsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables>(UpdateBillingContactsDocument, options);
      }
export type UpdateBillingContactsMutationHookResult = ReturnType<typeof useUpdateBillingContactsMutation>;
export type UpdateBillingContactsMutationResult = Apollo.MutationResult<Types.UpdateBillingContactsMutation>;
export type UpdateBillingContactsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBillingContactsMutation, Types.UpdateBillingContactsMutationVariables>;
export const UpdateRewardsContactDocument = gql`
    mutation updateRewardsContact($userId: String!) {
  updateRewardsContact(userId: $userId) {
    ...TeamForAdmin
  }
}
    ${TeamForAdminFragmentDoc}`;
export type UpdateRewardsContactMutationFn = Apollo.MutationFunction<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables>;
export type UpdateRewardsContactComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables>, 'mutation'>;

    export const UpdateRewardsContactComponent = (props: UpdateRewardsContactComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables> mutation={UpdateRewardsContactDocument} {...props} />
    );
    

/**
 * __useUpdateRewardsContactMutation__
 *
 * To run a mutation, you first call `useUpdateRewardsContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRewardsContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRewardsContactMutation, { data, loading, error }] = useUpdateRewardsContactMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateRewardsContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables>(UpdateRewardsContactDocument, options);
      }
export type UpdateRewardsContactMutationHookResult = ReturnType<typeof useUpdateRewardsContactMutation>;
export type UpdateRewardsContactMutationResult = Apollo.MutationResult<Types.UpdateRewardsContactMutation>;
export type UpdateRewardsContactMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRewardsContactMutation, Types.UpdateRewardsContactMutationVariables>;
export const UpdateBillingInfoDocument = gql`
    mutation updateBillingInfo($data: UpdateBillingInfoInput!) {
  updateBillingInfo(data: $data) {
    ...TeamForAdminNoPendingSetupIntent
  }
}
    ${TeamForAdminNoPendingSetupIntentFragmentDoc}`;
export type UpdateBillingInfoMutationFn = Apollo.MutationFunction<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables>;
export type UpdateBillingInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables>, 'mutation'>;

    export const UpdateBillingInfoComponent = (props: UpdateBillingInfoComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables> mutation={UpdateBillingInfoDocument} {...props} />
    );
    

/**
 * __useUpdateBillingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingInfoMutation, { data, loading, error }] = useUpdateBillingInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateBillingInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables>(UpdateBillingInfoDocument, options);
      }
export type UpdateBillingInfoMutationHookResult = ReturnType<typeof useUpdateBillingInfoMutation>;
export type UpdateBillingInfoMutationResult = Apollo.MutationResult<Types.UpdateBillingInfoMutation>;
export type UpdateBillingInfoMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBillingInfoMutation, Types.UpdateBillingInfoMutationVariables>;
export const ChargePendingInvoicesDocument = gql`
    mutation chargePendingInvoices {
  chargePendingInvoices {
    paymentIntentSecret
  }
}
    `;
export type ChargePendingInvoicesMutationFn = Apollo.MutationFunction<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables>;
export type ChargePendingInvoicesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables>, 'mutation'>;

    export const ChargePendingInvoicesComponent = (props: ChargePendingInvoicesComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables> mutation={ChargePendingInvoicesDocument} {...props} />
    );
    

/**
 * __useChargePendingInvoicesMutation__
 *
 * To run a mutation, you first call `useChargePendingInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChargePendingInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chargePendingInvoicesMutation, { data, loading, error }] = useChargePendingInvoicesMutation({
 *   variables: {
 *   },
 * });
 */
export function useChargePendingInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables>(ChargePendingInvoicesDocument, options);
      }
export type ChargePendingInvoicesMutationHookResult = ReturnType<typeof useChargePendingInvoicesMutation>;
export type ChargePendingInvoicesMutationResult = Apollo.MutationResult<Types.ChargePendingInvoicesMutation>;
export type ChargePendingInvoicesMutationOptions = Apollo.BaseMutationOptions<Types.ChargePendingInvoicesMutation, Types.ChargePendingInvoicesMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($data: CancelReasonInput!) {
  cancelSubscription(data: $data) {
    ...TeamForAdmin
  }
}
    ${TeamForAdminFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>;
export type CancelSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>, 'mutation'>;

    export const CancelSubscriptionComponent = (props: CancelSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables> mutation={CancelSubscriptionDocument} {...props} />
    );
    

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<Types.CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.CancelSubscriptionMutation, Types.CancelSubscriptionMutationVariables>;
export const ResubscribeSubscriptionDocument = gql`
    mutation resubscribeSubscription {
  resubscribeSubscription {
    ...TeamForAdmin
  }
}
    ${TeamForAdminFragmentDoc}`;
export type ResubscribeSubscriptionMutationFn = Apollo.MutationFunction<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables>;
export type ResubscribeSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables>, 'mutation'>;

    export const ResubscribeSubscriptionComponent = (props: ResubscribeSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables> mutation={ResubscribeSubscriptionDocument} {...props} />
    );
    

/**
 * __useResubscribeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResubscribeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubscribeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubscribeSubscriptionMutation, { data, loading, error }] = useResubscribeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useResubscribeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables>(ResubscribeSubscriptionDocument, options);
      }
export type ResubscribeSubscriptionMutationHookResult = ReturnType<typeof useResubscribeSubscriptionMutation>;
export type ResubscribeSubscriptionMutationResult = Apollo.MutationResult<Types.ResubscribeSubscriptionMutation>;
export type ResubscribeSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.ResubscribeSubscriptionMutation, Types.ResubscribeSubscriptionMutationVariables>;
export const RestoreSubscriptionDocument = gql`
    mutation restoreSubscription($fresh: Boolean!, $data: UpdateBillingInfoInput, $paymentIntentId: String) {
  restoreSubscription(
    fresh: $fresh
    data: $data
    paymentIntentId: $paymentIntentId
  ) {
    paymentIntentSecret
    team {
      ...TeamForAdmin
    }
  }
}
    ${TeamForAdminFragmentDoc}`;
export type RestoreSubscriptionMutationFn = Apollo.MutationFunction<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables>;
export type RestoreSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables>, 'mutation'>;

    export const RestoreSubscriptionComponent = (props: RestoreSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables> mutation={RestoreSubscriptionDocument} {...props} />
    );
    

/**
 * __useRestoreSubscriptionMutation__
 *
 * To run a mutation, you first call `useRestoreSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreSubscriptionMutation, { data, loading, error }] = useRestoreSubscriptionMutation({
 *   variables: {
 *      fresh: // value for 'fresh'
 *      data: // value for 'data'
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useRestoreSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables>(RestoreSubscriptionDocument, options);
      }
export type RestoreSubscriptionMutationHookResult = ReturnType<typeof useRestoreSubscriptionMutation>;
export type RestoreSubscriptionMutationResult = Apollo.MutationResult<Types.RestoreSubscriptionMutation>;
export type RestoreSubscriptionMutationOptions = Apollo.BaseMutationOptions<Types.RestoreSubscriptionMutation, Types.RestoreSubscriptionMutationVariables>;
export const TeamForDomainDocument = gql`
    query teamForDomain($domain: String!) {
  teamForDomain(domain: $domain) {
    redirectUrl
    team {
      ...PublicTeam
    }
  }
}
    ${PublicTeamFragmentDoc}`;
export type TeamForDomainComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>, 'query'> & ({ variables: Types.TeamForDomainQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamForDomainComponent = (props: TeamForDomainComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables> query={TeamForDomainDocument} {...props} />
    );
    

/**
 * __useTeamForDomainQuery__
 *
 * To run a query within a React component, call `useTeamForDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamForDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamForDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useTeamForDomainQuery(baseOptions: Apollo.QueryHookOptions<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables> & ({ variables: Types.TeamForDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>(TeamForDomainDocument, options);
      }
export function useTeamForDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>(TeamForDomainDocument, options);
        }
export function useTeamForDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>(TeamForDomainDocument, options);
        }
export type TeamForDomainQueryHookResult = ReturnType<typeof useTeamForDomainQuery>;
export type TeamForDomainLazyQueryHookResult = ReturnType<typeof useTeamForDomainLazyQuery>;
export type TeamForDomainSuspenseQueryHookResult = ReturnType<typeof useTeamForDomainSuspenseQuery>;
export type TeamForDomainQueryResult = Apollo.QueryResult<Types.TeamForDomainQuery, Types.TeamForDomainQueryVariables>;
export const TeamFromIdDocument = gql`
    query teamFromId($id: String!) {
  team(id: $id) {
    ...PublicTeam
  }
}
    ${PublicTeamFragmentDoc}`;
export type TeamFromIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>, 'query'> & ({ variables: Types.TeamFromIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamFromIdComponent = (props: TeamFromIdComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables> query={TeamFromIdDocument} {...props} />
    );
    

/**
 * __useTeamFromIdQuery__
 *
 * To run a query within a React component, call `useTeamFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamFromIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamFromIdQuery(baseOptions: Apollo.QueryHookOptions<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables> & ({ variables: Types.TeamFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>(TeamFromIdDocument, options);
      }
export function useTeamFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>(TeamFromIdDocument, options);
        }
export function useTeamFromIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>(TeamFromIdDocument, options);
        }
export type TeamFromIdQueryHookResult = ReturnType<typeof useTeamFromIdQuery>;
export type TeamFromIdLazyQueryHookResult = ReturnType<typeof useTeamFromIdLazyQuery>;
export type TeamFromIdSuspenseQueryHookResult = ReturnType<typeof useTeamFromIdSuspenseQuery>;
export type TeamFromIdQueryResult = Apollo.QueryResult<Types.TeamFromIdQuery, Types.TeamFromIdQueryVariables>;
export const TeamUsersDocument = gql`
    query teamUsers($filters: UserFilters!) {
  teamUsers(filters: $filters) {
    ...Member
  }
}
    ${MemberFragmentDoc}`;
export type TeamUsersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>, 'query'> & ({ variables: Types.TeamUsersQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TeamUsersComponent = (props: TeamUsersComponentProps) => (
      <ApolloReactComponents.Query<Types.TeamUsersQuery, Types.TeamUsersQueryVariables> query={TeamUsersDocument} {...props} />
    );
    

/**
 * __useTeamUsersQuery__
 *
 * To run a query within a React component, call `useTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTeamUsersQuery(baseOptions: Apollo.QueryHookOptions<Types.TeamUsersQuery, Types.TeamUsersQueryVariables> & ({ variables: Types.TeamUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>(TeamUsersDocument, options);
      }
export function useTeamUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>(TeamUsersDocument, options);
        }
export function useTeamUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>(TeamUsersDocument, options);
        }
export type TeamUsersQueryHookResult = ReturnType<typeof useTeamUsersQuery>;
export type TeamUsersLazyQueryHookResult = ReturnType<typeof useTeamUsersLazyQuery>;
export type TeamUsersSuspenseQueryHookResult = ReturnType<typeof useTeamUsersSuspenseQuery>;
export type TeamUsersQueryResult = Apollo.QueryResult<Types.TeamUsersQuery, Types.TeamUsersQueryVariables>;
export const ResendInvitationEmailDocument = gql`
    mutation resendInvitationEmail($userId: String!, $teamId: String!) {
  resendInvitationEmail(userId: $userId, teamId: $teamId)
}
    `;
export type ResendInvitationEmailMutationFn = Apollo.MutationFunction<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables>;
export type ResendInvitationEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables>, 'mutation'>;

    export const ResendInvitationEmailComponent = (props: ResendInvitationEmailComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables> mutation={ResendInvitationEmailDocument} {...props} />
    );
    

/**
 * __useResendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useResendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationEmailMutation, { data, loading, error }] = useResendInvitationEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useResendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables>(ResendInvitationEmailDocument, options);
      }
export type ResendInvitationEmailMutationHookResult = ReturnType<typeof useResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationResult = Apollo.MutationResult<Types.ResendInvitationEmailMutation>;
export type ResendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<Types.ResendInvitationEmailMutation, Types.ResendInvitationEmailMutationVariables>;
export const CurrentBillingInfoDocument = gql`
    query currentBillingInfo {
  currentBillingInfo {
    firstName
    lastName
    address1
    address2
    city
    country
    province
    postal
    card {
      ...CardInfo
    }
  }
}
    ${CardInfoFragmentDoc}`;
export type CurrentBillingInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>, 'query'>;

    export const CurrentBillingInfoComponent = (props: CurrentBillingInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables> query={CurrentBillingInfoDocument} {...props} />
    );
    

/**
 * __useCurrentBillingInfoQuery__
 *
 * To run a query within a React component, call `useCurrentBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>(CurrentBillingInfoDocument, options);
      }
export function useCurrentBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>(CurrentBillingInfoDocument, options);
        }
export function useCurrentBillingInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>(CurrentBillingInfoDocument, options);
        }
export type CurrentBillingInfoQueryHookResult = ReturnType<typeof useCurrentBillingInfoQuery>;
export type CurrentBillingInfoLazyQueryHookResult = ReturnType<typeof useCurrentBillingInfoLazyQuery>;
export type CurrentBillingInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentBillingInfoSuspenseQuery>;
export type CurrentBillingInfoQueryResult = Apollo.QueryResult<Types.CurrentBillingInfoQuery, Types.CurrentBillingInfoQueryVariables>;
export const UpdateTeamSettingsDocument = gql`
    mutation updateTeamSettings($data: TeamInput!) {
  updateTeamSettings(data: $data) {
    ...Team
  }
}
    ${TeamFragmentDoc}`;
export type UpdateTeamSettingsMutationFn = Apollo.MutationFunction<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables>;
export type UpdateTeamSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables>, 'mutation'>;

    export const UpdateTeamSettingsComponent = (props: UpdateTeamSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables> mutation={UpdateTeamSettingsDocument} {...props} />
    );
    

/**
 * __useUpdateTeamSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamSettingsMutation, { data, loading, error }] = useUpdateTeamSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTeamSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables>(UpdateTeamSettingsDocument, options);
      }
export type UpdateTeamSettingsMutationHookResult = ReturnType<typeof useUpdateTeamSettingsMutation>;
export type UpdateTeamSettingsMutationResult = Apollo.MutationResult<Types.UpdateTeamSettingsMutation>;
export type UpdateTeamSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTeamSettingsMutation, Types.UpdateTeamSettingsMutationVariables>;
export const UpdateSubdomainDocument = gql`
    mutation updateSubdomain($subdomain: String!) {
  updateSubdomain(subdomain: $subdomain) {
    id
  }
}
    `;
export type UpdateSubdomainMutationFn = Apollo.MutationFunction<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables>;
export type UpdateSubdomainComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables>, 'mutation'>;

    export const UpdateSubdomainComponent = (props: UpdateSubdomainComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables> mutation={UpdateSubdomainDocument} {...props} />
    );
    

/**
 * __useUpdateSubdomainMutation__
 *
 * To run a mutation, you first call `useUpdateSubdomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubdomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubdomainMutation, { data, loading, error }] = useUpdateSubdomainMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useUpdateSubdomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables>(UpdateSubdomainDocument, options);
      }
export type UpdateSubdomainMutationHookResult = ReturnType<typeof useUpdateSubdomainMutation>;
export type UpdateSubdomainMutationResult = Apollo.MutationResult<Types.UpdateSubdomainMutation>;
export type UpdateSubdomainMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSubdomainMutation, Types.UpdateSubdomainMutationVariables>;
export const SubdomainInUseDocument = gql`
    query subdomainInUse($subdomain: String!) {
  subdomainInUse(subdomain: $subdomain)
}
    `;
export type SubdomainInUseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>, 'query'> & ({ variables: Types.SubdomainInUseQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SubdomainInUseComponent = (props: SubdomainInUseComponentProps) => (
      <ApolloReactComponents.Query<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables> query={SubdomainInUseDocument} {...props} />
    );
    

/**
 * __useSubdomainInUseQuery__
 *
 * To run a query within a React component, call `useSubdomainInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubdomainInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubdomainInUseQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useSubdomainInUseQuery(baseOptions: Apollo.QueryHookOptions<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables> & ({ variables: Types.SubdomainInUseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>(SubdomainInUseDocument, options);
      }
export function useSubdomainInUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>(SubdomainInUseDocument, options);
        }
export function useSubdomainInUseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>(SubdomainInUseDocument, options);
        }
export type SubdomainInUseQueryHookResult = ReturnType<typeof useSubdomainInUseQuery>;
export type SubdomainInUseLazyQueryHookResult = ReturnType<typeof useSubdomainInUseLazyQuery>;
export type SubdomainInUseSuspenseQueryHookResult = ReturnType<typeof useSubdomainInUseSuspenseQuery>;
export type SubdomainInUseQueryResult = Apollo.QueryResult<Types.SubdomainInUseQuery, Types.SubdomainInUseQueryVariables>;
export const UpdateDomainDocument = gql`
    mutation updateDomain($domain: String!) {
  updateDomain(domain: $domain) {
    id
  }
}
    `;
export type UpdateDomainMutationFn = Apollo.MutationFunction<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables>;
export type UpdateDomainComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables>, 'mutation'>;

    export const UpdateDomainComponent = (props: UpdateDomainComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables> mutation={UpdateDomainDocument} {...props} />
    );
    

/**
 * __useUpdateDomainMutation__
 *
 * To run a mutation, you first call `useUpdateDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainMutation, { data, loading, error }] = useUpdateDomainMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useUpdateDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables>(UpdateDomainDocument, options);
      }
export type UpdateDomainMutationHookResult = ReturnType<typeof useUpdateDomainMutation>;
export type UpdateDomainMutationResult = Apollo.MutationResult<Types.UpdateDomainMutation>;
export type UpdateDomainMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDomainMutation, Types.UpdateDomainMutationVariables>;
export const VerifyDomainDocument = gql`
    mutation verifyDomain {
  verifyDomain {
    id
  }
}
    `;
export type VerifyDomainMutationFn = Apollo.MutationFunction<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables>;
export type VerifyDomainComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables>, 'mutation'>;

    export const VerifyDomainComponent = (props: VerifyDomainComponentProps) => (
      <ApolloReactComponents.Mutation<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables> mutation={VerifyDomainDocument} {...props} />
    );
    

/**
 * __useVerifyDomainMutation__
 *
 * To run a mutation, you first call `useVerifyDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDomainMutation, { data, loading, error }] = useVerifyDomainMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyDomainMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables>(VerifyDomainDocument, options);
      }
export type VerifyDomainMutationHookResult = ReturnType<typeof useVerifyDomainMutation>;
export type VerifyDomainMutationResult = Apollo.MutationResult<Types.VerifyDomainMutation>;
export type VerifyDomainMutationOptions = Apollo.BaseMutationOptions<Types.VerifyDomainMutation, Types.VerifyDomainMutationVariables>;
export const GetTeamDomainSettingsDocument = gql`
    query getTeamDomainSettings {
  me {
    id
    team {
      ...TeamDomainSettings
    }
  }
}
    ${TeamDomainSettingsFragmentDoc}`;
export type GetTeamDomainSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>, 'query'>;

    export const GetTeamDomainSettingsComponent = (props: GetTeamDomainSettingsComponentProps) => (
      <ApolloReactComponents.Query<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables> query={GetTeamDomainSettingsDocument} {...props} />
    );
    

/**
 * __useGetTeamDomainSettingsQuery__
 *
 * To run a query within a React component, call `useGetTeamDomainSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamDomainSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamDomainSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamDomainSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>(GetTeamDomainSettingsDocument, options);
      }
export function useGetTeamDomainSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>(GetTeamDomainSettingsDocument, options);
        }
export function useGetTeamDomainSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>(GetTeamDomainSettingsDocument, options);
        }
export type GetTeamDomainSettingsQueryHookResult = ReturnType<typeof useGetTeamDomainSettingsQuery>;
export type GetTeamDomainSettingsLazyQueryHookResult = ReturnType<typeof useGetTeamDomainSettingsLazyQuery>;
export type GetTeamDomainSettingsSuspenseQueryHookResult = ReturnType<typeof useGetTeamDomainSettingsSuspenseQuery>;
export type GetTeamDomainSettingsQueryResult = Apollo.QueryResult<Types.GetTeamDomainSettingsQuery, Types.GetTeamDomainSettingsQueryVariables>;
export const FieldPropertiesDocument = gql`
    query fieldProperties {
  fieldProperties
}
    `;
export type FieldPropertiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>, 'query'>;

    export const FieldPropertiesComponent = (props: FieldPropertiesComponentProps) => (
      <ApolloReactComponents.Query<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables> query={FieldPropertiesDocument} {...props} />
    );
    

/**
 * __useFieldPropertiesQuery__
 *
 * To run a query within a React component, call `useFieldPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFieldPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>(FieldPropertiesDocument, options);
      }
export function useFieldPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>(FieldPropertiesDocument, options);
        }
export function useFieldPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>(FieldPropertiesDocument, options);
        }
export type FieldPropertiesQueryHookResult = ReturnType<typeof useFieldPropertiesQuery>;
export type FieldPropertiesLazyQueryHookResult = ReturnType<typeof useFieldPropertiesLazyQuery>;
export type FieldPropertiesSuspenseQueryHookResult = ReturnType<typeof useFieldPropertiesSuspenseQuery>;
export type FieldPropertiesQueryResult = Apollo.QueryResult<Types.FieldPropertiesQuery, Types.FieldPropertiesQueryVariables>;
export const SubscriptionInfoDocument = gql`
    query subscriptionInfo {
  subscriptionInfo {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;
export type SubscriptionInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>, 'query'>;

    export const SubscriptionInfoComponent = (props: SubscriptionInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables> query={SubscriptionInfoDocument} {...props} />
    );
    

/**
 * __useSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionInfoQuery(baseOptions?: Apollo.QueryHookOptions<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
      }
export function useSubscriptionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
        }
export function useSubscriptionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
        }
export type SubscriptionInfoQueryHookResult = ReturnType<typeof useSubscriptionInfoQuery>;
export type SubscriptionInfoLazyQueryHookResult = ReturnType<typeof useSubscriptionInfoLazyQuery>;
export type SubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useSubscriptionInfoSuspenseQuery>;
export type SubscriptionInfoQueryResult = Apollo.QueryResult<Types.SubscriptionInfoQuery, Types.SubscriptionInfoQueryVariables>;
export const ConfirmPendingSetupIntentDocument = gql`
    mutation confirmPendingSetupIntent {
  confirmPendingSetupIntent {
    require3ds
    clientSecret
  }
}
    `;
export type ConfirmPendingSetupIntentMutationFn = Apollo.MutationFunction<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables>;
export type ConfirmPendingSetupIntentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables>, 'mutation'>;

    export const ConfirmPendingSetupIntentComponent = (props: ConfirmPendingSetupIntentComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables> mutation={ConfirmPendingSetupIntentDocument} {...props} />
    );
    

/**
 * __useConfirmPendingSetupIntentMutation__
 *
 * To run a mutation, you first call `useConfirmPendingSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPendingSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPendingSetupIntentMutation, { data, loading, error }] = useConfirmPendingSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfirmPendingSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables>(ConfirmPendingSetupIntentDocument, options);
      }
export type ConfirmPendingSetupIntentMutationHookResult = ReturnType<typeof useConfirmPendingSetupIntentMutation>;
export type ConfirmPendingSetupIntentMutationResult = Apollo.MutationResult<Types.ConfirmPendingSetupIntentMutation>;
export type ConfirmPendingSetupIntentMutationOptions = Apollo.BaseMutationOptions<Types.ConfirmPendingSetupIntentMutation, Types.ConfirmPendingSetupIntentMutationVariables>;
export const VerifyPendingSetupIntentDocument = gql`
    mutation verifyPendingSetupIntent {
  verifyPendingSetupIntent {
    id
    pendingSetupIntent
  }
}
    `;
export type VerifyPendingSetupIntentMutationFn = Apollo.MutationFunction<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables>;
export type VerifyPendingSetupIntentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables>, 'mutation'>;

    export const VerifyPendingSetupIntentComponent = (props: VerifyPendingSetupIntentComponentProps) => (
      <ApolloReactComponents.Mutation<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables> mutation={VerifyPendingSetupIntentDocument} {...props} />
    );
    

/**
 * __useVerifyPendingSetupIntentMutation__
 *
 * To run a mutation, you first call `useVerifyPendingSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPendingSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPendingSetupIntentMutation, { data, loading, error }] = useVerifyPendingSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyPendingSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables>(VerifyPendingSetupIntentDocument, options);
      }
export type VerifyPendingSetupIntentMutationHookResult = ReturnType<typeof useVerifyPendingSetupIntentMutation>;
export type VerifyPendingSetupIntentMutationResult = Apollo.MutationResult<Types.VerifyPendingSetupIntentMutation>;
export type VerifyPendingSetupIntentMutationOptions = Apollo.BaseMutationOptions<Types.VerifyPendingSetupIntentMutation, Types.VerifyPendingSetupIntentMutationVariables>;
export const EndTrialEarlyDocument = gql`
    mutation endTrialEarly {
  endTrialEarly {
    team {
      id
    }
    paymentIntentSecret
  }
}
    `;
export type EndTrialEarlyMutationFn = Apollo.MutationFunction<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables>;
export type EndTrialEarlyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables>, 'mutation'>;

    export const EndTrialEarlyComponent = (props: EndTrialEarlyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables> mutation={EndTrialEarlyDocument} {...props} />
    );
    

/**
 * __useEndTrialEarlyMutation__
 *
 * To run a mutation, you first call `useEndTrialEarlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndTrialEarlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endTrialEarlyMutation, { data, loading, error }] = useEndTrialEarlyMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndTrialEarlyMutation(baseOptions?: Apollo.MutationHookOptions<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables>(EndTrialEarlyDocument, options);
      }
export type EndTrialEarlyMutationHookResult = ReturnType<typeof useEndTrialEarlyMutation>;
export type EndTrialEarlyMutationResult = Apollo.MutationResult<Types.EndTrialEarlyMutation>;
export type EndTrialEarlyMutationOptions = Apollo.BaseMutationOptions<Types.EndTrialEarlyMutation, Types.EndTrialEarlyMutationVariables>;
export const MinimizedHtmlDocument = gql`
    query minimizedHTML($content: String!) {
  minimizedHTML(content: $content)
}
    `;
export type MinimizedHtmlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>, 'query'> & ({ variables: Types.MinimizedHtmlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MinimizedHtmlComponent = (props: MinimizedHtmlComponentProps) => (
      <ApolloReactComponents.Query<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables> query={MinimizedHtmlDocument} {...props} />
    );
    

/**
 * __useMinimizedHtmlQuery__
 *
 * To run a query within a React component, call `useMinimizedHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimizedHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimizedHtmlQuery({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useMinimizedHtmlQuery(baseOptions: Apollo.QueryHookOptions<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables> & ({ variables: Types.MinimizedHtmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>(MinimizedHtmlDocument, options);
      }
export function useMinimizedHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>(MinimizedHtmlDocument, options);
        }
export function useMinimizedHtmlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>(MinimizedHtmlDocument, options);
        }
export type MinimizedHtmlQueryHookResult = ReturnType<typeof useMinimizedHtmlQuery>;
export type MinimizedHtmlLazyQueryHookResult = ReturnType<typeof useMinimizedHtmlLazyQuery>;
export type MinimizedHtmlSuspenseQueryHookResult = ReturnType<typeof useMinimizedHtmlSuspenseQuery>;
export type MinimizedHtmlQueryResult = Apollo.QueryResult<Types.MinimizedHtmlQuery, Types.MinimizedHtmlQueryVariables>;
export const VerifyCardDocument = gql`
    mutation verifyCard($paymentMethodId: String!) {
  verifyCard(paymentMethodId: $paymentMethodId) {
    success
    paymentIntentSecret
  }
}
    `;
export type VerifyCardMutationFn = Apollo.MutationFunction<Types.VerifyCardMutation, Types.VerifyCardMutationVariables>;
export type VerifyCardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.VerifyCardMutation, Types.VerifyCardMutationVariables>, 'mutation'>;

    export const VerifyCardComponent = (props: VerifyCardComponentProps) => (
      <ApolloReactComponents.Mutation<Types.VerifyCardMutation, Types.VerifyCardMutationVariables> mutation={VerifyCardDocument} {...props} />
    );
    

/**
 * __useVerifyCardMutation__
 *
 * To run a mutation, you first call `useVerifyCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCardMutation, { data, loading, error }] = useVerifyCardMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useVerifyCardMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyCardMutation, Types.VerifyCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyCardMutation, Types.VerifyCardMutationVariables>(VerifyCardDocument, options);
      }
export type VerifyCardMutationHookResult = ReturnType<typeof useVerifyCardMutation>;
export type VerifyCardMutationResult = Apollo.MutationResult<Types.VerifyCardMutation>;
export type VerifyCardMutationOptions = Apollo.BaseMutationOptions<Types.VerifyCardMutation, Types.VerifyCardMutationVariables>;
export const ExportDocument = gql`
    mutation export($participantFilter: ParticipantFilter, $registrantFilter: GetRegistrantsInput, $messageFilter: MessageFilters, $format: ExportFormats!) {
  export(
    participantFilter: $participantFilter
    registrantFilter: $registrantFilter
    messageFilter: $messageFilter
    format: $format
  )
}
    `;
export type ExportMutationFn = Apollo.MutationFunction<Types.ExportMutation, Types.ExportMutationVariables>;
export type ExportComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ExportMutation, Types.ExportMutationVariables>, 'mutation'>;

    export const ExportComponent = (props: ExportComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ExportMutation, Types.ExportMutationVariables> mutation={ExportDocument} {...props} />
    );
    

/**
 * __useExportMutation__
 *
 * To run a mutation, you first call `useExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportMutation, { data, loading, error }] = useExportMutation({
 *   variables: {
 *      participantFilter: // value for 'participantFilter'
 *      registrantFilter: // value for 'registrantFilter'
 *      messageFilter: // value for 'messageFilter'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useExportMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExportMutation, Types.ExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExportMutation, Types.ExportMutationVariables>(ExportDocument, options);
      }
export type ExportMutationHookResult = ReturnType<typeof useExportMutation>;
export type ExportMutationResult = Apollo.MutationResult<Types.ExportMutation>;
export type ExportMutationOptions = Apollo.BaseMutationOptions<Types.ExportMutation, Types.ExportMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...Me
    now
  }
}
    ${MeFragmentDoc}`;
export type MeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MeQuery, Types.MeQueryVariables>, 'query'>;

    export const MeComponent = (props: MeComponentProps) => (
      <ApolloReactComponents.Query<Types.MeQuery, Types.MeQueryVariables> query={MeDocument} {...props} />
    );
    

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MeQuery, Types.MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MeQuery, Types.MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<Types.MeQuery, Types.MeQueryVariables>;
export const HubspotTokenDocument = gql`
    query hubspotToken {
  hubspotToken
}
    `;
export type HubspotTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>, 'query'>;

    export const HubspotTokenComponent = (props: HubspotTokenComponentProps) => (
      <ApolloReactComponents.Query<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables> query={HubspotTokenDocument} {...props} />
    );
    

/**
 * __useHubspotTokenQuery__
 *
 * To run a query within a React component, call `useHubspotTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubspotTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubspotTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useHubspotTokenQuery(baseOptions?: Apollo.QueryHookOptions<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>(HubspotTokenDocument, options);
      }
export function useHubspotTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>(HubspotTokenDocument, options);
        }
export function useHubspotTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>(HubspotTokenDocument, options);
        }
export type HubspotTokenQueryHookResult = ReturnType<typeof useHubspotTokenQuery>;
export type HubspotTokenLazyQueryHookResult = ReturnType<typeof useHubspotTokenLazyQuery>;
export type HubspotTokenSuspenseQueryHookResult = ReturnType<typeof useHubspotTokenSuspenseQuery>;
export type HubspotTokenQueryResult = Apollo.QueryResult<Types.HubspotTokenQuery, Types.HubspotTokenQueryVariables>;
export const RegisterForRewardsDocument = gql`
    mutation registerForRewards {
  registerForRewards {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type RegisterForRewardsMutationFn = Apollo.MutationFunction<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables>;
export type RegisterForRewardsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables>, 'mutation'>;

    export const RegisterForRewardsComponent = (props: RegisterForRewardsComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables> mutation={RegisterForRewardsDocument} {...props} />
    );
    

/**
 * __useRegisterForRewardsMutation__
 *
 * To run a mutation, you first call `useRegisterForRewardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterForRewardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerForRewardsMutation, { data, loading, error }] = useRegisterForRewardsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegisterForRewardsMutation(baseOptions?: Apollo.MutationHookOptions<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables>(RegisterForRewardsDocument, options);
      }
export type RegisterForRewardsMutationHookResult = ReturnType<typeof useRegisterForRewardsMutation>;
export type RegisterForRewardsMutationResult = Apollo.MutationResult<Types.RegisterForRewardsMutation>;
export type RegisterForRewardsMutationOptions = Apollo.BaseMutationOptions<Types.RegisterForRewardsMutation, Types.RegisterForRewardsMutationVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($data: UpdateMeInput!) {
  updateMe(data: $data) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<Types.UpdateMeMutation, Types.UpdateMeMutationVariables>;
export type UpdateMeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UpdateMeMutation, Types.UpdateMeMutationVariables>, 'mutation'>;

    export const UpdateMeComponent = (props: UpdateMeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UpdateMeMutation, Types.UpdateMeMutationVariables> mutation={UpdateMeDocument} {...props} />
    );
    

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateMeMutation, Types.UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateMeMutation, Types.UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<Types.UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<Types.UpdateMeMutation, Types.UpdateMeMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!, $loginInfo: LoginInfo!) {
  login(email: $email, password: $password, loginInfo: $loginInfo) {
    ...Me
    now
  }
}
    ${MeFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<Types.LoginMutation, Types.LoginMutationVariables>;
export type LoginComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.LoginMutation, Types.LoginMutationVariables>, 'mutation'>;

    export const LoginComponent = (props: LoginComponentProps) => (
      <ApolloReactComponents.Mutation<Types.LoginMutation, Types.LoginMutationVariables> mutation={LoginDocument} {...props} />
    );
    

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      loginInfo: // value for 'loginInfo'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginMutation, Types.LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginMutation, Types.LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<Types.LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables>;
export const LoginSsoDocument = gql`
    mutation loginSSO($provider: String!, $token: String!, $loginInfo: LoginInfo!) {
  loginSSO(provider: $provider, token: $token, loginInfo: $loginInfo) {
    ...Me
    now
  }
}
    ${MeFragmentDoc}`;
export type LoginSsoMutationFn = Apollo.MutationFunction<Types.LoginSsoMutation, Types.LoginSsoMutationVariables>;
export type LoginSsoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.LoginSsoMutation, Types.LoginSsoMutationVariables>, 'mutation'>;

    export const LoginSsoComponent = (props: LoginSsoComponentProps) => (
      <ApolloReactComponents.Mutation<Types.LoginSsoMutation, Types.LoginSsoMutationVariables> mutation={LoginSsoDocument} {...props} />
    );
    

/**
 * __useLoginSsoMutation__
 *
 * To run a mutation, you first call `useLoginSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSsoMutation, { data, loading, error }] = useLoginSsoMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      token: // value for 'token'
 *      loginInfo: // value for 'loginInfo'
 *   },
 * });
 */
export function useLoginSsoMutation(baseOptions?: Apollo.MutationHookOptions<Types.LoginSsoMutation, Types.LoginSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LoginSsoMutation, Types.LoginSsoMutationVariables>(LoginSsoDocument, options);
      }
export type LoginSsoMutationHookResult = ReturnType<typeof useLoginSsoMutation>;
export type LoginSsoMutationResult = Apollo.MutationResult<Types.LoginSsoMutation>;
export type LoginSsoMutationOptions = Apollo.BaseMutationOptions<Types.LoginSsoMutation, Types.LoginSsoMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<Types.LogoutMutation, Types.LogoutMutationVariables>;
export type LogoutComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.LogoutMutation, Types.LogoutMutationVariables>, 'mutation'>;

    export const LogoutComponent = (props: LogoutComponentProps) => (
      <ApolloReactComponents.Mutation<Types.LogoutMutation, Types.LogoutMutationVariables> mutation={LogoutDocument} {...props} />
    );
    

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<Types.LogoutMutation, Types.LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LogoutMutation, Types.LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<Types.LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<Types.LogoutMutation, Types.LogoutMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation changeEmail($code: String!, $email: String!) {
  changeEmail(code: $code, email: $email) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type ChangeEmailMutationFn = Apollo.MutationFunction<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables>;
export type ChangeEmailComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables>, 'mutation'>;

    export const ChangeEmailComponent = (props: ChangeEmailComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables> mutation={ChangeEmailDocument} {...props} />
    );
    

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      code: // value for 'code'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<Types.ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<Types.ChangeEmailMutation, Types.ChangeEmailMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($data: ChangePasswordInput!) {
  changePassword(data: $data) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export type ChangePasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>, 'mutation'>;

    export const ChangePasswordComponent = (props: ChangePasswordComponentProps) => (
      <ApolloReactComponents.Mutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables> mutation={ChangePasswordDocument} {...props} />
    );
    

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<Types.ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export const VerifyTokenDocument = gql`
    mutation verifyToken($token: String!, $loginInfo: LoginInfo!) {
  verifyInviteToken(token: $token, loginInfo: $loginInfo) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type VerifyTokenMutationFn = Apollo.MutationFunction<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables>;
export type VerifyTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables>, 'mutation'>;

    export const VerifyTokenComponent = (props: VerifyTokenComponentProps) => (
      <ApolloReactComponents.Mutation<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables> mutation={VerifyTokenDocument} {...props} />
    );
    

/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      loginInfo: // value for 'loginInfo'
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables>(VerifyTokenDocument, options);
      }
export type VerifyTokenMutationHookResult = ReturnType<typeof useVerifyTokenMutation>;
export type VerifyTokenMutationResult = Apollo.MutationResult<Types.VerifyTokenMutation>;
export type VerifyTokenMutationOptions = Apollo.BaseMutationOptions<Types.VerifyTokenMutation, Types.VerifyTokenMutationVariables>;
export const StartEmailVerifyDocument = gql`
    mutation startEmailVerify($email: String!, $changingEmail: Boolean!) {
  startEmailVerify(email: $email, changingEmail: $changingEmail)
}
    `;
export type StartEmailVerifyMutationFn = Apollo.MutationFunction<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables>;
export type StartEmailVerifyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables>, 'mutation'>;

    export const StartEmailVerifyComponent = (props: StartEmailVerifyComponentProps) => (
      <ApolloReactComponents.Mutation<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables> mutation={StartEmailVerifyDocument} {...props} />
    );
    

/**
 * __useStartEmailVerifyMutation__
 *
 * To run a mutation, you first call `useStartEmailVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEmailVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEmailVerifyMutation, { data, loading, error }] = useStartEmailVerifyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      changingEmail: // value for 'changingEmail'
 *   },
 * });
 */
export function useStartEmailVerifyMutation(baseOptions?: Apollo.MutationHookOptions<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables>(StartEmailVerifyDocument, options);
      }
export type StartEmailVerifyMutationHookResult = ReturnType<typeof useStartEmailVerifyMutation>;
export type StartEmailVerifyMutationResult = Apollo.MutationResult<Types.StartEmailVerifyMutation>;
export type StartEmailVerifyMutationOptions = Apollo.BaseMutationOptions<Types.StartEmailVerifyMutation, Types.StartEmailVerifyMutationVariables>;
export const VerifyEmailCodeDocument = gql`
    mutation verifyEmailCode($code: String!, $user: NewUserInput!) {
  verifyEmailCode(code: $code, user: $user) {
    firstName
    lastName
    email
    isVerified
  }
}
    `;
export type VerifyEmailCodeMutationFn = Apollo.MutationFunction<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables>;
export type VerifyEmailCodeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables>, 'mutation'>;

    export const VerifyEmailCodeComponent = (props: VerifyEmailCodeComponentProps) => (
      <ApolloReactComponents.Mutation<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables> mutation={VerifyEmailCodeDocument} {...props} />
    );
    

/**
 * __useVerifyEmailCodeMutation__
 *
 * To run a mutation, you first call `useVerifyEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailCodeMutation, { data, loading, error }] = useVerifyEmailCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useVerifyEmailCodeMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables>(VerifyEmailCodeDocument, options);
      }
export type VerifyEmailCodeMutationHookResult = ReturnType<typeof useVerifyEmailCodeMutation>;
export type VerifyEmailCodeMutationResult = Apollo.MutationResult<Types.VerifyEmailCodeMutation>;
export type VerifyEmailCodeMutationOptions = Apollo.BaseMutationOptions<Types.VerifyEmailCodeMutation, Types.VerifyEmailCodeMutationVariables>;
export const SignupUserDocument = gql`
    mutation signupUser($code: String!, $user: NewUserAndTeamInput!, $loginInfo: LoginInfo!) {
  signupUser(code: $code, user: $user, loginInfo: $loginInfo) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type SignupUserMutationFn = Apollo.MutationFunction<Types.SignupUserMutation, Types.SignupUserMutationVariables>;
export type SignupUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SignupUserMutation, Types.SignupUserMutationVariables>, 'mutation'>;

    export const SignupUserComponent = (props: SignupUserComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SignupUserMutation, Types.SignupUserMutationVariables> mutation={SignupUserDocument} {...props} />
    );
    

/**
 * __useSignupUserMutation__
 *
 * To run a mutation, you first call `useSignupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupUserMutation, { data, loading, error }] = useSignupUserMutation({
 *   variables: {
 *      code: // value for 'code'
 *      user: // value for 'user'
 *      loginInfo: // value for 'loginInfo'
 *   },
 * });
 */
export function useSignupUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignupUserMutation, Types.SignupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignupUserMutation, Types.SignupUserMutationVariables>(SignupUserDocument, options);
      }
export type SignupUserMutationHookResult = ReturnType<typeof useSignupUserMutation>;
export type SignupUserMutationResult = Apollo.MutationResult<Types.SignupUserMutation>;
export type SignupUserMutationOptions = Apollo.BaseMutationOptions<Types.SignupUserMutation, Types.SignupUserMutationVariables>;
export const SignupUserSsoDocument = gql`
    mutation signupUserSSO($provider: String!, $token: String!, $team: TeamInput!, $loginInfo: LoginInfo!) {
  signupUserSSO(
    provider: $provider
    token: $token
    team: $team
    loginInfo: $loginInfo
  ) {
    ...Me
    now
  }
}
    ${MeFragmentDoc}`;
export type SignupUserSsoMutationFn = Apollo.MutationFunction<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables>;
export type SignupUserSsoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables>, 'mutation'>;

    export const SignupUserSsoComponent = (props: SignupUserSsoComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables> mutation={SignupUserSsoDocument} {...props} />
    );
    

/**
 * __useSignupUserSsoMutation__
 *
 * To run a mutation, you first call `useSignupUserSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupUserSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupUserSsoMutation, { data, loading, error }] = useSignupUserSsoMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      token: // value for 'token'
 *      team: // value for 'team'
 *      loginInfo: // value for 'loginInfo'
 *   },
 * });
 */
export function useSignupUserSsoMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables>(SignupUserSsoDocument, options);
      }
export type SignupUserSsoMutationHookResult = ReturnType<typeof useSignupUserSsoMutation>;
export type SignupUserSsoMutationResult = Apollo.MutationResult<Types.SignupUserSsoMutation>;
export type SignupUserSsoMutationOptions = Apollo.BaseMutationOptions<Types.SignupUserSsoMutation, Types.SignupUserSsoMutationVariables>;
export const SignupTeamCcDocument = gql`
    mutation signupTeamCC($data: NewUserAndTeamInput!) {
  signupTeamCC(data: $data) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type SignupTeamCcMutationFn = Apollo.MutationFunction<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables>;
export type SignupTeamCcComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables>, 'mutation'>;

    export const SignupTeamCcComponent = (props: SignupTeamCcComponentProps) => (
      <ApolloReactComponents.Mutation<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables> mutation={SignupTeamCcDocument} {...props} />
    );
    

/**
 * __useSignupTeamCcMutation__
 *
 * To run a mutation, you first call `useSignupTeamCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupTeamCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupTeamCcMutation, { data, loading, error }] = useSignupTeamCcMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignupTeamCcMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables>(SignupTeamCcDocument, options);
      }
export type SignupTeamCcMutationHookResult = ReturnType<typeof useSignupTeamCcMutation>;
export type SignupTeamCcMutationResult = Apollo.MutationResult<Types.SignupTeamCcMutation>;
export type SignupTeamCcMutationOptions = Apollo.BaseMutationOptions<Types.SignupTeamCcMutation, Types.SignupTeamCcMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation acceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>;
export type AcceptInvitationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>, 'mutation'>;

    export const AcceptInvitationComponent = (props: AcceptInvitationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables> mutation={AcceptInvitationDocument} {...props} />
    );
    

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<Types.AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<Types.AcceptInvitationMutation, Types.AcceptInvitationMutationVariables>;
export const RejectInvitationDocument = gql`
    mutation rejectInvitation($token: String!) {
  rejectInvitation(token: $token)
}
    `;
export type RejectInvitationMutationFn = Apollo.MutationFunction<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables>;
export type RejectInvitationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables>, 'mutation'>;

    export const RejectInvitationComponent = (props: RejectInvitationComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables> mutation={RejectInvitationDocument} {...props} />
    );
    

/**
 * __useRejectInvitationMutation__
 *
 * To run a mutation, you first call `useRejectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInvitationMutation, { data, loading, error }] = useRejectInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRejectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables>(RejectInvitationDocument, options);
      }
export type RejectInvitationMutationHookResult = ReturnType<typeof useRejectInvitationMutation>;
export type RejectInvitationMutationResult = Apollo.MutationResult<Types.RejectInvitationMutation>;
export type RejectInvitationMutationOptions = Apollo.BaseMutationOptions<Types.RejectInvitationMutation, Types.RejectInvitationMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken {
  refreshToken
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export type RefreshTokenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>, 'mutation'>;

    export const RefreshTokenComponent = (props: RefreshTokenComponentProps) => (
      <ApolloReactComponents.Mutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables> mutation={RefreshTokenDocument} {...props} />
    );
    

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<Types.RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export const CreateVideoMultipartUploadDocument = gql`
    mutation createVideoMultipartUpload($data: VideoAssetInput!) {
  createVideoMultipartUpload(data: $data) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type CreateVideoMultipartUploadMutationFn = Apollo.MutationFunction<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables>;
export type CreateVideoMultipartUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables>, 'mutation'>;

    export const CreateVideoMultipartUploadComponent = (props: CreateVideoMultipartUploadComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables> mutation={CreateVideoMultipartUploadDocument} {...props} />
    );
    

/**
 * __useCreateVideoMultipartUploadMutation__
 *
 * To run a mutation, you first call `useCreateVideoMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMultipartUploadMutation, { data, loading, error }] = useCreateVideoMultipartUploadMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateVideoMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables>(CreateVideoMultipartUploadDocument, options);
      }
export type CreateVideoMultipartUploadMutationHookResult = ReturnType<typeof useCreateVideoMultipartUploadMutation>;
export type CreateVideoMultipartUploadMutationResult = Apollo.MutationResult<Types.CreateVideoMultipartUploadMutation>;
export type CreateVideoMultipartUploadMutationOptions = Apollo.BaseMutationOptions<Types.CreateVideoMultipartUploadMutation, Types.CreateVideoMultipartUploadMutationVariables>;
export const CompleteVideoMultipartUploadDocument = gql`
    mutation completeVideoMultipartUpload($ewebinarId: String!, $uploadId: String!, $parts: [VideoUploadPartInput!]!) {
  completeVideoMultipartUpload(
    ewebinarId: $ewebinarId
    uploadId: $uploadId
    parts: $parts
  ) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type CompleteVideoMultipartUploadMutationFn = Apollo.MutationFunction<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables>;
export type CompleteVideoMultipartUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables>, 'mutation'>;

    export const CompleteVideoMultipartUploadComponent = (props: CompleteVideoMultipartUploadComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables> mutation={CompleteVideoMultipartUploadDocument} {...props} />
    );
    

/**
 * __useCompleteVideoMultipartUploadMutation__
 *
 * To run a mutation, you first call `useCompleteVideoMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteVideoMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeVideoMultipartUploadMutation, { data, loading, error }] = useCompleteVideoMultipartUploadMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useCompleteVideoMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables>(CompleteVideoMultipartUploadDocument, options);
      }
export type CompleteVideoMultipartUploadMutationHookResult = ReturnType<typeof useCompleteVideoMultipartUploadMutation>;
export type CompleteVideoMultipartUploadMutationResult = Apollo.MutationResult<Types.CompleteVideoMultipartUploadMutation>;
export type CompleteVideoMultipartUploadMutationOptions = Apollo.BaseMutationOptions<Types.CompleteVideoMultipartUploadMutation, Types.CompleteVideoMultipartUploadMutationVariables>;
export const UploadVideoFromUrlDocument = gql`
    mutation uploadVideoFromUrl($data: UploadVideoInput!) {
  uploadVideoFromUrl(data: $data) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type UploadVideoFromUrlMutationFn = Apollo.MutationFunction<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables>;
export type UploadVideoFromUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables>, 'mutation'>;

    export const UploadVideoFromUrlComponent = (props: UploadVideoFromUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables> mutation={UploadVideoFromUrlDocument} {...props} />
    );
    

/**
 * __useUploadVideoFromUrlMutation__
 *
 * To run a mutation, you first call `useUploadVideoFromUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVideoFromUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVideoFromUrlMutation, { data, loading, error }] = useUploadVideoFromUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadVideoFromUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables>(UploadVideoFromUrlDocument, options);
      }
export type UploadVideoFromUrlMutationHookResult = ReturnType<typeof useUploadVideoFromUrlMutation>;
export type UploadVideoFromUrlMutationResult = Apollo.MutationResult<Types.UploadVideoFromUrlMutation>;
export type UploadVideoFromUrlMutationOptions = Apollo.BaseMutationOptions<Types.UploadVideoFromUrlMutation, Types.UploadVideoFromUrlMutationVariables>;
export const CancelVideoMultipartUploadDocument = gql`
    mutation cancelVideoMultipartUpload($ewebinarId: String!, $uuid: String!, $status: UploadStatusInput) {
  cancelVideoMultipartUpload(
    ewebinarId: $ewebinarId
    uuid: $uuid
    status: $status
  ) {
    id
    jobs {
      ...Jobs
    }
  }
}
    ${JobsFragmentDoc}`;
export type CancelVideoMultipartUploadMutationFn = Apollo.MutationFunction<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables>;
export type CancelVideoMultipartUploadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables>, 'mutation'>;

    export const CancelVideoMultipartUploadComponent = (props: CancelVideoMultipartUploadComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables> mutation={CancelVideoMultipartUploadDocument} {...props} />
    );
    

/**
 * __useCancelVideoMultipartUploadMutation__
 *
 * To run a mutation, you first call `useCancelVideoMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelVideoMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelVideoMultipartUploadMutation, { data, loading, error }] = useCancelVideoMultipartUploadMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCancelVideoMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables>(CancelVideoMultipartUploadDocument, options);
      }
export type CancelVideoMultipartUploadMutationHookResult = ReturnType<typeof useCancelVideoMultipartUploadMutation>;
export type CancelVideoMultipartUploadMutationResult = Apollo.MutationResult<Types.CancelVideoMultipartUploadMutation>;
export type CancelVideoMultipartUploadMutationOptions = Apollo.BaseMutationOptions<Types.CancelVideoMultipartUploadMutation, Types.CancelVideoMultipartUploadMutationVariables>;
export const CreateVimeoTextTrackUploadUrlDocument = gql`
    mutation createVimeoTextTrackUploadUrl($data: TextTrackUploadInput!) {
  createVimeoTextTrackUploadUrl(data: $data) {
    ...VimeoTextTrackUrls
  }
}
    ${VimeoTextTrackUrlsFragmentDoc}`;
export type CreateVimeoTextTrackUploadUrlMutationFn = Apollo.MutationFunction<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables>;
export type CreateVimeoTextTrackUploadUrlComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables>, 'mutation'>;

    export const CreateVimeoTextTrackUploadUrlComponent = (props: CreateVimeoTextTrackUploadUrlComponentProps) => (
      <ApolloReactComponents.Mutation<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables> mutation={CreateVimeoTextTrackUploadUrlDocument} {...props} />
    );
    

/**
 * __useCreateVimeoTextTrackUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateVimeoTextTrackUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVimeoTextTrackUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVimeoTextTrackUploadUrlMutation, { data, loading, error }] = useCreateVimeoTextTrackUploadUrlMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateVimeoTextTrackUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables>(CreateVimeoTextTrackUploadUrlDocument, options);
      }
export type CreateVimeoTextTrackUploadUrlMutationHookResult = ReturnType<typeof useCreateVimeoTextTrackUploadUrlMutation>;
export type CreateVimeoTextTrackUploadUrlMutationResult = Apollo.MutationResult<Types.CreateVimeoTextTrackUploadUrlMutation>;
export type CreateVimeoTextTrackUploadUrlMutationOptions = Apollo.BaseMutationOptions<Types.CreateVimeoTextTrackUploadUrlMutation, Types.CreateVimeoTextTrackUploadUrlMutationVariables>;
export const DeleteVimeoTextTrackDocument = gql`
    mutation deleteVimeoTextTrack($ewebinarId: String!, $vimeoTextTrackId: Float!) {
  deleteVimeoTextTrack(
    ewebinarId: $ewebinarId
    vimeoTextTrackId: $vimeoTextTrackId
  ) {
    ...EWebinar
  }
}
    ${EWebinarFragmentDoc}`;
export type DeleteVimeoTextTrackMutationFn = Apollo.MutationFunction<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables>;
export type DeleteVimeoTextTrackComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables>, 'mutation'>;

    export const DeleteVimeoTextTrackComponent = (props: DeleteVimeoTextTrackComponentProps) => (
      <ApolloReactComponents.Mutation<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables> mutation={DeleteVimeoTextTrackDocument} {...props} />
    );
    

/**
 * __useDeleteVimeoTextTrackMutation__
 *
 * To run a mutation, you first call `useDeleteVimeoTextTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVimeoTextTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVimeoTextTrackMutation, { data, loading, error }] = useDeleteVimeoTextTrackMutation({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      vimeoTextTrackId: // value for 'vimeoTextTrackId'
 *   },
 * });
 */
export function useDeleteVimeoTextTrackMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables>(DeleteVimeoTextTrackDocument, options);
      }
export type DeleteVimeoTextTrackMutationHookResult = ReturnType<typeof useDeleteVimeoTextTrackMutation>;
export type DeleteVimeoTextTrackMutationResult = Apollo.MutationResult<Types.DeleteVimeoTextTrackMutation>;
export type DeleteVimeoTextTrackMutationOptions = Apollo.BaseMutationOptions<Types.DeleteVimeoTextTrackMutation, Types.DeleteVimeoTextTrackMutationVariables>;
export const ActiveCampaignFillinsDocument = gql`
    query activeCampaignFillins($integration: IntegrationUpdateInput!) {
  activeCampaignFillins(integration: $integration) {
    lists {
      id
      name
    }
    fields {
      id
      name
      label
      type
    }
    tags {
      id
      name
    }
  }
}
    `;
export type ActiveCampaignFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>, 'query'> & ({ variables: Types.ActiveCampaignFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ActiveCampaignFillinsComponent = (props: ActiveCampaignFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables> query={ActiveCampaignFillinsDocument} {...props} />
    );
    

/**
 * __useActiveCampaignFillinsQuery__
 *
 * To run a query within a React component, call `useActiveCampaignFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCampaignFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCampaignFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useActiveCampaignFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables> & ({ variables: Types.ActiveCampaignFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>(ActiveCampaignFillinsDocument, options);
      }
export function useActiveCampaignFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>(ActiveCampaignFillinsDocument, options);
        }
export function useActiveCampaignFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>(ActiveCampaignFillinsDocument, options);
        }
export type ActiveCampaignFillinsQueryHookResult = ReturnType<typeof useActiveCampaignFillinsQuery>;
export type ActiveCampaignFillinsLazyQueryHookResult = ReturnType<typeof useActiveCampaignFillinsLazyQuery>;
export type ActiveCampaignFillinsSuspenseQueryHookResult = ReturnType<typeof useActiveCampaignFillinsSuspenseQuery>;
export type ActiveCampaignFillinsQueryResult = Apollo.QueryResult<Types.ActiveCampaignFillinsQuery, Types.ActiveCampaignFillinsQueryVariables>;
export const ConstantContactFillinsDocument = gql`
    query constantContactFillins($integration: IntegrationUpdateInput!) {
  constantContactFillins(integration: $integration) {
    lists {
      list_id
      name
    }
    fields {
      id
      name
      label
      type
    }
    tags {
      id
      name
    }
  }
}
    `;
export type ConstantContactFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>, 'query'> & ({ variables: Types.ConstantContactFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConstantContactFillinsComponent = (props: ConstantContactFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables> query={ConstantContactFillinsDocument} {...props} />
    );
    

/**
 * __useConstantContactFillinsQuery__
 *
 * To run a query within a React component, call `useConstantContactFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConstantContactFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConstantContactFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useConstantContactFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables> & ({ variables: Types.ConstantContactFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>(ConstantContactFillinsDocument, options);
      }
export function useConstantContactFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>(ConstantContactFillinsDocument, options);
        }
export function useConstantContactFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>(ConstantContactFillinsDocument, options);
        }
export type ConstantContactFillinsQueryHookResult = ReturnType<typeof useConstantContactFillinsQuery>;
export type ConstantContactFillinsLazyQueryHookResult = ReturnType<typeof useConstantContactFillinsLazyQuery>;
export type ConstantContactFillinsSuspenseQueryHookResult = ReturnType<typeof useConstantContactFillinsSuspenseQuery>;
export type ConstantContactFillinsQueryResult = Apollo.QueryResult<Types.ConstantContactFillinsQuery, Types.ConstantContactFillinsQueryVariables>;
export const ConvertKitFillinsDocument = gql`
    query convertKitFillins($integration: IntegrationUpdateInput!) {
  convertKitFillins(integration: $integration) {
    tags {
      id
      name
    }
    fields {
      id
      name
      label
      type
    }
    forms {
      id
      name
    }
  }
}
    `;
export type ConvertKitFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>, 'query'> & ({ variables: Types.ConvertKitFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ConvertKitFillinsComponent = (props: ConvertKitFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables> query={ConvertKitFillinsDocument} {...props} />
    );
    

/**
 * __useConvertKitFillinsQuery__
 *
 * To run a query within a React component, call `useConvertKitFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertKitFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertKitFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useConvertKitFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables> & ({ variables: Types.ConvertKitFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>(ConvertKitFillinsDocument, options);
      }
export function useConvertKitFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>(ConvertKitFillinsDocument, options);
        }
export function useConvertKitFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>(ConvertKitFillinsDocument, options);
        }
export type ConvertKitFillinsQueryHookResult = ReturnType<typeof useConvertKitFillinsQuery>;
export type ConvertKitFillinsLazyQueryHookResult = ReturnType<typeof useConvertKitFillinsLazyQuery>;
export type ConvertKitFillinsSuspenseQueryHookResult = ReturnType<typeof useConvertKitFillinsSuspenseQuery>;
export type ConvertKitFillinsQueryResult = Apollo.QueryResult<Types.ConvertKitFillinsQuery, Types.ConvertKitFillinsQueryVariables>;
export const HubspotFillinsDocument = gql`
    query hubspotFillins($integration: IntegrationUpdateInput!) {
  hubspotFillins(integration: $integration) {
    fields {
      id
      name
      label
      type
    }
  }
}
    `;
export type HubspotFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>, 'query'> & ({ variables: Types.HubspotFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HubspotFillinsComponent = (props: HubspotFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables> query={HubspotFillinsDocument} {...props} />
    );
    

/**
 * __useHubspotFillinsQuery__
 *
 * To run a query within a React component, call `useHubspotFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubspotFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubspotFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useHubspotFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables> & ({ variables: Types.HubspotFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>(HubspotFillinsDocument, options);
      }
export function useHubspotFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>(HubspotFillinsDocument, options);
        }
export function useHubspotFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>(HubspotFillinsDocument, options);
        }
export type HubspotFillinsQueryHookResult = ReturnType<typeof useHubspotFillinsQuery>;
export type HubspotFillinsLazyQueryHookResult = ReturnType<typeof useHubspotFillinsLazyQuery>;
export type HubspotFillinsSuspenseQueryHookResult = ReturnType<typeof useHubspotFillinsSuspenseQuery>;
export type HubspotFillinsQueryResult = Apollo.QueryResult<Types.HubspotFillinsQuery, Types.HubspotFillinsQueryVariables>;
export const IdentifyVisitorDocument = gql`
    query identifyVisitor($data: VisitorIdentificationInput!) {
  identifyVisitor(data: $data) {
    ...VisitorIdentification
  }
}
    ${VisitorIdentificationFragmentDoc}`;
export type IdentifyVisitorComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>, 'query'> & ({ variables: Types.IdentifyVisitorQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IdentifyVisitorComponent = (props: IdentifyVisitorComponentProps) => (
      <ApolloReactComponents.Query<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables> query={IdentifyVisitorDocument} {...props} />
    );
    

/**
 * __useIdentifyVisitorQuery__
 *
 * To run a query within a React component, call `useIdentifyVisitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentifyVisitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentifyVisitorQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useIdentifyVisitorQuery(baseOptions: Apollo.QueryHookOptions<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables> & ({ variables: Types.IdentifyVisitorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>(IdentifyVisitorDocument, options);
      }
export function useIdentifyVisitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>(IdentifyVisitorDocument, options);
        }
export function useIdentifyVisitorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>(IdentifyVisitorDocument, options);
        }
export type IdentifyVisitorQueryHookResult = ReturnType<typeof useIdentifyVisitorQuery>;
export type IdentifyVisitorLazyQueryHookResult = ReturnType<typeof useIdentifyVisitorLazyQuery>;
export type IdentifyVisitorSuspenseQueryHookResult = ReturnType<typeof useIdentifyVisitorSuspenseQuery>;
export type IdentifyVisitorQueryResult = Apollo.QueryResult<Types.IdentifyVisitorQuery, Types.IdentifyVisitorQueryVariables>;
export const InfusionsoftFillinsDocument = gql`
    query infusionsoftFillins($integration: IntegrationUpdateInput!) {
  infusionsoftFillins(integration: $integration) {
    fields {
      id
      name
      label
      type
    }
    tags {
      id
      name
    }
  }
}
    `;
export type InfusionsoftFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>, 'query'> & ({ variables: Types.InfusionsoftFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InfusionsoftFillinsComponent = (props: InfusionsoftFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables> query={InfusionsoftFillinsDocument} {...props} />
    );
    

/**
 * __useInfusionsoftFillinsQuery__
 *
 * To run a query within a React component, call `useInfusionsoftFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfusionsoftFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfusionsoftFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useInfusionsoftFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables> & ({ variables: Types.InfusionsoftFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>(InfusionsoftFillinsDocument, options);
      }
export function useInfusionsoftFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>(InfusionsoftFillinsDocument, options);
        }
export function useInfusionsoftFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>(InfusionsoftFillinsDocument, options);
        }
export type InfusionsoftFillinsQueryHookResult = ReturnType<typeof useInfusionsoftFillinsQuery>;
export type InfusionsoftFillinsLazyQueryHookResult = ReturnType<typeof useInfusionsoftFillinsLazyQuery>;
export type InfusionsoftFillinsSuspenseQueryHookResult = ReturnType<typeof useInfusionsoftFillinsSuspenseQuery>;
export type InfusionsoftFillinsQueryResult = Apollo.QueryResult<Types.InfusionsoftFillinsQuery, Types.InfusionsoftFillinsQueryVariables>;
export const IdentityVerificationDocument = gql`
    query identityVerification($integrationId: String!, $email: String!) {
  identityVerification(integrationId: $integrationId, email: $email)
}
    `;
export type IdentityVerificationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>, 'query'> & ({ variables: Types.IdentityVerificationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const IdentityVerificationComponent = (props: IdentityVerificationComponentProps) => (
      <ApolloReactComponents.Query<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables> query={IdentityVerificationDocument} {...props} />
    );
    

/**
 * __useIdentityVerificationQuery__
 *
 * To run a query within a React component, call `useIdentityVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityVerificationQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIdentityVerificationQuery(baseOptions: Apollo.QueryHookOptions<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables> & ({ variables: Types.IdentityVerificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>(IdentityVerificationDocument, options);
      }
export function useIdentityVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>(IdentityVerificationDocument, options);
        }
export function useIdentityVerificationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>(IdentityVerificationDocument, options);
        }
export type IdentityVerificationQueryHookResult = ReturnType<typeof useIdentityVerificationQuery>;
export type IdentityVerificationLazyQueryHookResult = ReturnType<typeof useIdentityVerificationLazyQuery>;
export type IdentityVerificationSuspenseQueryHookResult = ReturnType<typeof useIdentityVerificationSuspenseQuery>;
export type IdentityVerificationQueryResult = Apollo.QueryResult<Types.IdentityVerificationQuery, Types.IdentityVerificationQueryVariables>;
export const MailchimpFillinsDocument = gql`
    query mailchimpFillins($integration: IntegrationUpdateInput!) {
  mailchimpFillins(integration: $integration) {
    lists {
      id
      name
    }
  }
}
    `;
export type MailchimpFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>, 'query'> & ({ variables: Types.MailchimpFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MailchimpFillinsComponent = (props: MailchimpFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables> query={MailchimpFillinsDocument} {...props} />
    );
    

/**
 * __useMailchimpFillinsQuery__
 *
 * To run a query within a React component, call `useMailchimpFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useMailchimpFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables> & ({ variables: Types.MailchimpFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>(MailchimpFillinsDocument, options);
      }
export function useMailchimpFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>(MailchimpFillinsDocument, options);
        }
export function useMailchimpFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>(MailchimpFillinsDocument, options);
        }
export type MailchimpFillinsQueryHookResult = ReturnType<typeof useMailchimpFillinsQuery>;
export type MailchimpFillinsLazyQueryHookResult = ReturnType<typeof useMailchimpFillinsLazyQuery>;
export type MailchimpFillinsSuspenseQueryHookResult = ReturnType<typeof useMailchimpFillinsSuspenseQuery>;
export type MailchimpFillinsQueryResult = Apollo.QueryResult<Types.MailchimpFillinsQuery, Types.MailchimpFillinsQueryVariables>;
export const MailchimpMergeFieldsDocument = gql`
    query mailchimpMergeFields($integration: IntegrationUpdateInput!, $listId: String!) {
  mailchimpMergeFields(integration: $integration, listId: $listId) {
    id
    name
    label
    type
  }
}
    `;
export type MailchimpMergeFieldsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>, 'query'> & ({ variables: Types.MailchimpMergeFieldsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MailchimpMergeFieldsComponent = (props: MailchimpMergeFieldsComponentProps) => (
      <ApolloReactComponents.Query<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables> query={MailchimpMergeFieldsDocument} {...props} />
    );
    

/**
 * __useMailchimpMergeFieldsQuery__
 *
 * To run a query within a React component, call `useMailchimpMergeFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpMergeFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpMergeFieldsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useMailchimpMergeFieldsQuery(baseOptions: Apollo.QueryHookOptions<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables> & ({ variables: Types.MailchimpMergeFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>(MailchimpMergeFieldsDocument, options);
      }
export function useMailchimpMergeFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>(MailchimpMergeFieldsDocument, options);
        }
export function useMailchimpMergeFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>(MailchimpMergeFieldsDocument, options);
        }
export type MailchimpMergeFieldsQueryHookResult = ReturnType<typeof useMailchimpMergeFieldsQuery>;
export type MailchimpMergeFieldsLazyQueryHookResult = ReturnType<typeof useMailchimpMergeFieldsLazyQuery>;
export type MailchimpMergeFieldsSuspenseQueryHookResult = ReturnType<typeof useMailchimpMergeFieldsSuspenseQuery>;
export type MailchimpMergeFieldsQueryResult = Apollo.QueryResult<Types.MailchimpMergeFieldsQuery, Types.MailchimpMergeFieldsQueryVariables>;
export const MailchimpTagsDocument = gql`
    query mailchimpTags($integration: IntegrationUpdateInput!, $listId: String!) {
  mailchimpTags(integration: $integration, listId: $listId) {
    id
    name
  }
}
    `;
export type MailchimpTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>, 'query'> & ({ variables: Types.MailchimpTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MailchimpTagsComponent = (props: MailchimpTagsComponentProps) => (
      <ApolloReactComponents.Query<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables> query={MailchimpTagsDocument} {...props} />
    );
    

/**
 * __useMailchimpTagsQuery__
 *
 * To run a query within a React component, call `useMailchimpTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpTagsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useMailchimpTagsQuery(baseOptions: Apollo.QueryHookOptions<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables> & ({ variables: Types.MailchimpTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>(MailchimpTagsDocument, options);
      }
export function useMailchimpTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>(MailchimpTagsDocument, options);
        }
export function useMailchimpTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>(MailchimpTagsDocument, options);
        }
export type MailchimpTagsQueryHookResult = ReturnType<typeof useMailchimpTagsQuery>;
export type MailchimpTagsLazyQueryHookResult = ReturnType<typeof useMailchimpTagsLazyQuery>;
export type MailchimpTagsSuspenseQueryHookResult = ReturnType<typeof useMailchimpTagsSuspenseQuery>;
export type MailchimpTagsQueryResult = Apollo.QueryResult<Types.MailchimpTagsQuery, Types.MailchimpTagsQueryVariables>;
export const MailerliteFillinsDocument = gql`
    query mailerliteFillins($integration: IntegrationUpdateInput!) {
  mailerliteFillins(integration: $integration) {
    groups {
      id
      name
    }
    fields {
      id
      name
      label
      type
    }
  }
}
    `;
export type MailerliteFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>, 'query'> & ({ variables: Types.MailerliteFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MailerliteFillinsComponent = (props: MailerliteFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables> query={MailerliteFillinsDocument} {...props} />
    );
    

/**
 * __useMailerliteFillinsQuery__
 *
 * To run a query within a React component, call `useMailerliteFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailerliteFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailerliteFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useMailerliteFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables> & ({ variables: Types.MailerliteFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>(MailerliteFillinsDocument, options);
      }
export function useMailerliteFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>(MailerliteFillinsDocument, options);
        }
export function useMailerliteFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>(MailerliteFillinsDocument, options);
        }
export type MailerliteFillinsQueryHookResult = ReturnType<typeof useMailerliteFillinsQuery>;
export type MailerliteFillinsLazyQueryHookResult = ReturnType<typeof useMailerliteFillinsLazyQuery>;
export type MailerliteFillinsSuspenseQueryHookResult = ReturnType<typeof useMailerliteFillinsSuspenseQuery>;
export type MailerliteFillinsQueryResult = Apollo.QueryResult<Types.MailerliteFillinsQuery, Types.MailerliteFillinsQueryVariables>;
export const MarketoFillinsDocument = gql`
    query marketoFillins($integration: IntegrationUpdateInput!) {
  marketoFillins(integration: $integration) {
    fields {
      id
      name
      label
      type
    }
  }
}
    `;
export type MarketoFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>, 'query'> & ({ variables: Types.MarketoFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MarketoFillinsComponent = (props: MarketoFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables> query={MarketoFillinsDocument} {...props} />
    );
    

/**
 * __useMarketoFillinsQuery__
 *
 * To run a query within a React component, call `useMarketoFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketoFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketoFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useMarketoFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables> & ({ variables: Types.MarketoFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>(MarketoFillinsDocument, options);
      }
export function useMarketoFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>(MarketoFillinsDocument, options);
        }
export function useMarketoFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>(MarketoFillinsDocument, options);
        }
export type MarketoFillinsQueryHookResult = ReturnType<typeof useMarketoFillinsQuery>;
export type MarketoFillinsLazyQueryHookResult = ReturnType<typeof useMarketoFillinsLazyQuery>;
export type MarketoFillinsSuspenseQueryHookResult = ReturnType<typeof useMarketoFillinsSuspenseQuery>;
export type MarketoFillinsQueryResult = Apollo.QueryResult<Types.MarketoFillinsQuery, Types.MarketoFillinsQueryVariables>;
export const ProductHuntPostDocument = gql`
    query productHuntPost($ewebinarId: String!, $slug: String!) {
  productHuntPost(ewebinarId: $ewebinarId, slug: $slug) {
    ...ProductHuntPost
  }
}
    ${ProductHuntPostFragmentDoc}`;
export type ProductHuntPostComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>, 'query'> & ({ variables: Types.ProductHuntPostQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductHuntPostComponent = (props: ProductHuntPostComponentProps) => (
      <ApolloReactComponents.Query<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables> query={ProductHuntPostDocument} {...props} />
    );
    

/**
 * __useProductHuntPostQuery__
 *
 * To run a query within a React component, call `useProductHuntPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductHuntPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductHuntPostQuery({
 *   variables: {
 *      ewebinarId: // value for 'ewebinarId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useProductHuntPostQuery(baseOptions: Apollo.QueryHookOptions<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables> & ({ variables: Types.ProductHuntPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>(ProductHuntPostDocument, options);
      }
export function useProductHuntPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>(ProductHuntPostDocument, options);
        }
export function useProductHuntPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>(ProductHuntPostDocument, options);
        }
export type ProductHuntPostQueryHookResult = ReturnType<typeof useProductHuntPostQuery>;
export type ProductHuntPostLazyQueryHookResult = ReturnType<typeof useProductHuntPostLazyQuery>;
export type ProductHuntPostSuspenseQueryHookResult = ReturnType<typeof useProductHuntPostSuspenseQuery>;
export type ProductHuntPostQueryResult = Apollo.QueryResult<Types.ProductHuntPostQuery, Types.ProductHuntPostQueryVariables>;
export const InteractionTypeIntegrationDetailsForWebinarDocument = gql`
    query interactionTypeIntegrationDetailsForWebinar($setId: String!, $cardType: String!) {
  interactionTypeIntegrationDetailsForWebinar(setId: $setId, cardType: $cardType)
}
    `;
export type InteractionTypeIntegrationDetailsForWebinarComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>, 'query'> & ({ variables: Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InteractionTypeIntegrationDetailsForWebinarComponent = (props: InteractionTypeIntegrationDetailsForWebinarComponentProps) => (
      <ApolloReactComponents.Query<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables> query={InteractionTypeIntegrationDetailsForWebinarDocument} {...props} />
    );
    

/**
 * __useInteractionTypeIntegrationDetailsForWebinarQuery__
 *
 * To run a query within a React component, call `useInteractionTypeIntegrationDetailsForWebinarQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionTypeIntegrationDetailsForWebinarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionTypeIntegrationDetailsForWebinarQuery({
 *   variables: {
 *      setId: // value for 'setId'
 *      cardType: // value for 'cardType'
 *   },
 * });
 */
export function useInteractionTypeIntegrationDetailsForWebinarQuery(baseOptions: Apollo.QueryHookOptions<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables> & ({ variables: Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>(InteractionTypeIntegrationDetailsForWebinarDocument, options);
      }
export function useInteractionTypeIntegrationDetailsForWebinarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>(InteractionTypeIntegrationDetailsForWebinarDocument, options);
        }
export function useInteractionTypeIntegrationDetailsForWebinarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>(InteractionTypeIntegrationDetailsForWebinarDocument, options);
        }
export type InteractionTypeIntegrationDetailsForWebinarQueryHookResult = ReturnType<typeof useInteractionTypeIntegrationDetailsForWebinarQuery>;
export type InteractionTypeIntegrationDetailsForWebinarLazyQueryHookResult = ReturnType<typeof useInteractionTypeIntegrationDetailsForWebinarLazyQuery>;
export type InteractionTypeIntegrationDetailsForWebinarSuspenseQueryHookResult = ReturnType<typeof useInteractionTypeIntegrationDetailsForWebinarSuspenseQuery>;
export type InteractionTypeIntegrationDetailsForWebinarQueryResult = Apollo.QueryResult<Types.InteractionTypeIntegrationDetailsForWebinarQuery, Types.InteractionTypeIntegrationDetailsForWebinarQueryVariables>;
export const SsoCheckIssuerDocument = gql`
    query ssoCheckIssuer($issuerUrl: String!) {
  ssoCheckIssuer(issuerUrl: $issuerUrl)
}
    `;
export type SsoCheckIssuerComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>, 'query'> & ({ variables: Types.SsoCheckIssuerQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SsoCheckIssuerComponent = (props: SsoCheckIssuerComponentProps) => (
      <ApolloReactComponents.Query<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables> query={SsoCheckIssuerDocument} {...props} />
    );
    

/**
 * __useSsoCheckIssuerQuery__
 *
 * To run a query within a React component, call `useSsoCheckIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoCheckIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoCheckIssuerQuery({
 *   variables: {
 *      issuerUrl: // value for 'issuerUrl'
 *   },
 * });
 */
export function useSsoCheckIssuerQuery(baseOptions: Apollo.QueryHookOptions<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables> & ({ variables: Types.SsoCheckIssuerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>(SsoCheckIssuerDocument, options);
      }
export function useSsoCheckIssuerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>(SsoCheckIssuerDocument, options);
        }
export function useSsoCheckIssuerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>(SsoCheckIssuerDocument, options);
        }
export type SsoCheckIssuerQueryHookResult = ReturnType<typeof useSsoCheckIssuerQuery>;
export type SsoCheckIssuerLazyQueryHookResult = ReturnType<typeof useSsoCheckIssuerLazyQuery>;
export type SsoCheckIssuerSuspenseQueryHookResult = ReturnType<typeof useSsoCheckIssuerSuspenseQuery>;
export type SsoCheckIssuerQueryResult = Apollo.QueryResult<Types.SsoCheckIssuerQuery, Types.SsoCheckIssuerQueryVariables>;
export const SalesforceFillinsDocument = gql`
    query salesforceFillins($integration: IntegrationUpdateInput!) {
  salesforceFillins(integration: $integration) {
    fields {
      id
      name
      label
      type
    }
    campaigns {
      ...SalesforceCampaign
    }
    subjects {
      ...SalesforceSubject
    }
  }
}
    ${SalesforceCampaignFragmentDoc}
${SalesforceSubjectFragmentDoc}`;
export type SalesforceFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>, 'query'> & ({ variables: Types.SalesforceFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SalesforceFillinsComponent = (props: SalesforceFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables> query={SalesforceFillinsDocument} {...props} />
    );
    

/**
 * __useSalesforceFillinsQuery__
 *
 * To run a query within a React component, call `useSalesforceFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useSalesforceFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables> & ({ variables: Types.SalesforceFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>(SalesforceFillinsDocument, options);
      }
export function useSalesforceFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>(SalesforceFillinsDocument, options);
        }
export function useSalesforceFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>(SalesforceFillinsDocument, options);
        }
export type SalesforceFillinsQueryHookResult = ReturnType<typeof useSalesforceFillinsQuery>;
export type SalesforceFillinsLazyQueryHookResult = ReturnType<typeof useSalesforceFillinsLazyQuery>;
export type SalesforceFillinsSuspenseQueryHookResult = ReturnType<typeof useSalesforceFillinsSuspenseQuery>;
export type SalesforceFillinsQueryResult = Apollo.QueryResult<Types.SalesforceFillinsQuery, Types.SalesforceFillinsQueryVariables>;
export const SalesforceActivityPropertiesDocument = gql`
    query salesforceActivityProperties {
  salesforceActivityProperties {
    property
    salesforceProperty
  }
}
    `;
export type SalesforceActivityPropertiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>, 'query'>;

    export const SalesforceActivityPropertiesComponent = (props: SalesforceActivityPropertiesComponentProps) => (
      <ApolloReactComponents.Query<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables> query={SalesforceActivityPropertiesDocument} {...props} />
    );
    

/**
 * __useSalesforceActivityPropertiesQuery__
 *
 * To run a query within a React component, call `useSalesforceActivityPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesforceActivityPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesforceActivityPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesforceActivityPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>(SalesforceActivityPropertiesDocument, options);
      }
export function useSalesforceActivityPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>(SalesforceActivityPropertiesDocument, options);
        }
export function useSalesforceActivityPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>(SalesforceActivityPropertiesDocument, options);
        }
export type SalesforceActivityPropertiesQueryHookResult = ReturnType<typeof useSalesforceActivityPropertiesQuery>;
export type SalesforceActivityPropertiesLazyQueryHookResult = ReturnType<typeof useSalesforceActivityPropertiesLazyQuery>;
export type SalesforceActivityPropertiesSuspenseQueryHookResult = ReturnType<typeof useSalesforceActivityPropertiesSuspenseQuery>;
export type SalesforceActivityPropertiesQueryResult = Apollo.QueryResult<Types.SalesforceActivityPropertiesQuery, Types.SalesforceActivityPropertiesQueryVariables>;
export const SlackFillinsDocument = gql`
    query slackFillins($integration: IntegrationUpdateInput!) {
  slackFillins(integration: $integration) {
    channels {
      id
      name
    }
  }
}
    `;
export type SlackFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>, 'query'> & ({ variables: Types.SlackFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SlackFillinsComponent = (props: SlackFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables> query={SlackFillinsDocument} {...props} />
    );
    

/**
 * __useSlackFillinsQuery__
 *
 * To run a query within a React component, call `useSlackFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useSlackFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables> & ({ variables: Types.SlackFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>(SlackFillinsDocument, options);
      }
export function useSlackFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>(SlackFillinsDocument, options);
        }
export function useSlackFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>(SlackFillinsDocument, options);
        }
export type SlackFillinsQueryHookResult = ReturnType<typeof useSlackFillinsQuery>;
export type SlackFillinsLazyQueryHookResult = ReturnType<typeof useSlackFillinsLazyQuery>;
export type SlackFillinsSuspenseQueryHookResult = ReturnType<typeof useSlackFillinsSuspenseQuery>;
export type SlackFillinsQueryResult = Apollo.QueryResult<Types.SlackFillinsQuery, Types.SlackFillinsQueryVariables>;
export const ThinkificProductsDocument = gql`
    query thinkificProducts {
  thinkificProducts {
    ...ThinkificProduct
  }
}
    ${ThinkificProductFragmentDoc}`;
export type ThinkificProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>, 'query'>;

    export const ThinkificProductsComponent = (props: ThinkificProductsComponentProps) => (
      <ApolloReactComponents.Query<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables> query={ThinkificProductsDocument} {...props} />
    );
    

/**
 * __useThinkificProductsQuery__
 *
 * To run a query within a React component, call `useThinkificProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useThinkificProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThinkificProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useThinkificProductsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>(ThinkificProductsDocument, options);
      }
export function useThinkificProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>(ThinkificProductsDocument, options);
        }
export function useThinkificProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>(ThinkificProductsDocument, options);
        }
export type ThinkificProductsQueryHookResult = ReturnType<typeof useThinkificProductsQuery>;
export type ThinkificProductsLazyQueryHookResult = ReturnType<typeof useThinkificProductsLazyQuery>;
export type ThinkificProductsSuspenseQueryHookResult = ReturnType<typeof useThinkificProductsSuspenseQuery>;
export type ThinkificProductsQueryResult = Apollo.QueryResult<Types.ThinkificProductsQuery, Types.ThinkificProductsQueryVariables>;
export const TwilioFillinsDocument = gql`
    query twilioFillins($integration: IntegrationUpdateInput!) {
  twilioFillins(integration: $integration) {
    phoneNumbers
    templates {
      id
      name
      content
    }
  }
}
    `;
export type TwilioFillinsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>, 'query'> & ({ variables: Types.TwilioFillinsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const TwilioFillinsComponent = (props: TwilioFillinsComponentProps) => (
      <ApolloReactComponents.Query<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables> query={TwilioFillinsDocument} {...props} />
    );
    

/**
 * __useTwilioFillinsQuery__
 *
 * To run a query within a React component, call `useTwilioFillinsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwilioFillinsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwilioFillinsQuery({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useTwilioFillinsQuery(baseOptions: Apollo.QueryHookOptions<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables> & ({ variables: Types.TwilioFillinsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>(TwilioFillinsDocument, options);
      }
export function useTwilioFillinsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>(TwilioFillinsDocument, options);
        }
export function useTwilioFillinsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>(TwilioFillinsDocument, options);
        }
export type TwilioFillinsQueryHookResult = ReturnType<typeof useTwilioFillinsQuery>;
export type TwilioFillinsLazyQueryHookResult = ReturnType<typeof useTwilioFillinsLazyQuery>;
export type TwilioFillinsSuspenseQueryHookResult = ReturnType<typeof useTwilioFillinsSuspenseQuery>;
export type TwilioFillinsQueryResult = Apollo.QueryResult<Types.TwilioFillinsQuery, Types.TwilioFillinsQueryVariables>;
export const TwilioTemplatesDocument = gql`
    query twilioTemplates {
  twilioTemplates {
    id
    name
    content
  }
}
    `;
export type TwilioTemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>, 'query'>;

    export const TwilioTemplatesComponent = (props: TwilioTemplatesComponentProps) => (
      <ApolloReactComponents.Query<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables> query={TwilioTemplatesDocument} {...props} />
    );
    

/**
 * __useTwilioTemplatesQuery__
 *
 * To run a query within a React component, call `useTwilioTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwilioTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwilioTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTwilioTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>(TwilioTemplatesDocument, options);
      }
export function useTwilioTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>(TwilioTemplatesDocument, options);
        }
export function useTwilioTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>(TwilioTemplatesDocument, options);
        }
export type TwilioTemplatesQueryHookResult = ReturnType<typeof useTwilioTemplatesQuery>;
export type TwilioTemplatesLazyQueryHookResult = ReturnType<typeof useTwilioTemplatesLazyQuery>;
export type TwilioTemplatesSuspenseQueryHookResult = ReturnType<typeof useTwilioTemplatesSuspenseQuery>;
export type TwilioTemplatesQueryResult = Apollo.QueryResult<Types.TwilioTemplatesQuery, Types.TwilioTemplatesQueryVariables>;
export const VimeoVideosDocument = gql`
    query vimeoVideos($page: Float, $searchString: String) {
  vimeoVideos(page: $page, searchString: $searchString) {
    ...VimeoVideo
  }
}
    ${VimeoVideoFragmentDoc}`;
export type VimeoVideosComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>, 'query'>;

    export const VimeoVideosComponent = (props: VimeoVideosComponentProps) => (
      <ApolloReactComponents.Query<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables> query={VimeoVideosDocument} {...props} />
    );
    

/**
 * __useVimeoVideosQuery__
 *
 * To run a query within a React component, call `useVimeoVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useVimeoVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVimeoVideosQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useVimeoVideosQuery(baseOptions?: Apollo.QueryHookOptions<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>(VimeoVideosDocument, options);
      }
export function useVimeoVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>(VimeoVideosDocument, options);
        }
export function useVimeoVideosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>(VimeoVideosDocument, options);
        }
export type VimeoVideosQueryHookResult = ReturnType<typeof useVimeoVideosQuery>;
export type VimeoVideosLazyQueryHookResult = ReturnType<typeof useVimeoVideosLazyQuery>;
export type VimeoVideosSuspenseQueryHookResult = ReturnType<typeof useVimeoVideosSuspenseQuery>;
export type VimeoVideosQueryResult = Apollo.QueryResult<Types.VimeoVideosQuery, Types.VimeoVideosQueryVariables>;
export const VimeoVideoInfoDocument = gql`
    query vimeoVideoInfo($videoSourceUrl: String!) {
  vimeoVideoInfo(videoSourceUrl: $videoSourceUrl) {
    ...VimeoVideo
  }
}
    ${VimeoVideoFragmentDoc}`;
export type VimeoVideoInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>, 'query'> & ({ variables: Types.VimeoVideoInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const VimeoVideoInfoComponent = (props: VimeoVideoInfoComponentProps) => (
      <ApolloReactComponents.Query<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables> query={VimeoVideoInfoDocument} {...props} />
    );
    

/**
 * __useVimeoVideoInfoQuery__
 *
 * To run a query within a React component, call `useVimeoVideoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVimeoVideoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVimeoVideoInfoQuery({
 *   variables: {
 *      videoSourceUrl: // value for 'videoSourceUrl'
 *   },
 * });
 */
export function useVimeoVideoInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables> & ({ variables: Types.VimeoVideoInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>(VimeoVideoInfoDocument, options);
      }
export function useVimeoVideoInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>(VimeoVideoInfoDocument, options);
        }
export function useVimeoVideoInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>(VimeoVideoInfoDocument, options);
        }
export type VimeoVideoInfoQueryHookResult = ReturnType<typeof useVimeoVideoInfoQuery>;
export type VimeoVideoInfoLazyQueryHookResult = ReturnType<typeof useVimeoVideoInfoLazyQuery>;
export type VimeoVideoInfoSuspenseQueryHookResult = ReturnType<typeof useVimeoVideoInfoSuspenseQuery>;
export type VimeoVideoInfoQueryResult = Apollo.QueryResult<Types.VimeoVideoInfoQuery, Types.VimeoVideoInfoQueryVariables>;
export const ZoomMeetingsDocument = gql`
    query zoomMeetings {
  zoomMeetings {
    ...ZoomMeeting
  }
}
    ${ZoomMeetingFragmentDoc}`;
export type ZoomMeetingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>, 'query'>;

    export const ZoomMeetingsComponent = (props: ZoomMeetingsComponentProps) => (
      <ApolloReactComponents.Query<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables> query={ZoomMeetingsDocument} {...props} />
    );
    

/**
 * __useZoomMeetingsQuery__
 *
 * To run a query within a React component, call `useZoomMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomMeetingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomMeetingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useZoomMeetingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>(ZoomMeetingsDocument, options);
      }
export function useZoomMeetingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>(ZoomMeetingsDocument, options);
        }
export function useZoomMeetingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>(ZoomMeetingsDocument, options);
        }
export type ZoomMeetingsQueryHookResult = ReturnType<typeof useZoomMeetingsQuery>;
export type ZoomMeetingsLazyQueryHookResult = ReturnType<typeof useZoomMeetingsLazyQuery>;
export type ZoomMeetingsSuspenseQueryHookResult = ReturnType<typeof useZoomMeetingsSuspenseQuery>;
export type ZoomMeetingsQueryResult = Apollo.QueryResult<Types.ZoomMeetingsQuery, Types.ZoomMeetingsQueryVariables>;